export default {
    "en": {
        "banners": {
            "seats_banner": {
                "title": "<b>WARNING:  You’re Almost Out of Available Seats</b>",
                "message": "Once all of your licensed number of seats have been assigned, you will no longer be allowed to add users. Players, Coaches, and Admin Coaches all count toward to your total seat count. To minimize disruptions to your daily operations, please take the following actions before all available seats are assigned:<p><ul><li>If you have a user that is no longer associated with your organization, please click on the three dots to the right of the user’s name and click Remove.</li><li>If you need to purchase additional seats, please contact your Blast Motion representative for a quote.</li></ul></p>",
                "button": {
                    "title": "Remind Me Later"
                }
            },
            "upsell": {
                "common": {
                    "dismiss": "Dismiss",
                    "later": "Later",
                    "you_have_number_days_left_in_your_free_trial": "You have {number} days left in your free trial"
                },
                "non_subscribing": {
                    "upgrade_to_blast_premium_services": "Upgrade to Blast Premium Services",
                    "get_the_most_from_your_blast_experience_advanced_insights_analysis_and_reporting_at_your_fingertips": "Get the most from your Blast Experience!<br>Advanced insights, analysis and reporting at your fingertips.",
                    "learn_more_about_premium_services": "Learn More About Premium services"
                },
                "premium_user": {
                    "title": "Limited Time Offer",
                    "message": "Did you know that you get a discount on a new Swing Analyzer as a perk of attending {campName}? Add one to your bag or pick one up for a friend before the offer expires on {endDate}."
                },
                "camp_trial_active": {
                    "title": "Welcome to Blast Premium Services",
                    "message": {
                        "0-14": "Get started with Blast Premium Services today! As part of {campName}, experience all that Blast Motion has to offer for free until {endDate}. Click to learn more.",
                        "15-27": "Are you enjoying Blast Premium Services? Advanced metrics are just the beginning. PCR Scores, Ball Flight, and Blast Connect are all a part of your free Premium Services trial!",
                        "28-30": "Don't miss out! Your Blast Premium Services trial ends on {endDate}. Upgrade now to keep training with PCR."
                    }
                },
                "camp_trial_expired": {
                    "title": "Camp Trial Expired",
                    "message": "Your Blast Premium Services trial may have expired, but don't worry! Access all of your swings, metrics, and scores now by upgrading to Premium Services."
                }
            }
        },
        "blast_cloud": {
            "errors": {
                "blast_cloud_error": "Blast Cloud Error",
                "invalid_pro_academy": "Invalid Pro Team Academy",
                "blast_cloud_unavailable": "Unfortunately we could not sent your invitation(s) due to a problem on our server. Please try again.",
                "support_team_link_text": "If the problem persists, please contact our",
                "support_team_name": "Customer Support Team"
            }
        },
        "comment": {
            "messages": {
                "comment_posted": "Comment posted",
                "comment_not_found": "Comment not found",
                "comment_deleted": "Comment deleted",
                "comment_not_deleted": "Comment not deleted",
                "comment_restored": "Comment restored",
                "comment_not_restored": "Comment not restored"
            }
        },
        "stripe": {
            "incorrect_number": "The card number is incorrect.",
            "invalid_number": "The card number is not a valid credit card number.",
            "invalid_expiry_month": "The card's expiration month is invalid.",
            "invalid_expiry_year": "The card's expiration year is invalid.",
            "invalid_cvc": "The card's security code is invalid.",
            "expired_card": "The card has expired.",
            "incorrect_cvc": "The card's security code is incorrect.",
            "incorrect_zip": "The card's zip code failed validation.",
            "card_declined": "The card was declined.",
            "missing": "There is no card on a customer that is being charged.",
            "processing_error": "An error occurred while processing the card.",
            "rate_limit": "An error occurred due to requests hitting the API too quickly. Please let us know if you're consistently running into this error.",
            "card_decline_rate_limit_exceeded": "This card has been declined too many times.",
            "invalid_card_type": "The card provided as an external account is not supported for payouts. Provide a non-prepaid debit card instead.",
            "invalid_api_key": "Something went wrong. Please contact support"
        },
        "blast_insight": {
            "headings": {
                "swings_over_time": "Swings Over Time",
                "swing_quality": "Swing Quality",
                "swing_data": "Swing Data",
                "team_average_chart": "Team Average Chart",
                "averages_per_player": "Averages Per Player"
            },
            "units": {
                "avg": "Avg"
            },
            "labels": {
                "filter_sessions": "Filter Sessions",
                "sessions": "Sessions",
                "apply_filters": "Apply Filters",
                "reset_filters": "Reset Filters",
                "print": "Print",
                "download_csv": "Download CSV",
                "download_excel": "Download Excel",
                "goal": "Goal",
                "achieved_goal": "Achieved goal",
                "of_swings": "of swings",
                "how_to_improve": "How To Improve",
                "selected": "Selected",
                "back_to_team_averages": "Back to Team Averages",
                "user_name_swing_quality_chart": "Swing Quality - {name}",
                "zoom_message": "To zoom: click and hold your mouse while dragging over the data you like to zoom in on. Or, use the sliders on the chart's X and Y axis.",
                "metrics_importing": "Importing Metrics",
                "for_all_students": "For All Players",
                "sync_sport": "Sync {sport_name} Metrics",
                "sync_sport_for_all_students": "Sync {sport_name} For All Players",
                "user_has_not_connected": "This user has not connected their Blast App yet.",
                "averages_of_swings": "Averages {swing_count} Swings",
                "count_swings": "{count} Swings | {count} Swing | {count} Swings"
            },
            "errors": {
                "bulk_sync_metric_not_available": "Bulk metric sync not supported with this academy.",
                "unable_to_sync": "Unable to sync any players."
            }
        },
        "account": {
            "messages": {
                "subscription": {
                    "previous_payment_source_not_available": "Previous Payment Source is no longer available"
                }
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "filled": "The {attribute} field is required.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "array_count": "The {attribute} selection count is invalid.",
            "attributes": [],
            "invalid_date": "Invalid Date",
            "phone": "The {attribute} field is not a valid phone number.",
            "provided_credentials_are_wrong_or_contact_us": "Provided credentials are wrong. Please, try again. If you are sure credentials are correct, please, contact us.",
            "cannot_connect_to_cloud": "Request could not be processed. Please try refreshing the page and trying again. If this error persists, please contact support.",
            "input_is_invalid": "Input is invalid",
            "email_and_password_are_required": "Email and Password are required",
            "the_provided_external_id_is_not_valid": "The provided External ID is not valid.",
            "provided_blast_user_id_has_been_updated": "{user_identifier} has been updated.  Please note that {exist_identifier} also has this External ID assigned for this organization.",
            "invitation": {
                "academy_or_event_has_been_removed": "Your invitation is no longer valid. Contact your coach or admin to reinvite you."
            },
            "dob": "Birth Date and the I Certify checkbox values are required and will help us to personalize your goals and insights to help you become a better hitter.",
            "one_of_the_specified_emails_does_not_belong_to_any_coach_in_the_selected_academy": "Some emails do not belong to any coach in the selected academy. Check the emails and try again with them. (Wrong emails: {emails})",
            "specified_event_has_end_cannot_invite_users": "The specified event has been finished. Users can no longer be invited.",
            "the_user_already_belongs_to_the_specified_event": "The user already belongs to the specified event.",
            "event_has_already_been_started": "The specified event has already been started.",
            "profile_update_non_unique": "{blast_user_id} has been updated. Please note that {exist_blast_user_id} also has this External ID assigned for this organization.|{blast_user_id} has been updated. Please note that {exist_blast_user_id} also have this External ID assigned for this organization.",
            "this_user_has_been_added_to_the_event_with_the_provided_external_id": "WARNING: This user has been added to the event with the provided external_id value of {provided_external_id}. Please note that {email_exist_external_id} also has this External ID assigned for this organization. To change the external_id for one of the users, please use the PATCH {url_path} endpoint.",
            "this_user_already_has_an_external_id_value": "WARNING: This user already has an external_id value of {exists_external_id} assigned for this organization that does not match the provided value. The user has been added to the event, but the external_id value for the user has not been changed to the provided value. To change the external_id for the user, please use the PATCH {url_path} endpoint.",
            "the_player_was_automatically_assigned_to_all": "WARNING: The player was automatically assigned to all Admin Coaches currently in the event. Because a Coach Email value was not provided, if additional Coach assignments are needed, the player will need to be manually assigned to the coach(es) through the Blast Connect web interface.",
            "this_action_is_unauthorized": "This action is unauthorized.",
            "invalid_product_features": "Invalid Product Features",
            "unauthorized_payment_source": "Unauthorized Payment Source",
            "failed_payment_source_creation": "Cannot create a payment method with the provided data.",
            "invalid_products": "Invalid Products."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "user": "We can't find a user with that e-mail address.",
            "token": "This password reset token is invalid.",
            "sent": "Password reminder sent!"
        },
        "media": {
            "file_manager": [],
            "library": [],
            "file": {
                "name": "File Name",
                "description": "File Description",
                "analysis": "Analysis File",
                "original": "Original File",
                "format": "File Format",
                "encoded": "Encoded File"
            },
            "messages": {
                "file_added": "File added",
                "file_name_deleted": "{file_name} deleted",
                "file_name_restored": "{file_name} restored",
                "file_deleted": "File deleted",
                "file_not_deleted": "File not deleted",
                "file_delete_error": "Sorry, something happened and the media was not deleted yet",
                "not_found": "Media not found",
                "invalid_access": "Sorry, you don't appear to have access to this file. Please contact us for further assistance.",
                "unauthorized_comment": "Commenting Permission Denied for this File",
                "file_updated": "file_updated",
                "file_not_updated": "File could not be updated"
            },
            "errors": {
                "error_creating_media_key": "Error creating media key",
                "error_getting_all_media": "Error getting of all media",
                "error_saving_file": "Error saving file",
                "error_update_status": "Error updating file's status"
            },
            "common": {
                "file_name": "File Name",
                "select_file": "Select File",
                "max_file_size": "%s MB maximum",
                "upload_complete": "Upload Complete",
                "view_asset": "View Asset",
                "streaming_video": "Streaming Video",
                "dropbox": "Dropbox"
            }
        },
        "assessment": {
            "messages": {
                "no_results": "No results found",
                "no_results_for_filters": "There are no results for the selected filters"
            }
        },
        "messages": {
            "errors": {
                "no_contacts": {
                    "student": "Sorry, you have no coach to message.",
                    "all": "Sorry, you have no players or rosters to message."
                }
            }
        },
        "wi": {
            "blast_connect": "Blast Connect",
            "blast_metrics_title": "BLAST Metrics",
            "blast_insights": "BLAST Insights",
            "blast_insights_explain": "Does this academy see insights or metrics?",
            "blast_motion_title": "BLAST Motion",
            "metrics_title": "Metrics",
            "player_report": "Player Report",
            "blast": "BLAST",
            "no_metrics": "You don't have any Blast data to display. Go ahead and take some swings with your Blast app and sensor.",
            "action_not_available": "This action is no longer available.",
            "blast_analytics_title": "BLAST Analytics",
            "welcome_blast_metrics": "Connect your Blast account to view important metrics for each swing.",
            "welcome_library": "Upload videos, images and files for analysis or view and analyze auto-synced Blast videos and images.",
            "welcome_train": "View and execute assigned workouts and practices or create your own.",
            "welcome_stats": "View swing statistics and identify important trends.",
            "welcome_compete": "Test your skills with one of our assessment challenges.",
            "blast_motion": "Blast Motion",
            "blast_motion_address": "1780 La Costa Meadows Dr. Suite 101, San Marcos, CA 92078",
            "athlete": "Athlete",
            "player": "Player",
            "im_player": "I'm a Player",
            "coach": "Coach",
            "im_coach": "I'm a Coach",
            "academy": "Academy",
            "academy_name": "Academy Name",
            "see_all": "See All",
            "show_all": "Show All",
            "hide_all": "Hide All",
            "expand_all": "Expand All",
            "collapse_all": "Collapse All",
            "learn_more": "Learn more",
            "upgrade": "Upgrade",
            "continue": "Continue",
            "purchase": "Purchase",
            "select": "Select",
            "meta_description": "{appName} is an information analysis, reporting, player management, and coaching application for mobile and desktop.",
            "compete": "Compete",
            "train": "Train",
            "have_your_say": "Have your say...",
            "login": "Log in",
            "logout": "Logout",
            "home": "Home",
            "email": "Email",
            "email_invalid": "Email is invalid",
            "password": "Password",
            "new_password": "New Password",
            "password_forgotten": "Forgot Your Password?",
            "password_reset_success": "Password successfully reset. Your new password has been emailed.",
            "password_invalid_code": "Invalid Reset Code",
            "password_reset": "Password Reset",
            "password_reset_message": "Please provide your email address. A confirmation code will be sent to it.",
            "password_reset_code_sent": "Password reset code sent.",
            "password_reset_not_required": "Password reset not required",
            "password_minlength": "The password must be at least {length} characters.",
            "password_maxlength": "The password cannot be more than {length} characters.",
            "password_characters": "The password must contain at least a letter, and a number.",
            "password_matches": "The passwords do not match.",
            "password_strength": "Password strength",
            "password_very_weak": "Very Weak",
            "password_weak": "Weak",
            "password_good": "Good",
            "password_strong": "Strong",
            "password_very_strong": "Very Strong",
            "password_change_required": "Password Change Required",
            "current_password_is_incorrect": "Your current password was incorrect. Please try again.",
            "current_password_is_required": "Your current password is required when updating your email and/or password.",
            "logout_success": "Logout Successful",
            "member_not_found": "Member not found.",
            "incorrect_login": "Incorrect Email or Password",
            "incorrect_login_by_academy": "You are not a member of this academy.<br>If you have a valid Blast Premium account, try logging in at <a href=\"{url}\">{domain}</a>.<br><br>If you feel this is an error, please contact our <a href=\"https://blastmotion.com/about/support/\">Customer Support Team</a>.",
            "more": "more",
            "less": "less",
            "file": "File",
            "edit": "Edit",
            "add": "Add",
            "add_another": "Add another",
            "undo": "Undo",
            "added": "Added",
            "edited": "edited",
            "edited_camp": "Event successfully edited.<br><br>Information will be updated on Blast Connect, but registered players will not automatically be notified of these changes.",
            "edited_camp_with_level_of_play": "Event successfully edited.<br><br>Please note that the new level of play will only affect future player additions and will not affect existing players.<br><br>Information will be updated on BlastConnect, but registered players will not automatically be notified of these changes.",
            "delete": "Delete",
            "delete_permanently": "Permanently Delete",
            "delete_player": "Delete Player",
            "delete_coach": "Delete member/Coach",
            "deleted": "deleted",
            "restored": "restored",
            "answered": "answered",
            "create": "Create",
            "created": "created",
            "share": "Share",
            "preview": "Preview",
            "library": "Library",
            "update": "Update",
            "accept": "Accept",
            "remove": "Remove",
            "duplicate": "Duplicate",
            "duplicate_group": "Duplicate Group",
            "delete_group": "Delete Group",
            "decline": "Decline",
            "address_additional": "Address (additional)",
            "address1": "Address 1",
            "address2": "Address 2",
            "city": "City",
            "postal_code": "Zipcode/Postal Code",
            "cell": "cell",
            "about": "About",
            "saved": "Saved",
            "never": "Never",
            "none": "None",
            "rank": "Rank",
            "best": "Best",
            "unlimited": "Unlimited",
            "item_successfully_created": "{item} successfully created",
            "global_settings": "Global Settings",
            "do_not_reply_message": "Please do not reply to this email. We are unable to respond to inquiries sent to this address. To contact Customer Support, please visit {help_page_anchor} or send an email to {support_email}",
            "email_footer_do_not_reply": "Please don’t reply to this email. <br>Having problems? Check out",
            "form_leave_warning": "Are you sure you want to leave this screen? Changes you made have not been saved and will be lost.",
            "all_players": "All Players",
            "upsell_url": "Upsell URL",
            "member_since": "Member Since {date}",
            "last_login": "Last Login {date}",
            "last_login_heading": "Last Login",
            "log_in_as": "Login as",
            "transfer_to_academy": "Transfer to Another Academy",
            "student_transfer_warning_coaches": "Players with assigned coaches cannot be transferred. Please unassign coaches first if you want to transfer this player into another academy.",
            "search": "Search",
            "search_term_min": "The search term must be at least {min} characters.",
            "need_support": "If you think this was in error, or simply want some support, please contact us.",
            "oops": "Something went wrong. Please contact support",
            "oops_errors": "Oops, we'll need to fix up these errors",
            "oops_need_fix": "Oops, we'll need to fix up these errors:",
            "alert_validation_title": "Oops!",
            "unknown_error": "An unknown error has occurred.",
            "date": "date",
            "swing_quality": "Swing Quality",
            "dashboard": "Dashboard",
            "academies": "Academies",
            "details": "details",
            "media": "Library",
            "settings": "Settings",
            "personal_settings": "Personal Settings",
            "app_settings": "App Settings",
            "admin_tools": "Blast Admin Tools",
            "system_reports_tools": "System Reports &amp; Settings",
            "new": "new",
            "sub_domain": "Sub Domain",
            "create_academy": "Create Academy",
            "academy_not_found": "Academy not found",
            "academy_not_found_explain": "Unfortunately, we could not locate any academy at this URL.<br><br>Please try <a href=\"//blastconnect.test\">logging in from the home page</a>, or <a href=\"mailto:example@blastmotion.com\">contact support</a>.",
            "edit_academy": "Edit Academy",
            "manage_events": "Manage Events",
            "academy_settings": "Academy Settings",
            "academy_added": "Academy Added",
            "academy_edited": "Academy Edited",
            "academy_deleted": "Academy Deleted",
            "academy_unfound": "We couldn't find your academy. If you aren't sure of your academy's address, we can <a href=\"#\" class=\"find-academy\">help you find it</a>.",
            "choose_academy": "Choose an academy",
            "change_academy": "Change Academy",
            "search_for_academy_or_event": "Search for Academy or Event",
            "upcoming": "Upcoming",
            "past": "Past",
            "camps_and_events": "Camps & Events",
            "you_will_be_able_to_access_this_event_on_the_day_that_it_begins": "You'll be able to access this event on the day that it begins.",
            "email_unfound": "We couldn't find <em>{email}</em> in our system. Please check it for typos, or contact your academy if you think it's a mistake.",
            "email_found": "Thank you. We're sending instructions to <em>{email}</em>.",
            "form_not_found": "Could not find that form",
            "all_academies": "All Academies",
            "academy_information": "Academy Information",
            "academy_members": "Members",
            "invite_academy_members": "Invite Academy Members",
            "student_pluralize": "{count} player|{count} players",
            "available_in_pluralize": "Available in {count} {days}",
            "members": "Connections",
            "users": "Users",
            "sensors": "Sensors",
            "members_label": "Members",
            "member_unfound": "Member not found",
            "members_or_coaches": "members/Coaches",
            "member": "Member",
            "no_members": "Nobody is in your network yet.",
            "organizer": "Organizer",
            "add_student": "Add Player",
            "add_all_students": "Add All Players",
            "add_member": "Add Member",
            "add_members": "Add Members",
            "member_last_active": "Last Active",
            "bulk_member_add": "Add Members from Excel",
            "bulk_member_add_desc": "You can add many members using <a download=\"download\" href=\"{template_link}\">Excel Template</a>. After upload, you'll have the opportunity to review the information before creating any new members.",
            "no_members_bulk_upload": "No members where found in the Excel file you uploaded. Please try again.",
            "invalid_spreadsheet_bulk_upload": "We're having trouble processing the uploaded spreadsheet. It's likely an older version.  Please download the spreadsheet template below and try again.",
            "upload_xls_file_from_device": "Upload the spreadsheet from your device",
            "upload_xls_file_from_computer": "Upload the spreadsheet from your computer",
            "link_to_bulk_upload_intro": "Option 1: Add members directly on-screen",
            "link_to_bulk_upload_description": "An easy way to invite members with the click of a button.",
            "link_to_bulk_upload_label": "Let's Go",
            "bulk_intro": "Option 2: Just download, fill out and import this spreadsheet.",
            "bulk_disclaimer": "Use this option if you have multiple people who need to contribute to your list of members that need to be invited.",
            "bulk_step1": "Step 1: Download the spreadsheet and fill out your team's information",
            "bulk_step1_desc": "Download, fill out and save this spreadsheet.",
            "bulk_step2": "Step 2: Upload the completed spreadsheet, customize account details, and invite your members",
            "bulk_step2_desc": "Once completed, upload your spreadsheet, make any necessary changes and import your members.",
            "download_spreadsheet": "download spreadsheet",
            "drop_spreadsheet": "",
            "edit_member": "Edit member",
            "delete_member": "Delete member",
            "new_member": "New Member",
            "create_coach": "Create member/Coach",
            "edit_coach": "Edit member/Coach",
            "coaches_and_students": "Coaches &amp; Players",
            "coaches_and_rosters": "Coaches &amp; Rosters",
            "back": "Back",
            "submit": "Submit",
            "copy_invite_link_text": "Copy This URL To Invite Players By Email Or Social Media",
            "copy_invite_button": "Copy URL",
            "invite_players": "Invite Players",
            "invite_automatically": "Invite Automatically",
            "invite_manually": "Invite Manually",
            "roster": "Roster",
            "rosters": "Rosters",
            "your_rosters": "Your Rosters",
            "other_rosters": "Other Rosters",
            "add_roster": "Add Roster",
            "edit_roster": "Edit Roster",
            "delete_roster": "Delete Roster",
            "save_roster": "Save Roster",
            "manage_rosters": "Manage Rosters",
            "roster_name": "Roster Name",
            "my_rosters": "My Rosters",
            "message_all_rosters": "Message All Rosters",
            "assign_rosters": "Assign Rosters",
            "assigned_rosters": "Assigned Rosters",
            "unassigned_rosters": "Unassigned Rosters",
            "list_view": "List View",
            "grid_view": "Grid View",
            "successfully_added_roster": "Successfully added roster: {roster_name}",
            "successfully_edited_roster": "Successfully edited roster: {roster_name}",
            "successfully_deleted_roster": "Successfully deleted roster: {roster_name}",
            "successfully_restored_roster": "Successfully restored roster: {roster_name}",
            "players": "Player|Players",
            "add_coach": "Add Coach",
            "add_all_coaches": "Add All Coaches",
            "add_player": "Add Player",
            "manage_players": "Manage Players",
            "manage_students": "Manage Players",
            "you_are_not_assigned_to_any_rosters": "You are not assigned to any rosters.",
            "no_rosters": "You don't have any rosters yet",
            "no_rosters_desc": "Use rosters to organize your players. You can communicate directly with your rosters as well as assign practices, workouts and other events to them.",
            "no_students": "You don't have any players yet.",
            "no_students_desc": "Harness the real power of Blast Connect! Monitor your players progress over time and stay connected to ensure they remain focused and continue to improve.",
            "view_metrics": "View Metrics",
            "to_request_role_change": "To request a role change for a member (i.e. coach to admin coach), please",
            "players_invited_not_accepted": "Players who have been invited but have not signed up for Blast Connect.",
            "manage_settings": "Manage Settings",
            "timezone_changed": "It looks like your timezone has changed from your current preference of {timezone}.",
            "timezone_not_set": "It looks like your timezone has not been set. This is important to make sure we're displaying times properly for you.",
            "japanese": "Japanese",
            "english": "English (US)",
            "feedback": "Feedback",
            "product_feedback_placeholder": "Tell us about your experience and help us make {product} even better!",
            "product_feedback_explain": "Have an idea to make {product} even better? A great feature suggestion?",
            "product_feedback_thanks": "Thank you for your feedback!",
            "communicate": "Custom Forms",
            "form_builder": "Form Builder",
            "assess": "Assess",
            "message": "Message",
            "messages": "Messages",
            "new_message": "New Message",
            "messaging": "Messaging",
            "write_message": "Write a Message...",
            "send_message": "Send Message",
            "a_message": "a message",
            "toggle_navigation": "Toggle navigation",
            "skip_to_content": "Skip to content",
            "unauthorized_action": "Unauthorized Action",
            "unauthorized_subscription": "Unauthorized Subscription",
            "cancellation_unsuccessful": "Cancellation Unsuccessful.",
            "no_exercises_yet_add_one": "No exercises have been added yet. You can add one using the ",
            "workouts": "Workouts",
            "workout_name": "Workout Name",
            "workout_results": "Workout Results",
            "practice_name": "Practice Name",
            "practices": "Practices",
            "practices_lower": "practices",
            "practice_results": "Practice Results",
            "workout": "Workout",
            "practice": "Practice",
            "add_exercise": "Add Exercise",
            "add_exercises": "Add Exercises",
            "add_exercises_desc": "Start by adding your exercises into the portal. Build a library that you can use later (below) when creating workouts.",
            "edit_exercise": "Edit Exercise",
            "delete_exercise": "Delete Exercise",
            "manage_exercises": "Manage Exercises",
            "duplicate_exercise": "Duplicate Exercise",
            "existing_exercises": "Existing Exercises",
            "exercises_search": "Search Exercises",
            "save_exercise": "Save Exercise",
            "exercise_name": "Exercise Name",
            "add_workout": "Add Workout",
            "add_a_workout": "Add a Workout",
            "add_workouts": "Add Workouts",
            "add_workouts_desc": "Adding workouts is a 2-step process. Create the workout, then add exercises (that already exist in the system) to the workout.",
            "edit_workout": "Edit Workout",
            "delete_workout": "Delete Workout",
            "manage_workouts": "Manage Your Workouts & Exercises",
            "existing_workouts": "Existing Workouts",
            "remove_workout": "Remove Workout",
            "workouts_search": "Search Workouts",
            "workouts_intro": "Workouts are general exercises for improving overall performance.",
            "media_file": "Media",
            "add_file": "Add File",
            "edit_file": "Edit File",
            "change_file": "Change File",
            "doing_great": "You&apos;re doing great. Keep up the good work.",
            "errors_on_form": "It Looks Like There Are Errors On This Form",
            "drill_type": "Drill Type",
            "drill_types": "Drill Types",
            "manage_existing_drills": "Manage Existing Drills",
            "existing_drills": "Existing Drills",
            "add_drill": "Add Drill",
            "add_drills": "Add Drills",
            "edit_drill": "Edit Drill",
            "add_drills_desc": "Start by adding your drills into the portal. Build a library that you can use later (below) when creating practices.",
            "exercise_search": "Search Exercises",
            "add_practice": "Add Practice Plan",
            "add_a_practice": "Add a Practice",
            "edit_practice": "Edit Practice Plan",
            "manage_practices": "Manage Your Practices & Drills",
            "existing_practices": "Existing Practice Plans",
            "remove_practice": "Remove Practice Plan",
            "add_practices": "Add Practice Plans",
            "add_practices_desc": "Adding practice plans is a 2-step process. Create the practice, then add drills (that already exist in the system) to the practice.",
            "practices_intro_part1": "are a collection of specialized",
            "practices_intro_part2": "-specific drills to enhance performance.",
            "add_organization": "Add Organization",
            "organization": "Organization",
            "organizations": "Organizations",
            "organization_unfound": "Organization Not Found",
            "organization_added": "Organization Added",
            "organization_deleted": "Organization Deleted",
            "organization_edited": "Organization Edited",
            "organization_form": "Organization Form",
            "drills_not_found_exception": "Drills for the provided region [{region}] are not found.",
            "manage_drills": "Manage Drills",
            "manage_assessments": "Manage Assessments",
            "create_custom_forms": "Create Custom Forms",
            "new_custom_form": "New Custom Form",
            "manage_schedule": "Manage Schedule",
            "manage_practice_builder": "Manage Practice Builder",
            "manage_workout_builder": "Manage Workout Builder",
            "manage_media": "Manage Library",
            "website": "Website",
            "system_tools": "System Tools",
            "utilities_explain": "A collection of administrative tools.",
            "server_information": "Server Information",
            "server_information_explain": "Information about this server's configuration.",
            "server_logs": "Server Logs",
            "data_viewer": "Data Viewer",
            "member_type": "Member Type",
            "level_of_play": "Level Of Play",
            "jan": "Jan",
            "feb": "Feb",
            "mar": "Mar",
            "apr": "Apr",
            "may": "May",
            "jun": "Jun",
            "jul": "Jul",
            "aug": "Aug",
            "sep": "Sep",
            "oct": "Oct",
            "nov": "Nov",
            "dec": "Dec",
            "month": "Month",
            "day": "Day",
            "day_s": "day(s)",
            "year": "Year",
            "static_pages": "Static Pages",
            "add_static_page": "Add Static Page",
            "edit_static_page": "Edit Static Page",
            "no_pages_for": "There are no static pages for ",
            "static_page_name": "Page Name",
            "static_page_slug": "Page Slug",
            "static_page_content": "Contents",
            "static_page_restored": " restored",
            "static_pages_summary": "Static pages are additional pages of content for your academy. They only contain static content, and are ideal for sharing resources with your network. To have them added to your academy's menu, <a href=\"{support_link}\">contact support</a>.",
            "open_in_new_window": "Open in new tab or window",
            "page_slug_explain": "The <em>Page Slug</em> will be part of the URL",
            "page_slug_already_used": "This slug is already used by other pages in your academy. Please select another one.",
            "set_as_organization_page": "Make page available to all academies within {organization}",
            "page_belongs_to_org": "This page belongs to {organization}. Please contact a Blast Admin to edit it.",
            "overlapping_static_pages": "You have a page with the same slug as an organization page. Your page will take precedence over the organization page. If you want to use the organization page, you can delete your page. If you want to keep both, you can rename your page.",
            "nav_academy": "Academy",
            "nav_members": "Members",
            "nav_skills": "Skills",
            "nav_admin_only": "Blast Admin Only",
            "size_recommendation_320_50": "Recommended 320px x 50px. Different sizes work, but may not look optimal.",
            "size_recommendation_1140_300": "Recommended 1140px x 300px. Different sizes work, but may not look optimal.",
            "phone_required_reason": "A customer support representative may contact you to assist in setting up your Blast Connect Academy.<br><br>Note: International numbers require a + sign at the beginning.",
            "select_image": "Select image",
            "change": "Change",
            "camp": "Event",
            "camps": "Events",
            "camp_name": "Event Name",
            "add_camp": "Add Event",
            "edit_camp": "Edit Event",
            "camp_start": "Event Start",
            "camp_end": "Event End",
            "camp_duration": "Event Duration",
            "camp_location": "Event Location",
            "camp_description": "Event Description",
            "camp_location_placeholder": "You can provide information about where to park, how to find the field, etc.",
            "camp_description_placeholder": "An optional description of your event.",
            "external_id": "External ID",
            "event_added_longer": " created. Select your new event from the list below to invite players and coaches.",
            "no_camps": "No events are set up. Add one above.",
            "validate_event_coach_exists": "Please create an account for this Coach or Admin Coach user in your primary academy in order to invite this coach to your event.",
            "validate_event_coach_in_parent_error": "The user {email} is not a coach in your primary academy. Please create a new Coach or Admin Coach account with a different email address in your primary academy before inviting this user to your event.",
            "events_end_date": "event's end date",
            "invalid_subscription_canadian": "Sorry, your subscription is not valid. Please complete your subscription information. <p>If you believe this is an error, please contact customer service.</p> <p>Customer Service: +1-855-632-5278<br>Hours: 7 AM – 5 PM Pacific time</p>",
            "get_quick_overview": "Get a quick overview of your latest swings then dig deeper into the metrics.",
            "no_dashboard_sessions": "{name} have any sessions.",
            "baseball_create_session": "If you have the Blast Baseball App &amp; Sensor, create a new session and start swinging.",
            "softball_create_session": "If you have the Blast Softball App &amp; Sensor, create a new session and start swinging.",
            "golf_create_session": "If you have the Blast Golf App &amp; Sensor, create a new session and start swinging.",
            "baseball_learn": "Want to learn more about the Blast Baseball App?",
            "softball_learn": "Want to learn more about the Blast Softball App?",
            "golf_learn": "Want to learn more about the Blast Golf App?",
            "learn_more_baseball": "Learn more about the Blast Baseball App",
            "learn_more_softball": "Learn more about the Blast Softball App",
            "learn_more_golf": "Learn more about the Blast Golf App",
            "meantime_familiarize": "In the meantime, familiarize yourself with some key metrics and important drills.",
            "more_metrics": "More Metrics & Drills",
            "your_players_no_swings": "{name} players haven't taken any swings with a Blast Sensor yet.",
            "students_metrics_appear_here": "{name} players' lastest swing metrics will appear here.",
            "know_when_training": "Know when {name} next training session is happening.",
            "see_recent_training": "Keep track of {name} recent training sessions.",
            "upcoming_workouts_appear": "Upcoming workouts that have been assigned to {name} will appear here.",
            "upcoming_practices_appear": "Upcoming practices that have been assigned to {name} will appear here.",
            "recent_workouts_appear": "Recently completed workouts will appear here.",
            "recent_practices_appear": "Recently complted practices will appear here.",
            "your_players_no_workouts": "{name} players have not completed any workouts yet.",
            "completed_workouts_assigned_appear_here": "Completed workouts that {name} {have} assigned will appear here.",
            "your_players_no_practices": "{name} players have not completed any practices yet.",
            "completed_practices_assigned_appear_here": "Completed practices that {name} {have} assigned will appear here.",
            "you_have_not_completed_assessments": "{name} {have} not completed any assessments yet.",
            "completed_assessments_appear_here": "Completed assessments that have been assigned to {name} will appear here.",
            "your_players_have_not_completed_assessments": "{name} players have not completed any assessments yet.",
            "completed_assessments_assigned_appear_here": "Completed assessments that {name} {have} assigned will appear here.",
            "go_ahead_upload": "Go ahead &mdash; upload, analyze and share your own files from your Blast App, or directly from your computer.",
            "analyze_share": "Once you've uploaded a file, analyze it, and share it.",
            "calendar": "Calendar",
            "calendar_enabled": "Calendar Enabled",
            "academy_access_to_calendar": "Does this Academy have access to the Calendar?",
            "allow_team_metrics": "Team Report Enabled",
            "academy_access_to_team_metrics": "Does this academy have access to the Team Report",
            "blast_analytics_enabled": "Blast Analytics Enabled",
            "academy_access_to_blast_analytics": "Does this academy have access to Blast Analytics?",
            "scheduler": "Scheduler",
            "scheduler_enabled": "Scheduler Enabled",
            "academy_access_to_scheduler": "Does this Academy have access to the Scheduler?",
            "event_type": "Event Type",
            "location": "Location",
            "lesson": "Lesson",
            "lessons": "Lessons",
            "book_event": "Register",
            "registration_full": "Registration Full",
            "registration_enabled": "Allow Registration",
            "schedule": "Schedule",
            "add_event": "Add Event",
            "add_an_event": "Add an Event",
            "edit_event": "Edit Event",
            "edit_master_event": "Edit Master Event",
            "save_event": "Save Event",
            "times": "Times",
            "timess": "Time(s)",
            "repeat": "Repeat",
            "until": "Until",
            "every": "Every",
            "week": "week",
            "week_s": "week(s)",
            "month_s": "month(s)",
            "year_s": "year(s)",
            "each": "それぞれ",
            "on_the": "On the",
            "looks_like_an_easy_week": "It looks like an easy <span class=\"cal-view\">week</span>. A little too easy...",
            "upcoming_events_appear_here": "Upcoming workouts, practices, lessons and other events will appear here.",
            "no_customization": "No Customization",
            "specific_days": "Specific Day(s)",
            "day_of_the_week": "Day of the Week",
            "price": "Price",
            "assign_members": "Assign Members",
            "assigned_members": "Assigned Members",
            "unassigned_members": "Unassigned Members",
            "max_registrants": "Max Registrants",
            "max_registrants_helper": "Leave blank for unlimited",
            "max_registrants_placeholder": "ie: 10",
            "add_students": "Add Players",
            "add_coaches": "Add Coaches",
            "assign_students": "Assign Players",
            "assigned_students": "Assigned Players",
            "remove_all_students": "Remove All Players",
            "unassigned_students": "Unassigned Players",
            "max_students": "Max Players",
            "cancellation_date": "Cancel Policy",
            "cancellation_date_helper": "Specify a timeframe, before the event begins, where participants can no longer cancel.",
            "only_edit_recurring_dates": "You can only edit the dates of a recurring event.",
            "recurring_event_change_future_dates": "This is a recurring event. Do you want to change all future dates as well?",
            "change_future_dates": "Yes, Change all future dates.",
            "cancelled": "Cancelled",
            "cancelled_members": "Cancelled Members",
            "marked_cancelled": "You marked yourself as not attending this event.",
            "marked_cancelled_contact": "Contact <a href=\"mailto:{email}\">{name}</a> if you wish to attend.",
            "attending": "Attending",
            "no_attendees": "No Attendees",
            "registered_students": "Registered Players",
            "registered_for_event": "You are registered for this event.",
            "confirm_cancel_event": "Are you sure you want to cancel this event?",
            "cancellation_period_ended": "The cancellation period has ended.",
            "slots": "slot|slots",
            "update_event": "Update Event",
            "changing_date_time_for": "You are changing the date/time for",
            "event_from": "From",
            "event_to": "To",
            "save_changes": "Save Changes",
            "undo_changes": "Undo Changes",
            "schedule_workout": "Schedule Workout",
            "schedule_practice": "Schedule Practice Plan",
            "days": "day|days",
            "hours": "hours",
            "successfully_deleted_event": "Successfully deleted event: {event_name}",
            "successfully_restored_event": "Successfully restored event: {event_name}",
            "event_unavailable": "This event is no longer available.",
            "loading_dots": "Loading...",
            "swing_types": {
                "all": "All Swings",
                "swings_with_impact": "Swings with Impact",
                "air_swings": "Air Swings"
            },
            "environments": {
                "all": "All Environments",
                "tee": "Tee",
                "soft_toss": "Soft Toss",
                "front_toss_overhand": "Front Toss - Overhand",
                "front_toss_underhand": "Front Toss - Underhand",
                "live_pitch": "Live Pitch",
                "pitching_machine": "Pitching Machine",
                "in_game": "In Game",
                "assessment": "Assessment",
                "general_practice": "General Practice",
                "chop_slap": "Chop Slap",
                "general_slapping": "General Slapping",
                "power_slap": "Power Slap",
                "soft_slap": "Soft Slap",
                "undefined": "Undefined"
            },
            "constraints": {
                "all_constraints": "All Constraints",
                "no_constraint": "No Constraint",
                "arm_constraint": "Arm Constraint",
                "wrist_constraint": "Wrist Constraint",
                "torso_constraint": "Torso Constraint",
                "pelvis_constraint": "Pelvis Constraint",
                "other_constraint": "Other Constraint",
                "impact_bag": "Impact Bag",
                "undefined": "Undefined"
            },
            "slapping": {
                "all": "All Slapping Types",
                "general_slapping": "General Slapping",
                "power_slap": "Power Slap",
                "chop_slap": "Chop Slap",
                "soft_slap": "Soft Slap"
            },
            "slap_type": {
                "all": "All Slapping Types",
                "general_slapping": "General Slapping",
                "power_slap": "Power Slap",
                "chop_slap": "Chop Slap",
                "soft_slap": "Soft Slap"
            },
            "pitch_type": {
                "all_pitch_types": "All Pitch Types",
                "fastball": "Fastball",
                "curveball": "Curveball",
                "slider": "Slider",
                "changeup": "ChangeUp",
                "other": "Other",
                "undefined": "Undefined"
            },
            "pitch_location": {
                "all_pitch_locations": "All Pitch Locations",
                "up_in": "Up/In",
                "up_mid": "Up/Mid",
                "up_away": "Up/Away",
                "mid_in": "Mid/In",
                "mid_mid": "Mid/Mid",
                "mid_away": "Mid/Away",
                "low_in": "Low/In",
                "low_mid": "Low/Mid",
                "low_away": "Low/Away",
                "undefined": "Undefined"
            },
            "filter_action_types": {
                "all": "All Swings",
                "swings_with_impact": "Swings with Impact",
                "air_swings": "Air Swings",
                "full_swing": "Full Swing",
                "slapping": "Slapping"
            },
            "filter_impact_types": {
                "all_swings": "All Swings",
                "swings_with_impact": "Swings with Impact",
                "air_swings": "Air Swings"
            },
            "meeting": "Meeting",
            "game": "Game",
            "practice_general": "Practice (General)",
            "event": "Event",
            "gmap_format_msg": "Must be a format accepted by Google Maps.",
            "waiver": "Waiver",
            "waiver_text": "Waiver Text",
            "waiver_required": "Waiver Required?",
            "enable_site_access_waiver_msg": "Enabling this will require all your members to accept the below waiver before they can access your site.",
            "academy_customization": "Academy Customization",
            "collections_note": "Collections will appear in the sidebar of the Library for every user in your Academy. They filter by tag, and are great for giving your players/coaches quick access to commonly used groups of files.",
            "used_on_menu_note": "空欄にするとデフォルトに戻ります。",
            "used_on_buttons_note": "ボタンと他のハイライトで使用します。空欄にするとデフォルトに戻ります。",
            "communicate_verb": "Communicate Verb",
            "default_menu_name_communicate_note": "By default 'Custom Forms' will be the name of the menu item. You can change it here. Leave blank for 'Custom Forms'.",
            "academy_configuration": "Academy Configuration",
            "internal_academy": "Blast Internal Academy",
            "internal_academy_explain": "When flagged on, {app_name} is aware that this academy is used for internal or demonstration purposes, and can be used to exclude this academy from various system reports.",
            "view_adv_settings": "View Advanced Settings",
            "adv_config_warning": "This option is for advanced configuration, and could potentially destabilize {academy_name}. Please <a href=\"{support_link}\" rel=\"external\">contact support</a> if you need assistance.",
            "got_it": "Got it",
            "enabling_this_provides_members_network": "Enabling this provides Connections.",
            "enabling_this_provides_messaging": "Enabling this provides Messages.",
            "enabling_search_in_menu_bar": "Enabling this will turn on 'search' in the menu bar.",
            "team": "Team",
            "academics_website": "Academics Website",
            "mens_coach": "Men's Coach",
            "assistant_coach": "Assistant Coach",
            "womens_coach": "Women's Coach",
            "send": "Send",
            "send_feedback": "Send Feedback",
            "no_thanks": "No thanks",
            "school": "School",
            "student_application": "Player Application",
            "application_form": "This is the application for {player}",
            "incomplete_school": "Sorry. This school has incomplete information and your application cannot be sent.",
            "can_academy_use_communicate": "Can this Academy use Custom Forms?",
            "owner_member_management": "Admin Coach Member Management",
            "can_owners_manage_members": "Can Admin Coaches in this Academy add and manage their own members?",
            "show_academy_skill_results": "Player Skill Results",
            "universal_payments_enabled": "Master Payment Source",
            "universal_payments_enabled_explain": "Enables admin coaches to save their Credit Card on file and pay for new members.",
            "new_members_recieve_email_w_login": "New members will receive an email with their login information. The new member will also need to change their password as soon as they log in for the first time.",
            "email_already_registered": "That email address is already registered.",
            "temp_password_note": "Minimum 8 characters. Password must contain at least 1 letter and 1 number. If you leave this field blank, a random password will be created for the new member.",
            "student_requires_subscription": "The player will need to sign up for a paid subscription before they will be able to access their account.",
            "you_will_need_a_subscription": "You will need a valid subscription before you can access your account. Please register here.",
            "coach_assignements": "Coach Assignment(s)",
            "assign_all_coaches": "Assign All Coaches",
            "parent_assignments": "Parent Assignment(s)",
            "parents_available": "parent(s) available",
            "students": "Players",
            "students_and_coaches": "Players and Coaches",
            "student": "player",
            "first_name": "First Name",
            "last_name": "Last Name",
            "status": "Status",
            "parents": "Parents",
            "parent": "Parent",
            "coaches": "Coaches",
            "owner": "Admin Coach",
            "owners": "Admin Coaches",
            "not_available": "Not Available",
            "no_students_in": "No players in",
            "override_default_skills": "Override Skills defaults for",
            "enter_your_score": "Enter your score",
            "default_skill_desc_notes": "Override the default title “Assessments” here. You can also add your own description, which will appear directly below the title.",
            "default_skill_desc_org": "Default skill descriptions can also be changed at the organizational level. To do this, speak with a Blast Admin.",
            "custom_skills_description": "Custom Skills Title And Description",
            "save_skill_summary": "Save Skill Summary",
            "custom_skills_assessments": "Custom Skills Assessments",
            "verified_score": "Verified Score",
            "verified_scores_are": "Scores you enter for yourself or your players are \"verified\" scores.",
            "org_skill_edit_delete": "Organizational skills cannot be edited or deleted. For assistance, please contact {email}",
            "add_custom_skill": "Add Custom Skill",
            "title": "Title",
            "change_title": "Change Title",
            "description": "Description",
            "scoring_type": "Scoring Type",
            "scoring_range": "Scoring Range",
            "between": "Between",
            "score": "score",
            "no_associated_custom_skills_default": "has no assessments.",
            "assign_coaches": "Assign Coaches",
            "remove_all_coaches": "Remove All Coaches",
            "assign_parents": "Assign Parents",
            "academy_region": "Region",
            "academy_region_explain": "Academy's region",
            "academy_region_us": "United States",
            "academy_region_jp": "Japan",
            "baseball_only": "Baseball Only",
            "academy_logo": "Academy Logo",
            "api_access": "API Access Enabled",
            "api_access_explain": "Can users have access to academy by external API.",
            "import_coach_schedule": "Import Coach Schedule",
            "import_coach_schedule_note": "Upload custom Excel schedule file.",
            "domains_academy_is_not_found": "Academy, provided in the sub-domain has not been found.",
            "name": "Name",
            "domain": "Domain",
            "national": "National",
            "subscription": "Subscription",
            "subscriptions": "Subscriptions",
            "subscription_cancel": "Cancel Subscription",
            "allow_invites": "Allow Invites",
            "allow_invites_explain": "Can this academy invite new members?",
            "allow_public_registration": "Allow Public Registration",
            "allow_public_registration_explain": "The log in screen will feature a <em>Register Now</em> link, and allow anyone to join.",
            "blast_require_subscription": "Subscription Required",
            "blast_require_subscription_explain": "If enabled, players will need a valid Stripe subscription to access {academy_name}.",
            "enforce_licensed_seats": "Enforce licensed seats",
            "enforce_licensed_seats_explain": "If this setting is toggled ON, then the app shall enforce the licensed seat limits.",
            "your_subscription": "Your Subscription Plan",
            "subscription_valid": "Valid",
            "subscription_invalid": "Invalid",
            "subscription_na": "Not Applicable",
            "subscription_unknown": "Unknown",
            "subscription_information_heading": "Subscription Information",
            "subscription_status": "Status",
            "subscription_period": "Period",
            "subscription_change": "Change Your Subscription",
            "subscription_update_payment_info": "Update Payment Information",
            "new_credit_card": "Update Your Credit Card Information",
            "credit_card_information": "Your Credit Card Information",
            "subscription_update_card": "Update Credit Card",
            "subscription_update_subscription_heading": "Update Instructions",
            "subscription_update_subscription_message": "If you would like to change or update any information for your subscription. Please contact customer service.",
            "subscription_not_available_heading": "Not available at the moment",
            "subscription_not_available_message": "Your account has not been registered as a subscription yet. Coaches and Admin Coaches do not need valid subscriptions to access {appName}.",
            "subscription_not_needed_message": "{user_types} do not require subscriptions to access {appName}. Your players will have the option to pay for their subscription from this tab.",
            "billing_customer_service": "Billing Customer Service",
            "account_cancelled": "Account Cancelled",
            "card_not_visible": "Your card number will not be visible.",
            "contact_location_name_blast_california": "Carlsbad California",
            "contact_location_name_blast_canada": "Toronto Canada",
            "settings_general_heading": "General",
            "notifications_academy_heading": "Academy Updates",
            "notifications_messages_content_heading": "Messages and Content Sharing",
            "notifications_updates_from_blast": "Updates from Blast Motion",
            "assessment_enabled": "Enable Assessments",
            "assessment_enabled_explain": "Enable Assessment usage for this academy",
            "allow_coaches_to_manage_assessments": "Allow Coaches to manage Assessments",
            "allow_coaches_to_manage_assessments_explain": "Allow Coaches in this academy to manage Assessments",
            "camps_enabled": "Events Enabled",
            "camps_enabled_explain": "Allow this Academy to create Events",
            "blast_subscription_cancelled": "Blast Connect Subscription Cancelled",
            "seats": "Seats",
            "capacity": "Capacity",
            "sales_rep": "Sales Rep",
            "account_manager": "Account Manager",
            "renewal_price": "Renewal Price",
            "member_options": "Member Options",
            "manage_coaches": "Manage Coaches",
            "suspend_account": "Suspend Account",
            "block_access": "Block Access",
            "suspended": "Suspended",
            "reinstate_account": "Reinstate Account",
            "resend_invitation": "Resend Invitation",
            "manage_subscription": "Manage Subscription",
            "activate": {
                "yes_suspend": "Yes, suspend",
                "yes_block_access": "Yes, Block Access",
                "yes_reinstate": "Yes, reinstate",
                "no_go_back": "No, go back",
                "confirm_suspend": "Are you sure you want to suspend this account?",
                "confirm_suspend_description": "This will not delete the user's account, however the user will not be able to access their account until it has been reinstated.",
                "confirm_reinstate": "Are you sure you want to reinstate this account?",
                "confirm_block": "<b>Are you sure you want to block <span class=\"blockUserFullName\"></span> from accessing this account?</b>",
                "confirm_block_description": "This will not delete the the account, and it will not change the subscription.",
                "confirm_block_description_subscription": "The person paying for <b>this account will continue to be charged</b>.<br /><br /> If you want to make changes to <span class=\"blockUserFullName\"></span>’s subscription, select Manage Subscription from the same menu.",
                "confirm_block_description_ending": "<br /><br /> <span class=\"blockUserFirstName\"></span> will not be able to access this account until it has been reinstated."
            },
            "account_blocked": "Account blocked. {fullName} can no longer access their account. Select “Reinstate Account” to unblock access.",
            "invitation_unavailable": "Invitation Accepted",
            "invitation_unavailable_explain": "This invitation appears to have already been accepted. You can simply <a href=\"/login\">log in</a> now.",
            "invitation_expired": "Invitation Expired",
            "invitation_expired_explain": "Unfortunately, that invitation expired {exp_date}.",
            "no": "No",
            "in": "in",
            "courses": "Courses",
            "course": "Course",
            "manage_academies": "Manage Academies",
            "academy_delete_warning": "Academies must have no members to be deleted.",
            "force_statistic_updates_for": "Force Statistic Updates for",
            "recalculate_statistics_note": "Recalculates statistics for every member of the academy (in 10 person increments). May take awhile, let it run. Each button needs to be hit, recommend you let each one run, then do the next.",
            "refresh_statistics": "Refresh Statistics",
            "stats": "Stats",
            "last_active": "Last Active",
            "files": "Files",
            "storage": "Storage",
            "sport": "Sport",
            "locator": "Locator",
            "no_files_uploaded_with": "No files uploaded with",
            "no_public_scores_entered": "No public scores have been entered. Be the first!",
            "skills_tests": "Skills Tests",
            "enter_scores": "Enter Scores",
            "enter_score": "Enter Score",
            "results": "Results",
            "result": "Result",
            "active_assessments": "Active Assessments",
            "how_to_play": "How to play",
            "sorry": "Sorry",
            "has_not_set_up_skills": "has not set up any {skills_term} at this time.",
            "preventing_video_load_warning": "Yikes! Sorry, something is preventing this video from loading.",
            "overall": "Overall",
            "academy_average_grade": "Academy Average Grade",
            "national_average_grade": "National Average Grade",
            "my_recent_score": "My Most Recent Score",
            "scores": "Scores",
            "my_scores": "My Scores",
            "currently_viewing_results_for": "Filter By",
            "academy_average": "Academy Average",
            "national_average": "National Average",
            "leaderboard": "Leaderboard",
            "grade": "Grade",
            "below_average": "Below Average",
            "average": "Average",
            "above_average": "Above Average",
            "avg": "Avg",
            "high": "High",
            "low": "Low",
            "skills": "Skills",
            "high_to_low": "High to Low",
            "low_to_high": "Low to High",
            "assessment": "Assessment",
            "assessments": "Assessments",
            "your_assessments": "{name} Assessments",
            "assessment_view": {
                "measurements": {
                    "": "",
                    "types": {
                        "length": "Length",
                        "speed": "Speed",
                        "weight": "Weight",
                        "time": "Time",
                        "number": "Score"
                    }
                },
                "labels": {
                    "assessments": "Assessments",
                    "scoring": "Scoring",
                    "score": "Score",
                    "add_result": "Add Result",
                    "edit_result": "Edit Result",
                    "delete_result": "Delete Result",
                    "date": "Date",
                    "time": "Time",
                    "your_scores": "Your Scores",
                    "leaders": "Leaders",
                    "view_results": "View Results",
                    "name": "Name",
                    "description": "Description",
                    "category": "Category",
                    "measurement_type": "Measurement Type",
                    "status": "Status",
                    "create_assessment": "Create Assessment",
                    "academy_leaderboard": "Academy Leaderboard",
                    "organization_leaderboard": "Organization Leaderboard",
                    "result_limited_to": "Between {min} & {max}",
                    "result_limited_to_min": "Minimum {min}",
                    "result_limited_to_max": "Maximum {max}",
                    "best": "Best",
                    "last": "Last",
                    "rank": "Rank",
                    "out_of": "Out of",
                    "customize_assessment_page": "Customize",
                    "select_student_or_roster": "Select a Player or a Roster to view results.",
                    "members": "Members",
                    "all_members": "All Members",
                    "members_without_result": "Members without results",
                    "has_not_participated_yet": "This member has not participated yet."
                },
                "messages": {
                    "no_assessments_available": "{academy_name} currently has no assessments.",
                    "go_ahead_create": "Go ahead and create an assessment by clicking the + button.",
                    "assessment_created": "{assessment_name} was created successfully",
                    "assessment_updated": "{assessment_name} was updated successfully",
                    "assessment_deleted": "{assessment_name} was removed successfully {undo_link}",
                    "assessment_restored": "{assessment_name} was restored successfully",
                    "yourself": "yourself",
                    "result_added": "Result was successfully added.",
                    "result_updated": "Result was successfully updated.",
                    "result_deleted": "Result was successfully removed. {undo_anchor}",
                    "result_restored": "Result was successfully restored.",
                    "assessments_edited": "Assessments Edited",
                    "result_delete_confirmation": "Are you sure you want to delete this result?",
                    "loading_results": "Loading results..."
                },
                "buttons": {
                    "manage_assessments": "Manage Assessments",
                    "team_report": "Team Report",
                    "add_score": "Add Score",
                    "details": "Details",
                    "instructions": "Instructions",
                    "add_file": "Add File",
                    "add_detail": "Add Detail",
                    "edit_file": "Edit File",
                    "edit_detail": "Edit Detail",
                    "view_assessments": "View Assessments"
                }
            },
            "save_custom_settings": "Save Custom Settings",
            "customize": "Customize",
            "category": "Category / Tab Title",
            "categories": "Categories",
            "manage_categories": "Manage Categories",
            "assess_category_description": "The category assigned here determines the tab that the assessment is positioned under.",
            "show_leaderboard": "Player Leaderboard To Players?",
            "video_or_image": "Video or Image",
            "unit_of_measure": "Unit of Measure",
            "value_decimal": "Value Decimal Places",
            "set_max_low_limits": "Set maximum high and low score limits",
            "what_scoring_objective": "What is the scoring objective for this assessment?",
            "outcome_high": "High",
            "outcome_low": "Low",
            "outcome_target": "Target Score",
            "outcome_target_range": "Target Range",
            "outcome_none": "None",
            "outcome_disable_leaderboard": "This will disable the leaderboard and scores will be sorted by date.",
            "score_limits": "Limits",
            "add_score": "Add Score",
            "add_a_score": "Add a Score",
            "add_your_score": "Add your score",
            "categories_desc": "Categories determine the tabs that appear at the top of the Assessments screen. You can then assign assessments to a category.",
            "back_to_assessments": "Back to Assessments",
            "view_assessments": "View Assessments",
            "view_active_assessments": "View Your Active Assessments",
            "advanced_options": "Advanced Options",
            "no_categories": "No categories or assessments have been set up yet.",
            "no_assessments_category": "No assessments have been added to this category yet.",
            "no_assessments_categories": "There are no assessment categories yet. Click Manage Assessments and add an assessment category.",
            "problem_saving_category": "There was a problem saving the category. Please try again.",
            "if_problem_persists": "If problem persists, please contact customer support.",
            "outcome_options_disabled": "Editing of scoring options has been disabled because people have already submitted scores for this assessment.",
            "select_at_least_one_student": "Select at least 1 player or roster to see results.",
            "date_filter": "Date Filter",
            "no_one_has_participated": "No one has participated yet. Enter a score!",
            "select_student_to_view_results": "Select a player or a roster to view some results.",
            "participate_first": "Be the first to participate!",
            "student_not_participated": "{name} has not participated yet.",
            "students_not_completed": "You and your players have not completed this assessment yet.",
            "personal_best": "Personal Best",
            "academy_best": "Academy Best",
            "verified": "Verified",
            "add_category": "Add Category",
            "wi_analysis_winning_identity": "Video Analysis",
            "panels": "Panels",
            "media_nav": "Media",
            "cloud": "Cloud",
            "loading": "loading",
            "all": "All",
            "tool_guide": "Tool Guide",
            "close": "Close",
            "chrome_required": "Google Chrome Browser Required",
            "no_browser_support_screen_audio_recording": "The browser you are currently using does not support screen &amp; audio recording.",
            "recording_use_dl_chrome": "To use screen &amp; audio recording, please <a href=\"http://www.google.com/chrome/\" target=\"_blank\">download and use Google Chrome</a>.",
            "analysis_extension_required": "Analysis Extension Required",
            "screen_capture_extension_note": "Please make sure our Analysis Screen Capture Extension is installed in your browser and its enabled.",
            "chrome_extension": "Chrome Extension",
            "install": "Install",
            "analysis_view": {
                "ver2": {
                    "modal": {
                        "headers": {
                            "initializing": "Initializing...",
                            "loading": "Loading",
                            "stopped_recording": "You have stopped recording",
                            "save_to_library": "Save to Library",
                            "uploading": "Uploading",
                            "saved": "Saved",
                            "where_should_be_placed": "Where should this be placed?",
                            "processing": "Processing...",
                            "chrome_extension": "We're sorry, but the Video Analysis tool is not supported by your web browser."
                        },
                        "messages": {
                            "annotation_saved": {
                                "before_file_name": "Your video annotation",
                                "after_file_name": "has been saved to your library."
                            },
                            "select_panel_to_replace": "You're currently using both panels to compare media. Select which panel you'd like to place this file into.",
                            "unable_install_chrome_ext": "Unfortunately, Google has decided to no longer support custom Chrome apps, so our Blast Video Analysis Tool can no longer be installed.  Mobile Video Analysis is available within the iOS Blast Baseball, Blast Softball, and Blast Golf apps, though.",
                            "grant_permission": "Please select the area of your screen that you'd like to record using the icon to the left of your address bar."
                        },
                        "labels": {
                            "file_name": "File Name",
                            "description": "File Description",
                            "share_with": "Share With",
                            "tags": "Tags",
                            "left": "Left",
                            "right": "Right"
                        },
                        "buttons": {
                            "save_to_library": "Save to Library",
                            "download": "Download",
                            "discard": "Discard",
                            "save": "Save",
                            "back": "Back",
                            "ok": "OK",
                            "select": "Select",
                            "cancel": "Cancel",
                            "close": "Close",
                            "refresh": "Refresh",
                            "install": "Install",
                            "view_in_library": "View In Library"
                        }
                    },
                    "heading": {
                        "panel_list": "Media Currently Loaded",
                        "select_another_file": "Select Another File"
                    },
                    "messages": {
                        "empty_panel": "No media is currently loaded. Get started!"
                    },
                    "alerts": {
                        "types": {
                            "warning": "Warning!"
                        },
                        "not-recording": "Drawings will not be saved unless you're recording your annotations."
                    },
                    "buttons": {
                        "compare": "COMPARE",
                        "add_image_video": "Add an Image or Video",
                        "options_tools": {
                            "overlay": "Overlay",
                            "grid": "Grid",
                            "mirror": "Mirror",
                            "rotate": "Rotate",
                            "zoom_in": "Zoom In",
                            "zoom_out": "Zoom Out",
                            "reset": "Reset"
                        }
                    },
                    "tooltips": {
                        "tools": {
                            "move_tool": "Move",
                            "dot_tool": "Dot",
                            "line_tool": "Line",
                            "circle_tool": "Circle",
                            "rectangle_tool": "Rectangle",
                            "brush_tool": "Brush",
                            "arrow_tool": "Arrow",
                            "angle_tool": "Angle",
                            "color_tool": "Color",
                            "colors": {
                                "yellow": "Yellow",
                                "red": "Red",
                                "green": "Green",
                                "purple": "Purple",
                                "white": "White"
                            },
                            "record_tool": "Record",
                            "media": {
                                "backward": "Step Backward",
                                "backward10": "Step Backward x10",
                                "play": "Play",
                                "pause": "Pause",
                                "forward": "Step Forward",
                                "forward10": "Step Forward x10",
                                "stop": "Stop",
                                "loop": "Loop",
                                "all": "(all)"
                            },
                            "cue_tool": "Add a tag",
                            "option_tool": "More Options",
                            "panel": {
                                "hide": "Hide media",
                                "undo": "Undo",
                                "clear": "Clear All"
                            },
                            "layer": {
                                "layer_number": "Layer Number",
                                "hide_show": "Player/Hide",
                                "remove_layer": "REMOVE OVERLAY"
                            }
                        }
                    },
                    "panel_labels": {
                        "left": "Left Panel",
                        "right": "Right Panel",
                        "single": "Active Panel"
                    }
                }
            },
            "zoomed": "It looks like your browser is zoomed",
            "reset_zoom": "You will need to reset your browser zoom level to continue.",
            "chrome": "Chrome",
            "firefox": "Firefox",
            "zoom_menu_instructions_chrome": "Select <em>View</em> and select <em>Actual Size</em>",
            "zoom_key_instructions_chrome": "Hold <em>Ctrl / Command + 0</em> on your keyboard.",
            "zoom_menu_instructions_firefox": "Select <em>View > Zoom</em> and select <em>Reset</em>",
            "zoom_key_instructions_firefox": "Hold <em>Ctrl / Command + 0</em> on your keyboard.",
            "communicate_form_not_found": "Could not find that form",
            "communicate_response_not_found": "Response not found.",
            "communicate_response_not_found_message": "Sorry, we are unable to locate that response. Please contact us for further assistance.",
            "communicate_permission_denied": "Permission Denied",
            "communicate_permission_denied_message": "You don't have permission to edit this response. If you think this is an error, please contact support.",
            "communicate_problem_locating_account": "Problem Locating Account",
            "communicate_problem_locating_account_message": "Sorry, we could not locate the account you should be associated with. Please contact us for further assistance.<br><small>Error: 42-5</small>",
            "communicate_organizational_form_title": "Organizational Form",
            "communicate_organizational_form_message": "This form has been setup as an organizational form by {academy_name}. Please ask a Blast Admin to edit it on your behalf. Thank you.",
            "communicate_invalid_notify_emails": "An Invalid email was found in your notification list",
            "communicate_answeree_message_title_edited": "{first_name} {last_name} ({email}) edited the Form {form_name}",
            "communicate_answeree_message_title_answered": "{first_name} {last_name} ({email}) answered the Form {form_name}",
            "communicate_by_coach_on_behalf_of_student": "* Submitted by a coach on this player's behalf",
            "communicate_email_problem": "Problem sending email",
            "communicate_email_problem_message": "Sorry, there was a problem sending the email. Please contact us for further assistance.",
            "communicate_thank_for_edited": "Thanks! {form_name} edited.",
            "communicate_thank_for_answered": "Thanks! {form_name} answered.",
            "communicate_form_response_not_found": "Could not find the Form the response is associated with.",
            "communicate_response_deleted": "Response Deleted ",
            "communicate_form_deleted": "Form Deleted ",
            "communicate_form_delete_confirmation": "Permanently Remove {form_name}?",
            "response_deleted": "Response Deleted",
            "response_restored": "Response Restored",
            "could_not_find_form": "Could not find that form",
            "permission_denied": "Permission Denied. Please contact us if you feel this is an error.",
            "form_name": "Form Name",
            "short_name": "Short Name",
            "short_name_help": "If your form name is too long for the menu, you can specify a shorter name.",
            "menu_placement": "Menu Placement",
            "add_to_improve_menu_note": "Add this form to the bottom of the 'Train' menu, below the existing menu options.",
            "add_to_analyze_menu_note": "Add this form to the bottom of the 'Analyze' menu, below the existing menu options.",
            "add_to_main_menu_note": "Add this form to main menu. If more than one form are on the menu, they will be added to a dropdown menu entitled ",
            "not_on_menu_go_to_communicate_option": "This form will not be available on the menu. It will only be available by visiting the 'Communicate' option from the profile dropdown in the upper right.",
            "communicate_menu": "Custom Form Menu",
            "form_avail_on_communicate_menu": "Form will be available from the 'custom forms' menu.",
            "add_question": "Add Question",
            "questions": "Questions",
            "question": "Question",
            "question_type": "Questions Type",
            "required": "Required",
            "hidden": "Hidden",
            "undo_delete": "Undo Delete",
            "add_questions_w_add_field": "Add questions to your form with \"Add Field\" above.",
            "form_settings": "Form Settings",
            "who_can_answer_this_form": "Who can answer this form?",
            "parent_accts_cant_respond_to_forms": "<em>'Parent'</em> account types cannot respond to forms, including required forms.",
            "coaches_on_behalf_of_students": "Coaches on behalf of their Players",
            "who_sees_responses_for_form": "Who can see responses for this form?",
            "and_parents": "(and parent accounts if applicable)",
            "required_form": "Required Form",
            "required_form_to_access_site_note": "When a member logs in, if they haven't filled in a required form, they will be forced to do so before they can access the site.",
            "respond_limit": "Response Limit",
            "respond_limit_explanation": "The limit to the number of times a user who have access can respond to this form. (leave blank or 0 for unlimited)",
            "show_form_on_timeline": "Player Form on Timeline",
            "timeline_updated": "Timeline Updated",
            "answered_forms_show_on_timeline": "When this form is answered, it will show up on the user's timeline. Forms answered by coaches on behalf of players will show on the player's timeline.",
            "yes": "Yes",
            "form_placed_in_every_academy_in_the": "This form will be placed in every academy in the",
            "network": "network",
            "academy_owners_cannot_change_forms": "Admin coaches will not be able to edit or remove these forms.",
            "save_form": "Save Form",
            "type": "Type",
            "255_character_max": "255 Characters maximum please",
            "how_was_our_service": "How was our service?",
            "instructions": "Instructions",
            "instructions_accompany_form_note": "Any instructions or explanations entered here will accompany the form when its visited.",
            "optional_summary_extras": "Optional long form summary, or any extra information you want to add.",
            "possible_answers": "Possible Answers",
            "one_answer_per_line": "One answer per line.",
            "question_cannot_be_unanswered": "(This question cannot be left unanswered.)",
            "qm": "?",
            "hidden_fields_not_available_for_users": "Hidden fields will <strong>not</strong> be available to your users. It should be used when you want a question removed from an existing form that already has responses.",
            "update_question": "Update Question",
            "appears_invalid": "appears invalid. If you add the form with this, it will cause instability and prevent users from using the system.",
            "see_submitted_responses": "See Submitted Responses",
            "logout_return_later": "Log Out and Return Later",
            "answer_self_or_behalf_of_student": "You can answer for yourself, or on behalf of a player.",
            "disabled_answer_self_or_behalf_of_student": "The following players have reached their response limit",
            "students_see_responses_on_their_behalf": "Players will be able to see the responses you enter on their behalf if they are allowed to see the form. (Forms can be set to 'coaches only')",
            "no_media_available_add_some": "No media available. You can add some",
            "from_library": "from your library",
            "or": "OR",
            "save": "Save",
            "publish": "Publish",
            "required_lower": "required",
            "question_lower": "question",
            "questions_lower": "questions",
            "must_be_answered": "must be answered",
            "communicate_response_limit": "Response Limit",
            "communicate_response_limit_explanation": "The number of times a user can respond to this form. \"0\" allows for unlimited responses.",
            "communicate_your_limit": "Your response limit:",
            "create_form": "Create Form",
            "see_responses": "See Responses",
            "answer": "Answer",
            "no_custom_forms_for": "No custom forms for",
            "no_responses_logged": "There aren't any responses logged for this form.",
            "back_to_communicate": "Back to Custom Forms",
            "export_to_excel": "Export to Excel",
            "export_to_pdf": "Export to PDF",
            "uc_date": "Date",
            "no_repsonse_edit_permission": "You don't have permission to edit this response.",
            "no_repsonse_delete_permission": "You don't have permission to delete this response.",
            "no_responses": "No Responses",
            "indicate_coach_submits_student_form_note": "Indicates a coach submitted the form on a player's behalf.",
            "no_questions_added_to_form": "No questions added to this form",
            "submitted_by_coach": "submitted by their coach",
            "generate_report": "Generate Report",
            "print": "Print",
            "export": "Export",
            "csv": ".CSV",
            "save_as_pdf": "Save as PDF",
            "save_as_csv": "Save as CSV",
            "save_as_excel": "Save as Excel",
            "save_full_team_report_excel": "Save Full Team Report - Excel",
            "save_full_team_report_csv": "Save Full Team Report - CSV",
            "you_must_select_a_session_first": "You must select a session first.",
            "the_sessions_you_selected_were_not_created_by_you_and_cannot_be_deleted": "The session you selected was not created by you and cannot be deleted. | The sessions you selected were not created by you and cannot be deleted.",
            "cannot_locate_deleted_file": "Cannot locate this file. It appears to have been deleted.",
            "submitted": "Submitted",
            "your_average": "Your Average",
            "student_average": "{name} Average",
            "continue_to_site": "Continue to Site",
            "timeline": "Timeline",
            "golf_channel_news_archive": "Golf Channel - News Archive",
            "news": "News",
            "just_now": "Just Now",
            "wrote_on_timeline": "wrote on their own Timeline",
            "write_to_your_timeline": "Write to your Timeline",
            "welcome_to": "Welcome to",
            "youve_begun_a_journey": "{user_first_name}, you've begun a journey to better {sport} with access to the world's top professionals.",
            "lets_get_started": "Let's get started!",
            "get_started": "Get Started",
            "welcome_video": "Overview Video",
            "update_profile": "Update your Profile",
            "profile": "Profile",
            "provide_name_and_image": "Providing your name and image will make communicating with your coaches a lot easier.",
            "in_upper_right_corner_choose": "In upper right corner choose",
            "my_profile": "My Profile",
            "where_you_can_upload_media": "Where you can upload media",
            "menu": "Menu",
            "insights": "Insights",
            "training": "Training",
            "analyze": "Analyze",
            "analyzed": "Analyzed",
            "metrics_amp_reports": "Metrics &amp; Reports",
            "media_library": "Media Library",
            "video_analysis": "Video Analysis",
            "workouts_amp_practices": "Workouts &amp; Practices",
            "training_center": "Training Center",
            "metric_definitions": "Metric Definitions",
            "improve": "Improve",
            "check_out_your": "Check out your",
            "try_one_of": "Try one of",
            "default": "default",
            "test_your_skills_on_the": "Test your skills on the",
            "skills_tracker": "Skills Tracker",
            "and_see_where_you_rank": "and see where you rank!",
            "your_a_game": "Your A Game",
            "follow_the_progress_of_your": "Follow the progress of your",
            "friends_and_fellow_competitors": "friends and fellow competitors",
            "in_the_upper_right_corner": "in the upper right corner",
            "with_your_academy_custom_forms_available": "with your Academy. You may have custom forms available to you.",
            "record_round_of": "Record a round of {sport}",
            "or_two": "Or two! The data you enter will begin to give you an incredibly detailed look at your game.",
            "play": "Play",
            "explore_minds": "Explore! You have access to some of the best {sport} minds in the world.",
            "skip_for_now": "Skip for now",
            "dont_show_me_this_again": "Don't show me this again",
            "with_your_academy_may_have_custom_forms_available": "with your Academy. You may have custom forms available.",
            "complete_your_profile": "Complete Your Profile",
            "manage_your_profile": "Manage Your Profile",
            "profile_strength": "Your Profile Strength",
            "of": "of",
            "your_best_metrics": "Your Best Metrics",
            "view_your_metrics": "View Your Metrics",
            "announcement": "Announcement",
            "profile_complete": "{name} profile is {complete}% complete.",
            "update_your_profile": "Update your profile",
            "recently_added_files": "Recently Added Files",
            "academy_overview": "Academy Overview",
            "all_assessments": "All Assessments",
            "add_an_assessment": "Add an Assessment",
            "all_rounds": "All Rounds",
            "start_a_round": "Start a Round",
            "customize_your_dashboard": "Customize Dashboard",
            "swing_metrics": "Swing Metrics",
            "show_workouts": "Player Workouts",
            "show_practices": "Player Practices",
            "main": "Main",
            "sidebar": "Sidebar",
            "primary_academy": "Primary Academy",
            "events": "Events",
            "reset_pass_complete_form": "To reset your password, complete this form",
            "link_expires_in": "This link will expire in",
            "minutes": "minutes",
            "ffmpeg_exec_output": "FFMPEG EXEC Output",
            "user": "User",
            "has_invited_you_to_join": "has invited you to join",
            "invitation_available_until": "The invitation is available until",
            "to_accept_please_visit": "To accept, please visit",
            "invites_subject_new": "Invitation from {invitor_name} to join {academy_name}",
            "invites_subject_coach": "Invitation from {invitor_name} to join {academy_name}",
            "invites_subject_academy": "Invitation from {invitor_name} to join {academy_name}",
            "invites_subject_gca": "Invitation from {invitor_name} to join {academy_name}",
            "error": "Error",
            "server_error": "Something has gone wrong on our end",
            "internal_server_error": "Internal Server Error",
            "bad_request": "Bad Request",
            "what_does_this_mean": "What does this mean?",
            "400_explanation": "The server cannot or will not process the request due to something that is perceived to be a client error (e.g., malformed request syntax, invalid request message framing, or deceptive request routing).",
            "trying_to_access_without_credentials": "You are trying to access a resource without the correct credentials. For further assistance please contact customer support.",
            "forbidden": "Forbidden",
            "not_found": "We Can't Find the Page You're Looking For",
            "file_not_found": "File not found.",
            "couldnt_find_requested_page": "The page you're looking for may have been moved or deleted. It's also possible that you followed a bad link or entered an incorrect url. At any rate, let's get you to where you need to be.",
            "something_went_wrong_on_server": "Something went wrong on our servers while we were processing your request.",
            "sorry_will_resolve_please_send_note": "We're really sorry about this, and will work hard to get this resolved as quickly as possible. It would be very helpful if you could send a quick note.",
            "sorry_will_resolve_have_been_notified": "We're really sorry about this, and will work hard to get this resolved as quickly as possible. Our development team has been notified of this issue.",
            "something_went_wrong": "Something went wrong",
            "what_can_you_do": "What can you do?",
            "send_us_message": "send us a message",
            "404_option_1": "Go back to the previous page",
            "404_option_2": "Go to your dashboard",
            "404_option_3": "Report a problem with us",
            "try_again": "and try performing the action again",
            "are_you_sure": "Are you sure?",
            "return_to_previous_page": "Return to the previous page",
            "contact_customer_support": "Contact Customer Support",
            "contact_our_customer_support": "Contact our Customer Support Team.",
            "if_you_still_feel_thats_a_mistake_please_contact_our_support_team": "If you still feel that's a mistake - please, contact our support team.",
            "stop_following": "Stop Following",
            "remove_follower": "Remove",
            "joined": "Joined",
            "no_coaches_yet": "No coaches yet. Contact your academy about improving today!",
            "no_followers_yet": "No followers yet.",
            "no_coaches_assigned": "There are no coaches assigned.",
            "no_students_assigned": "There are no players assigned.",
            "coaches_assigned": "Coaches Assigned",
            "students_assigned": "Players Assigned",
            "cheatsheet": "Cheatsheet",
            "stat_name": "Stat Name",
            "last": "Last",
            "all_time": "All Time",
            "coming_soon": "Coming Soon...",
            "practices_completed": "Practices Completed",
            "workouts_completed": "Workouts Completed",
            "rounds_played_this_year": "Rounds Played This Year",
            "rounds_played": "Rounds Played",
            "scoring_average": "Scoring Average",
            "hasnt_written_bio_yet": "hasn't written a bio yet.",
            "your_profile": "your profile",
            "pga_average": "PGA Average",
            "following_graph_of_player_golf_game_msg": "The following graph displays a complete evaluation of a players golf game relative to the PGA Tour average for strokes gained. Strokes gained is a complete explanation of how a player compares relative to the PGA Tour. Here's how the stat is computed. Suppose, for example, a golfer one-putts from 33 feet. The Tour average to hole-out from that distance is 2.0 putts, so a one-putt gains one putt on the field.</p><p>The red circle in the middle shows the PGA Tour average based on putting 3-6ft., 7-21ft., and 22+ft., as well and Bunker Play, short game play from 0-20 yards, 20-60 yards, 60-100 yards, and ball striking stats from 100-150 yards, 150-200 yards, and other long shots.</p><p>You will see that you will have strengths and weaknesses relative to the tour. Your goal should be to get your charts as close to the PGA Tour statistics as possible.",
            "explain_this_graph": "Explain this graph",
            "yards": "Yards",
            "yards_lower": "yards",
            "feet": "Feet",
            "feet_lower": "feet",
            "other_long": "Other Long",
            "view_dashboard": "View Dashboard",
            "view_profile": "View Profile",
            "view_workout": "View Workout",
            "view_practice": "View Practice",
            "see_the_result": "See the Result",
            "see_the_response": "See the Response",
            "analysis": "Analysis",
            "hide": "Hide",
            "color": "Color",
            "red": "Red",
            "blue": "Blue",
            "yellow": "Yellow",
            "green": "Green",
            "white": "White",
            "live_session": "Live Session",
            "browser_size_restriction": "Browser Size Restriction",
            "live_session_requires": "Live Session requires a browser size of 1020 pixel wide &amp; 510 pixel high.",
            "beta_panel": "Beta Panel",
            "alpha_panel": "Alpha Panel",
            "manage_golf_courses": "Manage Golf Courses",
            "system_reports": "System Reports",
            "sso_warning": "User is not SSO",
            "admin_search_desc": "Quick lookups across all of {app_name}.",
            "system_reports_desc": "Reports of Academy usage and statistics.",
            "non_gca_academy_report": "Non GCA Academy Report",
            "gca_academy_report": "GCA Academy Report",
            "sales_academy_report": "Sales Report",
            "sales_academy_report_explain": "This is a list of academies that do not have subscriptions.",
            "academy_report": "Academy Report",
            "audit": "Audit",
            "welcome": "Welcome",
            "please_login": "Log in to Blast Connect",
            "remember_me": "Remember me",
            "please_visit": "Please visit",
            "to_reset_it": "to reset it.",
            "send_instructions": "Send reset instructions",
            "enter_email_to_reset": "Enter your email to reset it.",
            "please_choose_new_password_auto_log_in": "Please choose a new password and you'll automatically be logged in.",
            "need_you_to_set_password": "We're glad to have you. We just need you to create a new password and then you can start improving your game today!",
            "change_password": "Change Password",
            "create_password": "Create Password",
            "update_password": "Update Password",
            "temporary_password": "Temporary Password",
            "importance_of_communication": "Why is communicating important? Because you can’t do anything without it. Communication is necessary in order to avoid confusion. It’s vital to any successful organization to be clear. When you communicate, you eliminate confusion. Everybody understands the system and understands his responsibilities within the system, so that he can carry them out.",
            "login_to_your_academy": "Log in to your Academy",
            "no_academies_are_currently_accepting_members": "No academies are currently accepting members",
            "change_password_login": "Change your password and log in",
            "terms_of_service_agree": "I hereby agree to the Blast Motion",
            "terms_of_age_agree": "I certify that I am 13 years old or older or have my parent’s / guardian’s consent to create a Blast Motion account.",
            "terms_of_receive_sms_agree": "I consent to receive periodic SMS or MMS messages from Blast Motion containing but not limited to important information, product support information, updates, deals, and specials. Standard message and data rates may apply.",
            "terms_of_service": "terms of service",
            "register_no_account": "Don't have an account?",
            "register_call_to_action": "Get Started",
            "invite_account_registration_heading": "Create a Blast Account",
            "invite_information": "Information",
            "invite_information_caption": "Tell us a little about yourself",
            "invite_account": "Account",
            "invite_account_caption": "Creating your account",
            "email_note_available_error_message": "Sorry, the email address provided is not available",
            "confirm_password": "Confirm Password",
            "ready_heading": "Ready?",
            "ready_heading_caption": "Great! Lets continue to your registration",
            "service_disclaimer": "Service Disclaimer",
            "service_disclaimer_text": "Service Disclaimer Text",
            "accept_and_continue": "Continue",
            "subscription_setup": "Subscribe to Blast Connect",
            "subscription_setup_subtext": "Add catchy subtext here which highlights the value people will get...",
            "subscription_select_plan": "Select your subscription plan",
            "free_trial": "Includes {trial_days}-day Free Trial",
            "one_year_subscription": "One year subscription, billed immediately",
            "billed_us_dollars": "All plans are billed in US dollars.",
            "plans_automatic_renew": "Plans will automatically renew at the end of their billing term.",
            "one_time": "One Time",
            "subscription_monthly_plan": "Monthly Plan",
            "subscription_monthly_plan_price": "Not available",
            "monthly": "Monthly",
            "subscription_annual_plan": "Annual Plan",
            "annual": "Annual",
            "addons": "Add-Ons",
            "boditrak": {
                "stance_width": "Stance Width",
                "peak_lateral_cop_velocity": "Peak Lateral C<span class=\"text-lowercase\">O</span>P Velocity",
                "max_dvf": "Max DVF",
                "no_data": "You don't have any BodiTrak data to display.",
                "student_no_data": "{student} doesn't have any BodiTrak data to display.",
                "invalid_subscription": "You don't have a BodiTrak subscription. Go ahead and <a href=\"{subscription_link}\">subscribe now</a>."
            },
            "addon_boditrak": "Add-On - BodiTrak",
            "payment_source": "Master Credit Card",
            "payment_source_caption": "Setting up your payment source",
            "supported_credit_cards_jp": "Credit cards accepted:",
            "unsupported_credit_cards_jp": "(Other credit cards are not accepted.)",
            "stripe_form_cc_nickname": "Description of Card",
            "stripe_form_cc_name": "Cardholder Name",
            "stripe_form_cc_number": "Card Number",
            "stripe_form_cc_expiry": "Expires",
            "stripe_form_cvc": "CVC Security Code",
            "stripe_form_mm": "MM",
            "stripe_form_yy": "YY",
            "stripe_form_confirm_cc": "Confirm Credit Card",
            "stripe_form_confirm_card": "Confirm Card",
            "stripe_form_confirm_card_error": "Confirm Card Error",
            "stripe_form_credit_card": "Credit Card",
            "stripe_form_academy_card": "Academy Card?",
            "stripe_form_academy_card_description": "Share this card with other admin coaches in this academy",
            "stripe_form_cardholder_name_required": "The cardholder name field is required.",
            "master_card_about_to_expire": "Your master credit card is about to expire. Please update your credit card information in order to continue with your subscriptions.",
            "subscriptions_under_card": "Subscriptions Paid By This Card",
            "valid_until": "Valid Until",
            "remove_master_card_alert": "There are active subscriptions being paid for by the card you removed. To continue service for these active subscriptions, please add a Master Credit Card.",
            "pay_for_new_users_start": "Pay for new users by adding a master credit card from within your",
            "master_credit_card_desc_start": "Once added, you'll have the option of paying for new members that you",
            "master_credit_card_desc_end": "add to your academy",
            "subscription_confirm": "Confirm?",
            "subscription_confirm_caption": "Amazing! Let us know by clicking the blue button below",
            "subscription_subscribe": "Subscribe To Blast Connect",
            "academy_paid": "Academy Paid",
            "invalid": "Invalid",
            "renews": "Renews",
            "plan": "Plan",
            "payment": "Payment",
            "subscription_cancel_sorry_to_see_you_go": "We're sorry to see you go",
            "subscription_cancel_we_would_love_to_know_why": "Please help us improve by sending us a quick message explaining why you chose to cancel your subscription.",
            "subscription_cancel_feedback_thanks": "Thank you for your feedback.",
            "subscription_disclaimers": {
                "owners": "Each Athlete added to the account is {price} (first month free) which can be billed to the Coach or the Athlete."
            },
            "pick_files_analyze": "You can pick up to 2 files to analyze.",
            "pick_files_analyze_limit": "You can only analyze 1 or 2 files at a time.",
            "streaming_video": "Streaming Video",
            "dropbox": "Dropbox",
            "file_name": "File Name",
            "select_file": "Select File",
            "select_files": "Select Files",
            "attach_file": "Attach a File",
            "500mb_max": "500 MB maximum",
            "max_file_size": "%s MB maximum",
            "file_too_large": "Files cannot be larger than %s MB",
            "unsupported_file_type": "Files must be one of the following types: %s",
            "upload_a_file": "Upload a File",
            "uploading": "Uploading",
            "initializing_upload": "Initializing Upload",
            "processing_upload": "Processing Upload",
            "upload_complete": "Upload Complete",
            "retry": "Retry",
            "processing_dropped_files": "Processing dropped files...",
            "processing": "Processing...",
            "dropbox_coming_soon": "Dropbox is planned to come soon.",
            "streaming": "Streaming",
            "score_entered": "Score Entered",
            "share_with_everyone_in": "Share with everyone in",
            "you_can_optionally_rename_this_file": "Optional - if left blank the filename will be used",
            "optional_desc_of_file": "Optional",
            "use_uploaded_file": "Use Uploaded File",
            "putting_driving": "i.e. Putting, Driving",
            "please_add_your_file_first": "Please select a file first",
            "edit_file_details": "Edit File Details",
            "add_or_change_file_details": "Add or Change File Information",
            "save_details": "Save Details",
            "saving_details": "Saving Details",
            "back_to_library": "Back to Library",
            "action": "Action",
            "download": "Download",
            "fullscreen": "Fullscreen",
            "machine_vision": "M-Cast (BETA)",
            "machine_vision_result": "M-Cast Result (BETA)",
            "shared_by": "shared by",
            "my": "My",
            "shared_with": "Shared with",
            "comments": "Comments",
            "write_a_comment": "Write a Comment...",
            "add_comment": "Add Comment",
            "left_a_comment": "{user_name} left a comment",
            "no_comments_yet_be_the_first": "No comments yet... be the first!",
            "related": "Related",
            "drag_file_onto_page": "Or just drag a file onto this page",
            "add_to_your_library": "Add To Your Library",
            "you_are_viewing": "You are viewing",
            "library_lower": "library",
            "return_to_your_library": "Return to your library",
            "newest_to_oldest": "Newest to Oldest",
            "oldest_to_newest": "Oldest to Newest",
            "library_collections": "Library Collections",
            "collections": "Collections",
            "tags": "tags",
            "show": "show",
            "uc_show": "Show",
            "hide_extra": "hide extra",
            "more_tags": "more tags",
            "file_type": "File Type",
            "videos": "Videos",
            "standard_videos": "Standard Videos",
            "analyzed_videos": "Analyzed Videos",
            "blast_metrics_videos": "Blast Metrics Videos",
            "images": "Images",
            "documents": "Documents",
            "my_files": "My Files",
            "academy_files": "Academy Files",
            "shared_files": "Shared Files",
            "premium_content": "Premium Content",
            "date_range": "Date Range",
            "sort_order": "Sort Order",
            "sharing": "Sharing",
            "filter_library": "Filter Library",
            "filters": "Filters",
            "more_filters": "More Filters",
            "reset": "Reset",
            "apply": "Apply",
            "apply_filter": "Apply Filter",
            "apply_filters": "Apply Filters",
            "hide_filters": "Hide Filters",
            "show_filters": "Player Filters",
            "previous": "Previous",
            "next": "Next",
            "total_files": "total files",
            "no_results_try_expanding_filters_note": "<p>You have no items to show in your library.</p><p>Add a video, image or document to your library or try expanding your filters.</p>",
            "user_does_not_have_any_files": "{user_name} has not added any files into their library.",
            "adding_library_items_is_simple_note": "Adding library items is as simple as dragging things anywhere onto this page. Once added they can be shared, analyzed, categorized and will start to become a valuable tool in helping you improve!",
            "view": "View",
            "add_file_library": "Add File",
            "edit_file_library": "Edit File",
            "edited_file": "Edited File",
            "converting_video": "Processing video, thanks for your patience.",
            "processing_video": {
                "headings": [
                    "Almost Ready!"
                ],
                "messages": [
                    "This page will refresh as soon as your video is ready. If you need to do something else, turn on the email notification and we'll notify you as soon as it's all set."
                ],
                "labels": {
                    "notify_when_ready": "Notify me when my video is ready"
                }
            },
            "encoding_error": {
                "heading": "The provided video failed to encode.",
                "message": "The video uploaded was not able to complete the encoding process, please try to upload the video again.<br>If the problem persists, contact customer support."
            },
            "refresh_page": "Refresh Page",
            "email_me_when_ready": "Email me when the video is ready",
            "view_all_metrics": "View all metrics",
            "deselect": "Deselect",
            "selected": "selected",
            "refresh_library": "Refresh Library",
            "upload_another_file": "Upload Another File",
            "analysis_browser_no_support_title": "We're sorry, but the Video Analysis tool is not supported by your web browser.  It is a Chrome-only feature.",
            "analysis_browser_no_support_message": "The Video Analysis tool can only be used with Google Chrome if you had previously used Google Chrome to analyze Blast videos and have not removed the \"Blast Motion - Web Analysis Extension\".",
            "analysis_browser_no_support_chrome": "Unfortunately, Google has decided to no longer support custom Chrome apps, so our Blast Video Analysis Tool can no longer be installed.  Mobile Video Analysis is available within the iOS Blast Baseball, Blast Softball, and Blast Golf apps, though.",
            "analysis_browser_no_support_firefox": "Firefox - mozilla.org/firefox/",
            "analysis_browser_no_support_message_safari": "At this time, we recommend using Chrome for the best experience with the Video Analysis tool. Download it for free from http://www.google.com/chrome/",
            "analysis_video_is_ready": "Your analysis video is now ready.",
            "analysis_video_is_ready_title": "Analysis Video Upload Complete",
            "analysis_video_is_ready_body": "We have finished processing your video. It is now available within your <a href=\"https://{sub_domain}.{base_url}/library\"> {app_name} library.</a>",
            "uploaded_file_is_ready": "Your uploaded file is now ready",
            "thanks_for_uploaded_file": "Thank you for your patience, your video is now ready, and is available in your library. <a href=\"https://{sub_domain}.{base_url}/library/{file_id}\">You can access your file here</a>.",
            "drop_files_here": "Drop your files here",
            "select_file_device": "Select a file from your device",
            "multiple_files_allowed": "Multiple files allowed",
            "browse_files": "Browse Files",
            "browse_file": "Select File",
            "canceling_remove_uploads": "Canceling will remove all uploads that are currently in progress.",
            "sure_cancel": "I'm sure - Cancel",
            "go_back": "Go Back",
            "view_library": "View library",
            "add_another_file": "Add More",
            "something_prevents_video": "Yikes! Sorry, something is preventing this video from loading.",
            "uploaded_by": "Uploaded by",
            "uploaded_by_you": "Uploaded by you",
            "upload_and_analyze": "Upload and Analyze",
            "team_averages": "Team Averages",
            "self_serve_registration": {
                "invalid_sport": "Sorry, you have selected an invalid sport",
                "invalid_organization": "Sorry, the registration page you're trying to access is invalid. Double check that the registration url you were given is correct, or visit www.blastmotion.com.",
                "create_account": "Create Account",
                "login_to_continue": "Login to continue",
                "already_have_blast_account": "Already have a Blast Account?",
                "already_have_blast_account_message": "If you already have the Blast Mobile app, you have a Blast account. Just log in with your Blast account email and password to continue.",
                "do_not_have_blast_account": "Don't have a Blast Account?",
                "do_not_have_blast_account_message": "If you have not used the Blast Mobile App, let's create a new Blast Account to access your academy.",
                "academy": {
                    "academy": "Academy",
                    "owner": "Admin Coach",
                    "account_creation": "Create a Blast Connect Academy",
                    "academy_information": "Academy Information",
                    "academy_name": "Name",
                    "academy_logo": "Logo (optional)",
                    "academy_website": "Website",
                    "academy_phone": "Phone",
                    "academy_address": "Address",
                    "academy_address_2": "Address Additional",
                    "academy_city": "City",
                    "academy_state": "Province / State",
                    "academy_country": "Country",
                    "academy_zip": "Postal / ZIP",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "Admin Coach's Information",
                    "owner_first_name": "First Name",
                    "owner_last_name": "Last Name",
                    "owner_email": "Email",
                    "owner_password": "Password",
                    "confirm_password": "Password Confirmation",
                    "create_account": "Create Account",
                    "processing_registration": "Processing Registration",
                    "payment_source_reference": "Payment Reference Name",
                    "subscription_summary": "Your Subscription Summary",
                    "payment_details": "Payment Details",
                    "plan_name": "Blast Connect - Annual subscription",
                    "plan_note": "",
                    "processing_subscription": "Processing Subscription",
                    "payment_information": "Payment Information",
                    "shipping_address": "Shipping Address",
                    "shipping_address_optional": "Shipping Address (Optional)",
                    "continue_message": "You will have a chance to review your purchase on the next page.",
                    "credit_card_will_be_billed": "Your 30 day trial begins as soon as you complete this purchase. Your credit card will be billed in 30 days.",
                    "subtotal": "Subtotal",
                    "tax": "Tax",
                    "total": "Total",
                    "credit_cart_required": "Payment Credit Card is required for purchase.",
                    "purchase_requirement_message": "In order to proceed, you will need to purchase a Blast Connect subscription: ",
                    "subscribe_you_are_subscribed_message": "Congratulations! You're currently subscribed to:",
                    "subscribe_enhance_by_purchasing_message": "Enhance your development by purchasing an optional add-on:",
                    "subscribe_no_thanks_message": "No thanks, continue signing in",
                    "main_subscription_title": "Pay For Your Subscription",
                    "cvc_code_description": "CVC: Please enter the 3 or 4 digit number on the back of the card.",
                    "shipping_country": "Country",
                    "shipping_postal_code": "Postal Code",
                    "shipping_prefecture_name": "Prefecture Name",
                    "shipping_city_village_ward": "City / Village / Ward",
                    "shipping_subarea": "Subarea",
                    "shipping_subarea_number": "Subarea Number",
                    "shipping_block_number": "Block Number",
                    "shipping_house_number": "House Number",
                    "first_run_title": "Congrats! You’re now using Blast Premium Services!",
                    "first_run_description_coach": "Let’s confirm some things before you start using Blast Connect.",
                    "first_run_description_player1": "Your {days} day trial begins as soon as you complete this purchase. ",
                    "first_run_description_player2": "Let’s confirm some things before you start using Blast Connect.",
                    "first_run_select_language_label": "Set Your Preferred Language",
                    "first_run_form_button": "Start Using Blast Connect",
                    "first_run_mobile_apps_title": "Download the Blast {academy_name} mobile app and make the most out of your Blast experience (opens new window).",
                    "first_run_pro_team": " Pro Team",
                    "account_creation_successful": "Account Successfully Created",
                    "thank_you_subscription_message": "Thank you, {user_full_name} for your subscription!",
                    "success_message": "Your academy, {academy_name} has been successfully activated, and an account manager will be in touch within 24 hours to help you customize your account and get started.",
                    "continue_to_dashboard": "Continue",
                    "complete_purchase": "Complete Purchase"
                },
                "gca": {
                    "academy": "Academy",
                    "owner": "Admin Coach",
                    "account_creation": "Create a Blast Connect Academy",
                    "academy_information": "Academy Information",
                    "academy_name": "Name",
                    "academy_logo": "Logo (optional)",
                    "academy_website": "Website",
                    "academy_phone": "Phone",
                    "academy_address": "Address",
                    "academy_address_2": "Address Additional",
                    "academy_city": "City",
                    "academy_state": "Province / State",
                    "academy_country": "Country",
                    "academy_zip": "Postal / ZIP",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "Admin Coach's Information",
                    "owner_first_name": "First Name",
                    "owner_last_name": "Last Name",
                    "owner_email": "Email",
                    "owner_password": "Password",
                    "confirm_password": "Password Confirmation",
                    "create_account": "Create Account",
                    "processing_registration": "Processing Registration",
                    "payment_source_reference": "Payment Reference Name",
                    "payment_details": "Payment Details",
                    "plan_name": "Blast Connect - Annual subscription",
                    "plan_note": "",
                    "processing_subscription": "Processing Subscription",
                    "account_creation_successful": "Account Successfully Created",
                    "thank_you_subscription_message": "Thank you {user_full_name} for your subscription!",
                    "success_message": "Your academy, {academy_name} has been successfully activated, and an account manager will be in touch within 24 hours to help you customize your account and get started.",
                    "continue_to_dashboard": "Continue"
                },
                "coach": {
                    "academy": "Academy",
                    "owner": "Admin Coach",
                    "account_creation": "Create a Blast Connect Academy",
                    "academy_information": "Academy Information",
                    "academy_name": "Name",
                    "academy_logo": "Logo (optional)",
                    "academy_website": "Website",
                    "academy_phone": "Phone",
                    "academy_address": "Address",
                    "academy_address_2": "Address Additional",
                    "academy_city": "City",
                    "academy_state": "Province / State",
                    "academy_country": "Country",
                    "academy_zip": "Postal / ZIP",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "Admin Coach's Information",
                    "owner_first_name": "First Name",
                    "owner_last_name": "Last Name",
                    "owner_email": "Email",
                    "owner_password": "Password",
                    "confirm_password": "Password Confirmation",
                    "create_account": "Create Account",
                    "processing_registration": "Processing Registration",
                    "payment_details": "Payment Details",
                    "plan_name": "Blast Connect - Annual subscription",
                    "plan_note": "",
                    "processing_subscription": "Processing Subscription",
                    "account_creation_successful": "Account Successfully Created",
                    "thank_you_subscription_message": "Thank you! {user_full_name} for your subscription.",
                    "success_message": "Your academy, {academy_name}, has been successfully activated.",
                    "continue_to_dashboard": "Continue"
                },
                "email": {
                    "baseball": {
                        "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/"
                        }
                    },
                    "softball": {
                        "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/d"
                        }
                    },
                    "golf": {
                        "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created.",
                            "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/"
                        }
                    },
                    "other": {
                        "academy": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created."
                        },
                        "coach": {
                            "mail_title": "Welcome to Blast Connect – Let’s Get Started!",
                            "mail_body": "Thank you, {full_name}. Your account, {academy_name} has been successfully created."
                        }
                    }
                }
            },
            "welcome_emails": {
                "title": {
                    "golf": {
                        "message": "Welcome to Blast Connect Golf - Let's Get Started!",
                        "no_subscription": "Welcome to Blast Connect Golf - Let's Get Started!"
                    },
                    "baseball": {
                        "message": "Welcome to Blast Connect Baseball - Let's Get Started!",
                        "no_subscription": "Welcome to Blast Connect Baseball - Let's Get Started!"
                    },
                    "softball": {
                        "message": "Welcome to Blast Connect Softball - Let's Get Started!",
                        "no_subscription": "Welcome to Blast Connect Softball - Let's Get Started!"
                    }
                },
                "intro": {
                    "heading": {
                        "golf": "On behalf of the <strong>Blast Customer Support Team</strong>, welcome to the <strong>Blast Golf Premium Solution!</strong>",
                        "baseball": "On behalf of the <strong>Blast Customer Support Team</strong>, welcome to the <strong>Blast Baseball Team Solution</strong>!",
                        "softball": "On behalf of the <strong>Blast Customer Support Team</strong>, welcome to the <strong>Blast Softball Team Solution</strong>!"
                    },
                    "message": {
                        "student": "You’re just one step away from gaining access to premium metrics, cloud-based video storage, advanced reporting, team management, coach feedback, video annotation, scheduling, and much more!",
                        "coach": "You’re just one step away from gaining access to premium metrics, cloud-based video storage, advanced reporting, team management, integrated coaching feedback, video annotation, scheduling, and much more!",
                        "owner": {
                            "generic": "Your academy is just one step away accessing a fully-integrated suite of software analysis, coaching, communication and management tools designed to help you manage your business more effectively and efficiently.",
                            "golf": "Your coaching account has been created and is ready for you to get started.",
                            "baseball": "Your coaching account has been created and is ready for you to get started.",
                            "softball": "Your coaching account has been created and is ready for you to get started."
                        }
                    }
                },
                "account_info": {
                    "title": "<strong>Account Details:</strong>",
                    "confirm_message": "Please confirm the following account details:",
                    "academy_name": "Academy Name:",
                    "name": {
                        "student": "Name:",
                        "coach": "Name:",
                        "owner": "Account Admin Coach Name:"
                    },
                    "email": {
                        "student": "Email:",
                        "coach": "Email:",
                        "owner": "Account Admin Coach Email:"
                    },
                    "subscription_plan_name": "Subscription Plan:",
                    "subscription_price": "Subscription Price:",
                    "subscription_start_date": "Subscription Start Date:",
                    "verify_and_login_message": "Use the login link (below) to access to your Blast Connect account. You will be prompted to enter your User Name (provided above) and Password (provided during registration).\n            {login_anchor}"
                },
                "steps": {
                    "baseball": {
                        "step_1": {
                            "title": "<strong>Step 1</strong>: Invite your players to join your team / academy.",
                            "message": "Please review the following videos and document designed to help you get up and running quickly:"
                        }
                    },
                    "softball": {
                        "step_1": {
                            "title": "<strong>Step 1</strong>: Invite your players to join your team / academy.",
                            "message": "Please review the following videos and document designed to help you get up and running quickly:"
                        }
                    }
                },
                "onboarding": {
                    "softball": {
                        "title": "<strong>Onboarding Documentation:</strong>",
                        "list": {
                            "onboarding_video": {
                                "title": "Onboarding Video",
                                "url": "https://vimeo.com/299343554"
                            },
                            "functionality_video": {
                                "title": "Blast Softball App Functionality",
                                "url": "https://vimeo.com/304655793"
                            },
                            "player_data_video": {
                                "title": "Viewing Player data in Blast Connect",
                                "url": "https://vimeo.com/304655839"
                            },
                            "user_guide_solution_functionality": {
                                "title": "Blast User Guide for Solution Functionality",
                                "url": "https://www.manula.com/manuals/blast-motion/get-started-blast-softball/1/en/topic/app-overviews"
                            }
                        }
                    },
                    "baseball": {
                        "title": "<strong>Onboarding Documentation:</strong>",
                        "list": {
                            "onboarding_video": {
                                "title": "Onboarding Video",
                                "url": "https://vimeo.com/299343491"
                            },
                            "functionality_video": {
                                "title": "Blast Baseball App Functionality",
                                "url": "https://vimeo.com/304655793"
                            },
                            "player_data_video": {
                                "title": "Viewing Player data in Blast Connect",
                                "url": "https://vimeo.com/304655839"
                            },
                            "user_guide_solution_functionality": {
                                "title": "Blast User Guide for Solution Functionality",
                                "url": "https://www.manula.com/manuals/blast-motion/get-started-blast-baseball/1/en/topic/app-overviews"
                            }
                        }
                    }
                },
                "explore_messages": {
                    "click_to_schedule_meeting": "click here to schedule a 30-minute virtual meeting",
                    "virtual_meeting_message": "If you would like help getting started, {schedule_meeting_anchor}. (Note: You’ll want to have access to a computer for this meeting.)",
                    "video_invite_students_and_coaches_label": "Video: Invite Players and Coaches",
                    "begin_exploring_message": {
                        "student": "Begin exploring your personalized Blast Connect dashboard and take your training to the next level.",
                        "coach": "Begin exploring your personalized Blast Connect dashboard and start inviting players to your Blast Connect portal.",
                        "owner": {
                            "invite_user_highlight_text": "invite players and coaches to join your Academy",
                            "invite_user_video": "Invite Players and Coaches",
                            "generic": "Begin exploring your academy’s Blast Connect dashboard and start inviting coaches and players to your academy’s portal to take your business to the next level.",
                            "golf": "The first step for getting your Academy up and running is to {invite_user_highlight_text}. For directions on how to complete this process, please watch the following informational video: {invite_user_video_anchor}",
                            "baseball": "The first step for getting your Academy up and running is to {invite_user_highlight_text}. For directions on how to complete this process, please watch the following informational video: {invite_user_video_anchor}",
                            "softball": "The first step for getting your Academy up and running is to {invite_user_highlight_text}. For directions on how to complete this process, please watch the following informational video: {invite_user_video_anchor}"
                        }
                    },
                    "blast_sensor_synced_message": {
                        "student": "If you own a Blast sensor, your data will be automatically synced with your Blast Connect account and available for review, advanced analysis, coach feedback, and much more!",
                        "coach": "If your players have or purchase a Blast sensor, their data will be synced with your Blast Connect account and available for review and advanced analysis.",
                        "owner": {
                            "generic": "If your players have or purchase a Blast sensor, their data will be synced with your Blast Connect account and available for review and advanced analysis.",
                            "golf": "After you have invited players to join your portal and they have accepted, you can request access to their Blast sensor data and videos to provide advanced coaching analysis and feedback.",
                            "baseball": "After you have invited players to join your portal and they have accepted, you can request access to their Blast sensor data and videos to provide advanced coaching analysis and feedback.",
                            "softball": "After you have invited players to join your portal and they have accepted, you can request access to their Blast sensor data and videos to provide advanced coaching analysis and feedback."
                        }
                    }
                },
                "support_info": {
                    "quick_start_video": "Blast Connect - Quick Start Video",
                    "help_page": "Blast Connect Help Page",
                    "need_help_message": "Need help?  Watch the {quick_start_video_anchor} or visit the {help_page_anchor} for details on making the most of your Blast Connect experience.",
                    "need_support_message": "Need tech. support?  Give us a call: {support_phone_number}",
                    "for_additional_info": {
                        "generic": "<strong>For additional information</strong>, including overviews of Blast and Blast Connect, pro tips, and drills please visit the Training Center at {blast_motion_anchor}: {training_center_anchor}",
                        "golf": "<strong>For additional information</strong>, including overviews of Blast Golf and Blast Golf Premium, pro tips, and drills please visit the Training Center at {training_center_anchor}",
                        "baseball": "<strong>For additional information</strong>, including overviews of Blast Baseball and Blast Baseball Premium, pro tips, and drills please visit the Training Center at {blast_motion_anchor}: {training_center_anchor}",
                        "softball": "<strong>For additional information</strong>, including overviews of Blast Softball and Blast Softball Premium, pro tips, and drills please visit the Training Center at {blast_motion_anchor}: {training_center_anchor}"
                    },
                    "feel_free_to_contact": "If you have any questions, please reach out to <a href=\"mailto:{email}\">{email}</a> or create a case <strong><a target=\"_blank\" href=\"{support_link}\">HERE</a></strong>. We will get back to you as soon as possible.",
                    "generic": "If you have any questions, please reach out to <a href=\"mailto:{email}\">{email}</a> or create a case <strong><a target=\"_blank\" href=\"{support_link}\">HERE</a></strong>. We will get back to you as soon as possible."
                },
                "signature": {
                    "message": "Once again, thank you and welcome to Blast Connect!",
                    "footer": "Have a great day, <br>Blast Customer Support Team",
                    "generic": "Have a great day, <br>Blast Customer Support Team"
                },
                "sign_in_link": {
                    "title": "<strong>Sign in here</strong>",
                    "url": "https://{sub_domain}.{root_domain}"
                }
            },
            "invitation_emails": {
                "title": {
                    "message": {
                        "complimentary": "Complimentary Membership from {invited_by_user_name} - Welcome to the {academy_name} ",
                        "payment_required": "Invitation to “Connect” – {invited_by_user_name} would like you to join the {academy_name}",
                        "subscription_off": "Great news, your Blast Connect {academy_name} account has been created by {invited_by_user_name}!"
                    }
                },
                "intro": {
                    "message": {
                        "complimentary": {
                            "student": "You have received a complimentary membership to the {academy_name} for {blast_connect_feature_name}. This membership gives you access to a fully integrated suite of software analysis, coaching, communication and management tools that empower your daily drive to improve. You can also “connect” with a coach and give them the ability to review your practice sessions, assign workouts, analyze your metrics, & provide remote coaching for the delivery of actionable insights … anywhere, anytime.",
                            "coach": "You have received a complimentary membership to the {academy_name} for {blast_connect_feature_name}. This membership gives you access to a fully integrated suite of software analysis, coaching, communication and management tools. You will be able to provide feedback to your athletes through powerful video analysis, voiceover, and markup features. You can even review your athlete’s practice sessions, assign workouts, and provide them with actionable insights … anywhere, anytime.",
                            "owner": "You have received a complimentary membership to the {academy_name} for {blast_connect_feature_name}. This membership gives you access to a fully integrated suite of software analysis, coaching, communication and management tools. You will be able to provide feedback to your athletes through powerful video analysis, voiceover, and markup features. You can even review your athlete’s practice sessions, assign workouts, and provide them with actionable insights … anywhere, anytime."
                        },
                        "payment_required": {
                            "great_news_message": "Great news, your Blast account has been created!",
                            "invited_by_message": "{invited_by_user_name} has sent you an invitation to join their academy."
                        },
                        "subscription_off": {
                            "message": "To access your account, click the link below and log in with the email and password provided."
                        }
                    }
                },
                "account_info": {
                    "accountEmail": "Account Email:",
                    "accountPassword": "Account Password:",
                    "ssoPasswordMessage": "Use your existing Blast Account password",
                    "ssoPasswordResetMessage": "Can’t remember your password? Don’t worry, {forgot_password_anchor}.",
                    "ssoPasswordResetText": "you can reset your password",
                    "accountActivation": "Account Activation:"
                },
                "payment_info": {
                    "heading": "Blast Connect Subscription - {role_name} Plan & Payment",
                    "message": "Use the following link to enter your payment information ({payment_option_text}) and complete the subscription process."
                },
                "invite_info": {
                    "accountEmail": "Account Email:",
                    "accountPassword": "Account Password:",
                    "accountActivation": "Account Activation:",
                    "message": {
                        "student": "By accepting this invitation and joining {academy_name}, you will gain access to a fully integrated suite of software analysis, coaching, communication and management tools that empower your daily drive to improve. You can also give {coach_name} the ability to review your practice sessions, assign workouts, analyze your metrics, & provide remote coaching for the delivery of actionable insights … anywhere, anytime.",
                        "coach": "By accepting this invitation and joining the {academy_name}, you will gain access to a fully integrated suite of software analysis, coaching, communication and management tools. You will be able to provide feedback to your athletes through powerful video analysis, voiceover, and markup features. You can even review your athlete’s practice sessions, assign workouts, and provide them with actionable insights … anywhere, anytime.",
                        "owner": "By accepting this invitation and joining the {academy_name}, you will gain access to a fully integrated suite of software analysis, coaching, communication and management tools. You will be able to provide feedback to your athletes through powerful video analysis, voiceover, and markup features. You can even review your athlete’s practice sessions, assign workouts, and provide them with actionable insights … anywhere, anytime."
                    }
                },
                "support_info": {
                    "message": "Have questions or need tech. support?  Give us a call: {support_phone_number}"
                },
                "signature": {
                    "message": "-- The Blast Motion Team"
                }
            },
            "sign_up_title": "Sign Up For Blast Connect",
            "choose_your_sport": "Choose Your Sport",
            "sign_up_subtitle": "The insights and tools that empower your daily drive to get better.",
            "choose_focus": "Choose your focus",
            "account_type": "Account Type",
            "golf_athlete_description": "Get the insights and tools to become a better golfer.",
            "golf_coach_description": "Improve your players with coaching, analysis, and communication tools.",
            "golf_academy_description": "Get the tools to elevate your business while improving your players.",
            "softball_athlete_description": "Get the insights and tools to become a better hitter.",
            "softball_coach_description": "Improve your players with coaching, analysis, and communication tools.",
            "softball_academy_description": "Get the tools to elevate your business while improving your players.",
            "baseball_athlete_description": "Get the insights and tools to become a better hitter.",
            "baseball_player_description": "Track the performance of an individual - yours or your athlete. Choose this option if you are a <b>player</b> or <b>parent</b>.",
            "softball_player_description": "Track the performance of an individual - yours or your athlete. Choose this option if you are a <b>player</b> or <b>parent</b>.",
            "golf_player_description": "Track the performance of an individual - yours or your athlete. Choose this option if you are a <b>player</b> or <b>parent</b>.",
            "baseball_player_trial_period": "{days} Day Free Trial",
            "softball_player_trial_period": "{days} Day Free Trial",
            "golf_player_trial_period": "{days} Day Free Trial",
            "baseball_coach_description_self_serve": "Track and manage team performance or groups of players.\n    Choose this option if you are a <b>coach</b> or the <b>owner of an academy</b> and plan to add players to your account.",
            "softball_coach_description_self_serve": "Track and manage team performance or groups of players.\n    Choose this option if you are a <b>coach</b> or the <b>owner of an academy</b> and plan to add players to your account.",
            "golf_coach_description_self_serve": "Track and manage team performance or groups of players.\n    Choose this option if you are a <b>coach</b> or the <b>owner of an academy</b> and plan to add players to your account.",
            "baseball_coach_pricing": "Todo need a translation",
            "baseball_coach_trial_period": "Each player requires an active Blast Connect subscription",
            "softball_coach_pricing": "Todo need a translation",
            "softball_coach_trial_period": "Each player requires an active Blast Connect subscription",
            "golf_coach_pricing": "Todo need a translation",
            "golf_coach_trial_period": "Each player requires an active Blast Connect subscription",
            "player_description": "Track the performance of an individual - yours or your athlete. Choose this option if you are a <b>player</b> or <b>parent</b>.",
            "player_trial_period": "{days} Day Free Trial",
            "baseball_coach_description": "Improve your players with coaching, analysis, and communication tools.",
            "coach_description_self_serve": "Track and manage team performance or groups of players.\n    Choose this option if you are a <b>coach</b> or the <b>owner of an academy</b> and plan to add players to your account.",
            "baseball_academy_description": "Get the tools to elevate your business while improving your players.",
            "coach_trial_period": "Each player requires an active Blast Connect subscription",
            "discounted_package": "Discounted team packages available.",
            "request_a_quote": "Request a quote",
            "registration_popup": {
                "us": {
                    "baseball": {
                        "player": {
                            "title": "Track the performance of an individual.",
                            "items": {
                                "list_1": "Automatic swing quality assessments - performance history, swing insights and recommended drills",
                                "list_2": "Public Player Profile",
                                "list_3": "Video Analysis",
                                "list_4": "Media Library"
                            }
                        },
                        "non-player": {
                            "title": "Make your players better, faster!",
                            "items": {
                                "list_1": "Manage team, rosters and multiple players",
                                "list_2": "Automatic swing quality assessments - performance history, swing insights, recommended drills",
                                "list_3": "Team and Player reports",
                                "list_4": "Workouts & Practices",
                                "list_5": "Video Analysis with sharing",
                                "list_6": "Media Library with sharing"
                            }
                        }
                    },
                    "softball": {
                        "player": {
                            "title": "Track the performance of an individual.",
                            "items": {
                                "list_1": "Automatic swing quality assessments - performance history, swing insights and recommended drills",
                                "list_2": "Public Player Profile",
                                "list_3": "Video Analysis",
                                "list_4": "Media Library"
                            }
                        },
                        "non-player": {
                            "title": "Make your players better, faster!",
                            "items": {
                                "list_1": "Manage team, rosters and multiple players",
                                "list_2": "Automatic swing quality assessments - performance history, swing insights, recommended drills",
                                "list_3": "Team and Player reports",
                                "list_4": "Workouts & Practices",
                                "list_5": "Video Analysis with sharing",
                                "list_6": "Media Library with sharing"
                            }
                        }
                    },
                    "golf": {
                        "player": {
                            "title": "Track the performance of an individual.",
                            "items": {
                                "list_1": "Automatic swing quality assessments - performance history, swing insights and recommended drills",
                                "list_2": "Public Player Profile",
                                "list_3": "Video Analysis",
                                "list_4": "Media Library"
                            }
                        },
                        "non-player": {
                            "title": "Manage teams or groups of players:",
                            "items": {
                                "list_1": "Add multiple Players and Coaches",
                                "list_2": "Player Reports",
                                "list_3": "Assessments",
                                "list_4": "Round Tracking",
                                "list_5": "Practices & Drills",
                                "list_6": "Video Analysis with sharing",
                                "list_7": "Media Library with sharing"
                            }
                        }
                    }
                },
                "jp": {
                    "baseball": {
                        "player": {
                            "title": "Track the performance of an individual.",
                            "items": {
                                "list_1": "Automatic swing quality assessments - performance history, swing insights and recommended drills",
                                "list_2": "Public Player Profile",
                                "list_3": "Video Analysis",
                                "list_4": "Media Library"
                            }
                        },
                        "non-player": {
                            "title": "Make your players better, faster!",
                            "items": {
                                "list_1": "Manage team, rosters and multiple players",
                                "list_2": "Automatic swing quality assessments - performance history, swing insights, recommended drills",
                                "list_3": "Team and Player reports",
                                "list_4": "Video Analysis with sharing",
                                "list_5": "Media Library with sharing"
                            }
                        }
                    }
                }
            },
            "welcome_to_blast": "Welcome To Blast",
            "lets_setup_your_blast_account": "Let's set up your Blast account and get you into Blast Connect",
            "setup_blast_connect": "Setup Blast Connect",
            "already_using_blast_app": "Already using the Blast Mobile app?",
            "if_has_blast_app_login_to_continue": "If you already using the Blast Mobile app, then log in and we'll get you signed up for Blast Connect that much quicker.",
            "email_address": "Email Address",
            "dont_have_blast_app": "Don't have a Blast Mobile app?",
            "have_mobile_app": "Do you have a Blast Mobile App?",
            "have_mobile_app_yes": "Yes - I'm already using a Blast Mobile App",
            "have_mobile_app_yes_desc": "If you're already using a Blast Mobile App, it means that you already have a Blast account. Log in with the same email and password and we'll get you signed up for Blast Connect quickly.",
            "have_mobile_app_no": "No - I don't have a Blast Mobile App",
            "have_mobile_app_no_desc": "If you haven't used a Blast Mobile App, chances are you don't have a Blast account yet. Let's set up your Blast account and get you registered with Blast Connect.",
            "setup_blast_account": "Setup a New Blast Account",
            "register_blast_connect": "Register for Blast Connect",
            "coach_signup": "Prefer to sign up as a coach and start your own Academy?",
            "player_signup": "Prefer to sign up as a player?",
            "already_have_mobile_app": "It looks like you already have a Blast Account",
            "log_in_app_pw": "Log in using your Blast Account password and we'll get you signed up for Blast Connect.",
            "please_login_with_blast_account": "please login with your Blast Mobile Account",
            "already_have_blast_mobile_account": "We see that your email is already register with a Blast Mobile Account, {please_login_with_blast_account} to setup your Blast Connect Account.",
            "invalid_blast_mobile_account_potential": "We could not find a Blast account with that email and password. Double-check that what you have entered is correct.",
            "not_able_to_retrieve_blast_account": "We are not able to retrieve your Blast account information. Please contact customer support.",
            "login_with_password_in_email": "Sign In To Continue",
            "password_from_invite_email": "Your Blast Account password can be found in your invitation email.",
            "your_invitations_have_been_successfully_sent": "Your invitation has been successfully sent.|Your invitations have been successfully sent.",
            "account_created_housekeeping": "Let's take care of some house keeping items, then you'll be on your way.",
            "your_blast_account_ready": "Your Blast Account is ready to go!",
            "download_the_app": "Download the Blast App",
            "download_the_blast": "Download the Blast",
            "mobile_app_and": "mobile app and make the most out of your Blast experience.",
            "no_thanks_dashboard": "No thanks, take me to Blast Connect",
            "pro": "Pro",
            "pro_team": "Pro Team",
            "please_check_all_subscription_information": "Please check all subscription information.",
            "your_blast_connect_account_has_been_successfully_created_thank_you_for_subscribing": "Your Blast Connect account has been successfully created! Thank you for subscribing.",
            "register_invalid_invitation": "Invalid invitation, please contact your organization representative.",
            "account_exists_on_register": "We see that you already have a Blast Connect account with that email, please login with your Blast Connect instead.",
            "account_register_provided_form_is_invalid": "Form information is not valid.",
            "membership_receipt": {
                "subject": "{invitee_name} has joined {academy}",
                "intro": "{owner_name}, {invitee_name} has accepted your invite and created an account to join {academy}. Your credit card(s) listed below will be charged for this member’s subscription(s).",
                "link_view_members": "View your <a href=\"{url}\">academy members</a>.",
                "subscription": "Subscription",
                "interval": "Interval",
                "amount": "Amount",
                "card": "Card",
                "total": "Total",
                "paid": "Paid"
            },
            "add_follower": "Add Follower",
            "invite": "Invite",
            "invite_members": "Invite Members",
            "invite_another_member": "Invite another member",
            "new_members_invite_email": "New members will receive an invite via email. The new member will need to click through from that email to create an account in your academy.",
            "new_members_pro_create": "Add a new member to Blast Connect. New members will receive an invite via email. The new member will need to click through from that email to create an account.",
            "followers_are_already_part_of": "Followers are people who are already part of",
            "want_to_follow_your_progress": "and want to follow your progress. They'll be able to message you, see your stats, library and progress.",
            "invite_students": "Invite Players",
            "invite_student_s": "Invite Player(s)",
            "send_invitation": "Send Invitation(s)",
            "enter_students_name_email_send_invite": "Enter your player's email address to send them an invite to {academy}.",
            "invite_friends": "Invite Friends",
            "are_your_friends_golfers_invite_them_to": "Are your friends golfers, or do you want them to be able to see your progress? Invite them to join",
            "seven_days_to_join_free": "and they'll have 7 days to join for free and get instant access!<br><small><em>Hint: To invite multiple people, simply separate emails with a comma (&ldquo;,&rdquo;).</em></small>",
            "send_invite_s": "Send Invite(s)",
            "manage_members": "Manage Members",
            "team_management": "Team Management",
            "following": "Following",
            "these_players_show_in_your_timeline": "These players show in your timeline, and you can view their profile and follow their account.",
            "followers": "Followers",
            "followers_can_view_your_profile": "Followers can view your profile and follow your account.",
            "you_give_players_permission_to_follow_above": "",
            "groups": "Groups",
            "create_group": "Create Group",
            "add_group": "Add Group",
            "no_groups_start_one": "You haven't set up any groups. Start one now.",
            "members_message": "Send a Message to",
            "members_twitter": "'s Twitter",
            "members_facebook": "'s Facebook",
            "social_share": "Social Share",
            "social_share_notice_coach": "Note that players invited through the link above will be prompted to purchase a Blast Connect subscription. Please select the Email option if you would like to pay for your player's account.",
            "social_share_notice": "Note that players invited through the link above will be prompted to purchase a Blast Connect subscription. Please select Email or Bulk Upload options if you would like to pay for your player's account.",
            "bulk_upload": "Bulk Upload",
            "user_information": "User Information",
            "account_payment": "Account Payment",
            "coach_assignment": "Coach Assignment",
            "whos_paying": "Who's Paying?",
            "select_card": "Select Card",
            "payer_will_not_be_charged": "You will not be charged until the player has accepted the invite and created their account.",
            "member_will_pay": "Member will pay for themselves",
            "member_paid_subscription": "Member paid subscription",
            "owner_paid_subscription": "Admin Coach paid subscription",
            "disable_password_reset": "Disable Password Reset",
            "all_emails_must_be_unique": "All email addresses must be unique for each member.",
            "email_must_be_unique": "Email address must be unique.",
            "sensor_name": "Sensor Name",
            "sensor_serial_number": "Sensor Serial Number",
            "sensor_location": "Sensor Location",
            "equipment_name": "Equipment Name",
            "equipment_weight": "Equipment Weight",
            "equipment_length": "Equipment Length",
            "mlb_bam_id": "MLB BAM ID",
            "embedded": "Embedded",
            "attached": "Attached",
            "not_specified": "Not Specified",
            "invites_sent_message_new": "The following new member(s) have been invited",
            "invites_sent_message_exist": "The following member(s) are already your player.",
            "invites_sent_message_coach": "<i class=\"far fa-check\"></i> Invitation(s) sent to",
            "invites_sent_message_academy": "<i class=\"far fa-exclamation\"></i> The following email(s) already belong(s) to another academy. Currently we are not able to add them to your academy",
            "invites_sent_message_gca": "We have invited the following users to your academy",
            "invites_error_self_invite": "Sorry, you’re already a member and cannot invite yourself.",
            "delete_user_multi_academy_message": "Sorry, This user belongs to multiple academies, please contact ",
            "email_in_use": "This email address is already in use.",
            "subscription_plan": "Subscription Plan",
            "member_pay_desc": "Selecting this option will prompt the member to purchase a Blast Connect subscription in order to access your Academy.",
            "global_payment_reminder": "Remember to assign subscriptions to each member when you're setting the global payment card.",
            "disabled_add_new_user_btn_text": "No more users can be added at this time if you invite the user(s) on this page because you have no more licensed seats available.",
            "bulk_upload_spreadsheet_seats_error": "The new accounts in the uploaded spreadsheet cannot be created at this time because you do not have enough licensed seats available.  You can remove the excess users from the spreadsheet and try again to upload it.  If you need to purchase additional seats, please contact your Blast Motion representative for a quote.",
            "has_not_available_seats_error": "New accounts cannot be created at this time because you have no more licensed seats available.  If you need to purchase additional seats, please contact your Blast Motion representative for a quote.",
            "quick_create_seats_error": "This account cannot be created at this time because you have no more licensed seats available. If you need to purchase additional seats, please contact your Blast Motion representative for a quote.",
            "account_settings_non_admin": "Account and Subscription Settings",
            "account_settings": "Account Settings",
            "my_account": "My Account Settings",
            "msg_name_blast_connect": "Your name as you would like it to appear within Blast Connect and any Blast Connect-generated messages.",
            "msg_email_blast_connect": "The email you use to log into Blast Connect.",
            "msg_email_sso": "The email you use to log into your Blast Account.",
            "strokes_gained": "Strokes Gained",
            "strokes_gained_total": "Strokes Gained Total",
            "strokes_gained_putting": "Strokes Gained Putting",
            "monthly_reports": "Monthly Reports",
            "no_monthly_reports_yet_for": "No monthly reports yet for",
            "uc_media": "Media",
            "see": "See",
            "full_library": "full library",
            "hasnt_added_files_to_library": "hasn't added any files to their library.",
            "statistics": "Statistics",
            "player_average": "Player Average",
            "stats_graph_description": "<p>The following graph displays a complete evaluation of a players golf game relative to the PGA Tour average for strokes gained. Strokes gained is a complete explanation of how a player compares relative to the PGA Tour. Here's how the stat is computed. Suppose, for example, a golfer one-putts from 33 feet. The Tour average to hole-out from that distance is 2.0 putts, so a one-putt gains one putt on the field.</p><p>The red circle in the middle shows the PGA Tour average based on putting 3-6ft., 7-21ft., and 22+ft., as well and Bunker Play, short game play from 0-20 yards, 20-60 yards, 60-100 yards, and ball striking stats from 100-150 yards, 150-200 yards, and other long shots.</p><p>You will see that you will have strengths and weaknesses relative to the tour. Your goal should be to get your charts as close to the PGA Tour statistics as possible.</p>",
            "want_to_see_more_statistics": "Want to see more statistics?",
            "uc_shows": "Shows",
            "advanced_stats": "advanced stats",
            "repsonse_to_monthly_reports": "response to Monthly Report",
            "canceled": "Canceled",
            "balls": "Balls",
            "time": "Time",
            "club": "Club",
            "distance": "Distance",
            "comment": "Comment",
            "uc_score": "Score",
            "no_practices_recorded_start_today": "No practices recorded yet. Start improving today!",
            "equipment": "Equipment",
            "sets": "Sets",
            "reps": "Reps",
            "weight": "Weight",
            "tempo": "Tempo",
            "rest": "Rest",
            "no_workouts_recorded_start_today": "No workouts recorded yet. Start improving today!",
            "workout_log": "Workout Log",
            "practice_log": "Practice Log",
            "update_workout_log": "Add to Workout Log",
            "update_practice_log": "Add to Practice Log",
            "remove_from_log": "Remove From Log",
            "your_avatar": "your avatar",
            "swing_coach": "Swing Coach",
            "golf_instructor": "Golf Instructor",
            "golf_instructors": "Golf Instructors",
            "overview": "Overview",
            "goals": "Goals",
            "jobtitle": "Title",
            "goal": "Goal",
            "security": "Security",
            "tip_square_images_look_best": "Tip: Square images look best!",
            "personal_info": "Personal Info",
            "phone": "Phone",
            "mobile": "mobile",
            "office": "office",
            "facebook": "Facebook",
            "twitter": "Twitter",
            "instagram": "Instagram",
            "timezone": "Timezone",
            "language_preference": "Language Preference",
            "address": "Address",
            "throws": "Throws",
            "edit_vitals": "Edit Your Vitals",
            "custom_stats": "Custom Stats",
            "athletic": "Athletic",
            "add_another_stat": "Add another stat",
            "key_statistics": "Key Statistics",
            "statisitic_name": "Statistic Name",
            "statisitic_value": "Statistic Value",
            "avg_driving_distance": "Average Driving Distance",
            "eligibility_center": "Eligibility Center",
            "for_more_info": "for more information.",
            "tournament_name": "Tournament & Event Name",
            "tournament_location": "Tournament & Event Location",
            "start_date": "Start Date",
            "end_date": "End Date",
            "field_size": "Field Size",
            "yardage_and_par": "Yardage &amp; Par",
            "fourth": "Fourth",
            "did_you_play_in_more_tournaments": "Did you play in more tournaments?",
            "add_another_tournament": "Add Another Tournament",
            "profile_public": "Make Your Profile Public",
            "services_provided": "Services Provided",
            "accepting_new_students": "Accepting New Players",
            "personal_stats": "Personal Stats",
            "athletic_stats": "Athletic Stats",
            "edit_bio": "Edit Your Bio",
            "bio": "Bio",
            "describe_your_bio": "Describe your background and goals in detail",
            "edit_goals": "Edit Your Goals",
            "describe_your_goals": "Describe your goals",
            "if_left_blank": "If this is left blank, this section will not appear on your public profile.",
            "education_experience": "Education & Experience",
            "edit_education_experience": "Edit Your Education & Experience",
            "dates": "dates",
            "dates_ie": "i.e. 2016 to present",
            "name_of_institution": "Name of Institution",
            "education_ie": "i.e. experience, achievements, role",
            "teams": "Teams",
            "add_team": "Add a Team",
            "team_members": "Team Members",
            "edit_your_team": "Edit Your Team",
            "add_team_member": "Add a team member",
            "edit_team_member": "Edit Team Member",
            "edit_your_teams_info": "Edit Your Team's Information",
            "title_ie": "i.e. Coach, Manager, Parent",
            "current_team": "Current Team?",
            "team_name": "team name",
            "team_details_ie": "i.e. Positions played, major achievements",
            "highlight_reel": "highlight reel",
            "highlights": "highlights",
            "add_highlight_reel": "Add To Your Highlight Videos",
            "add_highlight_videos": "Add Highlight Videos",
            "customize_highlight_reel": "Customize Highlight Videos",
            "reorder_highlight_reel": "Add, reorder or remove videos.",
            "add_up_to_10": "Add up to 10.",
            "choose_up_to_images": "Choose up to 10 images or videos.",
            "are_you_sure_remove_highlight": "Are you sure you want to remove this file from your Highlight Videos?",
            "yes_remove": "Yes, Remove",
            "verify_metrics": "Verify These Metrics",
            "verified_by": "Verified by",
            "customize_avg_swing_metrics": "Customize Your Average Swing Metrics",
            "customize_best_swing_metrics": "Customize Your Best Swing Metrics",
            "select_metrics_to_show": "Select Metrics To Show",
            "edit_stats": "Edit Your Stats",
            "add_education_experience": "Add more education and experience",
            "edit_school_info": "Edit Your School Information",
            "add_school": "Add a School",
            "school_name": "School Name",
            "advanced_placement": "Advanced Placement Classes",
            "additional_information": "Additional Information",
            "edu_additional": "Add details about offices held, clubs, advanced placement classes, etc...",
            "gpa": "GPA",
            "sat": "SAT",
            "act": "ACT",
            "add_tournament": "Add a tournament",
            "edit_tournament_results": "Edit Your Tournament Results",
            "tournament_dates": "Tournament & Event Dates",
            "tournament_location_ie": "A city name will do just fine",
            "yardage": "Yardage & Par",
            "showcases": "Showcases",
            "add_showcase": "Add a showcase",
            "customize_showcase": "Customize Your Showcase",
            "showcase_name": "Showcase Name",
            "showcase_city_state": "City / State",
            "showcase_metrics": "Showcase Metrics",
            "share_profile": "Share Your Profile",
            "public_profile": "Public Profile",
            "profile_located_at": "Your Profile Is Located At:",
            "your_profile_is_percent_complete": "Your profile is {percent} complete.",
            "ncaa_clearing_house": "NCAA Clearing House",
            "caps_key_stats": "KEY STATS",
            "key_stats": "Key Stats",
            "caps_tournament_results": "TOURNAMENT RESULTS",
            "tournament_results": "Tournament Results",
            "the_open": "The Open",
            "caps_score": "SCORE",
            "caps_finish": "FINISH",
            "finish": "Finish",
            "caps_field": "FIELD",
            "caps_yardage_par": "YARDAGE/PAR",
            "caps_upcoming_tournaments": "UPCOMING TOURNAMENTS",
            "upcoming_tournaments": "Upcoming Tournaments",
            "caps_awards": "AWARDS",
            "caps_education": "EDUCATION",
            "education": "Education",
            "derek_allard_award": "The Derek Allard Award for General Awesomeness",
            "honors": "Honors",
            "honors_classes": "Honors Classes",
            "advanced": "Advanced",
            "placement": "Placement",
            "offices_held": "Offices Held",
            "awards": "Awards",
            "caps_extra_curriculars": "EXTRA CURRICULARS",
            "extra_curriculars": "Extra Curriculars",
            "caps_other_information": "OTHER INFORMATION",
            "my_team": "My Team",
            "golf_instructor_s": "Golf Instructor(s)",
            "references": "References",
            "reference": "Reference",
            "parent_info": "Parent Information",
            "graduated": "Graduated",
            "learn_more_blast": "Learn more about Blast:",
            "blastmotion_com": "blastmotion.com",
            "profile_fields_optional": "All fields are optional. If you don't include any content, this section will not appear on your public profile.",
            "profile_fields_required": "Required fields are marked with <sup class=\"text-danger\">*</sup>",
            "contact_information": "Contact Information",
            "parent_information": "Parent Information",
            "parent_guardian": "Parent/Guardian",
            "add_parent_guardian": "Add parent or guardian",
            "display_parent_profile": "Display parent information on your profile?",
            "display_contact_profile": "Display contact information on your profile?",
            "settings_payment_source": "Master Credit Card",
            "payment_source_not_available": "Your account is not currently associated with a master credit card. Please update your payment information.",
            "setting_add_payment_source": "Add Master Credit Card",
            "settings_blast_account": "Blast Account",
            "settings_unlink_blast_account": "Unlink Blast Account",
            "settings_unlink": "Unlink",
            "settings_unlink_warning": "Unlinking your Blast Motion Account will remove all your saved metrics. This action can not be undone, however you can reconnect at any time.",
            "settings_unlink_reconnect_message": "Blast Motion account disconnected. <a href=\"{reconnect_url}\">Reconnect</a> your account.",
            "blast_mobile_app_sensor": "Blast Mobile App and Sensor",
            "settings_connect_msg_1": "Your Blast Mobile App and Sensor are not connected to Blast Connect. Go ahead and",
            "settings_connect_msg_2": "connect them now",
            "settings_save_updates": "Save Profile Updates",
            "are_you_playing_in_upcoming_tournament": "Are you playing in more upcoming tournaments?",
            "add_another_upcoming_tournament": "Add Another Upcoming Tournament",
            "fulltime_resi_student_years": "Full-Time Residential Player-Years",
            "school_info": "School Info",
            "graduation_year": "Graduating Year",
            "high_school_name": "High School Name",
            "offices_you_hold": "Offices You Hold",
            "student_council_treasurer": "Player Council Treasurer",
            "eng_math_sci": "English, Math, Science",
            "adv_placement_classes": "Advanced Placement Classes",
            "special_awards": "Special Awards",
            "community_spirit_award": "Community Spirit Award",
            "did_you_attend_second_highschool": "Did you attend a second high school? You can enter it also.",
            "show_highschool2_details": "Player Second High School Details",
            "parent1_info": "Parent 1 Information",
            "parent2_info": "Parent 2 Information",
            "attachments": "Attachments",
            "choose_items_for_personal_library": "You can choose items from your personal library to display on your résumé. Videos will be playable on the web version, but will not be present on the downloadable PDF file.",
            "no_media_visible_add_some": "No media that are visible to the academy are available. You can add some",
            "to": "to",
            "from": "from",
            "province_state": "State / Province",
            "zippostal": "Zip / Postal Code",
            "country": "Country",
            "gender": "Gender",
            "gender_male": "Male",
            "gender_female": "Female",
            "gender_other": "Other",
            "gender_unstated": "Unstated",
            "height": "Height",
            "birthday": "Birthday",
            "date_of_birth": "Date of Birth",
            "biography": "Biography",
            "just_a_few_words_about_yourself": "Just a few words about yourself...",
            "outcome_goals_are_an_ultimate_destination": "Outcome goals are an ultimate destination.",
            "change_password_follow_link": "You can quickly and conveniently change your password by following",
            "change_password_follow_link_sso": "Change your password on the",
            "change_password_message": "Let's change your password and set your timezone.",
            "this_link_to_gca": "this link to Golf Channel Academy",
            "this_link_to_blast_motion": "this link to Blast Motion Password Reset",
            "bm_password_change_page": "Blast Motion password change page",
            "you_need_to_login_again_after_change": "You will need to log in again after you change your password.",
            "current_password": "Current Password",
            "reenter_new_password": "Re-Enter New Password",
            "show_welcome_on_dashboard": "Player Welcome on Dashboard?",
            "profile_updated": "Profile updated.",
            "change_your_password": "Change your password",
            "set_your_timezone": "Set your timezone",
            "cancel_subscription_message": {
                "cancel_subscription": "Cancel Subscription",
                "we_are_sorry": "We're sorry you're thinking of leaving us! If there is anything we can do to help before you go, our Support Team would be happy to assist you: <b><a href=\"{help_link}\" target=\"_blank\">Click here for help.</a></b>",
                "we_would_love_to_know_why": "Please help us improve by sending us a quick message explaining why you chose to cancel your subscription.",
                "warning_message": "Warning! This action can not be undone.",
                "are_you_sure": "Are you sure you want to cancel your subscription?",
                "if_cancelled": "If cancelled, your access will end on {period_end_date}",
                "yes_cancel": "Yes, cancel",
                "no_go_back": "No, go back",
                "dont_cancel": "Don't cancel",
                "feedback": "Feedback",
                "send_feedback": "Send feedback",
                "dont_send_feedback": "Don't send feedback",
                "cancellation_completed": "Subscription cancellation completed",
                "processing_cancellation": "Processing cancellation",
                "sending_feedback": "Sending feedback"
            },
            "cancel_subscription_form": {
                "primary_reason_for_canceling_label": "Please select the primary reason for canceling (required):",
                "primary_reason_for_canceling_options": {
                    "no_playing_or_coaching": "I'm no longer playing or coaching {sport}",
                    "no_working_with": "I'm no longer working with my coach / team / academy",
                    "was_not_satisfied": "I wasn't satisfied with or had issues with the features",
                    "needed_features_temporarily": "I only needed Blast Connect / Premium Services temporarily",
                    "too_expensive_time": "Blast Connect / Premium Services is too expensive for how often I use it",
                    "too_expensive_value": "Blast Connect / Premium Services is too expensive for the value I get out of the features",
                    "dont_have_budget": "I no longer have budget to be able to pay for Blast Connect / Premium Services",
                    "take_break": "I'm just taking a break, but I'll be back",
                    "other": "Other"
                }
            },
            "handicap": "Handicap",
            "jersey_number": "Jersey Number",
            "position": "Position",
            "bam_id": "BAM ID",
            "organization_member_id": "Organization Member Id",
            "is_organization_admin": "Is Organization Admin",
            "handedness": "Handedness",
            "dexterity": "Dexterity",
            "left": "Left",
            "right": "Right",
            "both": "Both",
            "left_or_right": "Left / Right",
            "email_confirmed": "Email address successfully confirmed.",
            "email_confirmation_expired": "Email confirmation expired. Please update your profile again.",
            "email_confirmation_sent": "A confirmation email has been sent to {email} to confirm.",
            "confirm_your_email_address": "Confirm Your Email Address",
            "confirm_email_body": "<p>A new email address has been entered on your Blast Connect account. You must confirm this change by following the link below.</p>\n<p><a href=\"{url}\">{url}</a></p>\n<p>If this was done in error, please disregard this email.</p>",
            "golf_stats": "Golf Stats",
            "rounds": "Rounds",
            "notes_for_hole": "Enter notes for hole {hole_number}",
            "back_to_rounds": "Back to Rounds",
            "played_rounds": "Played Rounds",
            "play_round": "Play a Round",
            "round": "Round",
            "practice_stats": "Practice Stats",
            "workout_stats": "Workout Stats",
            "par": "Par",
            "hole": "Hole",
            "view_details": "View Details",
            "shot": "Shot",
            "shots": "Shots",
            "recovery": "Recovery",
            "hasnt_played_any_rounds_yet": "hasn't played any rounds yet.",
            "accept_eula": "End User Licence Agreement",
            "accept_eula_to_continue_to_site": "I accept the <a href=\"{link}\" rel=\"external\">Blast Connect End User License Agreement</a>.",
            "eula_i_accept": "I accept",
            "eula_i_decline": "I decline",
            "eula_error": "You must accept the end user license agreement in order to use Blast Connect.",
            "accept_waiver": "I accept the waiver.",
            "accept_waiver_to_continue_to_site": "You need to accept the following waiver to continue to the site:",
            "waiver_rejected": "Waiver Rejected",
            "waiver_rejected_msg": "We're sorry it didn't work out right now. We really do want to work with you; please contact us with your concerns and we'll do what we can to resolve them. You can try again at any time to accept the waiver.",
            "create_a_new_message": "New message",
            "message_everyone": "Message Everyone",
            "message_all_students": "Message All Players",
            "message_all_coaches": "Message All Coaches",
            "subject": "Subject",
            "participants": "Participants",
            "unread": "unread",
            "uc_unread": "Unread",
            "sorry_no_msg": "Sorry, no messages.",
            "write_one": "Write one",
            "now": "now.",
            "back_to_messages": "Back to Messages",
            "mark": "Mark",
            "mark_read": "Mark Selected as Read",
            "mark_unread": "Mark Selected as Unread",
            "delete_thread": "Delete Thread",
            "people_in_this_conversation": "People In This Conversation",
            "leave_reply": "Reply",
            "no_academies_yet": "No Academies yet. Add one by editing an",
            "sub_domain_not_used_but_here_note": "Sub Domain is not currently used, but is here to future-proof our data should we decide to implement 'per organization' pages.",
            "logo": "Logo",
            "this_isnt_working": "This isn't working... to be built, but as its only for Blast Admins, its low-priority.",
            "permanently_delete": "Permanently Delete",
            "organization_name": "Organization Name",
            "share_with_other_coaches_in": "Share with other coaches in {academy_name}",
            "share_with_all_students_in": "Share with all players in {academy_name}",
            "share_with_your_students": "Share with your players",
            "author": "Author",
            "button_above": "button above.",
            "description_of_the_practice": "Description of the practice",
            "make_this_practice_available_to_other_coaches_in": "Make this practice available to other coaches in",
            "practice_builder": "Practice Builder",
            "practices_comprised_of_drills_note": "<em>Practices</em> are comprised of <em>drills</em> saved within the system. You can add drills or prescribe and assign practices below.",
            "add_drills_first": "Add drills first",
            "existing": "Existing",
            "created_by": "Created By",
            "shared": "shared",
            "currently_available": "currently available.",
            "assigned": "Assigned",
            "mark_progress_coming_soon": "Mark progress coming soon.",
            "mark_progress": "Mark Progress",
            "no_practices_assigned_yet": "No practices assigned yet. Check your library for great ideas you can use on your own!",
            "recently_completed": "Recently Completed",
            "to_see_full_practice_history_view": "To see your full practice history, view your",
            "no_completed_practices_yet": "No completed practices yet.",
            "back_to": "Back to",
            "date_completed": "Date Completed",
            "uc_drill": "Drill",
            "scores_are_optional_title": "Scores are optional markers of your progress. Talk to your coach about the best way to score your practices.",
            "optional_comments": "Optional Comments",
            "practice_history": "Practice History",
            "drills_in_this_practice": "Drills in this Practice",
            "to_this_practice": "to this practice",
            "no_drills_assigned_yet": "No drills have been added to this practice.",
            "add_one_with_the": "Add one with the",
            "button": "button",
            "students_assigned_this_practice": "Players Assigned this Practice",
            "all_students_assignd_this_practice": "All your players have been assigned this practice.",
            "assign_practice_to_students": "Assign this Practice to Players",
            "no_students_assinged_this_practice": "No players have been assigned to this practice.",
            "to_this": "to this",
            "optional_bg_colors_note": "Optional background colors will show when players look at the Workout.",
            "select_all": "Select All",
            "unselect_all": "Unselect All",
            "assign_this_practice": "Assign this Practice",
            "assign_this_practices": "Assign this Practice",
            "completed": "Completed",
            "nothing_yet": "Nothing Yet",
            "main_menu": "Main Menu",
            "distance_to_pin_before_shot": "Distance to Pin before shot",
            "choose_club": "Choose Club",
            "take_your_first_swing": "Take your first swing!",
            "add_shot": "Add Shot",
            "save_shot": "Save Shot",
            "cancel_shot": "Cancel Shot",
            "done": "Done",
            "cancel": "Cancel",
            "other": "Other",
            "round_summary": "Round Summary",
            "to_par": "To Par",
            "total": "Total",
            "golf_stats_see_them_from": "This is where full members can log their games and rounds. This information is aggregated to construct <em>'Golf Stats'</em> which you can see from their profiles. You can see your children and their profiles, from the",
            "network_page": "network page",
            "where_playing": "Where are you playing?",
            "post_score": "Post Score",
            "tournament": "Tournament",
            "treatment": "Treatment",
            "start_game": "Start Game",
            "start_round": "Start Round",
            "select_hole": "Select a Hole",
            "no_tee_found_new_add": "No tee found. New tee will be added",
            "could_not_locate_game": "Could not locate that game",
            "round_recorded": "Round Recorded",
            "not_your_game": "The game that shot was part of is not one of your games",
            "round_deleted": "Round Deleted",
            "round_restored": "Round Restored",
            "shot_not_found": "Shot not found",
            "shot_deleted": "Shot Deleted",
            "shot_restored": "Shot Restored",
            "hide_diagram": "Hide Diagram",
            "show_diagram": "Player Diagram",
            "diagram_explaining": "A diagram explaining how to use distance to pin before shot",
            "how_distance_to_pin_works": "How Distance To Pin Works",
            "view_calendar": "View Calendar",
            "distance_to_pin_error": "Each shot must have a numeric distance to pin value.",
            "page": "page",
            "wi.see_progress_from_the": "This is where full members can view their progress. You can see your children and their profiles, from the",
            "tee_to_green": "Tee-to-Green",
            "exercise_type": "Exercise Type",
            "exercise_types": "Exercise Types",
            "filter_stats": "Filter Stats",
            "balls_hit": "Balls Hit",
            "longest_shot": "Longest Shot",
            "practices_assigned": "Practices Assigned",
            "practices_over_time": "Practices Over Time",
            "see_games_rounds_from_the": "This is where full members can view their past games and rounds. This information is aggregated to construct <em>'Golf Stats'</em> which you can see from their profiles. You can see your children and their profiles, from the",
            "tee": "Tee",
            "no_games_recorded_start_today": "No games recorded yet. Start improving today!",
            "workouts_assigned": "Workouts Assigned",
            "workouts_over_time": "Workouts Over Time",
            "workout_history": "Workout History",
            "gca_player_links": "Golf Channel Academy Player Links",
            "legend": "Legend",
            "active_available_for_air": "Active - Available for air",
            "uncategorized": "Uncategorized",
            "archived_hidden_but_recoverable": "Archived - Hidden but recoverable",
            "accepted_video_files_5mb_plz": "(MP4, MPEG, AVI, MOV, and WebM files. 5 megabytes please)",
            "upload_a_video": "Upload a Video",
            "upload": "Upload",
            "restrict_to_shows": "Restrict to Shows",
            "use": "Use",
            "archive": "Archive",
            "no_results": "No results.",
            "start": "Start",
            "end": "End",
            "seconds": "Seconds",
            "set_time": "Set Time",
            "shows_assigned_to_this_video": "Shows Assigned to this Video",
            "selected_for_show_use": "selected for show use",
            "removed_from_show_use": "removed from show use",
            "on_air_video_welcome_msg": "Welcome to the on air video upload. Please share your videos here for a chance to be reviewed on air.",
            "on_air_video_step1": "Step 1 - Choose Video and Submit to On Air!",
            "oav_step1_details": "MP4, MPEG, AVI, MOV, and WebM files will produce the best results. Keep it under 5 megabytes please.",
            "on_air_video_step2": "Step 2 - Description",
            "oav_step2_details": "Tell us a bit about the video and you. If you want to be contacted, please leave your email.",
            "on_air_video_step3": "Step 3 - Submit",
            "oav_step3_details": "I hereby agree to share the video under the terms of the Golf Channel.",
            "thank_you_for_your_video_submission": "Thank you for your video submission.",
            "another_video": "another video",
            "to_get_started": "To get started",
            "edit_your_profile": "Edit your profile",
            "update_my_profile": "Update My Profile",
            "tweets": "tweets",
            "word_count": "Word Count",
            "no_summary_available": "No summary available.",
            "out_of": "out of",
            "with": "with",
            "routines": "Workouts &amp; Practices",
            "all_routines": "All Workouts &amp; Practices",
            "exercises": "Exercises",
            "drills": "Drills",
            "an_exercise": "an Exercise",
            "a drill": "a Drill",
            "assigned_to_me": "Assigned to me",
            "history": "History",
            "available": "Available",
            "assigned_description": "Workouts and/or practices that have been assigned to you, but have not yet been completed.",
            "available_description": "All workouts and/or practices that have been assigned to you since the beginning of time. Go ahead and complete them again!",
            "assigned_by": "Assigned by:",
            "date_assigned": "Date assigned:",
            "start_workout": "Start Workout",
            "start_practice": "Start Practice",
            "create_workout": "Create a Workout",
            "create_practice": "Create a Practice",
            "create_workout_practice": "Create a Workout or Practice",
            "complete_workout": "Complete Workout",
            "workout_type": "Workout Type",
            "practice_type": "Practice Type",
            "workout_description": "Workout Description",
            "practice_description": "Practice Description",
            "assign_workout": "Assign Workout",
            "assign_practice": "Assign Practice",
            "schedule_assign": "Schedule and Assign",
            "assign_without_schedule": "Assign Without Scheduling",
            "share_workout": "Share Workout",
            "share_practice": "Share Practice",
            "other_coachs_academy": "Other coaches in this academy",
            "add_to_workout": "Add to Workout",
            "add_to_practice": "Add to Practice",
            "create_exercise": "Create Exercise",
            "create_new_exercise": "Create a New Exercise",
            "create_drill": "Create Drill",
            "exercise_description": "Exercise Description",
            "drill_description": "Description of the Drill",
            "video_image": "Video or Image",
            "equipment_type": "Equipment Type",
            "all_equipment_types": "All Equipment Types",
            "exercise_details": "Exercise Details",
            "drill_details": "Drill Details",
            "share_exercise_with": "Share Exercise With",
            "share_drill_with": "Share Drill With",
            "your_students": "Your Players",
            "notes": "Notes",
            "complete": "Complete",
            "skip": "Skip",
            "equipment_needed": "Equipment Needed",
            "finish_workout": "Finish Workout",
            "finish_practice": "Finish Practice",
            "complete_exercise": "Complete Exercise",
            "complete_drill": "Complete Drill",
            "you_finished": "You've finished! Nicely done.",
            "review_workout": "Review Workout",
            "view_mark_all": "Want to view & mark your exercises all at once?",
            "view_mark_one": "Want to view & mark your exercises as you complete them?",
            "switch_list_view": "Switch to list view",
            "switch_horizontal_view": "Switch to grid view",
            "add-group": "Add group",
            "add_group_same_exercises": "If you completed more than what was assigned to you, add another group of these same exercises.",
            "add_group_same_drills": "If you completed more than what was assigned to you, add another group of these same drills.",
            "outstanding": "Outstanding",
            "since": "Since",
            "last_7_days": "Last 7 Days",
            "by_month": "By Month",
            "by_type": "By Type",
            "your_workout_list": "Your Workout List",
            "your_practice_list": "Your Practice List",
            "view_only": "View only",
            "duplicate_to_edit": "Duplicate to edit",
            "scheduled": "Scheduled",
            "your_week_at_a_glance": "{name} Week At A Glance",
            "schedule_coach_subtext": "Workouts and practices that you've assigned to your players.",
            "full_calendar": "Full Calendar",
            "complete_question": "Complete?",
            "mark_complete": "Mark Complete",
            "owner_mode": "Admin Coach Mode",
            "coach_mode": "Coach Mode",
            "personal_mode": "Personal Mode",
            "coach_mode_tip": "Manage your players' workouts and practices",
            "personal_mode_tip": "Complete your own workouts and practices",
            "no_type": "you've completed were not given category types when they were created.",
            "routines_before_after": "Routines completed before or after the assigned date will not show as completed.",
            "not_editable_note": "This is not editable because it was created by another member and shared with you. You can still assign it to your players.",
            "not_editable_note_student": "This is not editable because it was created by another member and shared with you. You can still schedule it for yourself.",
            "assign": "Assign",
            "you_have_not_assigned_routines": "You have not scheduled any workouts or practices here.",
            "routines_assigned_show_here": "Your scheduled Workouts and Practices are shown here.",
            "complete_routine_for_student": "You are completing this {routine_type} for <strong>{user}</strong>.",
            "routine_which_type_are_you_completing": "Which scheduled {type} are you completing?",
            "routine_not_found": "The workout/practice you are looking for cannot be found and may have been deleted. <a href=\"{url}\">Find another workout/practice</a>",
            "routine_deleted": "The {type} you are looking for cannot be found and may have been deleted. <a href=\"{url}\">Find another {type}</a>",
            "complete_again": "Complete Again",
            "other_coaches_in": "Other coaches in {academy_name}",
            "other_coaches": "Other coaches",
            "all_coaches_in": "All coaches in {academy_name}",
            "select_coaches": "Specific coaches",
            "all_students_in": "All players in {academy_name}",
            "your_next_workout": "{name} next workout",
            "your_last_workout": "{name} last workout",
            "your_next_practice": "{name} next practice",
            "your_last_practice": "{name} last practice",
            "routines_calendar_disabled": "Stay on top of your players progress. Monitor each of your players training including assigned workouts and practices and their completed history.",
            "form_validation_error_message": "Please fill in all required fields.",
            "event_must_be_workout_or_practice": "Completion is only available for workouts and practices.",
            "drill": "Drill",
            "routines_category": {
                "workouts": {
                    "title": "Workout",
                    "recent": "Recent Workouts",
                    "scheduled_this_week": "Workouts scheduled this week",
                    "routine_view": "View Workout",
                    "routine_review": "Review Workout",
                    "routine_create": "Create Workout",
                    "routine_list": "Your Workout List",
                    "manage_task": "Manage Exercises",
                    "tasks_link": "exercises",
                    "your_have_completed_your_routine": "You've completed your workout. Nicely done!",
                    "start_routine": "Start Workout",
                    "log_routine": "Log Workout",
                    "routine_name": "Workout Name",
                    "routine_type": "Workout Type",
                    "routine_assign": "Assign Workout",
                    "routine_share": "Share Workout",
                    "routine_description": "Workout Description",
                    "duplicate_task": "Duplicate Exercise",
                    "create_task": "Create Exercise",
                    "task": "Exercise",
                    "tasks": "Exercises",
                    "task_add": "Add Exercises",
                    "task_name": "Exercise Name",
                    "task_description": "Exercise Description",
                    "task_type": "Exercise Type",
                    "task_create_new": "Create a New Exercise",
                    "task_details": "Exercise Details",
                    "task_group_desc": "Exercises are added to groups. This allows you to define different parts of the workout (i.e. warmup, cool down). You'll need to have at least 1 group of exercises in your workout.",
                    "share_task_with": "Share exercise with",
                    "task_details_text": "Define what you want tracked for this exercise. You will add the specific number of reps, weight, etc for this exercise on the Create Workout screen.",
                    "add_to_routine": "Add to Workout",
                    "manage_tasks": "Manage Exercises",
                    "routine_updated": "Workout updated",
                    "routine_deleted": "Workout deleted {restore_anchor}",
                    "routine_restored": "Workout restored",
                    "routine_complete": "Complete Workout",
                    "assign_routine_to_students": "Assign this workout to Players",
                    "schedule_routine": "Schedule Workout",
                    "make_routine_available": "Make Workout Available To:",
                    "make_routine_available_text": "This does not assign the workout, but makes it available to complete on their own (and assign it to others, in the case of coaches)."
                },
                "practices": {
                    "title": "Practice",
                    "recent": "Recent Practices",
                    "scheduled_this_week": "Practices scheduled this week",
                    "routine_view": "View Practice",
                    "routine_review": "Review Practice",
                    "routine_create": "Create Practice",
                    "routine_list": "Your Practice List",
                    "manage_task": "Manage Drills",
                    "tasks_link": "drills",
                    "your_have_completed_your_routine": "You've completed your practice. Nicely done!",
                    "start_routine": "Start Practice",
                    "log_routine": "Log Practice",
                    "routine_name": "Practice Name",
                    "routine_type": "Practice Type",
                    "routine_assign": "Assign Practice",
                    "routine_share": "Share Practice",
                    "routine_description": "Practice Description",
                    "duplicate_task": "Duplicate Drill",
                    "create_task": "Create Drill",
                    "task": "Drill",
                    "tasks": "Drills",
                    "task_add": "Add Drills",
                    "task_name": "Drill Name",
                    "task_description": "Drill Description",
                    "task_type": "Drill Type",
                    "task_create_new": "Create a New Drill",
                    "task_details": "Drill Details",
                    "task_group_desc": "Drills are added to groups. This allows you to define different parts of the practice plan (i.e. warmup, cool down). You'll need to have at least 1 group of drills in your practice.",
                    "share_task_with": "Share drill with",
                    "task_details_text": "Define what you want tracked for this drill. You will add the specific number of repetitions, etc for this drill on the Create Practice screen.",
                    "add_to_routine": "Add to Practice",
                    "manage_tasks": "Manage Drills",
                    "routine_updated": "Practice updated",
                    "routine_deleted": "Practice deleted {restore_anchor}",
                    "routine_restored": "Practice restored",
                    "routine_complete": "Complete Practice",
                    "assign_routine_to_students": "Assign this practice to Players",
                    "schedule_routine": "Schedule Practice",
                    "make_routine_available": "Make Practice Available To:",
                    "make_routine_available_text": "This does not assign the practice, but makes it available to complete on their own (and assign it to others, in the case of coaches)."
                }
            },
            "desc_of_exercise": "Description of the exercise",
            "share_with": "Share with",
            "auto_shared_with": "Automatically shared with",
            "back_to_workouts": "Back to Workouts",
            "back_to_manage_exercises": "Back to Manage Exercises",
            "exercises_may_not_be_deleted_in_workouts": "Exercises may not be deleted while they are part of workouts",
            "exercise_lower": "exercise",
            "workouts_using": "Workouts Using",
            "not_currently_used_in_any_workouts": "Not currently used in any workouts.",
            "return_to_workouts": "Return to Workouts",
            "no_exercises_yet_add_first_w": "No exercises yet. Add your first one with the",
            "workout_builder": "Workout Builder",
            "workout_not_found": "Workout not found",
            "workouts_practices_comprised_of_saved_exercises_you_can_add": "<strong>Workouts</strong> are comprised of <strong>exercises</strong> saved within the system. You can add exercises or prescribe and assign workouts below.",
            "add_exercises_first": "Add exercises first",
            "no_workouts_currently_available": "No Workouts currently available.",
            "your_workouts": "Your Workouts",
            "no_workouts_assigned_yet": "No Workouts assigned yet. Check your library for great ideas you can use on your own!",
            "to_see_full_workout_history_view_your": "To see your full workout history, view your",
            "no_completed_workouts_yet": "No completed workouts yet.",
            "sorry_that_workout_isnt_in_the_system": "Sorry, that workout isn't in the system.",
            "sorry_that_practice_isnt_in_the_system": "Sorry, that practice isn't in the system.",
            "exercises_in_this_workout": "Exercises in this Workout",
            "to_this_workout": "to this Workout",
            "no_exercises_assigned_yet": "No exercises have been added to this workout.",
            "exercise": "Exercise",
            "order": "Order",
            "students_assigned_this_workout": "Players Assigned this Workout",
            "all_students_assigned_workout": "All your players have been assigned this workout.",
            "assign_workout_to_students": "Assign this workout to Players",
            "no_students_assigned_this_workout": "No players have been assigned this workout.",
            "add_exercise_to_this_workout": "Add Exercise to this Workout",
            "assign_this_workout": "Assign this Workout",
            "assign_this_workouts": "Assign this Workout",
            "desc_of_the_workout": "Description of the workout",
            "make_this_workout_available_to_other_coaches_in": "Make this workout available to other coaches in",
            "enter_your_email_to_reset": "Enter your email address to reset your password.",
            "enter_email_to_reset_password": "Enter your email to reset your password",
            "login_to_academy": "Log In To Your Academy",
            "find_academy": "Find Your Academy",
            "enter_academy_domain": "Enter your academy's <strong>{network_name}</strong> domain:",
            "cant_remember_domain": "Can't remember your academy domain?",
            "find_your_academy": "Find your academy",
            "send_me_email": "Send me an email",
            "enter_your_email": "Enter your <strong>email address</strong>:",
            "check_email_domain_match": "We'll check for your email in our system and send you an email with a link to your academy's log in page.",
            "academy_domain": "academydomain",
            "your_email": "Your Email",
            "sport_incomplete": "We have not completed Blast Analytics for that sport yet. Please check again later.",
            "check_app_for_instructions": "Please check your BLAST application for instructions.",
            "blast_logo": "Blast Motion logo",
            "connect_title": "Connect to your Blast Motion Sensor app",
            "connect_subtitle": "Visualize your swing metrics and videos directly within the Blast Portal.",
            "connect_intro_text": "To view your Blast Motion metrics you'll need to authorize a connection with your Blast Motion Sensor app. Have your Blast Motion Sensor app ready with you, as you may need to refer to it during the set up process.",
            "start_connecting": "Start Connecting",
            "dont_have_sensor": "Don't have a Blast Motion Sensor?",
            "dont_have_sensor_text": "Capture, analyze and improve your swing. Blast Motion Sensor apps capture video highlights of your swings, combines them with insightful Blast sensor metrics, helps you analyze your mechanics, and provides drills for improvement.",
            "buy_sensor": "Buy a sensor at the Blast Store",
            "enter_blast_app_info": "Connect Your Mobile App",
            "enter_blast_info_pw_match": "Your Blast Motion Portal email address and your Blast Motion App email address match! You now only need to enter your Blast Motion App password and you'll be ready to view your Blast Motion App metrics.",
            "enter_blast_info_pw_no_match": "Enter your Blast Motion App email address & password and you'll be ready to view your Blast Motion App metrics.",
            "connect_desc_golf": "In order to sync your metrics to Blast Connect, enter the email and password used to log into your Blast Golf mobile app.",
            "connect_desc_baseball": "In order to sync your metrics to Blast Connect, enter the email and password used to log into your Blast Baseball mobile app.",
            "connect_desc_softball": "In order to sync your metrics to Blast Connect, enter the email and password used to log into your Blast Softball mobile app.",
            "blast_motion_app_email": "App email",
            "blast_motion_app_pw": "App password",
            "connect_blast_app": "Connect",
            "forgot_blast_password": "Forgot your mobile app password?",
            "how_to_find_blast_email": "Can't Find Your Email and Password?",
            "email_listed_profile_golf": "Your email and password are listed in the Blast Golf mobile app under your user profile.",
            "email_listed_profile_baseball": "Your email and password are listed in the Blast Baseball mobile app under your user profile.",
            "email_listed_profile_softball": "Your email and password are listed in the Blast Softball mobile app under your user profile.",
            "ios": "iOS",
            "android": "Android",
            "step1": "1",
            "step2": "2",
            "step3": "3",
            "step4": "4",
            "ios_bb_step1_title": "Settings",
            "ios_bb_step1_instructions": "Tap the hamburger icon at the top left of your screen.",
            "ios_bb_step2_title": "Profile",
            "ios_bb_step2_instructions": "Tap your avatar to open your User Profile panel.",
            "ios_bb_step3_title": "Account",
            "ios_bb_step3_instructions": "Tap Account near the top of your screen.",
            "ios_bb_step4_title": "Email",
            "ios_bb_step4_instructions": "Your email address is located in the first field.",
            "android_bb_step1_title": "Settings",
            "android_bb_step1_instructions": "Tap the hamburger icon at the top left of your screen.",
            "android_bb_step2_title": "Profile",
            "android_bb_step2_instructions": "Tap your avatar to open your User Profile panel.",
            "android_bb_step3_title": "Account",
            "android_bb_step3_instructions": "Tap Account near the top of your screen.",
            "android_bb_step4_title": "Email",
            "android_bb_step4_instructions": "Your email address is located in the first field.",
            "golf_step1_title": "Settings",
            "golf_step1_instructions": "Tap the hamburger icon at the top left of your screen.",
            "golf_step2_title": "Profile",
            "golf_step2_instructions": "Tap your avatar to open your User Profile panel.",
            "golf_step3_title": "Account",
            "golf_step3_instructions": "Tap Account near the top of your screen.",
            "golf_step4_title": "Email",
            "golf_step4_instructions": "Your email address is located in the first field.",
            "android_golf_step1_title": "Settings",
            "android_golf_step1_instructions": "Tap the hamburger icon at the top left of your screen.",
            "android_golf_step2_title": "Profile",
            "android_golf_step2_instructions": "Tap your avatar to open your User Profile panel.",
            "android_golf_step3_title": "Account",
            "android_golf_step3_instructions": "Tap Account near the top of your screen.",
            "android_golf_step4_title": "Email",
            "android_golf_step4_instructions": "Your email address is located in the first field.",
            "error_title": "Try Again!",
            "email_not_in_system": "The information you entered in the following field(s) do not exist in the system:",
            "metric_name": "Metric Name",
            "metric_value": "Metric Value",
            "metric_unit": "Metric Unit",
            "you": "You",
            "you2": "you",
            "your": "Your",
            "your2": "your",
            "dont": "don't",
            "doesnt": "doesn't",
            "has": "has",
            "have": "have",
            "blast_metrics": "Metrics",
            "blast_metrics_and_reports": "Metrics & Reports",
            "many_metrics_search": "You have Blast Metrics that match including",
            "invalid_access_token": "Your access token is invalid. Please reconnect your Blast Motion account.",
            "with_actions": "With Actions",
            "total_actions": "total actions",
            "without_actions": "No Actions",
            "showing_actions_pt1": "Showing",
            "refresh": "Refresh",
            "sync": "Sync",
            "async": "Async",
            "swings": "Swings",
            "strokes": "Strokes",
            "swings_num": "Swing|Swings",
            "swing_type": "Swing Type",
            "timeframe": "Time Frame",
            "individual_swings": "Individual Swings",
            "no_actions": "No {sport} actions found. Try expanding your filters or date ranges, or take a few swings with your Blast sensor!",
            "no_actions_student": "{name} does not have any {sport} actions yet. Try expanding your filters or date ranges.",
            "averages": "Averages",
            "all_metrics_averages": "All Metrics/Averages",
            "swing_averages": "Swing Averages",
            "all_swings": "All Swings",
            "full_swings": "Full Swings",
            "short_games": "Short Games",
            "bunkers": "Bunkers",
            "total_swings": "Total Swings",
            "total_strokes": "Total Strokes",
            "putts": "Putts",
            "jumps": "Jumps",
            "sprints": "Sprints",
            "last_swing": "Last Swing",
            "last_5_swings": "Last 5 Swings",
            "last_10_swings": "Last 10 Swings",
            "last_25_swings": "Last 25 Swings",
            "last_50_swings": "Last 50 Swings",
            "go": "Go",
            "filter": "Filter",
            "clear_filters": "Clear Filters",
            "averages_charts_last_100_golf": "*Charts based on last 100 swings.",
            "scheduler_must_be_enabled_organization": "The Scheduler must be turned on at the organizational level first. Please contact {email}",
            "metrics_must_be_enabled_organization": "Blast Metrics must be turned on at the organizational level first. Please contact {email}",
            "subscription_must_be_enabled_organization": "Subscriptions must be turned on at the organizational level first. Please contact {email}",
            "public_registration_must_be_enabled_organization": "Public registration must be turned on at the organizational level first. Please contact {email}",
            "connecting": "Connecting...",
            "importing": "Importing metrics...",
            "finding_new_metrics": "Finding new metrics...",
            "finished": "Finished",
            "finished_redirecting": "Finished. Redirecting...",
            "calculating_averages": "Calculating averages...",
            "importing_equipment": "Importing equipment...",
            "importing_sessions": "Importing sessions...",
            "initiating_import": "Initializing metrics sync...",
            "requesting_import": "Starting metrics sync...",
            "actions": "Actions",
            "sync_latest_metrics": "Sync Latest Metrics",
            "refresh_all_metrics": "Refresh All Metrics",
            "unable_to_connect_blast_account": "<i class=\"far fa-exclamation-triangle\"></i> We had trouble connecting to your Blast account. <a href=\"/blast/connect\">Try reconnecting.</a>",
            "see_section_below": "See &quot;<em>{section}</em>&quot; below.",
            "metrics_sport_not_supported": "We have not completed Blast Metrics for that sport yet. Please check again later.",
            "blast_account_not_connected": "You haven't connected a Blast Motion account to your {appname} yet. <a href=\"{url}\">Connect them now</a> to see your Blast Metrics here.",
            "blast_account_connected": "Congratulations! You have successfully connected to your Blast Motion Sensor app.",
            "blast_metrics_unavailable": "<i class=\"far fa-exclamation-triangle\"></i> Blast Metrics are currently unavailable. We apologize for the inconvenience, please check back later.",
            "blast_metrics_updated_zero": "Your Blast Metrics are up to date.",
            "page_out_of_date": "This page is out of date.",
            "blast_metrics_updated": "Your Blast Metrics have been updated with <span class=\"import-total\">{imported}</span> new actions.",
            "blast_session_timeout": "Your Blast Session has timed out please reconnect again.",
            "metrics_sync_error": "<i class=\"far fa-exclamation-triangle\"></i> There was a problem syncing your metrics. Please retry your sync.",
            "metrics_sync_error_retrying": "<i class=\"far fa-exclamation-triangle\"></i> There was a problem syncing your metrics. Retrying, please wait.",
            "error_contact_support": "<i class=\"far fa-exclamation-triangle\"></i> There was a problem syncing your metrics. Please contact support.",
            "team_report": "Team Report",
            "swing_profile": "Swing Profile",
            "swing_data": "Swing Data",
            "back_to_team_report": "Back to Team Report",
            "rankings": "Rankings",
            "back_to_metrics": "Back to Metrics",
            "customize_your_metrics": "Customize Your Metrics",
            "show_videos_only": "Player videos only",
            "videos_only": "Videos Only",
            "share_your_metrics": "Share Your Metrics",
            "reset_filters": "Reset Filters",
            "close_filters": "Close Filters",
            "customize_metrics": "Customize Metrics",
            "sync_metrics": "Sync Metrics",
            "sync_metrics_sport": "Sync {sport} Metrics",
            "sync_all_students": "Sync All Players",
            "sync_all_students_sport": "Sync All Players {sport}",
            "download_full_team_report": "Download Full Team Report",
            "full_team_report": "Full Team Report",
            "full_team_report_options": {
                "email": {
                    "title": "Get an email sent to you when your report is ready.",
                    "description": "This option is great for reports with many players in it. You’ll be able to browse through Blast Connect while your report is being generated.",
                    "button_caption": "Send an email"
                },
                "browser": {
                    "title": "Download the report directly in your browser.",
                    "description": "This could take several minutes if you have many players in your report. You won’t be able to navigate away from this screen until the report is finished downloading.",
                    "button_caption": "Download"
                },
                "common": {
                    "title": "Team Reports can take a while to generate and download. We’ll send you an email with a link to the report when it’s ready.",
                    "description": "You can continue to do other things in Blast Connect while you’re waiting for your report to be delivered.",
                    "button_caption": "Generate Report"
                }
            },
            "user_unsynced": "This user has not connected their Blast App yet.",
            "current_user_unsynced": "You have not connected your Blast App yet.",
            "user_reconnect": "This user needs to reconnect their Blast App.",
            "current_user_reconnect": "We had trouble connecting to your Blast account.",
            "connect_account": "Connect your Blast account",
            "reconnect_account": "Reconnect your Blast account",
            "learn_about_metrics": "Learn About These Metrics",
            "all_equipment": "All Equipment",
            "sessions": "Sessions",
            "all_session_types": "Session Types",
            "all_sessions": "Sessions",
            "multi_player_sessions": "Multi-Player Sessions",
            "no_sessions": "You have no sessions",
            "clear_daterange": "Clear Date Range",
            "delete_metrics": "Delete Individual Metrics",
            "delete_session": "Delete This Session",
            "delete_sessions": "Delete Session(s)",
            "delete_session_info": "Deleting a session will not delete the actions associated with it.",
            "can_not_delete_session_text": "The following session(s) was created by other people and cannot be deleted:",
            "can_not_deleted_session_description": "The sessions you're viewing were not created by you and cannot be deleted.",
            "view_session": "View Session",
            "download_csv": "Download CSV",
            "download_excel": "Download Excel",
            "download_metrics": "Download Metrics",
            "downloading_metrics_please_wait": "Your metrics are currently exporting. This could take a few minutes. Please wait.",
            "no_actions_selected": "You have not selected any actions to delete.",
            "confirm_delete_actions": "This cannot be undone. Are you sure you want to remove these actions?",
            "confirm_delete_session": "Are you sure you want to delete this session?",
            "confirm_delete_sessions": "Are you sure you want to delete these sessions?",
            "delete_session_and_actions": "Delete session and all actions in this session",
            "delete_sessions_and_actions": "Delete sessions and all actions in these sessions",
            "delete_session_only": "Delete session only (do not delete actions)",
            "delete_sessions_only": "Delete sessions only (do not delete actions)",
            "delete_sessions_and_all_actions": "Delete session(s) and all actions",
            "yes_delete": "Yes, Delete",
            "no_go_back": "No, Go Back",
            "blast_metrics_deleted": "Successfully deleted {total} action(s).",
            "blast_session_deleted": "Successfully deleted session.",
            "blast_sessions_deleted": "Successfully deleted {count} sessions.",
            "blast_session_missing": "Could not find session.",
            "reset_daterange": "Reset Date Range",
            "session_notes": "Session Notes",
            "date_s": "Date(s)",
            "environment_s": "Environment(s)",
            "pitch_type_s": "Pitch Type(s)",
            "pitch_location_s": "Pitch Location(s)",
            "constraint_s": "Constraint(s)",
            "slap_type_s": "Slap Type(s)",
            "search_for_a_player": "Search for a player",
            "search_for_a_roster": "Search for a roster",
            "all_students": "All Students",
            "all_rosters": "All Rosters",
            "action_type": "Action Type",
            "impact_type": "Impact Type",
            "range_today": "Today",
            "range_yesterday": "Yesterday",
            "range_last_x_days": "Last {days} days",
            "range_next_x_days": "Next {days} days",
            "range_days": "days",
            "range_all_time": "All Time",
            "custom_range": "Custom Range",
            "terms_and_conditions": "Terms &amp; Conditions",
            "footer_text": "Blast Motion. All rights reserved.",
            "footer_text_with_year": "©{year} Blast Motion",
            "all_right_reserved": "All rights reserved.",
            "note_access_to_and_use_of_this_data_is_subject_to_the_blast_motion_terms_of_use_and_end_user_license_agreement": "NOTE: Access to and use of this data is subject to the Blast Motion terms of use and end user license agreement, which can be found at {url}",
            "blast_motion_services": "Blast Motion Services",
            "invalid_login_credentials": "Your login credentials are incorrect. Please try again.",
            "uploaded_videos_actions": "{name} uploaded {videos} new {videos_noun} and {actions} new {actions_noun}.",
            "all_metrics": "All Metrics",
            "your_latest_actions": "{name} Latest Actions",
            "recent_student_sessions": "Recent Player Sessions",
            "recent_player_sessions": "Recent Player Sessions",
            "your_last_session": "{name} Last Session",
            "videos_noun": "video|videos",
            "actions_noun": "action|actions",
            "session_s": "Session(s)",
            "sessions_are_not_found": "No sessions found",
            "no_equipment_found": "No equipment found",
            "great_news": "Great News!",
            "your_team_report_is_ready_now": "Your team report is ready now",
            "here_is_a_link_to_download_the_report": "Here is a link to download the report:",
            "this_report_will_be_available_for_download_for_the_next_24_hours_if_you_do_not_download_the_report_before_then": "This report will be available for download for the next 24 hours. If you do not download the report before then, you'll need to generate the report again.",
            "period": "Period",
            "view_in_library": "View In Library",
            "edit_and_share": "Edit & Share",
            "left_handed": "Left Handed",
            "right_handed": "Right Handed",
            "camp_invite_to_join": "Please complete your registration for {camp_academy_name} + Blast by accepting this invitation now.",
            "camp_invite_to_join_student": "At the upcoming {camp_academy_name} event, a Blast Motion Swing Analyzer will be used to capture swing metrics, impact metrics, and swing quality scores for your swings. This swing performance data will be available to you after the event on your personal Blast Player Report in Blast Connect.",
            "invite_to_join": "has invited you to join their Blast Connect Team.",
            "login_to_join": "Log Into Blast To Accept This Invitation",
            "login_to_join_student": "Log Into Blast Connect To Accept This Invitation",
            "invitation_username": "Username:",
            "invitation_password": "Password (New Users Only):",
            "invitation_accept": "Accept Invitation",
            "invitation_sub_heading_camp": "Accepting this invitation and the Blast Terms and Conditions is required for your participation in {camp_academy_name} + Blast. Please click the link above now to ensure your swing data is captured at the event.",
            "invitation_sub_heading_camp_student": "Accepting this invitation to Blast Connect is not required to participate in the event or to have your Blast swing performance data captured. After the event, when you’re ready to view your data, just use the button above to accept this Blast Connect invitation. The data will be available to you to view for 45 days after the start of the event at no additional charge. After 45 days, you will need an active Blast Premium Services subscription to access the data.<br><br>Blast Premium Services, when coupled with the Blast Swing Analyzer, lets you take your training to a whole new level so that you can dominate at the plate. As an attendee of the {camp_academy_name} event, you get a 30-day free trial to Blast Premium Services when you sign up. <a href=\"{url}\" target=\"_blank\" class=\"link-font\">Learn more about the Blast solution</a>.",
            "invitation_sub_heading_player": "Once you join, you and your coach can access all of your Blast metrics, videos, and training history using the Blast App or view more details in Blast Connect.",
            "invitation_sub_heading_coach_admin": "Give feedback to your athletes through powerful video analysis, voiceover, and markup features. You can even review your athletes’ practice sessions, assign workouts, and provide them with actionable insights… anywhere, anytime.",
            "need_a_sensor": "Need a Sensor?",
            "ready_to_continue_your_player_development": "Ready to Continue Your Player Development?",
            "sensor_description": "The Blast sensor allows you to collect, view, and improve your swing impact metrics.",
            "sensor_description_student": "{blast_sport} is the <strong class=\"link-font\">#1 swing analyzer</strong> for pro teams, colleges, high schools, and elite travel teams for player development and recruiting.<br><br>The Blast Swing Analyzer helps you to train smarter and build a better swing by allowing you to collect, view, and improve your swing impact metrics.",
            "subscription_description": "Premium Services allow you to level-up the Blast experience and gain access to Blast Connect, a customized website and information management platform.",
            "get_a_sensor": "Get A Sensor",
            "get_a_blast_swing_analyzer": "Get A Blast Swing Analyzer",
            "camp_invitation_title": "Invitation to {parent_academy} - {camp_academy}",
            "camp_invitation_title_student": "Invitation to Blast Connect for {parent_academy} - {camp_academy}",
            "camp_invitation_upsell": "Limited time offer! Get your own Blast Swing Analyzer with a special discount for attending {camp_academy} + Blast. Offer expires on {upsell_expiration}.",
            "camp_invitation_upsell_student": "Limited time offer! Get your own Blast Swing Analyzer with a special discount for attending {camp_academy} + Blast. Offer expires on {upsell_expiration}.",
            "invitation_title": "{invited_by} has invited you to join Blast Premium",
            "invitation_accepted_title": {
                "baseball": "You are now a member of Blast Connect Team!",
                "softball": "You are now a member of Blast Connect Team!",
                "golf": "You are now a member of Blast Premium!"
            },
            "invitation_accepted_message_coach_admin": {
                "baseball": "You can now access of your players' Blast metrics, videos, and training history using the Blast App or Blast Connect web portal.",
                "softball": "You can now access of your players' Blast metrics, videos, and training history using the Blast App or Blast Connect web portal.",
                "golf": "You can now access your players' and your own Blast metrics, videos, and training history using the Blast App or Blast Connect web portal."
            },
            "invitation_accepted_message_player": "You and your coach can now access all of your Blast metrics, videos, and training history using the Blast App or Blast Connect.",
            "invitation_accepted_instructions_title": "New to Blast? Let’s Get You Started.",
            "invitation_accepted_device_ios_title": "Apple/iOS Instructions",
            "invitation_accepted_device_android_title": "Android Instructions",
            "invitation_accepted_instructions": {
                "1": {
                    "title": "Download the Blast {sport} App & Sign In",
                    "description": "Using your smartphone go to Apple’s App Store, search for “Blast {sport}” and download the app. When it’s ready, log in using the email you used to register for Blast."
                },
                "2": {
                    "title": "Pair your sensor",
                    "description": {
                        "ios": "Tap <b style=\"font-weight{700};\">Tap to add a sensor</b>. Then follow the instructions on your screen.",
                        "android": "Tap the <b style=\"font-weight{700};\">Hamburger menu</b> then <b style=\"font-weight{700};\">My Sensors</b>. Then follow the instructions on your screen."
                    }
                },
                "3": {
                    "title": "Add {equipment}",
                    "description": "Tap the <b style=\"font-weight{700};\">Hamburger menu</b> then <b style=\"font-weight{700};\">{equipment}</b>. {multiple_equipment}."
                },
                "4": {
                    "title": "Start swinging!",
                    "description": "Monitor your performance as you swing with the Blast {sport} App, or track your progress over time using Blast Connect."
                }
            },
            "boditrak_metrics": "BodiTrak Metrics",
            "boditrak_take_swings": "Go ahead and take some swings with the BodiTrak Dash app.",
            "dont_have_boditrak": "Don't have the BodiTrak Dash app?",
            "boditrak_description": "BodiTrak is a ground-force, pressure, and video analysis solution.",
            "boditrak_mat_separately": "BodiTrak Mat sold separately.",
            "download_ios": "Download it on the app store",
            "download_android": "Get it on Google Play",
            "no_sensor_title_golf": "Don't have a Blast Golf sensor?",
            "no_sensor_title_baseball": "Don't have a Blast Baseball sensor?",
            "no_sensor_title_softball": "Don't have a Blast Softball sensor?",
            "no_sensor_desc_golf": "The Blast Golf sensor captures your swing and stroke metrics, helps you analyze your data, and provides drills to improve your game. By knowing your metrics, you will make more putts and strike the ball more consistently.",
            "no_sensor_desc_baseball": "The Blast Baseball Swing Analyzer Sensor captures video highlights of your swings, combines them with insightful Blast sensor metrics, helps you analyze your mechanics, and provides drills for improvement.",
            "no_sensor_desc_softball": "The Blast Softball Swing Analyzer app captures video highlights of your swings, combines them with insightful Blast sensor metrics, helps you analyze your mechanics, and provides drills for improvement.",
            "sunday_shortname": "Su",
            "monday_shortname": "Mo",
            "tuesday_shortname": "Tu",
            "wednesday_shortname": "We",
            "thursday_shortname": "Th",
            "friday_shortname": "Fr",
            "saturday_shortname": "Sa",
            "not_going": "Not Going",
            "select_date_range": "Select date range",
            "training-center": "Training Center",
            "golf": "Golf",
            "baseball": "Baseball",
            "softball": "Softball",
            "get_better": "Get Better",
            "training-drills": "Training Drills",
            "no_training_center_drills_for": "There are no Training Center drills currently available for {sport}. Please check back soon.",
            "training-drills-description-app": "Guided training to improve your overall swing.",
            "pro-tips": "Pro Tips",
            "pro-tips-description-app": "Pro Tips for improving overall performance.",
            "back_to_training_center": "Back to Training Center",
            "back_to_pro_tips": "Back to Pro Tips",
            "metrics_title-description-app": "Metric definitions and explanations.",
            "back_to_drills": "Back to Drills",
            "golf-putting": "Putting",
            "golf-full-swing": "Full Swing",
            "golf-short-game": "Short Game",
            "golf-bunker": "Bunker",
            "baseball-swing": "Baseball Swing",
            "softball-swing": "Softball Swing",
            "tm-putting": "Putting",
            "tm-full-swing": "Full Swing",
            "control": "Control",
            "power": "Power",
            "length": "Length",
            "timing": "Timing",
            "angles": "Angles",
            "pro-tip": "Pro-Tip",
            "standard_drill": "Standard Drill",
            "interactive_drill": "Interactive Drill",
            "all_putts": "All Putts",
            "putt": "putt",
            "putting": "putting",
            "swing": "swing",
            "swing_details": "Swing Details",
            "air_swing": "Air Swing",
            "show_videos_only_phrase": "Show Videos Only",
            "swing_s": "{number} Swing|{number} Swings",
            "full_swing": "full swing",
            "full-swing": "full swing",
            "short_game": "short game",
            "short-game": "short game",
            "youth-drills": "youth drills",
            "bunker": "bunker",
            "learn_more_about": "Learn more about {item}",
            "visit_the_training_center": "Visit the Training Center",
            "unassigned": "Unassigned",
            "youth_drills": "Youth Drills",
            "member_search": "Member Search",
            "academy_search": "Academy Search",
            "subscriber": "Subscriber",
            "subscriber_report": "Subscriber Report",
            "subscriber_reports": "Subscriber Reports",
            "subscriber_reports_desc": "Report of all new subscribers within an organization.",
            "members_reports": "Members Reports",
            "members_reports_desc": "Report of all members within an academy.",
            "export_unpaid": "Unpaid Accounts Report",
            "export_unpaid_current_academy": "Export Unpaid Account Data for current academy",
            "export_unpaid_all_academy": "Export Unpaid Account Data for all academy",
            "export_unpaid_explain": "A report of users who have signed up for Blast Connect, but have not paid for their subscriptions.",
            "admin_user_report": "Blast Admin User Report",
            "view_report": "View Report",
            "most_active_reports": "Most Active Reports",
            "most_active_sensors": "Most Active Sensors",
            "most_active_subscriptions": "Most Active Subscriptions",
            "equipments": {
                "golf": {
                    "drivers": {
                        "name": "Drivers",
                        "types": {
                            "driver": "Driver"
                        }
                    },
                    "irons": {
                        "name": "Irons",
                        "types": {
                            "one_iron": "One Iron",
                            "two_iron": "Two Iron",
                            "three_iron": "Three Iron",
                            "four_iron": "Four Iron",
                            "five_iron": "Five Iron",
                            "six_iron": "Six Iron",
                            "seven_iron": "Seven Iron",
                            "eight_iron": "Eight Iron",
                            "nine_iron": "Nine Iron"
                        }
                    },
                    "wedges": {
                        "name": "Wedges",
                        "types": {
                            "pitching_wedge": "Pitching Wedge",
                            "gap_wedge": "Gap Wedge",
                            "sand_wedge": "Sand Wedge",
                            "lob_wedge": "Lob Wedge"
                        }
                    },
                    "putters": {
                        "name": "Putters",
                        "types": {
                            "putter": "Putter"
                        }
                    },
                    "training_aids": {
                        "name": "Training Aids",
                        "types": {
                            "super_light": "SuperLight"
                        }
                    },
                    "fairways_hybrids": {
                        "name": "Fairways / Hybrids",
                        "types": {
                            "two_hybrid": "2 Hybrid",
                            "four_hybrid": "4 Hybrid"
                        }
                    }
                },
                "baseball": {
                    "bats": {
                        "name": "Bats",
                        "types": {
                            "bat": "Bat"
                        }
                    }
                },
                "softball": {
                    "bats": {
                        "name": "Bats",
                        "types": {
                            "bat": "Bat"
                        }
                    }
                }
            },
            "metrics": {
                "load_consistency": "Load Consistency",
                "impact_position": "Impact Position",
                "definitions": {
                    "goal": "Goal",
                    "pro_average": "Pro Average",
                    "amateur_average": "Amateur Average",
                    "little_league_average": "Little League Average",
                    "senior_league_average": "Senior League Average",
                    "high_school_average": "High School Average",
                    "collegiate_pro_average": "Collegiate/Pro Average",
                    "recreational": "Recreational",
                    "high_school": "High School",
                    "travel_ball_12u_14u": "Travel Ball 12U - 14U",
                    "travel_ball_16u_18u": "Travel Ball 16U - 18U",
                    "college_non_d1": "College (non-D1)",
                    "college_d1": "College (D1)",
                    "professional": "Professional",
                    "tip": "Metric Tip"
                },
                "golf": {
                    "putt": {
                        "back_stroke_time": {
                            "name": "Back Stroke Time",
                            "description": "Backstroke Time is the elapsed time it takes to complete your Backstroke (address to top of backstroke), measured in seconds.",
                            "goal": "Tour Professionals typically have a Backstroke Time near 0.60 seconds.",
                            "pro_average": "0.57 to 0.63 seconds",
                            "amateur_average": "0.54 to 0.66 seconds",
                            "tip": "Once you determine your most consistent Backstroke Time, practice to repeat it for putts of all lengths.",
                            "unit": "sec"
                        },
                        "forward_stroke_time": {
                            "name": "Forward Stroke Time",
                            "description": "Forward Stroke Time is the elapsed time it takes to complete your Forward Stroke (top of backstroke to impact).",
                            "goal": "Tour Professionals typically have a Forward Stroke Time near 0.30 seconds, or half as long as their Backstroke Time, for putts of all lengths.",
                            "pro_average": "0.29 to 0.31 seconds",
                            "amateur_average": "0.26 to 0.34 seconds",
                            "tip": "Practice to keep your Forward Stroke Time consistent and maintain your 2.0{1} Tempo. A Forward Stroke Time that is too long may be a sign of deceleration into the ball.",
                            "unit": "sec"
                        },
                        "total_stroke_time": {
                            "name": "Total Stroke Time",
                            "description": "Total Stroke Time is the elapsed time it takes to make a complete putting stroke from the start of the stroke to impact with the ball, measured in seconds.",
                            "goal": "",
                            "pro_average": "0.86 to 0.94 seconds",
                            "amateur_average": "0.80 to 1.00 seconds",
                            "tip": "Once you determine the ideal Total Stroke Time of your best putts set / update your goal and practice to repeat it for putts of all lengths.",
                            "unit": "sec"
                        },
                        "tempo": {
                            "name": "Tempo",
                            "description": "Tempo is the ratio between Backstroke Time and Forward Stroke Time.",
                            "goal": "Ideal Tempo with a putter should be near 2.0{1} meaning your Backstroke Time should be 2 times longer than your forward stroke time.",
                            "pro_average": "1.8{1} to 2.2{1}",
                            "amateur_average": "1.6{1} to 2.5{1}",
                            "tip": "Once you determine the tempo of your best putts, set / update your goal and practice to repeat it for putts of all lengths.",
                            "unit": "ratio"
                        },
                        "back_stroke_length": {
                            "name": "Back Stroke Length",
                            "description": "Backstroke Length is the length the putter face travels in the Backstroke from address to the top of the Backstroke, measured in inches.  Your Backstroke Length will depend on the conditions you are faced with, green speed, slope of the green and the distance of the putt.  Because of these dependencies a goal for Backstroke Length is not automatically set.",
                            "goal": "As a guideline, each inch of Backstroke Length should result in 1 foot of roll for a flat putt (on medium speed greens).",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "If you are practicing putts from the same location, determine the ideal Backstroke length on your best putts, set your goal and work to repeat it.",
                            "unit": "inches"
                        },
                        "impact_stroke_speed": {
                            "name": "Impact Stroke Speed",
                            "description": "Impact Stroke Speed is the speed of the sweet spot of the putter face at the moment of impact, measured in miles per hour (mph).  The ideal stroke speed will depend on the conditions you are faced with, green speed, slope of the green and the distance of the putt.  Because of these dependencies a goal for Impact Stroke Speed is not automatically set.",
                            "goal": "As a guideline, on a flat 3-foot putt (on medium speed greens) Impact Stoke Speed is approximately 1.5 mph, while a 6-foot putt requires approximately 2 mph.",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "If you are practicing putts from the same location, determine the speed of your best putts, set your goal and work to repeat it.",
                            "unit": "mph"
                        },
                        "loft": {
                            "name": "Loft Change",
                            "unit": "deg",
                            "increased": "increased",
                            "decreased": "decreased",
                            "no_change": "no change",
                            "description": "Loft Change is the increase or decrease in Loft (the angle of the putter face relative to the vertical plane) between the start of the stroke and impact with the ball, measured in degrees.  If Loft Change is negative, you have decreased loft, causing the ball to be driven into the ground and affecting speed control.  If Loft Change is positive, you have increased loft, sending the ball into the air and affecting speed control.",
                            "goal": "In an ideal stroke, there should not be an increase or decrease in loft.  Loft Change will be 0*.",
                            "pro_average": "0.3 degrees",
                            "amateur_average": "1.3 degrees",
                            "tip": ""
                        },
                        "back_stroke_rotation": {
                            "name": "Backstroke Rotation",
                            "unit": "deg",
                            "open": "open",
                            "closed": "closed",
                            "no_change": "no change",
                            "description": "Backstroke Rotation is the rotation of the putter face during the backstroke, measured in degrees.  Because Backstroke Rotation will change based on the length of the putt, a goal for Backstroke Rotation is not automatically set.",
                            "goal": "Ideal Backstroke Rotation should equal Forward Stroke Rotation.",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": ""
                        },
                        "forward_stroke_rotation": {
                            "name": "Forward Stroke Rotation",
                            "unit": "deg",
                            "open": "open",
                            "closed": "closed",
                            "no_change": "no change",
                            "description": "Forward Stroke Rotation is the rotation of the putter face during the forward stroke, measured in degrees.  Because Forward Stroke rotation will change based on the length of the putt, a goal for Forward Stroke Rotation is not automatically set.",
                            "goal": "Ideal Forward Stroke Rotation should equal Backstroke Rotation.",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": ""
                        },
                        "face_angle_at_impact": {
                            "name": "Face Angle at Impact",
                            "unit": "deg",
                            "open": "open",
                            "closed": "closed",
                            "no_change": "no change",
                            "description": "Face Angle at Impact is the difference in Rotation (the rotation of the putter face around the shaft) between Backstroke Rotation and Forward Stroke Rotation, measured in degrees.  Face Angle at Impact (open / +) means the putter face was not rotated enough on the Forward Stroke to return to its original starting alignment. Face Angle at Impact (closed / -) means the putter face rotated past its original starting alignment.",
                            "goal": "Assuming the initial aim of the putter face is directly at the center of the target, a Face Angle at Impact of 0.0* is ideal.",
                            "pro_average": "0.3 degrees",
                            "amateur_average": "1.3 degrees",
                            "tip": ""
                        },
                        "lie": {
                            "name": "Lie Change",
                            "unit": "deg",
                            "increased": "increased",
                            "decreased": "decreased",
                            "no_change": "no change",
                            "description": "Lie Change is the increase or decrease in Lie (the angle between the club shaft and the ground) between the start of a stroke and impact with the ball, measured in degrees.  Assuming the sole of the putter is parallel with the ground at address, lifting your hands will Increase lie, causing the heel to be higher than the toe and pointing the putter face to point right of the target.  Lowering your hands will decrease lie, causing the toe to be higher than the heel and pointing the putter face to the left of the target.",
                            "goal": "In an ideal stroke, there should not be an increase or decrease in Lie.  Lie Change will be 0*.",
                            "pro_average": "0.3 degrees",
                            "amateur_average": "1.3 degrees",
                            "tip": ""
                        },
                        "backstroke_speed": {
                            "name": "Backstroke Speed",
                            "unit": "mph",
                            "description": "Blast Internal Only Metric",
                            "goal": "TBD in a future release",
                            "pro_average": "TBD in a future release",
                            "amateur_average": "TBD in a future release",
                            "tip": "TBD in a future release"
                        },
                        "forward_to_back_stroke_speed_ratio": {
                            "name": "Speed Ratio",
                            "unit": "",
                            "description": "Blast Internal Only Metric",
                            "goal": "TBD in a future release",
                            "pro_average": "TBD in a future release",
                            "amateur_average": "TBD in a future release",
                            "tip": "TBD in a future release"
                        }
                    },
                    "swing": {
                        "backswing_time": {
                            "name": "Backswing Time",
                            "unit": "sec",
                            "description": "Backswing Time is the elapsed time it takes to complete your backswing (address to top of backswing), measured in seconds.",
                            "goal": "Ideal Backswing Time should be 2.5 - 3 times longer than Downswing Time for your full swing. Ideal Backswing Time will vary based on the type of short game or bunker shot you are hitting but should be 2 - 3 times longer than Downswing Time.",
                            "pro_average": "Woods/Driver: 0.7 - 0.9 seconds, Long Irons: 0.65 - 0.85 seconds, Irons: 0.65 - 0.85 seconds, Wedges: 0.65 - 0.85 seconds",
                            "amateur_average": "Woods/Driver: 0.7 - 0.9 seconds, Long Irons: 0.65 - 0.85 seconds, Irons: 0.65 - 0.85 seconds, Wedges: 0.65 - 0.85 seconds",
                            "tip": "Once you determine the ideal Backswing time on your best swings, short game shots, or bunker shots, set / update your goal and practice to repeat it."
                        },
                        "downswing_time": {
                            "name": "Downswing Time",
                            "unit": "sec",
                            "description": "Downswing Time is elapsed time it takes to complete your downswing (top of backswing to impact with the ball), measured in seconds.",
                            "goal": "Ideal Downswing Time is approximately 2.5 - 3 times shorter than your Backswing Time for your full swing. Ideal Downswing Time will vary based on the type of short game or bunker shot you are hitting but should be approximately 2 - 3 times shorter than your Backswing Time.",
                            "pro_average": "Woods/Driver: 0.23 - 0.32 seconds, Long Irons: 0.23 - 0.32 seconds, Irons: 0.23 - 0.32 seconds, Wedges: 0.23 - 0.32 seconds",
                            "amateur_average": "Woods/Driver: 0.23 - 0.32 seconds, Long Irons: 0.23 - 0.32 seconds, Irons: 0.23 - 0.32 seconds, Wedges: 0.23 - 0.32 seconds",
                            "tip": "Once you determine the ideal Downswing Time on your best swings, short game shots, or bunker shots, set / update your goal and practice to repeat it."
                        },
                        "total_swing_time": {
                            "name": "Total Swing Time",
                            "unit": "sec",
                            "description": "Total Swing Time is the elapsed time it takes to complete your swing (start of the swing to impact with the ball), measured in seconds.  Total swing time will vary based on the type of shot you are hitting.",
                            "goal": "",
                            "pro_average": "Woods/Driver: 0.93 - 1.22 seconds, Long Irons: 0.88 - 1.17 seconds, Irons: 0.88 - 1.17 seconds, Wedges: 0.88 - 1.17 seconds",
                            "amateur_average": "Woods/Driver: 0.93 - 1.22 seconds, Long Irons: 0.88 - 1.17 seconds, Irons: 0.88 - 1.17 seconds, Wedges: 0.88 - 1.17 seconds",
                            "tip": "Once you determine the ideal Total Swing Time on your best swings, short game shots, or bunker shots, set / update your goal and practice to repeat it."
                        },
                        "swing_tempo": {
                            "name": "Swing Tempo",
                            "unit": "ratio",
                            "description": "Swing Tempo is the ratio between Backswing Time and Downswing Time.",
                            "goal": "Ideal Tempo for your full swing should be approximately 2.5{1} - 3.0{1}, meaning your Backswing Time should be 2.5 - 3 times longer than your Downswing Time. Ideal Tempo for your short game will vary based on the type of shot you are hitting but should be approximately 2.0{1} -  3.0{1}, meaning your Backstroke Time should be 2 - 3 times longer than your Forward Stroke time.",
                            "pro_average": "Woods/Driver: 2.7{1} to 3.3{1}, Long Irons: 2.7{1} to 3.3{1}, Irons: 2.5{1} to 3.1{1}, Wedges: 2.5{1} to 3.1{1}",
                            "amateur_average": "Woods/Driver: 2.7{1} to 3.3{1}, Long Irons: 2.7{1} to 3.3{1}, Irons: 2.5{1} to 3.1{1}, Wedges: 2.5{1} to 3.1{1}",
                            "tip": "Once you determine your tempo for your best swings, short game shots, or bunker shots, set / update your goal and practice to repeat it."
                        },
                        "attack_angle": {
                            "name": "Attack Angle",
                            "unit": "",
                            "description": "Attack Angle is the up or downward movement of the club head approaching the ball at impact, measured relative to the horizon. With irons, most great ball strikers have a slightly downward attack angle. With wedges, most players with a strong short game, as well as most great bunker players, have a slightly downward attack angle. The goal ranges in the app have been determined using data from the professional tours.",
                            "goal": "",
                            "pro_average": "Woods/Driver: Even to Up, Long Irons: Down, Irons: Down, Wedges: Down",
                            "amateur_average": "Woods/Driver: Even to Up, Long Irons: Down, Irons: Down, Wedges: Down",
                            "tip": "To maximize distance with your driver, hitting level or up on the ball (attack angle up) is recommended.",
                            "up": "Up",
                            "down": "Down",
                            "level": "Level"
                        },
                        "swing_speed": {
                            "name": "Swing Speed",
                            "unit": "mph",
                            "description": "Swing Speed is the speed of the clubhead’s sweet spot at impact, measured in miles per hour (mph).  Swing speed will depend on age, ability, mobility, strength and power, along with the distance of the shot and club selection.  Due to these dependencies, a goal for Swing Speed is not automatically set.",
                            "goal": "",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "If you are working on a specific shot type, determine the Swing Speed of your best shots, set a goal and work to repeat it. (Remember to set a new goal when working on different types of shots or with different clubs.)  If you are looking to maximize Swing Speed with a driver, set a goal speed and work on swing mechanics to achieve it."
                        },
                        "peak_hand_speed": {
                            "name": "Peak Hand Speed",
                            "unit": "mph",
                            "description": "Peak Hand Speed is the observed maximum speed of the hands as measured on the grip of the club, measured in miles per hour (mph).  When taking full swing shots, Peak Hand Speed should occur prior to the moment of impact, very close to the commit time in the swing when the hands transfer the energy of the swing into the shaft enabling the club head to move faster and pass the hands speed.  This is reflected in the range automatically set in the app.  When hitting short game or bunker shots, Peak Hand Speed should occur prior to the moment of impact but will vary with the type of shot you are hitting.",
                            "goal": "",
                            "pro_average": "Woods/Driver: 17 - 30 mph, Long Irons: 16 - 28 mph, Irons: 16 - 28 mph, Wedges: 16 - 28 mph",
                            "amateur_average": "Woods/Driver: 17 - 30 mph, Long Irons: 16 - 28 mph, Irons: 16 - 28 mph, Wedges: 16 - 28 mph",
                            "tip": "Peak hand speed should occur at a point between 60% - 80% of your Downswing Time.  Practice to reach Peak Hand Speed at the right time during your swing to maximize efficiency."
                        },
                        "backswing_speed": {
                            "name": "Backswing Speed",
                            "unit": "mph",
                            "description": "Blast Internal Only Metric",
                            "goal": "TBD in a future release",
                            "pro_average": "TBD in a future release",
                            "amateur_average": "TBD in a future release",
                            "tip": "TBD in a future release"
                        },
                        "speed_ratio": {
                            "name": "Speed Ratio",
                            "unit": "ratio",
                            "description": "Blast Internal Only Metric",
                            "goal": "TBD in a future release",
                            "pro_average": "TBD in a future release",
                            "amateur_average": "TBD in a future release",
                            "tip": "TBD in a future release"
                        }
                    }
                },
                "baseball": {
                    "swing": {
                        "swing_speed": {
                            "name": "Bat Speed",
                            "unit": "mph",
                            "target": {
                                "basic": "D1",
                                "pro": "MLB"
                            },
                            "relates_to": "Raw Power",
                            "description": "The total speed of the barrel at impact."
                        },
                        "time_to_contact": {
                            "name": "Time to Contact",
                            "unit": "sec",
                            "description": "The time measured from the start of the downswing to impact."
                        },
                        "bat_rpm": {
                            "name": "Bat RPM",
                            "unit": "rpm",
                            "description": "Bat RPM is the rotational speed of the bat at the moment of impact.",
                            "little_league_average": "320-380 rpm",
                            "senior_league_average": "355-415 rpm",
                            "high_school_average": "390-450 rpm",
                            "collegiate_pro_average": "425-485 rpm"
                        },
                        "bat_path_angle": {
                            "name": "Attack Angle",
                            "unit": "deg",
                            "description": "The angle that the barrel approaches the ball at impact. Positive is swinging up, negative is swinging down.",
                            "relates_to": "Swing Direction"
                        },
                        "blast_factor": {
                            "name": "Blast Factor",
                            "description": "Overall swing score based on the following components and their contributions:\nOn-Plane Score: 15%\nPeak Bat Speed Score: 10%\nAttack Angle Score: 10%\nBody Rotation Score: 15%\nPower Score: 50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast Factor",
                            "description": "Blast Factor is a swing score (0 to 100) for overall performance tracking."
                        },
                        "efficiency_index": {
                            "name": "Efficiency Index",
                            "description": "The Efficiency Index is a score (0 to 100) that indicates how effectively you create and direct energy to the ball. It combines Energy Transfer, Bat Path, and Bat Whip scores.",
                            "tip": "An ideal Efficiency Index is 100. You ultimately want to increase your efficiency as much as possible without sacrificing power."
                        },
                        "power_index": {
                            "name": "Power Index",
                            "description": "Power Index is a score (0 to 100) that represents your raw force. Ultimately, ball speed is a result of bat weight, swing speed, and quality of contact. In the Power Index, we focus on weight and speed, plus how quickly you generate that speed. Newton’s second law of motion is Force = Mass × Acceleration, or Mass × Swing Speed / Time to Contact. The more mass you can swing in a short amount of time, the higher your Power Index will be.",
                            "tip": "The ideal Power Index score is 100. How closely you approach this depends on your age, strength, skill level, and the size and weight of your bat. Ultimately, you want the Power Index as high as possible without sacrificing efficiency."
                        },
                        "energy_transfer": {
                            "name": "Energy Transfer",
                            "description": "Energy Transfer is a score (0-100) that measures how energy is transferred from the body to the bat. A rotational swing uses the kinematic chain of hips, shoulders, arms and wrists to transfer energy to the bat. When you use your body to generate speed, you generate bat speed more efficiently and with less effort from the arms. When you rely more on your arms, there is more variability in bat speed and you cannot ultimately achieve as high of bat speeds. We compare the total speed in the first half of the swing to the total speed in the second half of the swing to indicate how effectively you are using your body. Energy Transfer is a component of the Efficiency Index.",
                            "tip": "Rotationally efficient swings generate about half of their speed in the first half of the swing, where speed is primarily generated by the hips and shoulders versus the arms and wrists. The target zone is about 45% to 55% of your speed in the first half. Anything lower than this will result in an Energy Transfer score less than 100. This usually indicates an over-reliance on the arms (for example, casting the arms away from the body). Any speed in or above the target zone will receive an Energy Transfer score of 100. Even though we don’t penalize you for exceeding the target zone, it might be difficult to control the bat and adapt to pitches in a real game scenario. You’re probably swinging out of your shoes!"
                        },
                        "bat_whip": {
                            "name": "Bat Whip",
                            "description": "Bat Whip is one component of the Efficiency Index. It measures the time between the peak rotational speed (RPMs) during the swing and the RPMs at moment of impact. An efficient swing has peak rotational speed (RPMs) at impact.",
                            "tip": "An efficient baseball swing has peak rotational speed at the point of impact. If you achieve this, there won’t be a line on the tracer tool indicating that Bat Whip was achieved before impact."
                        },
                        "bat_path": {
                            "name": "Bat Path",
                            "description": "Bath Path is one component of the Efficiency Index. It is a score based on the relationship of swing speed and bat path angle that maximizes launch (distance). For example: When swinging 35 mph you would swing 22 degrees to achieve optimum launch. 55 mph @ 15 degrees, 75 mph @ 7 degrees, 85 mph @ 3 degrees … In general, the faster your swing speed the less of a positive angle necessary to achieve max launch (distance).",
                            "tip": "The ideal Bat Path is dependent on many factors including the incoming pitch angle, swing speed, and situational hitting. The Bat Path Score in this case was designed to maximize launch of a hit ball. So to achieve a high bat path score in the Efficiency Index, however, it will be between 3-22 degrees depending on how fast your swing speed is. (In general, the faster your swing speed, the smaller the angle necessary to achieve max launch)."
                        },
                        "barrel_acceleration": {
                            "name": "Barrel Acceleration",
                            "description": "Barrel Acceleration is one component of the Efficiency Index. It is a score (0 to 10) based on an ideal acceleration build where 2/3 (66%) of your bat speed generated should occurs in the last 1/3 of your swing. An efficient swing has peak acceleration occur at impact, therefore, acceleration should build from the start of the downswing to the point of impact. If you reach peak acceleration too early in the swing, you lose power to the ball.",
                            "tip": "The ultimate Barrel Acceleration will be a score of 10, and that should always be the goal. Focus on creating a dynamic acceleration build with peak acceleration happening at the point of impact. This will result in harder hit balls and favorable outcomes."
                        },
                        "peak_speed": {
                            "name": "Peak Bat Speed",
                            "unit": "mph",
                            "description": "Peak Bat Speed is the highest forward speed at the sweet spot of the bat, as measured six inches from the tip of the bat. This may occur at or before the moment of impact.\n\nAchieving your Peak Bat Speed at the moment of impact results in maximum ball exit speed and distance. If your peak speed is not timed with impact that means your swing is inefficient and you are losing Bat Speed at impact that could result in harder hit balls.\n\nYou should be able to read a pitch and time your swing so that you make contact near your peak speed.  Over a session, your Peak Bat Speed should be the same or very close to your Bat Speed at impact."
                        },
                        "bat_whip_sec_prior": {
                            "name": "Peak Speed Pre-Impact",
                            "unit": "sec",
                            "description": "Peak Speed Pre-Impact is the time from peak speed to the moment of impact, in seconds. An efficient baseball swing has peak speed at the moment of impact; therefore, the ideal Peak Speed Pre-Impact value is zero."
                        },
                        "power": {
                            "name": "Power",
                            "unit": "kW",
                            "description": "The amount of power generated, in kilowatts, during the swing."
                        },
                        "vertical_bat_angle": {
                            "name": "Vertical Bat Angle",
                            "unit": "deg",
                            "description": "The steepness of the barrel at impact from a catcher’s perspective. The value is negative when the barrel is below the hands."
                        },
                        "body_tilt_angle": {
                            "name": "Body Tilt Angle",
                            "unit": "deg",
                            "description": "The inferred 3D tilt for each swing, calculated from your center of rotation. The body tilt angle incorporates both flexion (forward/backward) and lateral (side to side) tilt and can be seen on the 3D Swing Tracer."
                        },
                        "peak_hand_speed": {
                            "name": "Peak Hand Speed",
                            "unit": "mph",
                            "description": "The fastest hand speed reached throughout the swing."
                        },
                        "on_plane": {
                            "name": "On Plane",
                            "unit": "%",
                            "description": "The On Plane metric measures the percentage of your swing that the sweet spot of the bat is considered to be On Plane.  The reference plane is defined at the moment of impact.  The percentage of your swing On Plane is determined by the amount of speed generated within that reference plane.\n\nIn an ideal world, the hitter wants to maximize their On Plane percentage.  The higher this percentage value, the better, as that requires less conscious and active control from the hitter during the dynamic downswing. There is a high correlation between the hitter's setup posture and the On Plane percentage metric.  A hitter that has more body tilt towards the plate will tend to be On Plane longer than someone who stands more upright at the beginning of the swing and drops the barrel down into the swing plane as the swing progresses.\n\nA good functional swing will have an average On Plane percentage starting at 60% or higher.  A typical dynamic range for On Plane percentage will be 55%-65%.  For the On Plane metric, moving the value higher is desired and directly indicative of a more connected swing."
                        },
                        "body_rotation": {
                            "name": "Body Rotation",
                            "unit": "%",
                            "description": "In a baseball swing, the resultant Bat Speed is a combination of both body and bat rotations.  Blast uses an advanced algorithm model that allows us to measure the contributions of both body and bat rotations from the sensor attached to the bat.  This allows the ability to analyze connection in the swing by comparing the contributions of both body and bat rotations once the hitter has committed to the swing by unhinging their wrists. The Body Rotation is expressed as the ratio of Body Rotation to total rotation during this time.\n\nMost players should have an average Body Rotation ratio of 45%, with a typical dynamic range of 40%-50%.  A value that is consistently outside this range typically indicates a deficiency in the hitter's kinematic sequencing pattern. Variation in Body Rotation ratio from the efficient average of 45% and outside of the typical dynamic range of 40%-50% can result from extreme pitch locations.  Pitch locations such as low and inside or high and outside require more adjustability in the swing.  The more disconnection that is found in the hitter's swing between the body and bat rotational patterns, the more variation that will be observed in the Body Rotation ratio."
                        },
                        "planar_efficiency": {
                            "name": "On Plane Efficiency",
                            "score_name": "Plane",
                            "unit": "%",
                            "description": "Measures the percentage of your swing where the bat is on the swing plane. Your vertical bat angle at contact establishes the plane for that swing. Plane is a great indicator for making more consistent contact on the barrel of the bat.",
                            "relates_to": "Swing Path",
                            "relates_to_tab": "Contact",
                            "blast_iq_description": "Plane Score comes directly from your On-Plane Efficiency metric only and evaluates it on the {scouting_scale}. On-Plane Efficiency is the primary metric for <strong>CONTACT</strong> Swing Profiles.<br><br>A strong CONTACT profile generally results in hitting the ball harder more often.",
                            "blast_iq_carousel_title": "CONTACT Swing Profiles have two parts. On-Plane Efficiency is the swing path and Attack Angle is the swing direction.",
                            "charts_description": "A good CONTACT profile is one that has a good Swing Path and Swing Direction, meaning your On-Plane Efficiency and Attack Angle are both in target range for your level of play."
                        },
                        "rotational_acceleration": {
                            "name": "Rotational Acceleration",
                            "score_name": "Rotation",
                            "target": {
                                "basic": "D1",
                                "pro": "MLB"
                            },
                            "unit": "g",
                            "description": "Measures how quickly your bat accelerates into the swing plane. Rotation is a good indicator of how you build bat speed by sequencing properly vs. pulling the bat with your hands. The quicker your rotational acceleration, the more power you will have and the more time you have to adjust to pitch locations.",
                            "relates_to": "Power Efficiency",
                            "relates_to_tab": "Power",
                            "blast_iq_description": "Rotation Score comes directly from the Rotational Acceleration metric only and evaluates it on the {scouting_scale}. Rotational Acceleration is the primary metric for <strong>POWER</strong> Swing Profiles.<br><br>Hitters with strong POWER Swing Profiles generally can hit for power without sacrificing contact. At Blast, we call this Dynamic Power.",
                            "blast_iq_carousel_title": "POWER Swing Profiles have two parts. Bat Speed is RAW POWER and Rotational Acceleration is POWER EFFICIENCY.",
                            "charts_description": "A good POWER Swing Profile is both powerful and efficient, meaning your Rotational Acceleration and Bat Speed are both in target range for your level of play."
                        },
                        "connection": {
                            "name": "Connection at Impact",
                            "score_name": "Connection",
                            "unit": "deg",
                            "description": "Measures the relationship between your body tilt and vertical bat angle at impact. Maintaining good connection (90 degrees) for all pitch locations is an indicator of dynamic adjustability.",
                            "relates_to": "Swing Consistency",
                            "relates_to_tab": "Swing Consistency",
                            "blast_iq_description": "Connection Score comes directly from your Early Connection and Connection at Impact metrics and evaluates them on the {scouting_scale}.<br><br>Hitters who are connected early and stay connected at impact generally have good On-Plane Efficiency and a better ability to adjust to pitches throughout the zone.",
                            "blast_iq_carousel_title": "<strong>CONSISTENCY</strong> has two parts - Early Connection is the primary metric for <strong>LOAD CONSISTENCY</strong> while Connection at Impact is the primary metric for your <strong>IMPACT POSITION</strong>.",
                            "charts_description": "You can compare Connection metrics to Vertical Bat Angle as a way to visualize consistency and adjustability throughout the hitting zone. Vertical Bat Angles are generally steeper on lower pitches, and flatter on higher pitches."
                        },
                        "early_connection": {
                            "name": "Early Connection",
                            "unit": "deg",
                            "relates_to": "Load Consistency",
                            "description": "Measures the relationship between your body tilt and vertical bat angle early in the downswing. Establishing good connection (90 degrees) early in the swing helps you get on plane and increases your ability to adjust to all pitch locations."
                        },
                        "commit_time": {
                            "name": "Commit Time",
                            "unit": "sec",
                            "description": "Commit Time is the time measured when the hitter unhinges their wrists and commits to the pitch during the downswing."
                        },
                        "plane_score": {
                            "name": "Plane Score",
                            "description": "Scores your On Plane Efficiency for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "connection_score": {
                            "name": "Connection Score",
                            "description": "Scores your Early Connection and Connection (at impact) for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "rotation_score": {
                            "name": "Rotation Score",
                            "description": "Scores your Rotational Acceleration for each swing on the scouting scale of 20-80.  Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "exit_velocity": {
                            "name": "Exit Velocity",
                            "unit": "mph"
                        },
                        "launch_angle": {
                            "name": "Launch Angle",
                            "unit": "deg"
                        },
                        "estimated_distance": {
                            "name": "Estimated Distance",
                            "unit": "feet"
                        },
                        "ball_direction": {
                            "name": "Ball Direction"
                        },
                        "field_angle": {
                            "name": "Field Angle",
                            "unit": "deg"
                        }
                    }
                },
                "softball": {
                    "swing": {
                        "swing_speed": {
                            "name": "Bat Speed",
                            "unit": "mph",
                            "target": {
                                "basic": "College",
                                "pro": "PRO"
                            },
                            "relates_to": "Raw Power",
                            "description": "The total speed of the barrel at impact. "
                        },
                        "time_to_contact": {
                            "name": "Time to Contact",
                            "unit": "sec",
                            "description": "The time measured from the start of the downswing to impact.",
                            "tip": "Time to Contact is all about speed and consistency. You want your contact time to be as quick as possible in order to react to pitches. You also want to be consistent from swing-to-swing. The only factor that should vary is when you commit to the swing—the rest is muscle memory and application of the kinematic sequence. The ideal Time to Contact depends on age, strength, bat length and weight, experience level and swing style. Our testing shows the typical Time to Contact ranges for different age groups and skill levels:"
                        },
                        "bat_rpm": {
                            "name": "Bat RPM",
                            "unit": "rpm",
                            "description": "Bat RPM is the rotational speed of the bat handle at the moment of impact. (Combined rotation around the X, Y, and Z axis) Higher is better. In practice, ideal Bat RPM depends on your age, skill level, bat length, and bat weight. The older and stronger you are, the more efficiently you can generate Bat RPM."
                        },
                        "bat_path_angle": {
                            "name": "Attack Angle",
                            "unit": "deg",
                            "description": "The angle that the barrel approaches the ball at impact. Positive is swinging up, negative is swinging down.",
                            "relates_to": "Swing Direction"
                        },
                        "blast_factor": {
                            "name": "Blast Factor",
                            "description": "Overall swing score based on the following components and their contributions:\nOn-Plane Score: 15%\nPeak Bat Speed Score: 10%\nAttack Angle Score: 10%\nBody Rotation Score: 15%\nPower Score: 50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast Factor",
                            "description": "Blast Factor is a swing score (0 to 100) for overall performance tracking."
                        },
                        "efficiency_index": {
                            "name": "Efficiency Index",
                            "description": "The Efficiency Index is a score (0 to 100) that indicates how effectively you create and direct energy to the ball. It combines Energy Transfer, Bat Path, and Bat Whip scores. Efficiency Index is important because if you are able to effectively transfer energy through the kinematic chain, align your swing to the incoming pitch, and time your swing to the ball, you are giving yourself the best opportunity to transfer the maximum amount of energy from yourself, through the bat, to the ball. An ideal Efficiency Index is 100. You ultimately want to increase your efficiency as much as possible without sacrificing power.",
                            "tip": "An ideal Efficiency Index is 100. You ultimately want to increase your efficiency as much as possible without sacrificing power."
                        },
                        "power_index": {
                            "name": "Power Index",
                            "description": "Power Index is a score (0 to 100) that represents your raw force. Ultimately, ball speed is a result of bat weight, swing speed, and quality of contact. In the Power Index, we focus on weight and speed, plus how quickly you generate that speed. Newton's second law of motion is Force = Mass x Acceleration, or Mass x Swing Speed / Time to Contact. The more mass you can swing in a short amount of time, the higher your Power Index will be. How closely you approach this depends on your age, strength, skill level, and the size and weight of your bat. Ultimately, you want the Power Index as high as possible without sacrificing efficiency.",
                            "tip": "The ideal Power Index score is 100. How closely you approach this depends on your age, strength, skill level, and the size and weight of your bat. Ultimately, you want the Power Index as high as possible without sacrificing efficiency."
                        },
                        "energy_transfer": {
                            "name": "Energy Transfer",
                            "description": "Energy Transfer is a score (0-100) that measures how energy is transferred from the body to the bat. A rotational swing uses the kinematic chain of hips, shoulders, arms and wrists to transfer energy to the bat. When you use your body to generate speed, you generate bat speed more efficiently and with less effort from the arms. When you rely more on your arms, there is more variability in bat speed and you cannot ultimately achieve as high of bat speeds. We compare the total speed in the first half of the swing to the total speed in the second half of the swing to indicate how effectively you are using your body. Energy Transfer is a component of the Efficiency Index. Rotationally efficient swings generate about half of their speed in the first half of the swing, where speed is primarily generated by the hips and shoulders versus the arms and wrists. The target zone is about 45% to 55% of your speed in the first half. Anything lower than this will result in an Energy Transfer score less than 100. This usually indicates an over-reliance on the arms (for example, casting the arms away from the body). Any speed in or above the target zone will receive an Energy Transfer score of 100. Even though we dont penalize you for exceeding the target zone, it might be difficult to control the bat and adapt to pitches in a real game scenario. Youre probably swinging out of your shoes!",
                            "tip": "Rotationally efficient swings generate about half of their speed in the first half of the swing, where speed is primarily generated by the hips and shoulders versus the arms and wrists. The target zone is about 45% to 55% of your speed in the first half. Anything lower than this will result in an Energy Transfer score less than 100. This usually indicates an over-reliance on the arms (for example, casting the arms away from the body). Any speed in or above the target zone will receive an Energy Transfer score of 100. Even though we don’t penalize you for exceeding the target zone, it might be difficult to control the bat and adapt to pitches in a real game scenario. You’re probably swinging out of your shoes!"
                        },
                        "bat_whip": {
                            "name": "Bat Whip",
                            "description": "Bat Whip is one component of the Efficiency Index. It measures the time between the peak rotational speed (RPMs) during the swing and the RPMs at moment of impact. An efficient swing has peak rotational speed (RPMs) at impact.",
                            "tip": "An efficient baseball swing has peak rotational speed at the point of impact. If you achieve this, there won’t be a line on the tracer tool indicating that Bat Whip was achieved before impact."
                        },
                        "bat_path": {
                            "name": "Bat Path",
                            "description": "Although the ideal bat path angle depends on the incoming pitch angle, swing speed, and situational hitting, the Bat Path score is designed to maximize launch distance. In general, the faster your swing speed the smaller the positive angle needed to achieve maximum launch distance. Bat Path is a score between zero and one hundred based on the difference between your actual bat path angle and the ideal angle that would maximize launch distance for your swing speed, assuming solid ball contact. Bath Path is one component of the Efficiency Index. The ideal Bat Path score of 100 is achieved when the actual bat path angle matches the angle that would produce the maximum launch distance for a given swing speed. For example, maximum distance is achieved at +22 degrees for a 35 mph swing, +15 degrees for a 55 mph swing, +7 degrees for a 75 mph swing and +3 degrees for an 85 mph swing.",
                            "tip": "The ideal Bat Path is dependent on many factors including the incoming pitch angle, swing speed, and situational hitting. The Bat Path Score in this case was designed to maximize launch of a hit ball. So to achieve a high bat path score in the Efficiency Index, however, it will be between 3-22 degrees depending on how fast your swing speed is. (In general, the faster your swing speed, the smaller the angle necessary to achieve max launch)."
                        },
                        "barrel_acceleration": {
                            "name": "Barrel Acceleration",
                            "description": "Barrel Acceleration is one component of the Efficiency Index. It is a score (0 to 10) based on an ideal acceleration build where 2/3 (66%) of your bat speed generated should occurs in the last 1/3 of your swing. An efficient swing has peak acceleration occur at impact, therefore, acceleration should build from the start of the downswing to the point of impact. If you reach peak acceleration too early in the swing, you lose power to the ball.",
                            "tip": "The ultimate Barrel Acceleration will be a score of 10, and that should always be the goal. Focus on creating a dynamic acceleration build with peak acceleration happening at the point of impact. This will result in harder hit balls and favorable outcomes."
                        },
                        "peak_speed": {
                            "name": "Peak Bat Speed",
                            "unit": "mph",
                            "description": "Peak Bat Speed is the highest forward speed at the sweet spot of the bat, as measured six inches from the tip of the bat. This may occur at or before the moment of impact.\n\nAchieving your Peak Bat Speed at the moment of impact results in maximum ball exit speed and distance. If your peak speed is not timed with impact that means your swing is inefficient and you are losing Bat Speed at impact that could result in harder hit balls.\n\nYou should be able to read a pitch and time your swing so that you make contact near your peak speed.  Over a session, your Peak Bat Speed should be the same or very close to your Bat Speed at impact."
                        },
                        "bat_whip_sec_prior": {
                            "name": "Bat Whip (sec. prior)",
                            "unit": "sec. prior",
                            "description": ""
                        },
                        "power": {
                            "name": "Power",
                            "unit": "kW",
                            "description": "The amount of power generated, in kilowatts, during the swing."
                        },
                        "vertical_bat_angle": {
                            "name": "Vertical Bat Angle",
                            "unit": "deg",
                            "description": "The steepness of the barrel at impact from a catcher’s perspective. The value is negative when the barrel is below the hands."
                        },
                        "body_tilt_angle": {
                            "name": "Body Tilt Angle",
                            "unit": "deg",
                            "description": "The inferred 3D tilt for each swing, calculated from your center of rotation. The body tilt angle incorporates both flexion (forward/backward) and lateral (side to side) tilt and can be seen on the 3D Swing Tracer."
                        },
                        "peak_hand_speed": {
                            "name": "Peak Hand Speed",
                            "unit": "mph",
                            "description": "The fastest hand speed reached throughout the swing."
                        },
                        "on_plane": {
                            "name": "On Plane",
                            "unit": "%",
                            "description": "The On Plane metric measures the percentage of your swing that the sweet spot of the bat is considered to be On Plane.  The reference plane is defined at the moment of impact.  The percentage of your swing On Plane is determined by the amount of speed generated within that reference plane.\n\nIn an ideal world, the hitter wants to maximize their On Plane percentage.  The higher this percentage value, the better, as that requires less conscious and active control from the hitter during the dynamic downswing. There is a high correlation between the hitter's setup posture and the On Plane percentage metric.  A hitter that has more body tilt towards the plate will tend to be On Plane longer than someone who stands more upright at the beginning of the swing and drops the barrel down into the swing plane as the swing progresses.\n\nA good functional swing will have an average On Plane percentage starting at 60% or higher.  A typical dynamic range for On Plane percentage will be 55%-65%.  For the On Plane metric, moving the value higher is desired and directly indicative of a more connected swing."
                        },
                        "body_rotation": {
                            "name": "Body Rotation",
                            "unit": "%",
                            "description": "In a softball swing, the resultant Bat Speed is a combination of both body and bat rotations.  Blast uses an advanced algorithm model that allows us to measure the contributions of both body and bat rotations from the sensor attached to the bat.  This allows the ability to analyze connection in the swing by comparing the contributions of both body and bat rotations once the hitter has committed to the swing by unhinging their wrists. The Body Rotation is expressed as the ratio of Body Rotation to total rotation during this time.\n\nMost players should have an average Body Rotation ratio of 45%, with a typical dynamic range of 40%-50%.  A value that is consistently outside this range typically indicates a deficiency in the hitter's kinematic sequencing pattern. Variation in Body Rotation ratio from the efficient average of 45% and outside of the typical dynamic range of 40%-50% can result from extreme pitch locations.  Pitch locations such as low and inside or high and outside require more adjustability in the swing.  The more disconnection that is found in the hitter's swing between the body and bat rotational patterns, the more variation that will be observed in the Body Rotation ratio."
                        },
                        "planar_efficiency": {
                            "name": "On Plane Efficiency",
                            "score_name": "Plane",
                            "unit": "%",
                            "description": "Measures the percentage of your swing where the bat is on the swing plane. Your vertical bat angle at contact establishes the plane for that swing. Plane is a great indicator for making more consistent contact on the barrel of the bat.",
                            "relates_to": "Swing Path",
                            "relates_to_tab": "Contact",
                            "blast_iq_description": "Plane Score comes directly from your On-Plane Efficiency metric only and evaluates it on the {scouting_scale}. On-Plane Efficiency is the primary metric for <strong>CONTACT</strong> Swing Profiles.<br><br>A strong CONTACT profile generally results in hitting the ball harder more often.",
                            "blast_iq_carousel_title": "CONTACT Swing Profiles have two parts. On-Plane Efficiency is the swing path and Attack Angle is the swing direction.",
                            "charts_description": "A good CONTACT profile is one that has a good Swing Path and Swing Direction, meaning your On-Plane Efficiency and Attack Angle are both in target range for your level of play."
                        },
                        "rotational_acceleration": {
                            "name": "Rotational Acceleration",
                            "score_name": "Rotation",
                            "unit": "g",
                            "target": {
                                "basic": "College",
                                "pro": "PRO"
                            },
                            "description": "Measures how quickly your bat accelerates into the swing plane. Rotation is a good indicator of how you build bat speed by sequencing properly vs. pulling the bat with your hands. The quicker your rotational acceleration, the more power you will have and the more time you have to adjust to pitch locations.",
                            "relates_to": "Power Efficiency",
                            "relates_to_tab": "Power",
                            "blast_iq_description": "Rotation Score comes directly from the Rotational Acceleration metric only and evaluates it on the {scouting_scale}. Rotational Acceleration is the primary metric for <strong>POWER</strong> Swing Profiles.<br><br>Hitters with strong POWER Swing Profiles generally can hit for power without sacrificing contact. At Blast, we call this Dynamic Power.",
                            "blast_iq_carousel_title": "POWER Swing Profiles have two parts. Bat Speed is RAW POWER and Rotational Acceleration is POWER EFFICIENCY.",
                            "charts_description": "A good POWER Swing Profile is both powerful and efficient, meaning your Rotational Acceleration and Bat Speed are both in target range for your level of play."
                        },
                        "connection": {
                            "name": "Connection at Impact",
                            "score_name": "Connection",
                            "unit": "deg",
                            "description": "Measures the relationship between your body tilt and vertical bat angle at impact. Maintaining good connection (90 degrees) for all pitch locations is an indicator of dynamic adjustability.",
                            "relates_to": "Swing Consistency",
                            "relates_to_tab": "Swing Consistency",
                            "blast_iq_description": "Connection Score comes directly from your Early Connection and Connection at Impact metrics and evaluates them on the {scouting_scale}.<br><br>Hitters who are connected early and stay connected at impact generally have good On-Plane Efficiency and a better ability to adjust to pitches throughout the zone.",
                            "blast_iq_carousel_title": "<strong>CONSISTENCY</strong> has two parts - Early Connection is the primary metric for <strong>LOAD CONSISTENCY</strong> while Connection at Impact is the primary metric for your <strong>IMPACT POSITION</strong>.",
                            "charts_description": "You can compare Connection metrics to Vertical Bat Angle as a way to visualize consistency and adjustability throughout the hitting zone. Vertical Bat Angles are generally steeper on lower pitches, and flatter on higher pitches."
                        },
                        "early_connection": {
                            "name": "Early Connection",
                            "unit": "deg",
                            "relates_to": "Load Consistency",
                            "description": "Measures the relationship between your body tilt and vertical bat angle early in the downswing. Establishing good connection (90 degrees) early in the swing helps you get on plane and increases your ability to adjust to all pitch locations."
                        },
                        "commit_time": {
                            "name": "Commit Time",
                            "unit": "sec",
                            "description": "Commit Time is the time measured when the hitter unhinges their wrists and commits to the pitch during the downswing."
                        },
                        "plane_score": {
                            "name": "Plane Score",
                            "description": "Scores your On Plane Efficiency for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "connection_score": {
                            "name": "Connection Score",
                            "description": "Scores your Early Connection and Connection (at impact) for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "rotation_score": {
                            "name": "Rotation Score",
                            "description": "Scores your Rotational Acceleration for each swing on the scouting scale of 20-80.  Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "exit_velocity": {
                            "name": "Exit Velocity",
                            "unit": "mph"
                        },
                        "launch_angle": {
                            "name": "Launch Angle",
                            "unit": "deg"
                        },
                        "estimated_distance": {
                            "name": "Estimated Distance",
                            "unit": "feet"
                        },
                        "ball_direction": {
                            "name": "Ball Direction"
                        },
                        "field_angle": {
                            "name": "Field Angle",
                            "unit": "deg"
                        }
                    },
                    "slap": {
                        "swing_speed": {
                            "name": "Bat Speed",
                            "unit": "mph",
                            "target": {
                                "basic": "College",
                                "pro": "PRO"
                            },
                            "relates_to": "Raw Power",
                            "description": "The total speed of the barrel at impact. "
                        },
                        "time_to_contact": {
                            "name": "Time to Contact",
                            "unit": "sec",
                            "description": "The time measured from the start of the downswing to impact.",
                            "tip": "Time to Contact is all about speed and consistency. You want your contact time to be as quick as possible in order to react to pitches. You also want to be consistent from swing-to-swing. The only factor that should vary is when you commit to the swing—the rest is muscle memory and application of the kinematic sequence. The ideal Time to Contact depends on age, strength, bat length and weight, experience level and swing style. Our testing shows the typical Time to Contact ranges for different age groups and skill levels:"
                        },
                        "bat_rpm": {
                            "name": "Bat RPM",
                            "unit": "rpm",
                            "description": "Bat RPM is the rotational speed of the bat handle at the moment of impact. (Combined rotation around the X, Y, and Z axis) Higher is better. In practice, ideal Bat RPM depends on your age, skill level, bat length, and bat weight. The older and stronger you are, the more efficiently you can generate Bat RPM."
                        },
                        "bat_path_angle": {
                            "name": "Attack Angle",
                            "unit": "deg",
                            "description": "The angle that the barrel approaches the ball at impact. Positive is swinging up, negative is swinging down.",
                            "relates_to": "Swing Direction"
                        },
                        "blast_factor": {
                            "name": "Blast Factor",
                            "description": "Overall swing score based on the following components and their contributions:\nOn-Plane Score: 15%\nPeak Bat Speed Score: 10%\nAttack Angle Score: 10%\nBody Rotation Score: 15%\nPower Score: 50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast Factor",
                            "description": "Blast Factor is a swing score (0 to 100) for overall performance tracking."
                        },
                        "efficiency_index": {
                            "name": "Efficiency Index",
                            "description": "The Efficiency Index is a score (0 to 100) that indicates how effectively you create and direct energy to the ball. It combines Energy Transfer, Bat Path, and Bat Whip scores. Efficiency Index is important because if you are able to effectively transfer energy through the kinematic chain, align your swing to the incoming pitch, and time your swing to the ball, you are giving yourself the best opportunity to transfer the maximum amount of energy from yourself, through the bat, to the ball. An ideal Efficiency Index is 100. You ultimately want to increase your efficiency as much as possible without sacrificing power.",
                            "tip": "An ideal Efficiency Index is 100. You ultimately want to increase your efficiency as much as possible without sacrificing power."
                        },
                        "power_index": {
                            "name": "Power Index",
                            "description": "Power Index is a score (0 to 100) that represents your raw force. Ultimately, ball speed is a result of bat weight, swing speed, and quality of contact. In the Power Index, we focus on weight and speed, plus how quickly you generate that speed. Newton's second law of motion is Force = Mass x Acceleration, or Mass x Swing Speed / Time to Contact. The more mass you can swing in a short amount of time, the higher your Power Index will be. How closely you approach this depends on your age, strength, skill level, and the size and weight of your bat. Ultimately, you want the Power Index as high as possible without sacrificing efficiency.",
                            "tip": "The ideal Power Index score is 100. How closely you approach this depends on your age, strength, skill level, and the size and weight of your bat. Ultimately, you want the Power Index as high as possible without sacrificing efficiency."
                        },
                        "energy_transfer": {
                            "name": "Energy Transfer",
                            "description": "Energy Transfer is a score (0-100) that measures how energy is transferred from the body to the bat. A rotational swing uses the kinematic chain of hips, shoulders, arms and wrists to transfer energy to the bat. When you use your body to generate speed, you generate bat speed more efficiently and with less effort from the arms. When you rely more on your arms, there is more variability in bat speed and you cannot ultimately achieve as high of bat speeds. We compare the total speed in the first half of the swing to the total speed in the second half of the swing to indicate how effectively you are using your body. Energy Transfer is a component of the Efficiency Index. Rotationally efficient swings generate about half of their speed in the first half of the swing, where speed is primarily generated by the hips and shoulders versus the arms and wrists. The target zone is about 45% to 55% of your speed in the first half. Anything lower than this will result in an Energy Transfer score less than 100. This usually indicates an over-reliance on the arms (for example, casting the arms away from the body). Any speed in or above the target zone will receive an Energy Transfer score of 100. Even though we dont penalize you for exceeding the target zone, it might be difficult to control the bat and adapt to pitches in a real game scenario. Youre probably swinging out of your shoes!",
                            "tip": "Rotationally efficient swings generate about half of their speed in the first half of the swing, where speed is primarily generated by the hips and shoulders versus the arms and wrists. The target zone is about 45% to 55% of your speed in the first half. Anything lower than this will result in an Energy Transfer score less than 100. This usually indicates an over-reliance on the arms (for example, casting the arms away from the body). Any speed in or above the target zone will receive an Energy Transfer score of 100. Even though we don’t penalize you for exceeding the target zone, it might be difficult to control the bat and adapt to pitches in a real game scenario. You’re probably swinging out of your shoes!"
                        },
                        "bat_whip": {
                            "name": "Bat Whip",
                            "description": "Bat Whip is one component of the Efficiency Index. It measures the time between the peak rotational speed (RPMs) during the swing and the RPMs at moment of impact. An efficient swing has peak rotational speed (RPMs) at impact.",
                            "tip": "An efficient baseball swing has peak rotational speed at the point of impact. If you achieve this, there won’t be a line on the tracer tool indicating that Bat Whip was achieved before impact."
                        },
                        "bat_path": {
                            "name": "Bat Path",
                            "description": "Although the ideal bat path angle depends on the incoming pitch angle, swing speed, and situational hitting, the Bat Path score is designed to maximize launch distance. In general, the faster your swing speed the smaller the positive angle needed to achieve maximum launch distance. Bat Path is a score between zero and one hundred based on the difference between your actual bat path angle and the ideal angle that would maximize launch distance for your swing speed, assuming solid ball contact. Bath Path is one component of the Efficiency Index. The ideal Bat Path score of 100 is achieved when the actual bat path angle matches the angle that would produce the maximum launch distance for a given swing speed. For example, maximum distance is achieved at +22 degrees for a 35 mph swing, +15 degrees for a 55 mph swing, +7 degrees for a 75 mph swing and +3 degrees for an 85 mph swing.",
                            "tip": "The ideal Bat Path is dependent on many factors including the incoming pitch angle, swing speed, and situational hitting. The Bat Path Score in this case was designed to maximize launch of a hit ball. So to achieve a high bat path score in the Efficiency Index, however, it will be between 3-22 degrees depending on how fast your swing speed is. (In general, the faster your swing speed, the smaller the angle necessary to achieve max launch)."
                        },
                        "barrel_acceleration": {
                            "name": "Barrel Acceleration",
                            "description": "Barrel Acceleration is one component of the Efficiency Index. It is a score (0 to 10) based on an ideal acceleration build where 2/3 (66%) of your bat speed generated should occurs in the last 1/3 of your swing. An efficient swing has peak acceleration occur at impact, therefore, acceleration should build from the start of the downswing to the point of impact. If you reach peak acceleration too early in the swing, you lose power to the ball.",
                            "tip": "The ultimate Barrel Acceleration will be a score of 10, and that should always be the goal. Focus on creating a dynamic acceleration build with peak acceleration happening at the point of impact. This will result in harder hit balls and favorable outcomes."
                        },
                        "peak_speed": {
                            "name": "Peak Bat Speed",
                            "unit": "mph",
                            "description": "Peak Bat Speed is the highest forward speed at the sweet spot of the bat, as measured six inches from the tip of the bat. This may occur at or before the moment of impact.\n\nAchieving your Peak Bat Speed at the moment of impact results in maximum ball exit speed and distance. If your peak speed is not timed with impact that means your swing is inefficient and you are losing Bat Speed at impact that could result in harder hit balls.\n\nYou should be able to read a pitch and time your swing so that you make contact near your peak speed.  Over a session, your Peak Bat Speed should be the same or very close to your Bat Speed at impact."
                        },
                        "bat_whip_sec_prior": {
                            "name": "Bat Whip (sec. prior)",
                            "unit": "sec. prior",
                            "description": ""
                        },
                        "power": {
                            "name": "Power",
                            "unit": "kW",
                            "description": "The amount of power generated, in kilowatts, during the swing."
                        },
                        "vertical_bat_angle": {
                            "name": "Vertical Bat Angle",
                            "unit": "deg",
                            "description": "The steepness of the barrel at impact from a catcher’s perspective. The value is negative when the barrel is below the hands."
                        },
                        "body_tilt_angle": {
                            "name": "Body Tilt Angle",
                            "unit": "deg",
                            "description": "The inferred 3D tilt for each swing, calculated from your center of rotation. The body tilt angle incorporates both flexion (forward/backward) and lateral (side to side) tilt and can be seen on the 3D Swing Tracer."
                        },
                        "peak_hand_speed": {
                            "name": "Peak Hand Speed",
                            "unit": "mph",
                            "description": "The fastest hand speed reached throughout the swing."
                        },
                        "on_plane": {
                            "name": "On Plane",
                            "unit": "%",
                            "description": "The On Plane metric measures the percentage of your swing that the sweet spot of the bat is considered to be On Plane.  The reference plane is defined at the moment of impact.  The percentage of your swing On Plane is determined by the amount of speed generated within that reference plane.\n\nIn an ideal world, the hitter wants to maximize their On Plane percentage.  The higher this percentage value, the better, as that requires less conscious and active control from the hitter during the dynamic downswing. There is a high correlation between the hitter's setup posture and the On Plane percentage metric.  A hitter that has more body tilt towards the plate will tend to be On Plane longer than someone who stands more upright at the beginning of the swing and drops the barrel down into the swing plane as the swing progresses.\n\nA good functional swing will have an average On Plane percentage starting at 60% or higher.  A typical dynamic range for On Plane percentage will be 55%-65%.  For the On Plane metric, moving the value higher is desired and directly indicative of a more connected swing."
                        },
                        "body_rotation": {
                            "name": "Body Rotation",
                            "unit": "%",
                            "description": "In a softball swing, the resultant Bat Speed is a combination of both body and bat rotations.  Blast uses an advanced algorithm model that allows us to measure the contributions of both body and bat rotations from the sensor attached to the bat.  This allows the ability to analyze connection in the swing by comparing the contributions of both body and bat rotations once the hitter has committed to the swing by unhinging their wrists. The Body Rotation is expressed as the ratio of Body Rotation to total rotation during this time.\n\nMost players should have an average Body Rotation ratio of 45%, with a typical dynamic range of 40%-50%.  A value that is consistently outside this range typically indicates a deficiency in the hitter's kinematic sequencing pattern. Variation in Body Rotation ratio from the efficient average of 45% and outside of the typical dynamic range of 40%-50% can result from extreme pitch locations.  Pitch locations such as low and inside or high and outside require more adjustability in the swing.  The more disconnection that is found in the hitter's swing between the body and bat rotational patterns, the more variation that will be observed in the Body Rotation ratio."
                        },
                        "planar_efficiency": {
                            "name": "On Plane Efficiency",
                            "score_name": "Plane",
                            "unit": "%",
                            "description": "Measures the percentage of your swing where the bat is on the swing plane. Your vertical bat angle at contact establishes the plane for that swing. Plane is a great indicator for making more consistent contact on the barrel of the bat.",
                            "relates_to": "Swing Path",
                            "relates_to_tab": "Contact",
                            "blast_iq_description": "Plane Score comes directly from your On-Plane Efficiency metric only and evaluates it on the {scouting_scale}. On-Plane Efficiency is the primary metric for <strong>CONTACT</strong> Swing Profiles.<br><br>A strong CONTACT profile generally results in hitting the ball harder more often.",
                            "blast_iq_carousel_title": "CONTACT Swing Profiles have two parts. On-Plane Efficiency is the swing path and Attack Angle is the swing direction.",
                            "charts_description": "A good CONTACT profile is one that has a good Swing Path and Swing Direction, meaning your On-Plane Efficiency and Attack Angle are both in target range for your level of play."
                        },
                        "rotational_acceleration": {
                            "name": "Rotational Acceleration",
                            "score_name": "Rotation",
                            "unit": "g",
                            "target": {
                                "basic": "College",
                                "pro": "PRO"
                            },
                            "description": "Measures how quickly your bat accelerates into the swing plane. Rotation is a good indicator of how you build bat speed by sequencing properly vs. pulling the bat with your hands. The quicker your rotational acceleration, the more power you will have and the more time you have to adjust to pitch locations.",
                            "relates_to": "Power Efficiency",
                            "relates_to_tab": "Power",
                            "blast_iq_description": "Rotation Score comes directly from the Rotational Acceleration metric only and evaluates it on the {scouting_scale}. Rotational Acceleration is the primary metric for <strong>POWER</strong> Swing Profiles.<br><br>Hitters with strong POWER Swing Profiles generally can hit for power without sacrificing contact. At Blast, we call this Dynamic Power.",
                            "blast_iq_carousel_title": "POWER Swing Profiles have two parts. Bat Speed is RAW POWER and Rotational Acceleration is POWER EFFICIENCY.",
                            "charts_description": "A good POWER Swing Profile is both powerful and efficient, meaning your Rotational Acceleration and Bat Speed are both in target range for your level of play."
                        },
                        "connection": {
                            "name": "Connection at Impact",
                            "score_name": "Connection",
                            "unit": "deg",
                            "description": "Measures the relationship between your body tilt and vertical bat angle at impact. Maintaining good connection (90 degrees) for all pitch locations is an indicator of dynamic adjustability.",
                            "relates_to": "Swing Consistency",
                            "relates_to_tab": "Swing Consistency",
                            "blast_iq_description": "Connection Score comes directly from your Early Connection and Connection at Impact metrics and evaluates them on the {scouting_scale}.<br><br>Hitters who are connected early and stay connected at impact generally have good On-Plane Efficiency and a better ability to adjust to pitches throughout the zone.",
                            "blast_iq_carousel_title": "<strong>CONSISTENCY</strong> has two parts - Early Connection is the primary metric for <strong>LOAD CONSISTENCY</strong> while Connection at Impact is the primary metric for your <strong>IMPACT POSITION</strong>.",
                            "charts_description": "You can compare Connection metrics to Vertical Bat Angle as a way to visualize consistency and adjustability throughout the hitting zone. Vertical Bat Angles are generally steeper on lower pitches, and flatter on higher pitches."
                        },
                        "early_connection": {
                            "name": "Early Connection",
                            "unit": "deg",
                            "relates_to": "Load Consistency",
                            "description": "Measures the relationship between your body tilt and vertical bat angle early in the downswing. Establishing good connection (90 degrees) early in the swing helps you get on plane and increases your ability to adjust to all pitch locations."
                        },
                        "commit_time": {
                            "name": "Commit Time",
                            "unit": "sec",
                            "description": "Commit Time is the time measured when the hitter unhinges their wrists and commits to the pitch during the downswing."
                        },
                        "plane_score": {
                            "name": "Plane Score",
                            "description": "Scores your On Plane Efficiency for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "connection_score": {
                            "name": "Connection Score",
                            "description": "Scores your Early Connection and Connection (at impact) for each swing on the scouting scale of 20-80. Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "rotation_score": {
                            "name": "Rotation Score",
                            "description": "Scores your Rotational Acceleration for each swing on the scouting scale of 20-80.  Your score is based on how you compare to others at your level of play. The higher the score the better."
                        },
                        "exit_velocity": {
                            "name": "Exit Velocity",
                            "unit": "mph"
                        },
                        "launch_angle": {
                            "name": "Launch Angle",
                            "unit": "deg"
                        },
                        "estimated_distance": {
                            "name": "Estimated Distance",
                            "unit": "feet"
                        },
                        "ball_direction": {
                            "name": "Ball Direction"
                        },
                        "field_angle": {
                            "name": "Field Angle",
                            "unit": "deg"
                        }
                    }
                },
                "athletic_performance": {
                    "jump": {
                        "vertical_height": {
                            "name": "Vertical Height",
                            "unit": "in",
                            "description": "During a jump, vertical height measures in inches the distance the sensor travels from when your feet leave the ground, to the highest point in your jump."
                        },
                        "jump_force": {
                            "name": "Jump Force",
                            "unit": "N",
                            "description": "Jump Force is the peak force applied for the jump prior to the moment of take-off. It is a combination of the athlete’s mass and peak acceleration measured prior to the moment of take-off."
                        },
                        "jump_acceleration": {
                            "name": "Jump Acceleration",
                            "unit": "g",
                            "description": "Acceleration measures in Standard Acceleration Gravity Units or “G’s” the maximum acceleration achieved during a sprint, run or jump."
                        },
                        "rotation": {
                            "name": "Rotation",
                            "unit": "deg",
                            "description": "Rotation measures in degrees, the amount of rotation your body achieves while you’re in the air during a jump."
                        },
                        "hang_time": {
                            "name": "Hang Time",
                            "unit": "sec",
                            "description": "Hang time is measured in fractions of seconds, from when your feet leave the ground to when they return. A jump must be at least 7 inches off the ground to be recorded."
                        }
                    },
                    "sprint": {
                        "time_to_peak_acceleration": {
                            "name": "Time to Peak Acceleration",
                            "unit": "sec",
                            "description": "Time to Peak Acceleration is the elapsed time between the start of the sprint to the moment of peak acceleration measured during the sprint."
                        },
                        "sprint_force": {
                            "name": "Sprint Force",
                            "unit": "N",
                            "description": "Sprint Force is the peak force applied during the sprint. It is a combination of the athlete’s mass and peak acceleration measured during the sprint."
                        },
                        "sprint_acceleration": {
                            "name": "Sprint Acceleration",
                            "unit": "g",
                            "description": "Acceleration measures in Standard Acceleration Gravity Units or “G’s” the maximum acceleration achieved during a sprint, run or jump."
                        }
                    }
                }
            },
            "api": {
                "messages": {
                    "auth": {
                        "golf_channel_academy_error": "There was a problem communicating with the Golf Channel Academy server to verify your account. Please try again later.",
                        "something_went_wrong": "Something went wrong attempting to login",
                        "user_not_exist": "User does not exist on {app_name}",
                        "account_not_active": "Your account is currently suspended. Please contact your Academy.",
                        "pass_academy_id_in_request": "Please pass along 'api_academy_id' in your request.",
                        "no_valid_academy": "You do not belong to any academy. Please contact us to help resolve this.",
                        "academy_access_denied": "Access to that Academy Denied.",
                        "you_belong_to_multiple_academies": "You belong to multiple academies",
                        "invalid_subscription": "Your {role} subscription is invalid/expired.",
                        "mobile_not_support_multiple_academies": "Blast Connect Mobile app does not currently support users associated with multiple academies. Please use the Blast Connect web interface.",
                        "camp_login_window_passed": "The login window for this event has expired.",
                        "camp_login_window_not_begun": "The login window for this event has not yet begun.",
                        "you_are_not_in_the_current_academy": "You don't belong to the current academy, but public registration is disabled. Contact us to resolve that issue.",
                        "you_are_all_set_for_event_name": "You're all set for {event_name}!",
                        "check_back_again_on_event_start_date_to_see_your_swing_data_from_the_event": "Check back again on {start_date} to see your swing data from the event."
                    },
                    "regenerate_token": {
                        "user_not_found": "User Not Found",
                        "token": {
                            "not_verified": "Could not verify token.",
                            "expired": "Token Expired",
                            "invalid": "Token Invalid",
                            "absent": "Token Absent"
                        }
                    }
                }
            },
            "faq": "Frequently Asked Questions",
            "welcome_help": "More detailed instructions and tips are available in the <a href=\"{help_link}\">Help</a> section.",
            "customer_support_link": "https://blastmotion.com/about/contact-us/",
            "blastmotion_com_link": "<a href=\"https://blastmotion.com\">https://blastmotion.com</a>",
            "customer_service": "Customer Support",
            "help": "Help",
            "contact_us": "Contact Us",
            "optional": "Optional",
            "privacy_policy_link": "Privacy Policy: <a href=\"{url}\">{url}</a>",
            "customer_support_phone": "Customer Support<br>1-855-632-5278 (US phone number)<br><br>Support hours<br>7AM – 5PM Pacific time (US business days)<br><br>Support available in English",
            "customer_support_phone_number": "+1 (855) 632-5278",
            "question_or_problem": "What is your question or problem?",
            "getting_started": "Getting Started",
            "using_blast_connect": "Using Blast Connect",
            "using_mobile_apps": "Using the Blast {sport} Mobile App",
            "thanks_for_contacting_us": "Thanks for contacting us!",
            "you_now_may_want_to": "You now may want to",
            "return_to_your": "Return to your",
            "visit": "Visit",
            "account_error": "Account Error",
            "csrf_error": "Sorry, we could not verify your request. Please try again.",
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December",
            "alerts": {
                "account_created": "Your account has been successfully created.",
                "instructions_sent": "Please check your email for the instructions on how to confirm your account.",
                "too_many_attempts": "Too many attempts. Try again in few minutes.",
                "wrong_credentials": "Incorrect username, email or password.",
                "not_confirmed": "Your account may not be confirmed. Check your email for the confirmation link",
                "confirmation": "Your account has been confirmed! You may now log in.",
                "password_confirmation": "The passwords did not match.",
                "wrong_confirmation": "Wrong confirmation code.",
                "password_forgot": "The information regarding password reset was sent to your email.",
                "wrong_password_forgot": "User not found.",
                "password_reset": "Your password has been changed successfully.",
                "wrong_password_reset": "Invalid password. Try again",
                "wrong_token": "The password reset token is not valid.",
                "duplicated_credentials": "The credentials provided have already been used. Try with different credentials.",
                "coaches_can_only_be_added_via_direct_invitation": "Coaches can only be added via direct invitation.",
                "email_and_or_password_are_incorrect_please_try_again_or_register": "Email and/or Password are incorrect. Please try again, or use the Registration option on this page to create a new account."
            },
            "validation": {
                "errors": {
                    "unauthorized": {
                        "access": "Unauthorized Access",
                        "actions": "Unauthorized Actions",
                        "resources": "Unauthorized Resources",
                        "cannot_authorize": "Internal Server Error. Cannot authorize user"
                    },
                    "phone": {
                        "regex": "Phone numbers can only contain numbers, spaces, and +, -, (, ) characters.",
                        "digits": "Phone numbers must be 10 digits."
                    }
                },
                "title": {
                    "required_if": "The title field is required."
                },
                "until": {
                    "required_if": "The until date field is required."
                },
                "viewable": {
                    "invalid": "You do not have permission to use the {relation} item."
                },
                "is_watcher": {
                    "invalid": "You are not authorized access the specified user(s)."
                },
                "assessment_result_limit": {
                    "invalid": "The value provided for the assessment in out of the limited range."
                },
                "messages": {
                    "standard": {
                        "email": {
                            "unique": "Email is already taken. <a href=\"{login_link}\">Login</a> to your existing account or contact <a href=\"{customer_support_link}\">customer support</a> for other inquiries."
                        }
                    },
                    "event": {
                        "email": {
                            "unique": "Email is already taken. Login to your existing account above or contact <a href=\"{customer_support_link}\">customer support</a> for other inquiries."
                        }
                    }
                }
            },
            "errors": {
                "academy": {
                    "invalid": "Invalid Academy"
                }
            },
            "email_view": {
                "subscription": {
                    "unpaid": {
                        "login_credentials": "Login Credentials",
                        "academy_name": "Academy Name",
                        "account_name": "Account Name",
                        "account_email": "Account Email",
                        "need_support": "Have questions or need support?  Give us a call: {support_number}"
                    }
                },
                "account": {
                    "email_change": {
                        "subject": "Email Change Request",
                        "messages": [
                            "We have received a request to change the email address associated with your Blast Connect account.",
                            "Please click on the following link to confirm this change. {email_change_confirmation_url_anchor}",
                            "",
                            "If you did not request this change, please click here {password_reset_url_anchor} to reset your password."
                        ]
                    },
                    "charge_failed": {
                        "subject": "Blast Connect - Payment Failed",
                        "messages": [
                            "Hi {user_full_name},",
                            "",
                            "Unfortunately we could not complete the payment for your renewing subscription, because your saved payment method is no longer valid. {update_your_cards_anchor} so that your payment can be processed and subscription validated.",
                            "",
                            "Need help? {contact_customer_support_anchor} for further assistance."
                        ],
                        "please_update_your_payment_source": "Update your payment source",
                        "contact_customer_support": "Contact Customer Support",
                        "signature": "Thank you for using Blast Connect!"
                    }
                },
                "password": {
                    "reset_request": {
                        "subject": "{academy_name} Blast Connect Password Reset",
                        "messages": [
                            "{to_user}, We received a request to reset the password for your {academy_name} Blast Connect account.",
                            "",
                            "Click the link below to reset your password:",
                            "{reset_password_link_anchor}",
                            "",
                            "If you have any questions or concerns, please calls us at {support_phone_number} or email us at {support_email}"
                        ],
                        "signature": "All the Best, Blast Motion"
                    }
                },
                "media": {
                    "shared": {
                        "subject": "{from_user} has shared a file with you.",
                        "messages": [
                            "{from_user} has shared a file with you.",
                            "",
                            "Please visit your Blast Connect library to access the file: {media_url_anchor}"
                        ]
                    },
                    "encoded": {
                        "subject": "{to_user}, your video has been uploaded on Blast Connect",
                        "messages": [
                            "Thank you for your patience, the video uploaded to your Blast Connect account is now ready. Click here to view your file:",
                            "{media_url_anchor}"
                        ]
                    }
                },
                "analysis": {
                    "encoded": {
                        "subject": "{to_user}, your video is ready to view, analyze, and share on Blast Connect",
                        "messages": [
                            "{to_user}, your video is ready to view, analyze, and share within your Blast Connect library {media_url_anchor}.",
                            "",
                            "To learn more about Blast Connect video analysis, {learn_about_analysis_url_anchor}"
                        ]
                    }
                },
                "message": {
                    "received": {
                        "subject": "{to_user}, you have received a private message from {from_user}",
                        "messages": [],
                        "labels": {
                            "from": "From: {from_user}",
                            "message": "Message: "
                        }
                    }
                },
                "communicate": {
                    "submitted_on_behave": {
                        "subject": "{to_user}, your form has been edited by {from_user}",
                        "messages": [
                            "{to_user}, your form has been edited by {from_user}.",
                            "",
                            "Please click on the following link to view the edit. {communicate_url_anchor}"
                        ]
                    }
                },
                "event": {
                    "added": {
                        "title": "You have been added to a {event_name}",
                        "subject": "{to_user}, you have been added to a {event_type} by {from_user}",
                        "message": "{to_user}, {from_user} has added you to the {event_type}: {event_name} {on_days}",
                        "body": "<p>Dear {first_name},</p><p>You have been added to the {event_name}: <strong>{event_title}</strong> on <strong>{start_date}</strong></p>",
                        "wish_cancel_message": "<p>If you wish to cancel, you must do so by {date}.</p>"
                    },
                    "updated": {
                        "subject": "{to_user}, your {event_name} has changed by {from_user}",
                        "message": "Your {event_type} {event_name} has changed {on_days} "
                    },
                    "with_more": "and {count} more",
                    "on_days": "on: |on the following days: ",
                    "view_your_calendar": "View your Calendar",
                    "cancel_by_date": "If you wish to cancel, you must do so by {cancel_by_date}"
                },
                "routine": {
                    "assigned": {
                        "subject": "{to_user_name}, you have been assigned {routine_name} by {from_user_name}",
                        "messages": [
                            "{to_user_name}, you have been assigned to {routine_name} by {from_user_name}.",
                            "{view_and_complete_anchor}",
                            "({routine_url})"
                        ],
                        "view_and_complete_message": "View and complete it"
                    }
                },
                "unpaid_reminder": {
                    "subject": "Blast Connect Account Created – One More Step To Go",
                    "student_subject": "Blast Motion Blast Connect {sport} Account Created – One More Step To Go"
                }
            },
            "edit_your_account": "Edit your account settings",
            "manage_your_members_subscription": "Manage other members' subscriptions",
            "currently_viewing_members_subscription": "<strong>Note:</strong> You are currently viewing another member's subscription information. Purchases made for this member will be charged to one of your credit cards on file.",
            "subscription_viewable_admin": "Subscriptions are not viewable on when logged in as a Blast Admin because Blast Admins don't have to pay for subscriptions.",
            "base_plan": "Base Plan",
            "add_ons": "Add Ons",
            "product": "Product",
            "buy_now": "Buy Now",
            "renewal_date": "Renewal Date",
            "billing_frequency": "Billing Frequency",
            "credit_card": "Credit Card",
            "request_take_over": "Request Takeover",
            "cancel_take_over": "Cancel Takeover",
            "cancel_payment_source_change": "Cancel Payment Source Change",
            "take_over": "Takeover",
            "request_hand_off": "Request Hand Off",
            "cancel_hand_off": "Cancel Hand Off",
            "hand_off_requested": "Hand off requested",
            "hand_off_declined": "Hand off declined",
            "hand_off": "Hand Off",
            "hand_off_desc": "In some cases, you may wish to ask an admin coach of your academy to continue paying for your Blast Connect or Add-On subscription after your next renewal date. Note: this is only a request, and the person you're requesting from needs to accept your request in order for the payment change to take effect.",
            "hand_off_select_person": "Select A Person To Continue Paying For {entitlement_user_name} Subscription.",
            "hand_off_accept_title": "has made a subscription hand-off request",
            "hand_off_accept_desc": "has requested that you take over paying for his subscription at the end of the next billing cycle.",
            "hand_off_accept_optional": "This is optional. If you choose to accept this request, select how you'd like to pay before accepting.",
            "unauthorized_payment_source": "Unauthorized Payment Source",
            "cancel_subscription": "Cancel Subscription",
            "change_card": "Change Card",
            "change_billing_frequency": "Change Billing Frequency",
            "one_time_charge": "One Time Charge",
            "restore_subscription": "Restore Subscription",
            "select_product": "Select a Product",
            "please_select_a_product": "Please select a product.",
            "pay_card_on_file": "Pay With a Credit Card on File",
            "use_another_card": "Use Another Credit Card",
            "buy": "Buy",
            "select_card_on_file": "Select a Credit Card on File",
            "add_new_card": "Add a New Card",
            "cancel_are_you_sure": "Are you sure you want to cancel this subscription?",
            "cancel_access_ends": "If canceled, your access will end on",
            "cannot_be_undone": "This cannot be undone.",
            "cancel_yes": "Yes, Cancel",
            "cancel_no": "No, Go Back",
            "you_have_already_paid": "You have already paid up until: {expiry_date}. This change will come into effect on: {new_date}.",
            "paid_for_by_card": "Subscriptions currently paid for by this card",
            "cards_on_file": "Cards On File",
            "account_configuration": "Account Configuration",
            "account_configuration_has_been_updated": "Account configuration has been updated.",
            "currently_paying_for_subscription": "Currently paying for this subscription",
            "will_be_paying_for_subscription_on_renewal": "Will start paying for this subscription upon renewal",
            "notifications": "Notifications",
            "expiry": "Expiry",
            "expires": "Expires",
            "expired": "Expired",
            "active_subscriptions": "Active Subscriptions",
            "pending_subscriptions": "Pending Subscriptions",
            "remove_card": "Remove Card",
            "remove_card_sure": "Are you sure you want to remove this credit card?",
            "update_your_card": "Update Your Credit Card",
            "update_card": "Update Card",
            "card_name": "Card Name",
            "card_number": "Card Number",
            "card_expiry": "Expiration Date",
            "card_holder_name": "Card Holder Name",
            "add_credit_card": "Add Credit Card",
            "clear": "clear",
            "remove_card_description": "You are about to remove a credit card that is currently paying for active subscriptions. To make sure you don't lose access to your account(s), please select or add a card that will continue paying for these subscriptions.",
            "choose_card_on_file": "Choose a credit card on file",
            "use_new_card": "Use a New Credit Card",
            "remove_card_transfer": "Remove Card and Transfer to New Card",
            "subscription_active": "Subscriptions Active",
            "no_cards_on_file": "You currently have no cards saved on file.",
            "no_addons_available": "There are no add-ons available for purchase.",
            "currently_paying_for": "Currently Paying For",
            "currently_paying_for_desc": "Use this area to take over paying for subscriptions that are currently being paid for by this person.",
            "viewing_own_info": "You're currently viewing your own information.",
            "select_card_pay": "Select a Card to Pay With",
            "people_plans": "People and Plans",
            "person_not_paying": "This person is not paying for any products themselves.",
            "paid_by": "Paid By",
            "next_renewal": "Next Renewal",
            "take_over_views": {
                "payment_source_required": "You’ll need to have a credit card on file in order to request a takeover.  Go ahead and add a credit card first, then initiate the takeover request. {cards_on_file_anchor}"
            },
            "current": "Current",
            "pending": "Pending",
            "pending_change": "Pending Change",
            "pending_cc_change": "Pending Card Change",
            "active": "Active",
            "trial": "Trial",
            "trial-ending-notification": "You have {days} {day_label} left in your trial.",
            "features": {
                "blast-connect": {
                    "description": "360° training, communications, management, and improvement tools for athletes, coaches and academies."
                },
                "boditrak": {
                    "description": "Ground-force, pressure, and video analysis solution."
                }
            },
            "primary_position": "Primary Position",
            "secondary_position": "Secondary Position",
            "update_profile_slug_requirement": "Only alphanumeric, dashes and underscores are allowed.",
            "copy_url": "Copy URL",
            "copied_to_clipboard_success_message": "URL copied to clipboard!",
            "update_profile_settings_success_message": "Publish settings updated!",
            "update_profile_settings_error_message": "An error happened. Try again later.",
            "user_profile_notification": "Please fill out your profile information.",
            "delete_school": "Delete School",
            "metrics_headings": {
                "plane_score": "Plane Score",
                "connection_score": "Connection Score",
                "rotation_score": "Rotation Score"
            },
            "select_timezone": "Select Timezone",
            "empty_states_messages": {
                "initial_coach": {
                    "title": "Dig deep into your players' swing metrics.",
                    "text": "Choose a player and hit \"GO\" to start analyzing."
                },
                "no_actions": {
                    "title": "{name} hasn't taken any swings yet.",
                    "text": "Get {first}-name to start a session in the blast app and start swinging."
                },
                "student_no_actions": {
                    "title": "You haven't taken any swings yet.",
                    "text": "Start a session in the blast app and start swinging."
                },
                "no_swings": {
                    "title": "There is no swing data to show.",
                    "text": "Try broadening your filter selections and hit \"GO\"."
                }
            },
            "max_chart_actions": "Only displaying the last {actions} actions. You can change your filters to see older actions in this chart.",
            "session_types": {
                "baseball": {
                    "tee": "Tee",
                    "soft_toss": "Soft Toss",
                    "live_pitch": "Live Pitch",
                    "pitching_machine": "Pitching Machine",
                    "in_game": "In Game",
                    "assessment": "Assessment",
                    "general_practice": "General Practice"
                },
                "softball": {
                    "tee": "Tee",
                    "soft_toss": "Soft Toss",
                    "live_pitch": "Live Pitch",
                    "pitching_machine": "Pitching Machine",
                    "in_game": "In Game",
                    "assessment": "Assessment",
                    "general_practice": "General Practice"
                },
                "golf": {
                    "inside_5_feet": "Inside 5 Feet",
                    "5_to_10_feet": "5 To 10 Feet",
                    "10_to_20_feet": "10 To 20 Feet",
                    "lag_putts": "Lag Putts",
                    "on_course": "On Course",
                    "assess": "Assessment",
                    "custom": "Custom",
                    "less_than_25_yards": "Less Than 25 Yards",
                    "25_to_50_yards": "25 To 50 Yards",
                    "50_to_100_yards": "50 To 100 Yards",
                    "75_to_100_yards": "75 To 100 Yards",
                    "100_to_150_yards": "100 To 150 Yards",
                    "chipping": "Chipping",
                    "pitching": "Pitching",
                    "bump_and_run": "Bump and Run",
                    "lob_shot": "Lob Shot",
                    "short_bunker_shot": "Short Bunker Shot",
                    "long_bunker_shot": "Long Bunker Shot"
                }
            },
            "ncsa": {
                "errors": {
                    "200": "Your information has been successfully submitted to NCSA. Once you're set up with NCSA, you can populate your Blast Connect player profile with your Blast scores, metrics and videos and publish them to your NCSA profle. Stand out from the crowd, and attract the attention of recruiters and coaches!",
                    "409": "You are already an athlete in the NCSA system based on the name, e-mail, and phone number provided.  Please follow up directly with NCSA regarding your account.",
                    "409_initial": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile.",
                    "409_updated": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile.",
                    "400": "Unfortunately, your information was not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "500": "Unfortunately, your information was unable to be sent to NCSA.  Please try again later.",
                    "general": "Something went wrong. Please try again later.",
                    "video_metric_error": "Unfortunately, some of your Blast videos and metrics were not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "metrics_error": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile.  Unfortunately, some of your Blast metrics were not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "metrics_error_no_videos": "Unfortunately, some of your Blast metrics were not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "videos_error": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile.  Unfortunately, some of your Blast videos were not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "videos_error_no_metrics": "Unfortunately, some of your Blast videos were not successfully submitted to NCSA. Our Customer Service team has been alerted and will follow up with you.",
                    "video_limit_reached": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile. Unfortunately, the following Blast videos were not submitted to NCSA: {videoList}. This is because you have exceeded the maximum allowed quantity of 6 videos on your NCSA profile.",
                    "video_limit_reached_no_metrics": "Unfortunately, the following Blast videos were not submitted to NCSA: {videoList}. This is because you have exceeded the maximum allowed quantity of 6 videos on your NCSA profile.",
                    "video_error_invalid_url": "You've successfully published to your NCSA profile. If you need to remove any of your metrics or videos from your NCSA profile, you'll need to do that directly on your NCSA profile. Unfortunately, the following Blast videos were not submitted to NCSA: {videoList}. Our Customer Service team has been alerted and will follow up with you.",
                    "video_error_invalid_url_no_metric": "Unfortunately, the following Blast videos were not submitted to NCSA: {videoList}. Our Customer Service team has been alerted and will follow up with you."
                }
            },
            "help_page": {
                "title": "How Can We Help?",
                "list": {
                    "block_1": {
                        "title": "Welcome Tour",
                        "description": "Welcome to Blast! Launch the tour and get started."
                    },
                    "block_2": {
                        "title": "Understanding Scores & Metrics",
                        "description": "Documents and PowerPoints for download to understand Blast Metrics. Download, print and share."
                    },
                    "block_3": {
                        "title": "Training Center",
                        "description": "Understand your metrics, gain coaching insights, and learn how to improve your game."
                    },
                    "block_4": {
                        "title": "Blast User Guide",
                        "description": "Everything you need to know about using Blast from top to bottom."
                    },
                    "block_5": {
                        "title": "FAQ's",
                        "description": "Answers to the most asked questions."
                    },
                    "block_6": {
                        "title": "Still Need Support?",
                        "description": "Our friendly support staff can help you find your way."
                    },
                    "block_7": {
                        "title": "Event Solution",
                        "description": "Everything you need to know about running an event with Blast."
                    }
                },
                "featured": {
                    "title": "Featured Topics",
                    "topics": {
                        "golf-putt": {
                            "list_1": "Blast Golf - Complete Solution",
                            "list_2": "Mobile Video Analysis Walkthrough",
                            "list_3": "Mobile Video Analysis Example",
                            "list_4": "Sean Lanyi - Video Analysis",
                            "list_5": "JJ Wood Coach Case Study",
                            "list_6": "Coaching with Blast Golf",
                            "list_7": "Practice Between Lessons",
                            "list_8": "Blast Golf with Martin Hall",
                            "list_9": "Blast Golf - Complete Solution Overview",
                            "list_10": "Player Profiles"
                        },
                        "softball": {
                            "list_1": "Getting Started with Onboarding",
                            "list_2": "How to use the Blast Softball App",
                            "list_3": "How to view swings in Blast Connect",
                            "list_4": "How to add a new bat",
                            "list_5": "How to delete swings in the app",
                            "list_6": "How to use Coach mode in the app",
                            "list_7": "Training Benefits with Plane, Connection, Rotation",
                            "list_8": "TNT Softball Academy Case Study"
                        },
                        "baseball": {
                            "list_1": "Getting Started with Onboarding",
                            "list_2": "How to use the Blast Baseball App",
                            "list_3": "How to view swings in Blast Connect",
                            "list_4": "How to add a new bat",
                            "list_5": "How to delete swings in the app",
                            "list_6": "How to use Coach mode in the app",
                            "list_7": "Mobile Video Analysis Walkthrough",
                            "list_8": "University of San Diego Case Study"
                        }
                    }
                },
                "documents": {
                    "title": "Understanding Scores & Metrics",
                    "description": "Documents for download to understand Blast Metrics. Download, print and share.",
                    "baseball": {
                        "list_1": {
                            "title": "Blast Swing Metrics",
                            "description": "A 1-pager which gives an overview of Swing Quality Scores, Swing Metrics, Impact Metrics and Ball Flight Metrics."
                        },
                        "list_2": {
                            "title": "Blast Insights Guide",
                            "description": "A more in-depth overview of Swing Scores, Metrics and the impact on your game."
                        },
                        "list_3": {
                            "title": "Blast Metric Ranges",
                            "description": "A quick reference to ideal metrics value ranges."
                        }
                    },
                    "softball": {
                        "list_1": {
                            "title": "Blast Swing Metrics",
                            "description": "A 1-pager which gives an overview of Swing Quality Scores, Swing Metrics, Impact Metrics and Ball Flight Metrics."
                        },
                        "list_2": {
                            "title": "Blast Insights Guide",
                            "description": "A more in-depth overview of Swing Scores, Metrics and the impact on your game."
                        },
                        "list_3": {
                            "title": "Blast Metric Ranges",
                            "description": "A quick reference to ideal metrics value ranges."
                        }
                    },
                    "golf": {
                        "list_1": {
                            "title": "Blast Golf - Get Started Booklet",
                            "description": "A succinct booklet which helps to understand metrics, and a 3-level prescription for improving your swing."
                        },
                        "list_2": {
                            "title": "Golf Metrics Defined",
                            "description": "A simple document eplaining what golf metrics mean - putting and full-swing."
                        },
                        "list_3": {
                            "title": "Coach's Metric Sheet",
                            "description": "A 1-page cheat sheet showing putting metrics with suggested ranges."
                        }
                    }
                },
                "event_solutions": {
                    "title": "Event Solution",
                    "description": "Everything you need to know about running an event with Blast.",
                    "baseball": {
                        "block_1": {
                            "title": "Getting Started",
                            "list_1": {
                                "title": "Blast Motion Event Checklist",
                                "description": "Find out what you will need to run an event, and get a checklist of the steps that you need to follow for the event to run smoothly."
                            }
                        },
                        "block_2": {
                            "title": "Pre-event",
                            "list_1": {
                                "title": "Blast Connect - Creating Event",
                                "description": "Learn the step-by-step process of how to create and enter your event in Blast Connect. "
                            },
                            "list_2": {
                                "title": "Blast Connect - Inviting Players to Event ",
                                "description": "Watch how quick and easy it is to invite players to the event that you have created."
                            },
                            "list_3": {
                                "title": "Blast Connect - Inviting Players with Social Share",
                                "description": "Learn how to invite players by utilizing the social share option. "
                            },
                            "list_4": {
                                "title": "Blast App - Adding Sensors",
                                "description": "We suggest adding your sensors to your coach account before your event has started. Here is a short video to walk you through that process. "
                            },
                            "list_5": {
                                "title": "Blast App - Adding Bats",
                                "description": "We suggest adding the bat lengths and weights that you anticipate seeing at your event the night before. Here is a short video to walk you through that process. "
                            }
                        },
                        "block_3": {
                            "title": "Day of / During Event",
                            "list_1": {
                                "title": "Blast App - Cross Reference / Quick Add Players",
                                "description": "We suggest that you cross-reference the players invited to the event in the app. Here is a walkthrough on how to do that."
                            },
                            "list_2": {
                                "title": "Blast App - Changing Environment and Layout Options",
                                "description": "Learn how to change the environment and metric layout within the app for your event here."
                            },
                            "list_3": {
                                "title": "Blast App - Capture",
                                "description": "Watch this video on best practices for capturing actions for all your players during the event. "
                            }
                        },
                        "block_4": {
                            "title": "Post-event",
                            "list_1": {
                                "title": "Blast Connect - Viewing Team Report",
                                "description": "Watch this video on how to view the team report in Blast Connect post event. The team report shows the averages of each metric for all the players."
                            },
                            "list_2": {
                                "title": "Blast Connect - Viewing Player Swing Profiles ",
                                "description": "Learn how to view the individual player swing profile in Blast Connect. The individual player swing profile breaks down their Plane, Connection, Rotation scores, as well as their swing-by-swing data."
                            },
                            "list_3": {
                                "title": "Blast Connect – Downloading the Team Report",
                                "description": "Watch how to download the full team report in Blast Connect to an Excel file."
                            }
                        }
                    },
                    "softball": {
                        "block_1": {
                            "title": "Getting Started",
                            "list_1": {
                                "title": "Blast Motion Event Checklist",
                                "description": "Find out what you will need to run an event, and get a checklist of the steps that you need to follow for the event to run smoothly."
                            }
                        },
                        "block_2": {
                            "title": "Pre-event",
                            "list_1": {
                                "title": "Blast Connect - Creating Event",
                                "description": "Learn the step-by-step process of how to create and enter your event in Blast Connect. "
                            },
                            "list_2": {
                                "title": "Blast Connect - Inviting Players to Event ",
                                "description": "Watch how quick and easy it is to invite players to the event that you have created."
                            },
                            "list_3": {
                                "title": "Blast Connect - Inviting Players with Social Share",
                                "description": "Learn how to invite players by utilizing the social share option. "
                            },
                            "list_4": {
                                "title": "Blast App - Adding Sensors",
                                "description": "We suggest adding your sensors to your coach account before your event has started. Here is a short video to walk you through that process. "
                            },
                            "list_5": {
                                "title": "Blast App - Adding Bats",
                                "description": "We suggest adding the bat lengths and weights that you anticipate seeing at your event the night before. Here is a short video to walk you through that process. "
                            }
                        },
                        "block_3": {
                            "title": "Day of / During Event",
                            "list_1": {
                                "title": "Blast App - Cross Reference / Quick Add Players",
                                "description": "We suggest that you cross-reference the players invited to the event in the app. Here is a walkthrough on how to do that."
                            },
                            "list_2": {
                                "title": "Blast App - Changing Environment and Layout Options",
                                "description": "Learn how to change the environment and metric layout within the app for your event here."
                            },
                            "list_3": {
                                "title": "Blast App - Capture",
                                "description": "Watch this video on best practices for capturing actions for all your players during the event. "
                            }
                        },
                        "block_4": {
                            "title": "Post-event",
                            "list_1": {
                                "title": "Blast Connect - Viewing Team Report",
                                "description": "Watch this video on how to view the team report in Blast Connect post event. The team report shows the averages of each metric for all the players."
                            },
                            "list_2": {
                                "title": "Blast Connect - Viewing Player Swing Profiles ",
                                "description": "Learn how to view the individual player swing profile in Blast Connect. The individual player swing profile breaks down their Plane, Connection, Rotation scores, as well as their swing-by-swing data."
                            },
                            "list_3": {
                                "title": "Blast Connect – Downloading the Team Report",
                                "description": "Watch how to download the full team report in Blast Connect to an Excel file."
                            }
                        }
                    },
                    "golf": {
                        "block_1": {
                            "title": "Getting Started",
                            "list_1": {
                                "title": "Blast Motion Event Checklist",
                                "description": "Find out what you will need to run an event, and get a checklist of the steps that you need to follow for the event to run smoothly."
                            }
                        },
                        "block_2": {
                            "title": "Pre-event",
                            "list_1": {
                                "title": "Blast Connect - Creating Event",
                                "description": "Learn the step-by-step process of how to create and enter your event in Blast Connect. "
                            },
                            "list_2": {
                                "title": "Blast Connect - Inviting Players to Event ",
                                "description": "Watch how quick and easy it is to invite players to the event that you have created."
                            },
                            "list_3": {
                                "title": "Blast Connect - Inviting Players with Social Share",
                                "description": "Learn how to invite players by utilizing the social share option. "
                            },
                            "list_4": {
                                "title": "Blast App - Adding Sensors",
                                "description": "We suggest adding your sensors to your coach account before your event has started. Here is a short video to walk you through that process. "
                            },
                            "list_5": {
                                "title": "Blast App - Adding Bats",
                                "description": "We suggest adding the bat lengths and weights that you anticipate seeing at your event the night before. Here is a short video to walk you through that process. "
                            }
                        },
                        "block_3": {
                            "title": "Day of / During Event",
                            "list_1": {
                                "title": "Blast App - Cross Reference / Quick Add Players",
                                "description": "We suggest that you cross-reference the players invited to the event in the app. Here is a walkthrough on how to do that."
                            },
                            "list_2": {
                                "title": "Blast App - Changing Environment and Layout Options",
                                "description": "Learn how to change the environment and metric layout within the app for your event here."
                            },
                            "list_3": {
                                "title": "Blast App - Capture",
                                "description": "Watch this video on best practices for capturing actions for all your players during the event. "
                            }
                        },
                        "block_4": {
                            "title": "Post-event",
                            "list_1": {
                                "title": "Blast Connect - Viewing Team Report",
                                "description": "Watch this video on how to view the team report in Blast Connect post event. The team report shows the averages of each metric for all the players."
                            },
                            "list_2": {
                                "title": "Blast Connect - Viewing Player Swing Profiles ",
                                "description": "Learn how to view the individual player swing profile in Blast Connect. The individual player swing profile breaks down their Plane, Connection, Rotation scores, as well as their swing-by-swing data."
                            },
                            "list_3": {
                                "title": "Blast Connect – Downloading the Team Report",
                                "description": "Watch how to download the full team report in Blast Connect to an Excel file."
                            }
                        }
                    }
                }
            },
            "subscription_reminder": {
                "subject": "Blast {sport} Premium Services Annual Subscription Renewal Reminder",
                "intro": {
                    "trial": {
                        "all": "We hope you are enjoying your 30-day free trial of the Blast Premium Services!"
                    },
                    "player": {
                        "golf": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to become better a golfer over the past year!",
                        "softball": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to become a better hitter over the past year!",
                        "baseball": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to become a better hitter over the past year!"
                    },
                    "non-player": {
                        "golf": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to help your players become better golfers over the past year!",
                        "softball": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to help your players become better hitters over the past year!",
                        "baseball": "We hope you have had a chance to take advantage of all the great features included as part of your Blast {sport} Premium Services subscription to help your players become better hitters over the past year!"
                    }
                },
                "trial": {
                    "subject": "Blast {sport} Premium Services Trial Expiration Reminder",
                    "renewal_date_and_charges": "Please note that your paid subscription will begin on {expiration_date}, with a charge of {charge} billed to your credit card on file.",
                    "paying_for_description": "Please note that the paid subscription(s) for the following user(s) will begin as follows and the associated charges will be billed to your credit card on file:",
                    "paying_for_item_description": "{name} will begin on {expiration_date} with a charge of {charge}",
                    "blast_premium_benefits_caption": "If you haven’t had a chance to check out all the benefits of the Blast Premium Services subscription, here’s a brief reminder of some the great features included:",
                    "premium_features": {
                        "golf": {
                            "non-player": {
                                "golf_premium_features_1": "<b>Coach Mode:</b> Manage team roster and capture or analyze each player’s putting and full-swing results in-app.",
                                "golf_premium_features_2": "<b>Mobile Video Analysis:</b> Analyze auto-clipped video and provide remote coaching feedback with voice-over and video markups - share feedback with players.",
                                "golf_premium_features_3": "<b>Player & Team Reports:</b> Organize and rank players by swing profile to customize training plans, measure their progress, and share the results with players or parents."
                            },
                            "player": {
                                "golf_premium_features_1": "<b>Coach Connection</b> - Join a Blast-powered team and stay connected with your coach - receive feedback anywhere, anytime.",
                                "golf_premium_features_2": "<b>Stats & Video Analysis</b> - Analyze auto-clipped videos with metrics and receive coaching feedback through video voice-overs, markups, and drawings.",
                                "golf_premium_features_3": "<b>Performance Reports</b> - Evaluate your performance history with statistics and data visualizations, set goals, and share the results.",
                                "golf_premium_features_4": "<b>Cloud-based Storage</b> – store all of your videos and swing details in the Blast cloud."
                            }
                        },
                        "baseball": {
                            "non-player": {
                                "baseball_premium_features_1": "<b>Automatic Swing Quality Assessment:</b> Review plane, connection, and rotation scores for every swing, make adjustments, and see the results in real-time, provided by Blast iQ™.",
                                "baseball_premium_features_2": "<b>Coach Mode:</b> Manage team roster and capture or analyze each player’s swing results in-app.",
                                "baseball_premium_features_3": "<b>Advanced Swing Analysis:</b> Deep dive into pre and post impact swing analysis.",
                                "baseball_premium_features_4": "<b>Mobile Video Analysis:</b> Analyze auto-clipped video and provide remote coaching feedback with voice-over and video markups - share feedback with players.",
                                "baseball_premium_features_5": "<b>Player & Team Reports:</b> Organize and rank players by swing profile to customize training plans, measure their progress, and share the results with players or parents."
                            },
                            "player": {
                                "baseball_premium_features_1": "<b>Automatic Swing Quality Assessment</b> - Review plane, connection, and rotation scores for every swing, make adjustments, and see the results in real-time, provided by Blast iQ™.",
                                "baseball_premium_features_2": "<b>Coach Connection</b> - Join a Blast-powered team and stay connected with your coach - receive feedback anywhere, anytime.",
                                "baseball_premium_features_3": "<b>Stats & Video Analysis</b> - Analyze auto-clipped videos with metrics and receive coaching feedback through video voice-overs, markups, and drawings.",
                                "baseball_premium_features_4": "<b>Performance Reports</b> - Evaluate your performance history with statistics and data visualizations, set goals, and share the results.",
                                "baseball_premium_features_5": "<b>Cloud-based Storage</b> – store all of your videos and swing details in the Blast cloud."
                            }
                        },
                        "softball": {
                            "non-player": {
                                "softball_premium_features_1": "<b>Automatic Swing Quality Assessment:</b> Review plane, connection, and rotation scores for every swing, make adjustments, and see the results in real-time, provided by Blast iQ™.",
                                "softball_premium_features_2": "<b>Coach Mode:</b> Manage team roster and capture or analyze each player’s swing results in-app.",
                                "softball_premium_features_3": "<b>Advanced Swing Analysis:</b> Deep dive into pre and post impact swing analysis.",
                                "softball_premium_features_4": "<b>Mobile Video Analysis:</b> Analyze auto-clipped video and provide remote coaching feedback with voice-over and video markups - share feedback with players.",
                                "softball_premium_features_5": "<b>Player & Team Reports:</b> Organize and rank players by swing profile to customize training plans, measure their progress, and share the results with players or parents."
                            },
                            "player": {
                                "softball_premium_features_1": "<b>Automatic Swing Quality Assessment</b> - Review plane, connection, and rotation scores for every swing, make adjustments, and see the results in real-time, provided by Blast iQ™.",
                                "softball_premium_features_2": "<b>Coach Connection</b> - Join a Blast-powered team and stay connected with your coach - receive feedback anywhere, anytime.",
                                "softball_premium_features_3": "<b>Stats & Video Analysis</b> - Analyze auto-clipped videos with metrics and receive coaching feedback through video voice-overs, markups, and drawings.",
                                "softball_premium_features_4": "<b>Performance Reports</b> - Evaluate your performance history with statistics and data visualizations, set goals, and share the results.",
                                "softball_premium_features_5": "<b>Cloud-based Storage</b> – store all of your videos and swing details in the Blast cloud."
                            }
                        }
                    }
                },
                "renewal_date_and_charges": "We wanted to let you know your subscription will renew on {expiration_date}, and a charge of {charge} will be billed to your credit card on file.",
                "paying_for_description": "We wanted to let you know the subscription(s) for the following user(s) will renew as follows and the associated charges will be billed to your credit card on file:",
                "paying_for_item_description": "{name} will renew on {expiration_date} with a charge of {charge}",
                "change_title": "<b>Need to make a subscription change?</b>",
                "change_steps_1": "Log into <a href=\"{app_url}\"><b>{app_domain}</b></a>",
                "change_steps_2": "Select <b>Profile</b> (located in the top-right corner)",
                "change_steps_3": "Select <b>My Account Settings</b>",
                "change_steps_4": "Select <b>Subscriptions</b>",
                "cancel_title": "If you need to <b>cancel a subscription</b>, please follow the <b>instructions below</b>.",
                "cancel_instruction_title": "<b>How to cancel a subscription in Blast Connect:</b>",
                "cancel_steps_1": "Log into <a href=\"{app_url}\"><b>{app_domain}</b></a>",
                "cancel_steps_2": "Select <b>Profile</b> (profile image located in the top-right corner)",
                "cancel_steps_3": "Select <b>Account and Subscription Settings</b>",
                "cancel_steps_4": "Select <b>Subscriptions</b>",
                "cancel_steps_5": "Click on <b>Cancel Subscription</b>",
                "for_more_info": "For more information about how to use the Blast {sport} solution, check out our <a href=\"{training_center_url}\"><b>Training Center</b></a> or our <a href=\"{help_url}\"><b>Help</b></a> information.",
                "any_questions": "If you have any questions, feel free to reach out to <a href=\"mailto:example@blastmotion.com\">example@blastmotion.com</a>, and we will get right back to you.",
                "signature": "Have a great day,<br>Team Blast"
            },
            "training_center_v3": {
                "title": "Training Center",
                "subtitle": "Training Center videos will help you get started, learn “how to” use the app, understand metrics, and learn from training drills – all designed to help you train smarter and get better."
            },
            "roles": {
                "student": "Player",
                "owner": "Admin Coach",
                "coach": "Coach"
            },
            "score_analyzes": {
                "planar_efficiency": {
                    "below_average": "demonstrated lower than average Plane swing performance compared to other players with a similar level of play. The highest priority to improve your swing quality is to focus on Plane drills. Below are some recommended drills to get started.",
                    "average": "demonstrated an average Plane swing performance compared to other players with a similar level of play. To improve your swing quality, focus on Plane drills. Below are some recommended drills to get started.",
                    "above_average": "demonstrated an above-average Plane swing performance compared to other players with a similar level of play. To continue to improve and maintain your high-quality swing, check out the recommended drills below."
                },
                "connection": {
                    "below_average": "demonstrated lower than average Connection swing performance compared to other players with a similar level of play. The highest priority to improve your swing quality is to focus on Connection drills. Below are some recommended drills to get started.",
                    "average": "demonstrated an average Connection swing performance compared to other players with a similar level of play. To improve your swing quality, focus on Connection drills. Below are some recommended drills to get started.",
                    "above_average": "demonstrated an above-average Connection swing performance compared to other players with a similar level of play. To continue to improve and maintain your high-quality swing, check out the recommended drills below."
                },
                "rotational_acceleration": {
                    "below_average": "demonstrated lower than average Rotation swing performance compared to other players with a similar level of play. The highest priority to improve your swing quality is to focus on Rotation drills. Below are some recommended drills to get started.",
                    "average": "demonstrated an average Rotation swing performance compared to other players with a similar level of play. To improve your swing quality, focus on Rotation drills. Below are some recommended drills to get started.",
                    "above_average": "demonstrated an above-average Rotation swing performance compared to other players with a similar level of play. To continue to improve and maintain your high-quality swing, check out the recommended drills below."
                }
            },
            "selected_session_not_found": "Selected session is not found",
            "cannot_create_payment_source": "Cannot create payment source. Please, try again or contact our support.",
            "academy_not_found_are_you_logged_in": "Academy not found. Are you logged in?",
            "user_is_not_found": "User is not found",
            "account_exists_login_or_reset": "Already have a Blast account? Continue to use your existing password, or reset your password from the link provided.",
            "account_already_exists_login_or_reset": "You already have a Blast Account. Continue to use your existing password, or reset your password from the link provided.",
            "current_academy_is_not_a_camp": "Current academy is not an event one.",
            "removed": "Removed",
            "user_removed_messages_popover": "This person has been removed and will not receive any future notifications from this message thread.",
            "academy_is_not_available_for_public_registration_if_you_feel_this_is_an_error_please_contact_us": "{academy_name} is not available for public registration. If you feel this is an error, please contact us.",
            "profile_items_have_been_added_successfully": "Profile Items have been added successfully.",
            "profile_item_has_been_deleted_successfully": "Profile item has been deleted successfully.",
            "we_are_not_able_to_retrieve_your_blast_mobile_account_information_please_try_again": "We are not able to retrieve your Blast Mobile account information, please try again.",
            "there_was_a_problem_with_update_your_blast_mobile_account_please_try_again": "There was a problem with update your Blast Mobile Account, please try again.",
            "publish_to_your_ncsa_profile": "Publish To Your NCSA Profile",
            "need_help_question": "Need Help?",
            "our_customer_support_team_is_here_for_you_with_any_questions_you_might_have": "Our customer support team is here for you with any questions you might have.",
            "swing_quality_scores_and_metrics": "Swing Quality Scores & Metrics",
            "you_are_currently_showing_length_sets_of_metrics_on_your_profile": "You're currently showing 1 set of metrics on your profile. You can only publish 1 set of metrics to your NCSA profile, and it needs to have a minimum of 20 swings. In order for a swing quality score or metric to appear below and to be sent to NCSA, that score or metric must be on a minimum of 20 swings within the set. In order for Exit Velocity to appear in the list of metrics below and to be sent to NCSA, the average value for the set must be at least {minimumExitVelocity} mph. | You're currently showing {numberSets} sets of metrics on your profile. You can only publish 1 set of metrics to your NCSA profile, and it needs to have a minimum of 20 swings. In order for a swing quality score or metric to appear below and to be sent to NCSA, that score or metric must be on a minimum of 20 swings within the set. In order for Exit Velocity to appear in the list of metrics below and to be sent to NCSA, the average value for the set must be at least {minimumExitVelocity} mph. Please select 1 below",
            "you_are_currently_showing_length_videos_on_your_profile": "You're currently showing 1 video on your profile. You can select up to 6 videos to publish to NCSA. If you want to publish videos, please select all videos that you want to publish below, including any that you had previously published. By proceeding, any videos that you had previously published from your Blast player profile will be removed and replaced by those selected below. | You're currently showing {numberOfVideos} videos on your profile. You can select up to 6 videos to publish to NCSA. If you want to publish videos, please select all videos that you want to publish below, including any that you had previously published. By proceeding, any videos that you had previously published from your Blast player profile will be removed and replaced by those selected below.",
            "you_can_have_a_maximum_of_6_videos_on_your_ncsa_profile": "You can have a maximum of 6 videos on your NCSA profile",
            "do_not_publish_any_metrics": "Do not publish any metrics",
            "highlight_videos": "Highlight Videos",
            "who_is_making_this_submission": "Who's Making This Submission?",
            "by_proceeding_you_grant_your_permission_for_the_information_from": "By proceeding, you grant your permission for the information from the previous form to be submitted to NCSA for purposes of NCSA contacting you about their services.",
            "ncsa_consent_disclaimer": "By clicking “yes” and submitting, you agree to receive personalized follow-up and marketing messages from NCSA by email, phone and automated text. Consent is not a condition of purchase. Standard rates apply.",
            "start_by_inviting_your_players": "Start By Inviting Your Players",
            "then_get_them_swinging_with_a_blast_sensor": "Then get them swinging with a Blast sensor.",
            "then_get_them_swinging_with_a_blast_analyzer_sensor": "Then get them swinging with a Blast Swing Analyzer sensor.",
            "their_swing_quality_scores_with_insights_will_appear_here": "Their Swing Quality Scores with Insights will appear here.",
            "invite_your_players": "Invite Your Players",
            "getting_started_tour": "Getting Started Tour",
            "need_sensors_question": "Need sensors?",
            "you_need_to_update_your_browser": "You Need to Update Your Browser",
            "viewing_metrics_on_blast_connect_works_best_on_the_following_browsers": "Viewing metrics on Blast Connect works best on the following Browsers:",
            "there_are_no_swings_to_display": "There are no swings to display",
            "there_are_no_swings_to_display_with_sensor_message": "There are no Blast Swing Analyzer swings to display",
            "if_first_name_is_new_to_blast": "If {first_name} is new to Blast",
            "if_first_name_has_already_been_using_blast": "If {first_name} has already been using Blast",
            "if_first_name_has_already_been_using_blast_with_sensor_message": "If {first_name} has already been using a Blast Swing Analyzer",
            "tell_them_to_start_a_session_in_their_blast_app": "Tell them to start a session in their Blast app and take some swings. Once on a wifi connection, their swings will automatically appear here.",
            "tell_them_to_start_a_session_in_their_blast_app_with_sensor_message": "Tell them to start a session in their Blast app and take some swings with a Blast Swing Analyzer sensor. Once on a wifi connection, their swings will automatically appear here.",
            "if_you_are_new_to_blast": "If you are new to Blast",
            "start_a_session_in_your_blast_app_and_take_some_swings": "Start a session in your Blast app and take some swings. Once on a wifi connection, your swings will automatically appear here.",
            "start_a_session_in_your_blast_app_and_take_some_swings_with_sensor_message": "Start a session in your Blast app and take some swings with a Blast Swing Analyzer sensor. Once on a wifi connection, your swings will automatically appear here.<br> <b>Note:</b> Swings captured with a Blast Personal Swing Trainer sensor are not available within Blast Connect.",
            "if_you_have_already_been_using_blast": "If you have already been using Blast",
            "try_expanding_your_filters_above": "Try expanding your filters above.",
            "note_swings_capture": "<b>Note:</b> Swings captured with a Blast Personal Swing Trainer sensor are not available in Coach mode or within Blast Connect.",
            "relates_to": "Relates to",
            "target": "Target",
            "there_is_no_items_with_provided_words": "There is no items with provided word(s)",
            "rankings_allow_you_to_compare_each_player_use_rankings_along_with_the_filters": "Rankings allow you to compare each player. Use rankings along with the filters above to compare player performance over different time periods.",
            "filter_by_below_average_to_isolate_players_that_need_extra_work_to_correct": "Filter by Below Average to isolate players that need extra work to correct deficiencies for a particular score or metric.",
            "select_a_player_to_see_specifically_how_to_help_them_improve_for_a_particular_metric": "Select a player to see specifically how to help them improve for a particular metric.",
            "customize_this_screen_to_show_rankings_for_scores_and_metrics_that_interest_you": "Customize this screen to show rankings for scores and metrics that interest you.",
            "use_the_team_report_to_take_a_wholistic_view_of_your_players_and_identify": "Use the Team Report to take a wholistic view of your players and identify those who need help in improving. Look in particular for red bar graphs to key in on areas your players need to work on.",
            "sort_this_chart_by_clicking_on_a_column_heading": "Sort this chart by clicking on a column heading.",
            "click_on_a_player_to_get_more_insights_on_how_that_player_can_improve": "Click on a player to get more insights on how that player can improve.",
            "click_icon_to_learn_more_about_what_a_metric_or_score_means": "Click <i class=\"tw-text-blue fal fa-info-circle\"></i> to learn more about what a metric or score means.",
            "measures_the_percentage_of_your_swing_where_the_bat_is_on_the_swing_plane": "Measures the percentage of your swing where the bat is on the swing plane. Your vertical bat angle at contact establishes the plane for that swing. Plane is a great indicator for making more consistent contact on the barrel of the bat.",
            "load_consistency_great_hitters_have_consistent_early_connection_values_on_all_swings": "Great hitters have consistent Early Connection values on all swings. Early connection measures the relationship between the body and the bat as the hitter transitions from their load into the downswing. If the hitters’ swings are in-range, the hitter is consistently loading into a good position and setting themselves up to rotate and be on plane. The target range for Early Connection gives the hitter room for their own personal style and natural adjustments in the swing.",
            "impact_consistency_the_goal_of_impact_consistency_is_for_the_hitter_to_always": "The goal of impact consistency is for the hitter to always be in a strong position at contact for all swings. Comparing Connection at Impact to different pitch locations (using Vertical Bat Angle) helps a hitter understand how the relationship between their body and bat angle changes (or stays the same) for different pitches throughout out the zone.",
            "learn_more_in_the_training_center": "Learn more in the Training Center",
            "plane": "Plane",
            "connection": "Connection",
            "rotation": "Rotation",
            "ball_flight": "Ball Flight",
            "ball_flight_swings": "Ball Flight Swings",
            "measures_the_relationship_between_your_body_tilt_and_vertical_bat_angle_at_impact": "Measures the relationship between your body tilt and vertical bat angle at impact. Maintaining good connection (90 degrees) for all pitch locations is an indicator of dynamic adjustability.",
            "measures_how_quickly_your_bat_accelerates_into_the_swing_plane": "Measures how quickly your bat accelerates into the swing plane. Rotation is a good indicator of how you build bat speed by sequencing roperly. The quicker your rotational acceleration, the more power you will have and the more time you have to adjust to pitch locations.",
            "this_means_ball_flight_data_was_not_captured_for_this_swing_to_capture_ball_flight_data_make_sure_ball_flight_mode": "This means Ball Flight data was not captured for this swing. To capture Ball Flight data, make sure Ball Flight mode is enabled in the app when taking swings.",
            "please_wait_while_we_are_processing_your_request": "Please wait while we're processing your request...",
            "number_actions_are_marked_for_deletion": "<strong>1</strong> action is marked for deletion.|<strong>{number}</strong> actions are marked for deletion.",
            "watch_video": "Watch Video",
            "your_best": "Your Best",
            "your_range": "Your Range",
            "recommended_training": "Recommended Training",
            "achieve_score": "{percent} achieve this score",
            "achieve_avg_above": "above avg.",
            "achieve_avg_below": "below avg.",
            "achieve_avg_based_on_level_of_play": "avg. based on level of play",
            "scores_based_on_the": "Scores based on the",
            "20_80_scouting_scale": "20 - 80 Scouting Scale",
            "the_scouting_scale": "The Scouting Scale",
            "measures_a_players_swing_performance_and_distributes_it_on_a_bell_curve_based_on_level_of_play": "Measures a player’s swing performance and distributes it on a bell curve, based on level of play.",
            "there_are_no_players_who_have_swings_with_selected_date_range": "There are no players who have swings with selected date range.",
            "there_are_no_players_who_are_average": "There are no players who are {average}",
            "customize_ranking_layout": "Customize Ranking Layout",
            "academies_are_not_found": "Academies are not found",
            "there_are_not_valid_subscription_available_to_cancel": "There are not valid subscription available to cancel.",
            "fullnames_subscription_has_been_cancelled_successfully": "{fullname}'s subscription has been cancelled successfully.",
            "fullnames_subscription_can_not_be_cancelled_properly_please_contact_customer_support": "{fullname}'s subscription can not be cancelled properly, please contact customer support.",
            "where_do_you_live": "Where do you live?",
            "select_a_sport": "Select a sport",
            "exclusive_of_taxes": "Exclusive of taxes",
            "this_has_the_potential_of_disrupting_this_customers_service_please_use_caution": "This has the potential of disrupting this customer's service. Please use caution, and <a href=\"mailto:{email}\">contact the dev team</a> if you have any questions.",
            "you_can_only_transfer_players_into_an_academy_of_the_same_sport_type": "You can only transfer players into an academy of the same sport-type, within the same organization, within the same region, with the same subscription settings; and only if they've paid for their own subscription.",
            "your_browser_does_not_support_the_video_tag": "Your browser does not support the video tag.",
            "initiated": "Initiated",
            "upload-started": "Upload Started",
            "upload-paused": "Upload Paused",
            "upload-cancelled": "Upload Cancelled",
            "upload-completed": "Upload Completed",
            "encode-started": "Encode Started",
            "encode-paused": "Encode Paused",
            "encode-cancelled": "Encode Cancelled",
            "encode-completed": "Encode Completed",
            "sequence-started": "Sequence Started",
            "sequence-paused": "Sequence Paused",
            "sequence-cancelled": "Sequence Cancelled",
            "sequence-completed": "Sequence Completed",
            "trialing": "Trialing",
            "unpaid": "Unpaid",
            "pending-cancel": "Pending Cancel",
            "pending-payment-source-change": "Pending Payment Source Change",
            "pending-product-change": "Pending Product Change",
            "pending-payment-hand-off-transfer": "Pending Payment Hand Off",
            "pending-payment-take-over-transfer": "Pending Payment Take Over",
            "the_social_share_link_is_not_available_for_blast_admins_if_you_need_an_invite_url_you_must_login_on": "The Social Share link is not available for Blast Admins. If you need an invite URL, you must login on behalf of a coach and use their Social Share link.",
            "please_login_to_the_subscribing_account_to_continue_the_subscription_process": "Please login to the subscribing account to continue the subscription process.",
            "date_of_birth_required": "Date of Birth Required",
            "date_of_birth_will_get_saved": "Your date of birth will get saved in your profile.",
            "profile_functionality_years_requires": "Certain player profile functionality requires users to be 13 years of age or older. If you are under 13, you can still use most of the features in your Profile, and your coach(es) will still be able to see it.",
            "profile_functionality_years_personalize_your_goals": "Your Date of Birth will also help us to personalize your goals and insights to help you become a better hitter.",
            "profile_functionality_years_please_enter_birthday": "Please enter your date of birth to proceed.",
            "hitter_type": "Hitter Type",
            "tell_about_yourself": "Tell About Yourself",
            "put_your_best_foot_forward": "Put your best foot forward. Your basic information, vitals, will appear here - easy <br>for anyone to see whenever they are in your profile.",
            "add_your_vitals": "Add Your Vitals",
            "publish_and_share": "Publish & Share",
            "public": "Public",
            "published_to_NCSA": "Published to NCSA",
            "publish_to_NCSA": "Publish to NCSA",
            "need_to_add_videos_and_set_of_metrics": "You'll need to add videos (under \"Summary\") and/or sets of swing metrics, with at least 20 swings per set, (under \"Stats\") in order to publish to NCSA.",
            "visible_to_ncsa": "Blast Profile Visible to NCSA?",
            "enter_information_before_share": "You need to enter your information before you can share your Profile.",
            "wish_to_remove_your_metrics": "If you wish to remove your metrics and/or videos from your NCSA profile, you'll need to do that directly on your NCSA profile.",
            "summary": "Summary",
            "athletics": "Athletics",
            "academics": "Academics",
            "contacts": "Contacts",
            "actions_speak_louder_than_words": "Actions speak louder than words. Show case your best swings and career highlights with videos!",
            "add_profile_information": "Add Profile Information",
            "tell_your_story_in_your_own_words": "Tell your story in your own words. Share more details about your background, goals and other important information.",
            "showcases_games_events": "Showcases, Games &amp; Events",
            "sure_to_delete": "Are you sure you want to delete",
            "showcase_from_profile": "showcase from your profile?",
            "show_your_best_showcase": "Show off your best showcase metrics and highlight videos from those events.",
            "add_your_team_information": "Add Your Team Information",
            "you_didnot_get_here_alone": "You didn't get here alone. List the teams that you have been a member of. Don't forget to include any accomplishment made while on those teams.",
            "team_from_your_profile": "team from your profile?",
            "additional_sports": "Additional Sports",
            "sport_from_your_profile": "sport from your profile?",
            "edit_your_sport": "Edit Your Sport",
            "add_your_sport_information": "Add Your Sport Information",
            "add_additional_sports": "Add Additional Sports",
            "more_to_life": "There's more to life than",
            "other_sports_you_play": "List other sports you play and additional teams, from other sports, that you've been on.",
            "from_your_profile": "from your profile?",
            "add_education_info": "Add Education Info",
            "your_education_history": "Your education history, including awards and honors.",
            "educational_institution": "Name of Educational Institution",
            "coaching_certification_levels": "Coaching Certification Levels I, II, II",
            "add_more": "Add more",
            "putting_averages": "Putting Averages",
            "short_game_averages": "Short Game Averages",
            "bunker_averages": "Bunker Averages",
            "full_swing_averages": "Full Swing Averages",
            "your_blast_swing_metrics": "Show off your blast swing metrics, captured on your Blast Motion sensor.",
            "select_your_swing_metrics": "Select Your Swing Metrics",
            "performance": "Performance",
            "add_more_stats": "Add More Stats",
            "add_any_other_relevant_statistics": "Add any other relevant statistics about your performance, which is not captured on your Blast Motion sensor.",
            "graduating": "Graduating",
            "edit_your_profile_statement": "Edit Your Profile Statement",
            "tell_recruiters_about_who_you_are": "Tell recruiters about who you are and what you expect to achieve.",
            "tips_for_writing_profile": "Tips for Writing Your Profile Statement",
            "your_opportunity_to_give_recruiters_a_glimpse": "This is your opportunity to give recruiters a glimpse behind the\n            metrics, stats and videos. This is where you can tell your story,\n            revealing more about your goals and personality.",
            "profile_statement_concise": "Keep your profile statement concise and try to include the following:",
            "why_you_play": "Why you play. Talk about your passion for the sport.",
            "your_most_important_accomplishments": "A summary of your most important accomplishments, even in your younger years.",
            "personal_qualities_you_possess": "Personal qualities you possess that make you excel at your sport.",
            "why_you_seek_an_opportunity": "Describe why you seek an opportunity to attend college.",
            "summary_of_your_academic": "A short summary of your academic accomplishments.",
            "other_interests": "Other interests outside of sports.",
            "a_sample_profile_statement": "A Sample Profile Statement",
            "sample_profile_statement_1": "My name is Ben Smith. I am a senior at Sage Creek High School in\n              Carlsbad, CA. I have been playing baseball since the age of 6.\n              When I was younger, I also played basketball, but quickly realized\n              that baseball is my passion. I have been playing travel ball since\n              the age of 10.",
            "sample_profile_statement_2": "In high school, I have been the starting varsity short stop all\n              three years. On the mound, I am the mid-relief/closer, but will\n              also become a starter my senior year. I am a ground ball inducing\n              pitcher, as my pitches have a lot of movement and I am able to\n              consistently hit my spots. My coaches comment on my mound\n              presence, as my mental game is one of my best attributes. I have\n              always been a strong bat in the lineup, batting third. Winning the\n              Section Title as a junior is the highlight of my high school\n              career. I have earned All-League all three years of high school\n              and Academic All-League my last two years.",
            "sample_profile_statement_3": "In the off season, I work with a Certified Athletic Trainer\n              3x/week with lifting, speed and agility. My goal is to make my\n              senior year my best year. As a team captain, I plan to be a\n              dynamic player and a positive influence on the team. I also\n              understand that the way I carry myself both on and off the field\n              reflects my team, my family and my school.",
            "sample_profile_statement_4": "I am really looking for a program that will be a good fit for me\n              athletically and academically. I am seeking to continue growing\n              under experienced coaches, while playing at a high level of\n              competitive baseball. I believe I have the talent to compete at\n              the college level with character, high work-ethic, and leadership\n              skills to make an immediate impact at any program.",
            "sample_profile_statement_5": "My goal is to major is Business with an emphasis in Sports\n              Management. My junior year I finished with a 3.7 GPA, challenging\n              myself with two AP courses. I will continue to challenge myself\n              next year, with three AP courses. I appreciate you taking the time\n              to read my personal statement. I am looking forward to my next\n              baseball challenge.",
            "add_an_avatar": "Add an avatar",
            "blast_account_email": "Blast Account Email",
            "blast_account_password": "Blast Account Password",
            "yearly": "Yearly",
            "ball_flight_data_was_not_captured_description": "This means Ball Flight data was not captured for this\n                      player. To capture\n                      Ball Flight data, make sure Ball Flight mode is enabled in\n                      the app when the\n                      player is taking swings or it’s enabled in coach mode.",
            "add_some_players": "Add some players",
            "roster_has_no_players": "This roster has no players in it.",
            "member_pays": "Member pays",
            "levels_of_play": {
                "other": "Amateur - All Levels",
                "youth": "Youth",
                "middle_school": "Middle School",
                "high_school_junior_varsity": "High School - Junior Varsity",
                "high_school_varsity": "High School - Varsity",
                "college_all_divisions": "College - All Divisions"
            },
            "action_id": "Action ID",
            "your_blast_connect_account_has_been_removed_from_academy": "Your Blast Connect Account has been removed from {academy}",
            "report_date": "Report Date",
            "swing_count": "Swing Count",
            "roster_average": "Roster Average",
            "variance": "Variance",
            "l_handedness": "L",
            "r_handedness": "R",
            "b_handedness": "B",
            "ok": "OK",
            "please_enter_2_or_more": "Please enter 2 or more characters",
            "share_file": "Share file",
            "image": "image",
            "document": "document",
            "already_have_blast_connect_account_good_news": "We see that you already have a Blast Connect account associated\n        with that email. Good news, there's no need to register for a Blast Connect account &mdash;\n        <a href=\"/login/\">just login</a>!",
            "profile_has_been_updated": "{name} 's profile has been updated.",
            "profile_changed": "{name} 's Profile Changed",
            "added_to_their_library": "Added {file_type} to their Library",
            "subscription_purchased_from_us_company": "Subscription is being purchased from a US company. Additional fees may be charged at the discretion of your credit card company.",
            "media_from_your_library": "Media From Your Library",
            "starting_recorder_dots": "Starting recorder...",
            "your_recording_will_start_in": "Your recording will start in:",
            "please_move_your_mouse_around": "Please move your mouse around within the browser window to continue.",
            "upload_file": "Upload File",
            "upload_images_formats": "Accepted image formats are ",
            "selected_files": "Selected Files",
            "encoding_files": "Encoding Files",
            "video": "Video",
            "audio": "Audio",
            "filter_by_date_range": "Filter by Date Range",
            "filter_by_month": "Filter by Month",
            "almost_ready": "Almost Ready!",
            "your_video_is_processing": "Your video is processing. It won't be long, but if you would rather not wait, click below to receive an email when it's ready.",
            "continue_and_email": "CONTINUE AND EMAIL ME WHEN IT'S READY",
            "pause": "Pause",
            "select_user_to_view_their_media_library": "Select User to view their Media Library",
            "sorry_file_is_not_valid": "Sorry, the file submitted is not valid",
            "added_on": "Added On",
            "file_size": "File Size",
            "first": "First",
            "no_data_available_in_table": "No data available in table",
            "showing_of_total_entities": "Showing _START_ to _END_ of _TOTAL_ entries",
            "filtered_from_total_entities": "Filtered from _TOTAL_ total entries",
            "showing_0_of_entities": "Showing 0 to 0 of 0 entries",
            "all_dates": "All Dates",
            "show_num_entries": "Show _MENU_",
            "want_to_play_baseball_in_college": "Want to play baseball in college?",
            "blast_motion_has_teamed_up_with_next_college_player_athlete_ncsa_to_help_athletes_with_the_dream_of_playing_sports": "Blast Motion has teamed up with NCSA College Recruiting to help athletes with the dream of playing sports at the next level.",
            "go_to_your_player_profile_to_start_your_own_free_recruiting_profile_with_ncsa_then_publish_your_blast_scores": "Go to your Player Profile to start your own FREE recruiting profile with NCSA. Then publish your Blast scores, metrics and videos directly to your NCSA profile to gain exposure to over 35,000 college coaches.",
            "publish_your_scores": "Publish your Blast scores, metrics and videos directly to your NCSA profile to gain exposure to over 35,000 college coaches.  Their team of 800+ recruiting experts can also help you and your family better understand the recruiting process.",
            "we_would_have_never_been_able_to_find_player_athletes_name_removed_had_it_not_been_for_your_services": "We would have never been able to find [player-athlete's-name removed] had it not been for your services.",
            "ncaa_division_i_head_baseball_coach": "NCAA Division I Head Baseball Coach",
            "get_recruited": "Get Recruited",
            "im_not_interested_right_now": "I'm not interested right now",
            "im_interested": "I'm interested",
            "go_to_player_profile": "Go to Player Profile",
            "dismiss": "Dismiss",
            "ncsa_profile_settings_updated": "NCSA Profile Settings Updated!",
            "metrics_are_not_found": "Metrics are not found",
            "requested_take_over_subscription": "{name} has requested to take over one of your subscription.",
            "requested_take_over_subscription_below": "{names} has requested to take over one of your subscription (stated below).",
            "accept_hand_off": "Accept Hand Off",
            "decline_hand_off": "Decline Hand Off",
            "hi_user_name": "Hi {name}",
            "dont_show_again": "DON'T SHOW AGAIN",
            "what_does_mean": "What does ‘ - - ‘ mean?",
            "select_your_session": "Select Your Session",
            "add_another_time_frame": "Add another time frame",
            "optional_describe_your_metrics_with_a_title": "Optional - describe your metrics with a title",
            "highlight": "Highlight",
            "show_hide": "Show/Hide",
            "you_need_to_select_a_session_or_date_range": "You need to select a session or date range!",
            "start_year": "Start Year",
            "head_coach": "Head Coach",
            "john_smith": "John Smith",
            "sport_name": "Sport Name",
            "add_video": "Add Video",
            "if_you_do_not_add_videos": "If you do not add videos, this section will not appear on your public profile.",
            "under_13_years_old_cannot_share_profiles": "Please note that players under 13 years old cannot share profiles publicly.",
            "update_profile_field_instruction": "Go to Account and Subscription Settings > My Account Settings > Overview to update this value.",
            "switch_hitter": "Switch Hitter",
            "slap_full_swing": "Slap / Full Swing",
            "parent_or_guardian_contact_information.": "Parent/or guardian contact information.",
            "add_your_parent_info": "Add Your Parent Info",
            "there_is_no_action_in_the_selected_date_range": "There are no actions in the selected date range.",
            "list_some_relevant_stats_about_your_athletic_physical_abilities": "List some relevant stats about your athletic/physical abilities.",
            "value": "Value",
            "unit": "Unit",
            "highlighted_question": "Highlighted?",
            "list_some_relevant_stats_about_your_in_game_performance": "List some relevant stats about your in-game performance.",
            "your_profile_has_been_updated": "Your profile has been updated",
            "birth_date": "Birth Date",
            "age": "Age",
            "blast_connect_account_created": "Blast Connect Account Created – One More Step for Access {academy_name}!",
            "great_news_account_has_been_created": "Great news, your Blast Connect account has been created!",
            "great_news_account_has_been_created_student": "Blast Motion Blast Connect {sport} Account Created – One More Step To Go",
            "we_need_you_to_complete_one_more_step": "<strong>We need you to complete one more step</strong> before you’ll gain access to the fully-integrated suite of software analysis, coaching, communication and management tools designed to help you manage your teams / athletes more effectively and efficiently.",
            "coach_subscription_plan_selection": "Blast Connect – Coach Subscription Plan Selection & Payment",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect": "To access your Blast Connect account, you’ll need to complete the sign-up process by choosing a Blast Connect – Coach / Admin Coach subscription plan and completing the payment process ({price_interval}). Simply click the following link to log in and complete this step.",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect_student": "To access your Blast Connect account, you’ll need to complete the sign-up process by choosing a Blast Connect - Athlete subscription plan and completing the payment process ({price_interval}). Simply click the following link to log in and complete this step.",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect_us_student": "As an athlete, you will have a <b>30-day FREE trial</b>, but to access your Blast Motion Blast Connect account and free trial, you’ll need to complete the sign-up process by choosing a Blast Connect - Athlete subscription plan and entering your payment details ({price_interval}). You can cancel anytime before the 30-day trial is up to avoid any charges to your credit card. Simply click the following link to log in and complete this step.",
            "the_blast_motion_team": "The Blast Motion Team",
            "athlete_subscription_plan_selection_payment": "Blast Connect – Athlete Subscription Plan Selection & Payment",
            "we_need_you_to_complete_one_more_step_student_precondition": "Whether you signed up yourself or you were invited by your coach,",
            "we_need_you_to_complete_one_more_step_student": "<strong>we need you to complete one more step</strong> before you’ll gain access to your own personalized suite of software analysis, coaching, communication, and management tools designed to help you train smarter and get better faster.",
            "bat_speed": "Bat Speed",
            "exit_velocity": "Exit Velocity",
            "now_playing": "Now Playing",
            "delete_showcase": "Delete Showcase",
            "add_to_your_showcase_video": "Add To Your Showcase Video",
            "showing_of_total_entities_replace": "Showing {start} to {end} of {total} entries",
            "no_video_in_your_library": "You have no video available in your library!",
            "weekly_event_report": "Weekly Event Report",
            "number_events_have_ended_this_week": "{count} event has ended this week. |{count} events have ended this week.",
            "the_following_session_was_created_by_other_people_and_can_not_be_deleted": "The following session was created by other people and can not be deleted|The following sessions were created by other people and can not be deleted",
            "number_sessions_have_been_deleted": "1 session has been deleted|{number} sessions have been deleted",
            "searching": "searching...",
            "results_could_not_be_loaded": "The results could not be loaded",
            "no_results_found": "No results found",
            "remove_all": "Remove All",
            "general_email_mail_to": "https://blastconnect.com/help",
            "full_team_report_is_ready": "Full Team Report is Ready",
            "temporarily_down": "Temporarily Down For Maintenance",
            "we_are_doing_maintenance": "We're doing some routine maintenance on {appName}. Just the standard stuff. Be right back!",
            "down_since": "Down since",
            "graduating_": "Graduating",
            "graduating_high_school": "Graduating High School",
            "uploaded": "Uploaded",
            "delete_sport_from_profile": "Are you sure you want to delete {sport} sport from your profile?",
            "warning": "Warning",
            "email_entered_not_change_login": "The email entered here will not change your Blast Account login",
            "delete_sport": "Delete Sport",
            "bench_press": "Bench Press",
            "want_to_delete_this_parent": "Are you sure you want to delete this parent?",
            "want_to_delete_this_stat": "Are you sure you want to delete this stat?",
            "want_to_delete_these_metrics": "Are you sure you want to delete these metrics from your profile?",
            "minor_league": "Minor League (all levels)",
            "dsl": "DSL",
            "rookie_ball": "Rookie Ball",
            "class_a_short_season": "Class A (short season)",
            "class_a_low": "Class A (low)",
            "class_a_advanced": "Class A (advanced)",
            "aa": "AA",
            "aaa": "AAA",
            "mlb": "MLB",
            "handicap_21_plus": "Handicap 21+",
            "handicap_16_20": "Handicap 16 - 20",
            "handicap_11_15": "Handicap 11 - 15",
            "handicap_6_10": "Handicap 6 - 10",
            "handicap_0_5": "Handicap 0 - 5",
            "handicap_plus_1_plus_5": "Handicap +1 - +5",
            "tour_player": "Tour Player",
            "travel_ball_12u_14u": "Travel Ball 12U - 14U",
            "travel_ball_16u_18u": "Travel Ball 16U - 18U",
            "college_junior_d3_d2": "College Junior D3 D2",
            "college_d1": "College D1",
            "professional": "Professional",
            "help_uppercase": "HELP",
            "high_school": "High School",
            "jr_college": "Jr. College",
            "university": "University",
            "present": "Present",
            "sure_to_delete_item": "Are you sure you want to delete {item} from your profile?",
            "shipping_address": "Shipping Address",
            "shipping_address_additional": "Shipping Address Additional",
            "shipping_address_additional_optional": "Shipping Address Additional (Optional)",
            "state": "State",
            "zip_code": "Zip Code",
            "united_states": "United States",
            "player_profile": "Player Profile",
            "number": "Number",
            "user_renews_status_description": "The person's Blast Premium account is active, and the date that their account will renew is shown",
            "user_pending_status_description": "The person's Blast Premium account is not active, most likely because they have not accepted their invitation to their account.",
            "user_invalid_status_description": "The invalid person's Blast Premium account is not active.",
            "search_players": "Search Players",
            "search_coaches": "Search Coaches",
            "graduating_jr_college": "Graduating Jr. College",
            "graduating_university": "Graduating University",
            "count_seats_in_academy": "{account_type} in this academy:  {count}",
            "assigned_seats_of_available": "{assigned_count} of {available_count} available seats are assigned",
            "assigned_seats": "{assigned_count} seats have been assigned.  Please contact your Blast Motion representative to find out how many available seats you have.",
            "seats_validation_message": "Seats is a required field and must be populated before the Academy Configuration can be saved.",
            "coaches_corner": "Coach's Corner",
            "coaches_corner_page": {
                "title": "Welcome, Coach!",
                "list": {
                    "block_1": {
                        "title": "Onboarding Videos",
                        "description": "Get started with inviting players and collecting data."
                    },
                    "block_2": {
                        "title": "Training with Blast",
                        "description": "Training with Blast can be made easy by following 4 phases: Assessment Phase, Analyze Phase, Training Phase, and Reassess Phase."
                    },
                    "block_3": {
                        "title": "Blast Video Hall of Fame",
                        "description": "A collection of the best and most useful videos we have created at Blast. These videos directly impact you and focus in on Swing Phases, Swing Profiles, and Key Blast Metrics."
                    },
                    "block_4": {
                        "title": "Understanding Scores & Metrics",
                        "description": "Documents for download to understand Blast Metrics. Download, print and share."
                    },
                    "block_5": {
                        "title": "Blast Certification",
                        "description": "Get Blast-certified with this self-paced video certification course outlining all things Blast."
                    },
                    "block_6": {
                        "title": "Event Solution",
                        "description": "Everything you need to know about running an event with Blast."
                    },
                    "block_7": {
                        "title": "Support Ticket",
                        "description": "Our friendly staff can help you find your way."
                    }
                },
                "onboarding_videos": {
                    "title": "Onboarding Videos",
                    "description": "Get started with inviting players and collecting data.",
                    "list": {
                        "block_1": {
                            "title": "Get Started",
                            "list": {
                                "title_1": "Get Started",
                                "title_2": "Support Follow-up",
                                "title_3": "Deeper Understanding"
                            }
                        }
                    }
                },
                "training_with_blast": {
                    "title": "Training with Blast",
                    "list": {
                        "block_1": {
                            "title": "Get Started",
                            "list": {
                                "title_1": "Train with Blast by following 4 easy phases",
                                "title_2": "Set up a Blast Motion Smart Cage at your facility"
                            }
                        }
                    }
                },
                "blast_video_hall_of_fame": {
                    "title": "Blast Video Hall of Fame",
                    "description": "A collection of the best and most useful videos we have created at Blast. These videos directly impact you and focus in on Swing Phases, Swing Profiles, and Key Blast Metrics.",
                    "block_1": {
                        "title": "Key Metrics",
                        "list_1": {
                            "title": "Blast Motion Key Metrics",
                            "description": "Walk through Blast Swing Metrics for Plane, Connection, and Rotation with actual hitter examples to help you understand Key Metrics in the swing."
                        }
                    },
                    "block_2": {
                        "title": "Swing Profile",
                        "list_1": {
                            "title": "Swing Consistency Profile: Early Connection + Connection at Impact",
                            "description": "Consistency Swing Profiles have two parts: Early Connection (deg) and Connection at Impact (deg). Learn more."
                        },
                        "list_2": {
                            "title": "Contact Profile: On Plane Efficiency + Attack Angle"
                        },
                        "list_3": {
                            "title": "Power Profile with Blast (Bat Speed + Rotational Acceleration)"
                        }
                    },
                    "block_3": {
                        "title": "Metric Definition & Comparison",
                        "list_1": {
                            "title": "Attack Angle vs. Launch Angle",
                            "description": "How does your Attack Angle affect your Launch Angle? Strive to match your Attack Angle to your desired Launch Angle based on the type of hitter you are. The hardest balls are hit when you square up the ball by having a similar Attack Angle and Launch Angle. Watch this video to learn more."
                        },
                        "list_2": {
                            "title": "Vertical Bat Angle",
                            "description": "Vertical Bat Angle is the angle of the bat with respect to horizontal at the moment of impact. Vertical Bat Angle is measured in degrees and provides the location of the barrel of the bat relative to the knob of the bat at impact. Vertical Bat Angle will be zero when the barrel of the bat and the knob are parallel to the ground. Vertical Bat Angle will be negative when the barrel of the bat is below the knob of the bat at impact."
                        },
                        "list_3": {
                            "title": "Connection at Impact",
                            "description": "Connection (at impact) measures the relationship between your body tilt and vertical bat angle at impact. Maintaining good connection (90 degrees) for all pitch locations is an indicator of dynamic adjustability."
                        },
                        "list_4": {
                            "title": "Early Connection",
                            "description": "Early Connection measures the relationship between your body tilt and vertical bat angle at the start of the downswing. Establishing good connection (90 degrees) early in the swing helps you get on plane and increases your ability to adjust to all pitch locations."
                        },
                        "list_5": {
                            "title": "Rotational Acceleration",
                            "description": "Rotation measures how quickly your bat accelerates into the swing plane. Rotation is a good indicator of how you build bat speed by sequencing properly vs. pulling the bat with your hands. The quicker your rotational acceleration, the more power you will have and the more time you have to make a decision at the plate."
                        },
                        "list_6": {
                            "title": "On Plane Efficiency",
                            "description": "Measures the percentage of your swing where the bat is on the swing plane. Your vertical bat angle at contact establishes the plane for that swing. Plane is a great indicator for making more consistent contact on the barrel of the bat."
                        },
                        "list_7": {
                            "title": "Connection at Impact vs Early Connection",
                            "description": "See what Connection at Impact and Early Connection are and how they are measured. Connection at Impact measures the relationship between body tilt and vertical bat angle at impact. Early Connection measures the relationship between body tilt and vertical bat angle just after the start of the swing."
                        }
                    },
                    "block_4": {
                        "title": "Training",
                        "list_1": {
                            "title": "Which Metrics to Train First",
                            "description": "Learn which metrics you should train around and focus on first. The first two metrics we recommend training to are Early Connection (Swing Metric) and Attack Angle (Impact Metric)."
                        },
                        "list_2": {
                            "title": "PVC Pipe Drill: Deep Dive",
                            "description": "Take a deeper look at our PVC Pipe drill so you can learn tips and tricks on how to best use the drill, and make better hitters."
                        },
                        "list_3": {
                            "title": "Small Ball Drill with Decision Making",
                            "description": "You can make any drill game like and add a decision making process. Watch this video to learn an advanced way to do the small ball drill by adding different color balls and add decision making into the mix."
                        },
                        "list_4": {
                            "title": "Heavy Ball Playing Catch (Youth)",
                            "description": "Using a heavy ball can be a great tool to use for feedback. Learn some ways to use the heavy ball drill with hitters to promote a good swing and hard contact. The heavy ball gives exaggerated feedback. The drill is also a game because you are playing catch. Watch to learn more!"
                        },
                        "list_5": {
                            "title": "Weighted Bat Sleeve with your Own Bat",
                            "description": "Swinging a heavy bat is great for your swing, including Plane, Connection, and Rotation. Learn how and when to use a heavy bat, along with easy ways to add weight to your existing bat."
                        },
                        "list_6": {
                            "title": "6-Ball Approach Drill",
                            "description": "Use the simple 6-Ball approach drill to train plate discipline and approach. Choose your favorite part of the plate and create a visual for your hitter to understand the plate and their approach."
                        },
                        "list_7": {
                            "title": "How to Improve Early Connection & Attack Angle",
                            "description": "What is Early Connection and Attack Angle? Learn how to train with these metrics, with specific drills to help you improve."
                        }
                    }
                },
                "understanding_scores_and_metrics": {
                    "title": "Understanding Scores & Metrics",
                    "description": "Documents for download to understand Blast Metrics. Download, print and share.",
                    "list_1": {
                        "title": "Blast Swing Metrics",
                        "description": "A 1-pager which gives an overview of Swing Quality Scores, Swing Metrics, Impact Metrics and Ball Flight Metrics."
                    },
                    "list_2": {
                        "title": "Blast Metric Ranges",
                        "description": "A quick reference to ideal metrics value ranges."
                    },
                    "list_3": {
                        "title": "Plane Connection Rotation - PowerPoint",
                        "description": "Use this presentation to educate others about Plane, Connection, Rotation."
                    },
                    "list_4": {
                        "title": "Blast Insights Guide",
                        "description": "A more in-depth overview of Swing Scores, Metrics and the impact on your game."
                    }
                },
                "certification": {
                    "title": "Certification",
                    "description": "Get Blast-certified with this self-paced video certification course outlining all things Blast.",
                    "block_1": {
                        "title": "Watch the Videos",
                        "list_1": {
                            "title": "Blast Certification Videos",
                            "description": "The Blast coach certification video course will provide you with important insights on how to use the Blast solution within your organization or program. You'll learn the fundamentals for how you can use the Blast swing analyzer and Blast Connect (premium services) to help assess a player's swing, track their performance over time, and use Blast information to improve your coaching to drive better training and on-field results."
                        }
                    },
                    "block_2": {
                        "title": "Take the Quiz",
                        "list_1": {
                            "title": "Blast Motion Certification Quiz",
                            "description": "After watching the videos, take the certification quiz to receive your certificate as a Blast-certified coach. Please note that the quiz will take approximately 30 minutes, and it must be completed in a single session. (There is not an option to save it if it’s partially completed.)\n\n                        After successfully completing the quiz, you will get a copy of your certificate for PDF download so that you can print it. You will also receive an e-mail with your results and a link to your certificate that you can download, save, and print."
                        }
                    }
                }
            },
            "sns_message_invalid": "SNS Message Invalid",
            "sales_report_title": "Blast Connect Sales Report",
            "academy_suspended": "Academy Suspended",
            "suspended_academy_title": "Access to this Academy has expired",
            "suspended_academy_help": "Please contact your account representative or <a href=\"{help_url}\">customer support</a> if you have any questions.",
            "disabled_registration_in_academy_title": "Registration for this Academy is not currently available",
            "disabled_registration_in_academy_help": "Please contact your Coach to assist you with your registration.",
            "you_have_no_more_seats_available": "You have no more licensed seats available.  If you need to purchase additional seats, please contact your Blast Motion representative for a quote.",
            "did_you_find_it_useful": "Did you find it useful?",
            "change_to_sport_training_center": "Change to {sport} Training Center",
            "name_has_been_moved_into_target_academy": "{name} has been moved into <a href=\"{url}\">{target_academy}</a>.",
            "upgrade_to_blast_premium_services": "Upgrade to Blast Premium Services",
            "get_the_most_from_your_blast_experience_advanced_insights_analysis_and_reporting_at_your_fingertips": "Get the most from your Blast Experience!<br>Advanced insights, analysis and reporting at your fingertips.",
            "you_have_number_days_left_in_your_free_trial": "You have {number} days left in your free trial",
            "learn_more_about_premium_services": "Learn More About Premium services",
            "click_to_change_language_label": "Click to change language to {lang}",
            "swing_trainer_sensors_are_not_available": "Includes only swings captured on Blast Swing Analyzer sensors.<br>Swings captured on Blast Swing Trainer sensors are not available.",
            "swing_trainer_sensors_are_not_available_warning": "<b>WARNING:</b> Only swings captured on Blast Swing Analyzer sensors are eligible for Blast Premium Services and can be viewed within Blast Connect. <br>Swings captured on Blast Swing Trainer sensors are not supported. <b><a href=\"{url}\" target=\"_blank\" class=\"sensor-support-learn-more\">Learn more</a></b>.",
            "allow_coaches_send_invites": "Allow Coaches to Send Invites",
            "academy_was_deleted": "The academy you were invited from has been removed.",
            "video_invite_title": "Video: Invite Student and Coaches",
            "roles_and_permissions_management": "Roles and Permissions management",
            "create_role": "Create Role",
            "update_role": "Update Role",
            "roles_title": "Roles",
            "permissions": "Permissions",
            "the_role_has_been_created_successfully": "The role has been created successfully",
            "the_role_has_been_update_successfully": "The role has been updated successfully",
            "the_role_has_been_deleted_successfully": "The role has been deleted successfully",
            "ncsa_modal": {
                "contact": {
                    "title": "College Recruiting With NCSA College Recruiting",
                    "note": "Note: Athletes must be 13 years or older to submit information to NCSA. The following fields are required to publish to NCSA. Please fill in the missing information to continue.",
                    "required_fields_description": "All fields are required unless marked otherwise.",
                    "fill_requred_fields": "Please fill in the missing information to continue. Athletes must be 13 years or older to continue.",
                    "we_want_to_help": "We want to help connect you to one of the 800+ recruiting experts at NCSA. Their team will help you better understand the recruiting process and  the steps your family can be taking to get ahead of your competition.",
                    "benefits": "They'll get the ball rolling by e-mailing a FREE recruiting profile to help you gain exposure to over 35,000 college coaches. Keep them updated with your progress by publishing your Blast scores, metrics and videos directly to your NCSA profile at any time.",
                    "athlete_information": "Athlete Information",
                    "submiting_note": "Submitting information to NCSA requires athletes to be 13 years of age or older. Please enter your date of birth to proceed"
                }
            },
            "type_the_name_of_the_academy_to_search": "Type the name of the academy to search",
            "air_swings_attack_angle_note": "NOTE: Attack Angle values are not available for air swings.",
            "required_fields_modal": {
                "title": "Missing Profile Information",
                "birthday": "Birth Date and the age certification checkbox values in your profile are required and will help us to personalize your goals and insights to help you become a better hitter.",
                "phone": "If you choose to provide us with a Phone Number, it will be more likely that you’ll receive important information, product support information, updates, deals, and specials."
            }
        },
        "vue_component": {
            "select2_messages": {
                "count_item_selected": "No {item} Selected | One {item} Selected | {count} {item} Selected",
                "all_item_selected": "All {item} selected"
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "common": {
            "file": "File",
            "close": "Close",
            "complete": "Complete",
            "deleted": "Deleted",
            "validation": {
                "missing_required_data": "Missing required data"
            }
        },
        "members": {
            "registration": {
                "sso_existing_bc": "Sorry, your email is already associated with a Blast Connect account."
            },
            "invitations": {
                "confirm": "Are you sure you want to submit these invitations?",
                "number_invites_sent": "{1} {number} invitation was sent successfully.|[2,*] {number} invitations were sent successfully.",
                "not_accepted_members": "Error occurred processing user invitations. Some users were not invited."
            },
            "errors": {
                "organization_member_id_not_available": "User does not have an Organization Member ID",
                "sensor_conflict_with_another_user": "Sensor could not be assigned because it's already associated with another user.",
                "sensor_conflict_with_another_sport": "Sensor could not be assigned because it is authorized to use with another sport.",
                "sensor_could_not_be_added": "Sensor could not be assigned.",
                "contact_support": "Please contact support to resolve these issues.",
                "invalid_account": "Invalid account information",
                "invalid_cloud_access_token": "Invalid Cloud Access Token, please reauthorize.",
                "session_expired_login_again": "Your session has expired, please login again to continue.",
                "session_expired_connect_again": "Your session has expired, please connect your Blast account again.",
                "not_able_to_complete_user_creation": "Not able to complete user creation",
                "blast_server_is_temporary_unavailable_please_try_again": "Blast Server is temporary unavailable, please try again",
                "user_not_found": "User not found"
            },
            "bulk_upload": {
                "the_number_new_member": "The {number} new member",
                "add_user_message": "Please review the imported user information",
                "members_successfully_processed": "[0,1] {number} user was processed successfully.|[2,*] {number} users were successfully processed.",
                "new_data_will_be_available_in_few_minutes": "New data will be shown in few minutes.",
                "confirm_add": "Are you sure you want to create these users?",
                "invite_message": "Please review the imported user information. Make any necessary changes below. When satisfied, submit and invitations will be sent to each user.",
                "empty_list": "Please, add at least one member",
                "some_addresses_belongs_to_exist_accounts": "This email address already belongs to an existing Blast user account with a name that does not match what you entered.",
                "if_this_is_not_the_player_you_intended_to_invite_click_edit_to_modify_the_information_you_provided": "To add the player with the name displayed, click the \"Add this Person\" button. If this is not the player that you intended to invite, click the edit icon above to modify the information you provided, or click the trash icon to delete the invitation entirely.",
                "yes_add_this_person": "Yes, add this person",
                "this_person_has_been_added": "This person has been added!",
                "there_errors_with_this_member": "There is an error with this member:|There are {number} errors with this member:",
                "this_user_is_already_part_of_another_academy": "This user is already part of another academy."
            },
            "validation_messages": {
                "member_type_required": "{member_name}'s member type is required.",
                "member_type_invalid": "{member_name}'s member type is invalid.",
                "first_name_required": "{member_name}'s first name is required.",
                "first_name_regex": "First name has invalid characters.",
                "last_name_regex": "Last name has invalid characters.",
                "name_regex": "Name has invalid characters.",
                "last_name_required": "{member_name}'s last name is required.",
                "full_name_field_required": "The Full Name field is required.",
                "email_required": "{member_name}'s email is required.",
                "email_field_required": "The Email field is required.",
                "email_email": "{member_name}'s email must be a valid email address.",
                "email_valid_email": "{member_name}'s email has already been used.",
                "email_unique": "{member_name}'s email has already been taken.",
                "password_min": "{member_name}'s password must be at least 8 characters.",
                "password_max": "{member_name}'s password must be no more than 100 characters.",
                "password_regex": "{member_name}'s password format is invalid.",
                "password_required": "{member_name}'s password field is required.",
                "country_required": "{member_name}'s country field is required.",
                "country_in": "{member_name}'s country is not supported.",
                "valid_sensor_serial": "{member_name}'s Sensor Serial is invalid.",
                "sensor_serial_numeric": "{member_name}'s Sensor Serial must be numeric.",
                "coach": "{member_name}'s coach is invalid.",
                "mlb_bam_id_invalid": "MLB BAM ID should contains only alphanumeric characters, dashes and colons.",
                "equipment_name_alpha_num": "{member_name}'s equipment name must be alpha numeric",
                "equipment_name_required_with": "{member_name}'s equipment name is required when other equipment info is present",
                "equipment_weight_required_with": "{member_name}'s equipment width is required when other equipment info is present",
                "equipment_length_required_with": "{member_name}'s equipment length is required when other equipment info is present",
                "equipment_weight_numeric": "{member_name}'s equipment weight must be numeric.",
                "equipment_length_numeric": "{member_name}'s equipment length must be numeric.",
                "member_email_unique": "One or more emails are already in use. Please change the emails for the accounts highlighted. Please note that no accounts were created. Please fix and upload your players again.",
                "bulk_upload_generic_error": "There are some issues with the players import form - {number} player(s) are not processed. Please fix the errors below and submit the form.",
                "email_already_belongs_to_another_user": "That email already belongs to another person with names that do not match what you've entered.",
                "we_are_not_able_to_process_your_information_please_contact_customer_support_for_more_information": "We aren't able to process your information. Please contact Customer Support for more information.",
                "bulk_wrong_external_id": "This user already has an External ID assigned for this organization that does not match what you have entered. To add the player with the External ID displayed, click the checkmark under Actions. To remove the player, click the trash can under Actions. To edit the e-mail address, click the pencil icon under Actions.",
                "external_id_already_assigned_for_this_organization": "This External ID is already assigned for this organization but the e-mail address does not match what you have entered. To add the player with the e-mail displayed, click the checkmark under Actions. To remove the player, click the trash can under Actions. To edit the External ID and member information, click the pencil icon under Actions.",
                "external_id_has_duplicate": "The External ID field has a duplicate value.",
                "names_not_equal_external_api": "This e-mail address belongs to an existing Blast user, but the name does not match the values provided. The user has been added to the event with the user’s existing name: {first_name} {last_name}."
            },
            "configuration": {
                "blast_certified": "Blast Certified",
                "blast_certification_date": "Blast Certification Date",
                "address": "Training Address:  Street Address",
                "additional_address": "Training Address:  Address (Additional)",
                "city": "Training Address: City",
                "state": "Training Address: State / Province",
                "country": "Training Address: Country",
                "zip_code": "Training Address: Zip / Postal Code"
            }
        }
    },
    "ja": {
        "banners": {
            "seats_banner": {
                "title": "<b>警告：空席がほとんどありません</b>",
                "message": "ライセンスされたシート数がすべて割り当てられると、ユーザーを追加することはできなくなります。 プレーヤー、コーチ、および管理者コーチはすべて、合計シート数にカウントされます。 日常業務の中断を最小限に抑えるために、利用可能なすべての座席を割り当てる前に、次のアクションを実行してください。<p><ul><li>組織に関連付けられていないユーザーがいる場合は、ユーザー名の右側にある3つのドットをクリックして、[削除]をクリックしてください。</li><li>追加の座席を購入する必要がある場合は、見積もりについてBlastMotionの担当者にお問い合わせください。</li></ul></p>",
                "button": {
                    "title": "後で思い出させる"
                }
            },
            "upsell": {
                "common": {
                    "dismiss": "閉じる",
                    "later": "あとで",
                    "you_have_number_days_left_in_your_free_trial": "無料トライアルの残り日数{number}日"
                },
                "non_subscribing": {
                    "upgrade_to_blast_premium_services": "ブラストプレミアムサービスにアップグレードする",
                    "get_the_most_from_your_blast_experience_advanced_insights_analysis_and_reporting_at_your_fingertips": "ブラストエクスペリエンスを最大限に活用してください！<br>高度な洞察、分析、レポートをすぐに利用できます。",
                    "learn_more_about_premium_services": "プレミアムサービスの詳細"
                },
                "premium_user": {
                    "title": "期間限定オファー",
                    "message": "{campName}の参加特典として、スイング分析センサーを割引価格で購入できます。特典は{endDate}までです。自分用に、お友達用に、この機会に購入しませんか？"
                },
                "camp_trial_active": {
                    "title": "Blastプレミアムサービスにようこそ",
                    "message": {
                        "0-14": "さっそくBlastプレミアムサービスに登録しましょう！{campName}に参加すると、Blast Motionの全機能を{endDate}まで無料でお試しいただけます。クリックして詳細をご覧ください。",
                        "15-27": "Blastプレミアムサービスは気に入っていただけましたか？詳細なデータの他にもさまざまな機能があります。プレミアムサービスの無料トライアルでは、PCRスコア、打球＆飛距離、Blast Connectもお使いいただけます。",
                        "28-30": "この機会にぜひお試しください！Blastプレミアムサービスのトライアル期間は{endDate}までです。今すぐアップグレードすると、PCRを使ったトレーニングを続けましょう。"
                    }
                },
                "camp_trial_expired": {
                    "title": "キャンプのトライアル終了",
                    "message": "Blastプレミアムサービストライアル期間は終了しましたが、ご安心ください！プレミアムサービスに今すぐアップデートすると、すべてのスイング、データ、スコアにアクセスできます。"
                }
            }
        },
        "blast_cloud": {
            "errors": {
                "blast_cloud_error": "Blast Cloudエラー",
                "invalid_pro_academy": "無効なプロチームアカデミー",
                "blast_cloud_unavailable": "サーバーにエラーが発生したため、招待を送信できませんでした。やり直してください。",
                "support_team_link_text": "引き続きエラーが発生する場合は",
                "support_team_name": "カスタマーサポートにお問い合わせください。"
            }
        },
        "comment": {
            "messages": {
                "comment_posted": "コメントを投稿しました",
                "comment_not_found": "コメントが見つかりません",
                "comment_deleted": "コメントを削除しました",
                "comment_not_deleted": "コメントは削除されていません",
                "comment_restored": "コメントを復元しました",
                "comment_not_restored": "コメントは復元されていません"
            }
        },
        "stripe": {
            "incorrect_number": "カード番号が間違っています。",
            "invalid_number": "カード番号は有効なクレジットカード番号ではありません。",
            "invalid_expiry_month": "カードの有効期限は無効です。",
            "invalid_expiry_year": "カードの有効期限は無効です。",
            "invalid_cvc": "カードのセキュリティコードが無効です。",
            "expired_card": "カードの有効期限が切れています。",
            "incorrect_cvc": "カードのセキュリティコードが正しくありません。",
            "incorrect_zip": "カードの郵便番号は検証に失敗しました。",
            "card_declined": "カードは拒否されました。",
            "missing": "請求されている顧客のカードはありません。",
            "processing_error": "カードの処理中にエラーが発生しました。",
            "rate_limit": "リクエストがAPIにすばやくヒットしたため、エラーが発生しました。 このエラーが常に発生する場合は、お知らせください。",
            "card_decline_rate_limit_exceeded": "このカードは何度も拒否されました。",
            "invalid_card_type": "外部アカウントとして提供されたカードは、支払いにはサポートされていません。 代わりに、プリペイドなしのデビットカードを提供してください。",
            "invalid_api_key": "エラーが発生しました。弊社お客様相談センターにお問い合わせください"
        },
        "blast_insight": {
            "headings": {
                "swings_over_time": "時系列でのスイング",
                "swing_quality": "スイングの評価",
                "swing_data": "スイングデータ",
                "team_average_chart": "チームの平均",
                "averages_per_player": "各選手の平均"
            },
            "units": {
                "avg": "平均"
            },
            "labels": {
                "filter_sessions": "計測を絞り込み",
                "sessions": "計測",
                "apply_filters": "フィルタを適用",
                "reset_filters": "フィルタをリセット",
                "print": "印刷",
                "download_csv": "CSV形式でダウンロード",
                "download_excel": "Excel形式でダウンロード",
                "goal": "目標",
                "achieved_goal": "達成した目標",
                "of_swings": "スイング",
                "how_to_improve": "上達のヒント",
                "selected": "選択済み",
                "back_to_team_averages": "チーム平均に戻る",
                "user_name_swing_quality_chart": "スイングの評価 - {name}",
                "zoom_message": "拡大：マウスのボタンを押したままにして拡大したいデータの上をドラッグします。または、グラフのX軸かY軸のスライダーを動かします。",
                "metrics_importing": "データをインポート中",
                "for_all_students": "全選手",
                "sync_sport": "{sport_name}データを同期",
                "sync_sport_for_all_students": "全選手の{sport_name}データを同期",
                "user_has_not_connected": "このユーザーはBlastアプリにまだ接続していません。",
                "averages_of_swings": "{swing_count}スイングの平均",
                "count_swings": "{count}スイング| {count}スイング | {count}スイング"
            },
            "errors": {
                "bulk_sync_metric_not_available": "この学校ではデータの一括同期はできません。",
                "unable_to_sync": "選手を同期できません。"
            }
        },
        "account": {
            "messages": {
                "subscription": {
                    "previous_payment_source_not_available": "前回のお支払い方法はご利用できません"
                }
            }
        },
        "validation": {
            "accepted": "{attribute}を承認してください。",
            "active_url": "{attribute}は、有効なURLではありません。",
            "after": "{attribute}には、{date}より後の日付を指定してください。",
            "after_or_equal": "{attribute}には、{date}以降の日付を指定してください。",
            "alpha": "{attribute}には、アルファベッドのみ使用できます。",
            "alpha_dash": "{attribute}には、英数字('A-Z','a-z','0-9')とハイフンと下線('-','_')が使用できます。",
            "alpha_num": "{attribute}には、英数字('A-Z','a-z','0-9')が使用できます。",
            "array": "{attribute}には、配列を指定してください。",
            "before": "{attribute}には、{date}より前の日付を指定してください。",
            "before_or_equal": "{attribute}には、{date}以前の日付を指定してください。",
            "between": {
                "numeric": "{attribute}には、{min}から、{max}までの数字を指定してください。",
                "file": "{attribute}には、{min} KBから{max} KBまでのサイズのファイルを指定してください。",
                "string": "{attribute}は、{min}文字から{max}文字にしてください。",
                "array": "{attribute}の項目は、{min}個から{max}個にしてください。"
            },
            "boolean": "{attribute}には、'true'か'false'を指定してください。",
            "confirmed": "{attribute}と{attribute}確認が一致しません。",
            "date": "{attribute}は、正しい日付ではありません。",
            "date_equals": "{attribute}は{date}に等しい日付でなければなりません。",
            "date_format": "{attribute}の形式は、'{format}'と合いません。",
            "different": "{attribute}と{other}には、異なるものを指定してください。",
            "digits": "{attribute}は、{digits}桁にしてください。",
            "digits_between": "{attribute}は、{min}桁から{max}桁にしてください。",
            "dimensions": "{attribute}の画像サイズが無効です",
            "distinct": "{attribute}の値が重複しています。",
            "email": "{attribute}は、有効なメールアドレス形式で指定してください。",
            "exists": "選択された{attribute}は、有効ではありません。",
            "file": "{attribute}はファイルでなければいけません。",
            "filled": "{attribute}は必須です。",
            "gt": {
                "numeric": "{attribute}は、{value}より大きくなければなりません。",
                "file": "{attribute}は、{value} KBより大きくなければなりません。",
                "string": "{attribute}は、{value}文字より大きくなければなりません。",
                "array": "{attribute}の項目数は、{value}個より大きくなければなりません。"
            },
            "gte": {
                "numeric": "{attribute}は、{value}以上でなければなりません。",
                "file": "{attribute}は、{value} KB以上でなければなりません。",
                "string": "{attribute}は、{value}文字以上でなければなりません。",
                "array": "{attribute}の項目数は、{value}個以上でなければなりません。"
            },
            "image": "{attribute}には、画像を指定してください。",
            "in": "選択された{attribute}は、有効ではありません。",
            "in_array": "{attribute}が{other}に存在しません。",
            "integer": "{attribute}には、整数を指定してください。",
            "ip": "{attribute}には、有効なIPアドレスを指定してください。",
            "ipv4": "{attribute}はIPv4アドレスを指定してください。",
            "ipv6": "{attribute}はIPv6アドレスを指定してください。",
            "json": "{attribute}には、有効なJSON文字列を指定してください。",
            "lt": {
                "numeric": "{attribute}は、{value}より小さくなければなりません。",
                "file": "{attribute}は、{value} KBより小さくなければなりません。",
                "string": "{attribute}は、{value}文字より小さくなければなりません。",
                "array": "{attribute}の項目数は、{value}個より小さくなければなりません。"
            },
            "lte": {
                "numeric": "{attribute}は、{value}以下でなければなりません。",
                "file": "{attribute}は、{value} KB以下でなければなりません。",
                "string": "{attribute}は、{value}文字以下でなければなりません。",
                "array": "{attribute}の項目数は、{value}個以下でなければなりません。"
            },
            "max": {
                "numeric": "{attribute}には、{max}以下の数字を指定してください。",
                "file": "{attribute}には、{max} KB以下のファイルを指定してください。",
                "string": "{attribute}は、{max}文字以下にしてください。",
                "array": "{attribute}の項目は、{max}個以下にしてください。"
            },
            "mimes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "mimetypes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "min": {
                "numeric": "{attribute}には、{min}以上の数字を指定してください。",
                "file": "{attribute}には、{min} KB以上のファイルを指定してください。",
                "string": "{attribute}は、{min}文字以上にしてください。",
                "array": "{attribute}の項目は、{min}個以上にしてください。"
            },
            "not_in": "選択された{attribute}は、有効ではありません。",
            "not_regex": "{attribute}の形式が無効です。",
            "numeric": "{attribute}には、数字を指定してください。",
            "present": "{attribute}が存在している必要があります。",
            "regex": "{attribute}には、有効な正規表現を指定してください。",
            "required": "{attribute}は、必ず指定してください。",
            "required_if": "{other}が{value}の場合、{attribute}を指定してください。",
            "required_unless": "{other}が{values}以外の場合、{attribute}を指定してください。",
            "required_with": "{values}が指定されている場合、{attribute}も指定してください。",
            "required_with_all": "{values}が全て指定されている場合、{attribute}も指定してください。",
            "required_without": "{values}が指定されていない場合、{attribute}を指定してください。",
            "required_without_all": "{values}が全て指定されていない場合、{attribute}を指定してください。",
            "same": "{attribute}と{other}が一致しません。",
            "size": {
                "numeric": "{attribute}には、{size}を指定してください。",
                "file": "{attribute}には、{size} KBのファイルを指定してください。",
                "string": "{attribute}は、{size}文字にしてください。",
                "array": "{attribute}の項目は、{size}個にしてください。"
            },
            "starts_with": "{attribute}は、次のいずれかで始まる必要があります。{values}",
            "string": "{attribute}には、文字を指定してください。",
            "timezone": "{attribute}には、有効なタイムゾーンを指定してください。",
            "unique": "指定の{attribute}は既に使用されています。",
            "uploaded": "{attribute}のアップロードに失敗しました。",
            "url": "{attribute}は、有効なURL形式で指定してください。",
            "uuid": "{attribute}は、有効なUUIDでなければなりません。",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "array_count": " {attribute}の選択数が無効です。",
            "attributes": [],
            "invalid_date": "無効な日付",
            "phone": " {attribute}の電話番号が無効です。",
            "provided_credentials_are_wrong_or_contact_us": "入力したログイン情報が間違っています。やり直してください。ログイン情報が正しいのにエラーが表示される場合は、ご連絡ください。",
            "cannot_connect_to_cloud": "リクエストを処理できませんでした。ページを更新してもう一度お試しください。引き続きエラーが発生する場合は、サポートにお問い合わせください。",
            "input_is_invalid": "入力内容が無効です",
            "email_and_password_are_required": "メールアドレスとパスワードを入力してください",
            "the_provided_external_id_is_not_valid": "指定された外部 ID は無効です。",
            "provided_blast_user_id_has_been_updated": "{user_identifier} が更新されました。 {exist_identifier} にも、この組織に割り当てられたこの外部 ID があることに注意してください。",
            "invitation": {
                "academy_or_event_has_been_removed": "招待がすでに無効になっています。コーチや管理者に再度招待してもらってください。"
            },
            "dob": "生年月日と I Certify チェックボックスの値は必須であり、より良い打者になるための目標と洞察をパーソナライズするのに役立ちます。",
            "one_of_the_specified_emails_does_not_belong_to_any_coach_in_the_selected_academy": "一部のメールは、選択したアカデミーのどのコーチにも属していません。 メールを確認して、もう一度やり直してください。 (間違った電子メール: {emails})",
            "specified_event_has_end_cannot_invite_users": "指定されたイベントは終了しました。 ユーザーを招待できなくなりました。",
            "the_user_already_belongs_to_the_specified_event": "ユーザーはすでに指定されたイベントに属しています。",
            "event_has_already_been_started": "指定されたイベントは既に開始されています。",
            "profile_update_non_unique": "{blast_user_id} が更新されました。{exist_blast_user_id} にも、この組織に割り当てられたこの外部 ID があることに注意してください。",
            "this_user_has_been_added_to_the_event_with_the_provided_external_id": "警告: このユーザーは、指定された external_id 値 {provided_external_id} でイベントに追加されました。 {email_exist_external_id} にも、この組織に割り当てられたこの外部 ID があることに注意してください。 いずれかのユーザーの external_id を変更するには、PATCH {url_path} エンドポイントを使用してください。",
            "this_user_already_has_an_external_id_value": "警告: このユーザーには、指定された値と一致しない、この組織に割り当てられた {exists_external_id} の external_id 値が既にあります。 ユーザーはイベントに追加されましたが、ユーザーの external_id 値は指定された値に変更されていません。 ユーザーの external_id を変更するには、PATCH {url_path} エンドポイントを使用してください。",
            "the_player_was_automatically_assigned_to_all": "警告: プレーヤーは、現在イベントに参加しているすべての管理者コーチに自動的に割り当てられました。 コーチの電子メール値が指定されていないため、追加のコーチの割り当てが必要な場合は、Blast Connect Web インターフェイスを介してプレイヤーを手動でコーチに割り当てる必要があります。",
            "this_action_is_unauthorized": "この行為は許可されていません。",
            "invalid_product_features": "無効な製品機能",
            "unauthorized_payment_source": "不正な支払い元",
            "failed_payment_source_creation": "提供されたデータで支払い方法を作成できません。",
            "invalid_products": "無効な商品です。"
        },
        "passwords": {
            "password": "パスワードは6文字以上かつ確認フィールドと一致していなければなりません。",
            "reset": "パスワードをリセットしました。",
            "sent": "パスワードリマインダーを送信しました。",
            "token": "このパスワードリセットトークンは無効です。",
            "user": "このメールアドレスに一致するユーザーを見つけることが出来ませんでした。"
        },
        "media": {
            "file_manager": [],
            "library": [],
            "file": {
                "name": "ファイル名",
                "description": "ファイルの説明",
                "analysis": "分析ファイル",
                "original": "元のファイル",
                "format": "ファイル形式",
                "encoded": "エンコード済みファイル"
            },
            "messages": {
                "file_added": "ファイルを追加済み",
                "file_name_deleted": "{file_name} 削除済み",
                "file_name_restored": "{file_name} 復元済み",
                "file_deleted": "ファイルを削除済み",
                "file_not_deleted": "ファイルは削除されていません",
                "file_delete_error": "エラーが発生したため、メディアはまだ削除されていません。",
                "not_found": "メディアが見つかりません",
                "invalid_access": "このファイルにはアクセスできません。サポートが必要な場合はご連絡ください。",
                "unauthorized_comment": "このファイルにはコメントできません",
                "file_updated": "file_updated",
                "file_not_updated": "ファイルを更新できませんでした"
            },
            "errors": {
                "error_creating_media_key": "メディアキーの作成中にエラーが発生しました",
                "error_getting_all_media": "すべてのメディアを取得中にエラーが発生しました",
                "error_saving_file": "ファイルの保存中にエラーが発生しました",
                "error_update_status": "ファイルのステータスの更新中にエラーが発生しました"
            },
            "common": {
                "file_name": "ファイル名",
                "select_file": "ファイルを選択",
                "max_file_size": "上限%sMB",
                "upload_complete": "アップロード完了",
                "view_asset": "アセットを見る",
                "streaming_video": "動画をストリーミング中",
                "dropbox": "Dropbox"
            }
        },
        "assessment": {
            "messages": {
                "no_results": "該当する結果なし",
                "no_results_for_filters": "選択されたフィルタに該当する結果はありません。"
            }
        },
        "messages": {
            "errors": {
                "no_contacts": {
                    "student": "コーチがいないのでメッセージを送信できません。",
                    "all": "選手がいないまたは選手リストがないのでメッセージを送信できません。"
                }
            }
        },
        "wi": {
            "blast_connect": "Blast Connect",
            "blast_metrics_title": "BLAST Metrics",
            "blast_insights": "BLAST Insights",
            "blast_insights_explain": "このチームに情報やデータを表示しますか？",
            "blast_motion_title": "BLAST Motion",
            "metrics_title": "測定データ",
            "player_report": "プレイヤーレポート",
            "blast": "BLAST",
            "no_metrics": "表示できるBlastデータはありません。Blastアプリとセンサーでスイングを計測してみましょう。",
            "action_not_available": "このアクションはもう表示できません。",
            "blast_analytics_title": "BLAST Analytics",
            "welcome_blast_metrics": "Blastアカウントを接続すると、スイングごとの重要データを確認できます。",
            "welcome_library": "動画、画像、ファイルをアップロードして分析/確認したり、自動的に同期されるBlast動画や画像を分析したりできます。",
            "welcome_train": "割り当てられたワークアウトや練習を確認/実行したり、自分で作成したりできます。",
            "welcome_stats": "スイングデータから重要な傾向をチェックしましょう。",
            "welcome_compete": "評価チャレンジでスキルをテストしましょう。",
            "blast_motion": "Blast Motion",
            "blast_motion_address": "1780 La Costa Meadows Dr. Suite 101, San Marcos, CA 92078",
            "athlete": "選手",
            "player": "選手",
            "im_player": "選手",
            "coach": "コーチ",
            "im_coach": "コーチ",
            "academy": "チーム",
            "academy_name": "チーム名",
            "see_all": "すべて見る",
            "show_all": "すべて表示",
            "hide_all": "すべて非表示",
            "expand_all": "すべて表示",
            "collapse_all": "すべて非表示",
            "learn_more": "詳細",
            "upgrade": "Upgrade",
            "continue": "続ける",
            "purchase": "購入",
            "select": "選択",
            "meta_description": "{appName}は、情報分析、報告、選手管理、コーチングのためのモバイル/デスクトップ用アプリケーションです。",
            "compete": "競う",
            "train": "トレーニング",
            "have_your_say": "Have your say...",
            "login": "ログイン",
            "logout": "ログアウト",
            "home": "ホーム",
            "email": "メールアドレス",
            "email_invalid": "メールアドレスが無効です",
            "password": "パスワード",
            "new_password": "新しいパスワード",
            "password_forgotten": "パスワードを忘れた場合",
            "password_reset_success": "パスワードをリセットしました。新しいパスワードをメールで送信しました。",
            "password_invalid_code": "無効なリセットコード",
            "password_reset": "パスワードのリセット",
            "password_reset_message": "メールアドレスを入力してください。確認コードを送信します。",
            "password_reset_code_sent": "パスワードのリセットコードを送信しました。",
            "password_reset_not_required": "パスワードのリセットは不要です",
            "password_minlength": "パスワードは{length}文字以上にしてください。",
            "password_maxlength": "パスワードは{length}文字以下にしてください。",
            "password_characters": "パスワードには文字と数字を含めてください。",
            "password_matches": "パスワードが一致しません。",
            "password_strength": "パスワードの強度",
            "password_very_weak": "とても弱い",
            "password_weak": "弱い",
            "password_good": "普通",
            "password_strong": "強い",
            "password_very_strong": "とても強い",
            "password_change_required": "パスワードの変更が必要です",
            "current_password_is_incorrect": "現在のパスワードが正しくありませんでした。 もう一度やり直してください。",
            "current_password_is_required": "電子メールやパスワードを更新するときは、現在のパスワードが必要です。",
            "logout_success": "ログアウトできました",
            "member_not_found": "メンバーが見つかりません。",
            "incorrect_login": "メールアドレスまたはパスワードが違います",
            "incorrect_login_by_academy": "あなたはこのチームのメンバーではありません。<br>Blast Premiumアカウントをお持ちの場合は、<a href=\"{url}\">{domain}</a>にログインしてください。<br><br>ご不明な点がありましたら、弊社お客様相談センター<a href=\"https://www.mizuno.co.jp/customer/\"></a>からお問い合わせください。",
            "more": "その他",
            "less": "減少",
            "file": "ファイル",
            "edit": "編集",
            "add": "追加",
            "add_another": "さらに追加",
            "undo": "元に戻す",
            "added": "追加済み",
            "edited": "編集済み",
            "edited_camp": "イベントの編集が完了しました。<br><br>情報はBlast Connectで更新されますが、登録選手に変更が通知されることはありません。",
            "edited_camp_with_level_of_play": "イベントの編集が完了しました。<br><br>新しいカテゴリーは、今後追加される選手にのみ適用され、既存の選手には適用されません。<br><br>情報はBlast Connectで更新されますが、登録選手に変更が通知されることはありません。",
            "delete": "削除",
            "delete_permanently": "完全に削除",
            "delete_player": "選手を削除",
            "delete_coach": "メンバー/コーチを削除",
            "deleted": "削除済み",
            "restored": "復元済み",
            "answered": "回答済み",
            "create": "作成",
            "created": "作成済み",
            "share": "共有",
            "preview": "プレビュー",
            "library": "ライブラリー",
            "update": "更新",
            "accept": "承諾",
            "remove": "を削除",
            "duplicate": "コピー",
            "duplicate_group": "グループをコピー",
            "delete_group": "グループを削除",
            "decline": "拒否",
            "address1": "住所1",
            "address2": "住所2",
            "city": "市",
            "postal_code": "郵便番号",
            "cell": "携帯電話",
            "about": "情報",
            "saved": "保存済み",
            "never": "なし",
            "none": "なし",
            "rank": "ランク",
            "best": "ベスト",
            "unlimited": "無制限",
            "item_successfully_created": "{item}を作成しました",
            "global_settings": "設定",
            "do_not_reply_message": "このメールには返信しないでください。 このアドレスに送信されたお問い合わせには対応できません。 カスタマーサポートに連絡するには、{help_page_anchor}にアクセスするか、{support_email}に電子メールを送信してください。",
            "email_footer_do_not_reply": "このメールには返信しないでください。<br>お困りですか？確認",
            "form_leave_warning": "この画面を離れてもよろしいですか？保存していない変更内容は破棄されます。",
            "all_players": "すべての選手",
            "upsell_url": "アップセルURL",
            "member_since": "{date}からメンバー",
            "last_login": "前回ログイン：{date}",
            "last_login_heading": "前回ログイン",
            "log_in_as": "代理ログイン：",
            "transfer_to_academy": "別のチームに移動",
            "student_transfer_warning_coaches": "コーチを割り当て済みの選手を移動することはできません。コーチの割り当てを解除してから、別のチームに選手を移動してください。",
            "search": "検索",
            "search_term_min": "検索用語は{min}文字以上にしてください。",
            "need_support": "エラーだと思われる場合やサポートが必要な場合はお問い合わせください。",
            "oops": "エラーが発生しました。弊社お客様相談センターにお問い合わせください",
            "oops_errors": "エラーを修正します",
            "oops_need_fix": "エラーを修正します：",
            "alert_validation_title": "エラーが発生しました。",
            "date": "日付",
            "swing_quality": "スイングの評価",
            "dashboard": "ダッシュボード",
            "academies": "チーム",
            "details": "情報",
            "media": "ライブラリー",
            "settings": "設定",
            "personal_settings": "個人設定",
            "app_settings": "アプリ設定",
            "admin_tools": "Blast管理者用ツール",
            "system_reports_tools": "システムレポート&amp;設定",
            "new": "new",
            "sub_domain": "サブドメイン",
            "create_academy": "チームを作成",
            "academy_not_found": "チームが見つかりません",
            "academy_not_found_explain": "このURLのチームが見つかりませんでした。<br><br><a href=\"//blastconnect.test\">ホームページからログイン</a>するか、<a href=\"https://www.mizuno.co.jp/customer/\">弊社お客様相談センターにお問い合わせ</a>ください。",
            "edit_academy": "チームを編集",
            "manage_events": "イベントを管理",
            "academy_settings": "チーム設定",
            "academy_added": "チームを追加しました",
            "academy_edited": "チームを編集しました",
            "academy_deleted": "チームを削除しました",
            "academy_unfound": "チームが見つかりませんでした。チームの住所が不明な場合は、<a href=\"#\" class=\"find-academy\">お手伝いします</a>。",
            "choose_academy": "チームを選択",
            "change_academy": "チームを変更",
            "search_for_academy_or_event": "チームまたはイベントを検索",
            "upcoming": "今後の予定",
            "past": "過去",
            "camps_and_events": "キャンプ＆イベント",
            "you_will_be_able_to_access_this_event_on_the_day_that_it_begins": "開始日にこのイベントにアクセスできるようになります。",
            "email_unfound": "<em>{email}</em>はシステムに登録されていません。メールアドレスを確認してください。間違いがあればチームに確認してください。",
            "email_found": "ありがとうございます。<em>{email}</em>に手順をお送りします。",
            "form_not_found": "フォームが見つかりませんでした",
            "all_academies": "すべてのチーム",
            "academy_information": "チーム情報",
            "academy_members": "メンバー",
            "invite_academy_members": "チームのメンバーを招待",
            "student_pluralize": "{count} 選手|{count} 選手",
            "available_in_pluralize": "あと {count} {days} で購入可能",
            "members": "コネクション",
            "users": "ユーザー",
            "sensors": "センサー",
            "members_label": "メンバー",
            "member_unfound": "メンバーが見つかりません",
            "members_or_coaches": "メンバー/コーチ",
            "member": "メンバー",
            "no_members": "ネットワークには誰もいません。",
            "organizer": "代表者",
            "add_student": "選手を追加",
            "add_all_students": "すべての選手を追加",
            "add_member": "メンバーを追加",
            "add_members": "メンバーを追加",
            "member_last_active": "前回の使用：",
            "bulk_member_add": "Excelからメンバーを追加",
            "bulk_member_add_desc": "<a download=\"download\" href=\"{template_link}\">Excelテンプレート</a>で多数のメンバーを追加できます。アップロード後、新しいメンバーを登録する前に情報を確認できるようになります。",
            "no_members_bulk_upload": "アップロードしたExcelにはメンバーが見つかりませんでした。やり直してください。",
            "invalid_spreadsheet_bulk_upload": "アップロードしたExcelファイルが破損しているか古くなっています。以下のスプレッドシートテンプレートをダウンロードして、もう一度お試しください。",
            "upload_xls_file_from_device": "デバイスからExcelファイルをアップロード",
            "upload_xls_file_from_computer": "パソコンからExcelファイルをアップロード",
            "link_to_bulk_upload_intro": "オプション1：画面上で直接メンバーを追加",
            "link_to_bulk_upload_description": "ボタンをクリックするだけで簡単にメンバーを招待できます。",
            "link_to_bulk_upload_label": "始める",
            "bulk_intro": "オプション2：このExcelファイルをダウンロードして、必要事項を入力したらインポートするだけです。",
            "bulk_disclaimer": "複数のメンバーを招待するときにこのオプションを使用します。",
            "bulk_step1": "ステップ1：Excelファイルをダウンロードしてチーム情報を入力する",
            "bulk_step1_desc": "このExcelファイルをダウンロードして、必要事項を入力、保存します。",
            "bulk_step2": "ステップ2：必定事項を入力したExcelファイルをアップロードし、アカウント情報をカスタマイズしてメンバーを招待する",
            "bulk_step2_desc": "必定事項を入力したらExcelファイルをアップロードし、必要に応じて変更を加え、メンバーをインポートします。",
            "download_spreadsheet": "Excelファイルをダウンロード",
            "drop_spreadsheet": "",
            "edit_member": "メンバーを編集",
            "delete_member": "メンバーを削除",
            "new_member": "新メンバー",
            "create_coach": "メンバー/コーチを登録",
            "edit_coach": "メンバー/コーチを編集",
            "coaches_and_students": "コーチ&amp;選手",
            "coaches_and_rosters": "コーチ&amp;グループ",
            "back": "戻る",
            "submit": "送信",
            "copy_invite_link_text": "このURLをコピーしてメールやソーシャルメディアで選手を招待",
            "copy_invite_button": "URLをコピー",
            "invite_players": "選手を招待",
            "invite_automatically": "自動で招待",
            "invite_manually": "手動で招待",
            "roster": "グループ",
            "rosters": "グループ",
            "your_rosters": "あなたのグループ",
            "other_rosters": "他のグループ",
            "add_roster": "グループを追加",
            "edit_roster": "グループを編集",
            "delete_roster": "グループを削除",
            "save_roster": "グループを保存",
            "manage_rosters": "グループを管理",
            "roster_name": "グループ名",
            "my_rosters": "グループ",
            "message_all_rosters": "すべてのグループにメッセージ送信",
            "assign_rosters": "グループを割り当てる",
            "assigned_rosters": "割り当て済みグループ",
            "unassigned_rosters": "未割り当てグループ",
            "list_view": "一覧表示",
            "grid_view": "グリッド表示",
            "successfully_added_roster": "グループを追加しました： {roster_name}",
            "successfully_edited_roster": "グループを編集しました： {roster_name}",
            "successfully_deleted_roster": "グループを削除しました： {roster_name}",
            "successfully_restored_roster": "グループを復元しました： {roster_name}",
            "players": "選手|選手",
            "add_coach": "コーチを追加",
            "add_all_coaches": "すべてのコーチを追加",
            "add_player": "選手を追加",
            "manage_players": "選手を管理",
            "manage_students": "選手を管理",
            "you_are_not_assigned_to_any_rosters": "あなたはどのグループにも割り当てられていません。",
            "no_rosters": "まだグループがありません",
            "no_rosters_desc": "グループを使って選手を管理しましょう。登録選手と直接やり取りできるほか、練習、ワークアウト、その他イベントの割り当てもできます。",
            "no_students": "まだ選手がいません",
            "no_students_desc": "Blast Connectで選手とつながることで、集中して上達に向けて取り組めるようになります。",
            "view_metrics": "データを見る",
            "to_request_role_change": "メンバーの役割変更（例：コーチから監督へ）をリクエストする際は、サポートにご連絡ください。",
            "players_invited_not_accepted": "まだBlast Connectに登録していない招待済みの選手です。",
            "manage_settings": "設定を管理",
            "timezone_changed": "タイムゾーンが現在の設定{timezone}から変更されたようです。",
            "timezone_not_set": "タイムゾーンが設定されていないようです。正確な時刻を表示するために必要です。",
            "feedback": "フィードバック",
            "product_feedback_placeholder": ":商品改善のためにご意見をお寄せください。",
            "product_feedback_explain": ":商品改善のためのアイデアや機能のリクエストもお待ちしています。",
            "product_feedback_thanks": "商品へのフィードバックありがとうございます！",
            "communicate": "カスタムフォーム",
            "form_builder": "フォーム作成ツール",
            "assess": "評価",
            "message": "メッセージ",
            "messages": "複数のメッセージ",
            "new_message": "新しいメッセージ",
            "messaging": "メッセージ送信中",
            "write_message": "メッセージを入力...",
            "send_message": "メッセージを送信",
            "a_message": "メッセージ",
            "toggle_navigation": "ナビゲーションを切り替え",
            "skip_to_content": "コンテンツにスキップ",
            "unauthorized_action": "不正なアクション",
            "unauthorized_subscription": "未承認の課金プラン",
            "cancellation_unsuccessful": "キャンセルできませんでした。",
            "no_exercises_yet_add_one": "まだエクササイズが追加されていません。エクササイズを追加するには、 ",
            "workouts": "ワークアウト",
            "workout_name": "ワークアウト名",
            "workout_results": "ワークアウトの結果",
            "practice_name": "練習名",
            "practices": "練習",
            "practices_lower": "練習",
            "practice_results": "練習の結果",
            "workout": "ワークアウト",
            "practice": "練習",
            "add_exercise": "エクササイズを追加",
            "add_exercises": "複数のエクササイズを追加",
            "add_exercises_desc": "ポータルにエクササイズを追加して開始します。ライブラリーを作成しておくと、あとでワークアウトを作成する際に（この下で）使用できます。",
            "edit_exercise": "エクササイズを編集",
            "delete_exercise": "エクササイズを削除",
            "manage_exercises": "エクササイズを管理",
            "duplicate_exercise": "エクササイズをコピー",
            "existing_exercises": "既存のエクササイズ",
            "exercises_search": "エクササイズを検索",
            "save_exercise": "エクササイズを保存",
            "exercise_name": "エクササイズ名",
            "add_workout": "ワークアウトを追加",
            "add_a_workout": "ワークアウトを追加",
            "add_workouts": "複数のワークアウトを追加",
            "add_workouts_desc": "2ステップでワークアウトを追加できます。ワークアウトを作成して、エクササイズ（すでにシステムに用意されています）を追加します。",
            "edit_workout": "ワークアウトを編集",
            "delete_workout": "ワークアウトを削除",
            "manage_workouts": "既存のワークアウトを管理",
            "existing_workouts": "既存のワークアウト",
            "remove_workout": "ワークアウトを移動",
            "workouts_search": "ワークアウトを検索",
            "workouts_intro": "ワークアウトは、パフォーマンス改善のためのエクササイズです。",
            "media_file": "動画",
            "add_file": "ファイルを追加",
            "edit_file": "ファイルを編集",
            "change_file": "ファイルを変更",
            "doing_great": "いい感じ！その調子で続けよう。",
            "errors_on_form": "このフォームに問題があるようです",
            "drill_type": "ドリルタイプ",
            "drill_types": "複数のドリルタイプ",
            "manage_existing_drills": "既存のドリルを管理",
            "existing_drills": "既存のドリル",
            "add_drill": "ドリルを追加",
            "add_drills": "複数のドリルを追加",
            "edit_drill": "ドリルの編集",
            "add_drills_desc": "ポータルにドリルを追加して開始します。ライブラリーを作成しておくと、あとで練習を作成する際に（この下で）使用できます。",
            "exercise_search": "エクササイズを検索",
            "add_practice": "練習プランの追加",
            "add_a_practice": "練習プランの追加",
            "edit_practice": "練習プランの編集",
            "manage_practices": "既存の練習プランの管理",
            "existing_practices": "既存の練習プラン",
            "remove_practice": "練習プランの移動",
            "add_practices": "練習プランを追加",
            "add_practices_desc": "2ステップで練習プランを追加できます。練習プランを作成して、ドリル（すでにシステムに用意されています）を追加します。",
            "practices_intro_part1": "は、",
            "practices_intro_part2": "のパフォーマンス強化のための専用ドリルです。",
            "add_organization": "組織を追加",
            "organization": "組織",
            "organizations": "複数の組織",
            "organization_unfound": "組織が見つかりません",
            "organization_added": "組織を追加しました",
            "organization_deleted": "組織を削除しました",
            "organization_edited": "組織を編集しました",
            "organization_form": "組織のフォーム",
            "drills_not_found_exception": "指定されたリージョン[{region}]のドリルが見つかりません。",
            "manage_drills": "ドリルを管理",
            "manage_assessments": "評価を管理",
            "create_custom_forms": "カスタムフォームを作成",
            "new_custom_form": "新しいカスタムフォーム",
            "manage_schedule": "スケジュールを管理",
            "manage_practice_builder": "練習作成ツールを管理",
            "manage_workout_builder": "ワークアウト作成ツールを管理",
            "manage_media": "ライブラリーを管理",
            "website": "ウェブサイト",
            "system_tools": "システムツール",
            "utilities_explain": "各種管理ツールです。",
            "server_information": "サーバー情報",
            "server_information_explain": "サーバー設定についての情報です。",
            "server_logs": "サーバーログ",
            "data_viewer": "データビューアー",
            "member_type": "メンバータイプ",
            "level_of_play": "カテゴリー",
            "jan": "1月",
            "feb": "2月",
            "mar": "3月",
            "apr": "4月",
            "may": "5月",
            "jun": "6月",
            "jul": "7月",
            "aug": "8月",
            "sep": "9月",
            "oct": "10月",
            "nov": "11月",
            "dec": "12月",
            "month": "月",
            "day": "日",
            "year": "年",
            "static_pages": "静止ページ",
            "add_static_page": "静止ページを追加",
            "edit_static_page": "静止ページを編集",
            "no_pages_for": "次の静止ページなし： ",
            "static_page_name": "ページ名",
            "static_page_slug": "ページの英語名",
            "static_page_content": "コンテンツ",
            "static_page_restored": " 復元済み",
            "static_pages_summary": "静止ページはチーム向けコンテンツの追加ページです。静止コンテンツのみのページで、ネットワークとのリソース共有に最適です。チームのメニューに追加するには、<a href=\"{support_link}\">サポートにご連絡ください</a>。",
            "open_in_new_window": "新しいタブ/ウィンドウで開く",
            "page_slug_explain": "<em>ページの英語名</em>はURLの一部になります。",
            "page_slug_already_used": "この英語名は他のページで既に使用中です。別の英語名を選択してください。",
            "set_as_organization_page": ":組織内のすべてのチームにページを表示する",
            "page_belongs_to_org": "このページは:組織のページです。編集するには、弊社お客様相談センターにお問い合わせください。",
            "overlapping_static_pages": "組織のページと同じ英語名の付いたページがあります。このページが組織のページより優先されます。組織のページを使用する場合は、このページを削除してください。両方とも使用する場合は、このページの名前を変更してください。",
            "nav_academy": "チーム",
            "nav_members": "メンバー",
            "nav_skills": "スキル",
            "nav_admin_only": "管理者のみ",
            "size_recommendation_320_50": "推奨サイズは320x50ピクセルです。他のサイズでは見え方が異なる場合があります。",
            "size_recommendation_1140_300": "推奨サイズは1140x300ピクセルです。他のサイズでは見え方が異なる場合があります。",
            "phone_required_reason": "弊社の担当者が、Blast Connect Academyの設定をサポートいたします。<br><br>",
            "select_image": "画像を選択",
            "change": "変更",
            "camp": "イベント",
            "camps": "複数のイベント",
            "camp_name": "イベント名",
            "add_camp": "イベントを追加",
            "edit_camp": "イベントを編集",
            "camp_start": "イベント開始",
            "camp_end": "イベント終了",
            "camp_duration": "イベントの時間",
            "camp_location": "イベントの場所",
            "camp_description": "イベントの説明",
            "camp_location_placeholder": "駐車場、練習会場までの道順などの情報を追加できます。",
            "camp_description_placeholder": "イベントの追加説明です。",
            "external_id": "外部ID",
            "event_added_longer": " を作成しました。一覧から新しいイベントを選択して、選手とコーチを招待します。",
            "no_camps": "イベントが設定されていません。追加してください。",
            "validate_event_coach_exists": "このコーチをイベントに招待するには、メインのチームにこのコーチ/監督用のアカウントを作成してください。",
            "validate_event_coach_in_parent_error": "ユーザー（{email}）はメインのチームのコーチではありません。このユーザーをイベントに招待するには、メインのチームにこのコーチ/監督用の新規アカウントを作成してください。",
            "events_end_date": "イベントの終了日",
            "invalid_subscription_canadian": "課金プランが無効です。課金プラン情報を入力してください。<p>エラーが発生していると思われる場合は、カスタマーサービスにお問い合わせください。</p><p><a href=\"https://www.mizuno.co.jp/customer/\" target=\"_blank\">https://www.mizuno.co.jp/customer/</a></p>",
            "get_quick_overview": "最近のスイングの概要を見てから、詳しいデータを確認しましょう。",
            "no_dashboard_sessions": "{name}の計測があります。",
            "baseball_create_session": "Blast Baseballアプリ&amp;センサーをお持ちの場合は、新しいセッションを作成してスイングを開始してください。",
            "softball_create_session": "Blast Softballアプリ&amp;センサーをお持ちの場合は、新しいセッションを作成してスイングを開始してください。",
            "golf_create_session": "Blast Golfアプリ&amp;センサーをお持ちの場合は、新しいセッションを作成してスイングを開始してください。",
            "baseball_learn": "Blast Baseballアプリの詳細をご覧ください。",
            "softball_learn": "Blast Softballアプリの詳細をご覧ください。",
            "golf_learn": "Blast Golfアプリの詳細をご覧ください。",
            "learn_more_baseball": "Blast Baseballアプリの詳細",
            "learn_more_softball": "Blast Softballアプリの詳細",
            "learn_more_golf": "Blast Golfアプリの詳細",
            "meantime_familiarize": "主なデータと重要なドリルについても確認しておきましょう。",
            "more_metrics": "その他のデータとドリル",
            "your_players_no_swings": "{name}選手はまだBlastセンサーを使ってスイングを撮影していません。",
            "students_metrics_appear_here": "{name}選手の最近のスイングデータがここに表示されます。",
            "know_when_training": "{name}の次回トレーニングセッションを確認しましょう。",
            "see_recent_training": "{name}の最近のトレーニングセッションをチェックしましょう。",
            "upcoming_workouts_appear": "{name}に割り当てられた今後のワークアウトがここに表示されます。",
            "upcoming_practices_appear": "{name}に割り当てられた今後の練習がここに表示されます。",
            "recent_workouts_appear": "最近完了したワークアウトがここに表示されます。",
            "recent_practices_appear": "最近完了した練習がここに表示されます。",
            "your_players_no_workouts": "{name}選手はまだワークアウトを完了していません。",
            "completed_workouts_assigned_appear_here": "{name}が割り当てた完了済みワークアウトがここに表示されます。",
            "your_players_no_practices": "{name}選手はまだ練習を完了していません。",
            "completed_practices_assigned_appear_here": "{name}が割り当てた完了済みの練習がここに表示されます。",
            "you_have_not_completed_assessments": "{name}はまだ評価を完了していません。",
            "completed_assessments_appear_here": "{name}に割り当てられた評価で、完了したものがここに表示されます。",
            "your_players_have_not_completed_assessments": "{name}選手はまだ評価を完了していません。",
            "completed_assessments_assigned_appear_here": "{name}が割り当てた評価で、完了したものがここに表示されます。",
            "go_ahead_upload": "Blastアプリまたは直接パソコンから自分のファイルをアップロード、分析、共有しましょう。",
            "analyze_share": "ファイルのアップロードが完了したら、分析して共有しましょう。",
            "calendar": "カレンダー",
            "calendar_enabled": "カレンダーを有効にしました",
            "academy_access_to_calendar": "このチームにカレンダーへのアクセスを許可しますか？",
            "allow_team_metrics": "チームレポートを有効にしました",
            "academy_access_to_team_metrics": "このチームにチームレポートへのアクセスを許可しますか？",
            "blast_analytics_enabled": "Blast Analyticsを有効にしました",
            "academy_access_to_blast_analytics": "このチームにBlast Analyticsへのアクセスを許可しますか？",
            "scheduler": "スケジューラー",
            "scheduler_enabled": "スケジューラーを有効にしました",
            "academy_access_to_scheduler": "このチームにスケジューラーへのアクセスを許可しますか？",
            "event_type": "イベントのタイプ",
            "location": "場所",
            "lesson": "レッスン",
            "lessons": "複数のレッスン",
            "book_event": "申し込む",
            "registration_full": "満員",
            "registration_enabled": "申し込みを許可",
            "schedule": "スケジュール",
            "add_event": "イベントを追加",
            "add_an_event": "イベントを追加",
            "edit_event": "イベントを編集",
            "edit_master_event": "マスターイベントを編集",
            "save_event": "イベントを保存",
            "times": "回数",
            "timess": "回",
            "repeat": "繰り返し",
            "until": "いつまで？",
            "every": "サイクル",
            "day_s": "日",
            "week": "週",
            "week_s": "週",
            "month_s": "か月",
            "year_s": "年",
            "each": "それぞれ",
            "on_the": "On the",
            "looks_like_an_easy_week": "楽な<span class=\"cal-view\">週</span>のようですね。ちょっと楽をしすぎかも...",
            "upcoming_events_appear_here": "今後のワークアウト、練習、レッスンなどのイベントがここに表示されます。",
            "no_customization": "カスタマイズなし",
            "specific_days": "特定の日",
            "day_of_the_week": "曜日",
            "price": "料金",
            "assign_members": "メンバーを割り当て",
            "assigned_members": "複数メンバーを割り当て",
            "unassigned_members": "割り当てられていないメンバー",
            "max_registrants": "定員",
            "max_registrants_helper": "無制限の場合は空欄のまま",
            "max_registrants_placeholder": "例：10",
            "add_students": "選手を追加",
            "add_coaches": "コーチを追加",
            "assign_students": "選手を割り当て",
            "assigned_students": "割り当て済み選手",
            "remove_all_students": "すべての選手を削除",
            "unassigned_students": "割り当てられていない選手",
            "max_students": "選手数上限",
            "cancellation_date": "キャンセルポリシー",
            "cancellation_date_helper": "キャンセルの受付を中止する時間（イベント開始前）を指定してください。",
            "only_edit_recurring_dates": "定例イベントの日程のみ編集できます。",
            "recurring_event_change_future_dates": "定例イベントです。今後の日程をすべて変更しますか？",
            "change_future_dates": "今後の日程をすべて変更",
            "cancelled": "キャンセル済み",
            "cancelled_members": "キャンセル済みメンバー",
            "marked_cancelled": "このイベントには欠席と回答済みです。",
            "marked_cancelled_contact": "出席を希望する場合は、<a href=\"mailto:{email}\">{name}</a>に連絡してください。",
            "attending": "出席予定",
            "no_attendees": "参加者なし",
            "registered_students": "申し込み済み選手",
            "registered_for_event": "このイベントに申し込み済みです。",
            "confirm_cancel_event": "このイベントをキャンセルしてもよろしいですか？",
            "cancellation_period_ended": "キャンセル期間は終了しています。",
            "slots": "スロット|スロット",
            "update_event": "イベントを更新",
            "changing_date_time_for": "次のイベントの日付/時刻を変更しようとしています：",
            "event_from": "開始日",
            "event_to": "終了日",
            "save_changes": "変更を保存",
            "undo_changes": "変更を取り消し",
            "schedule_workout": "ワークアウトのスケジュール設定",
            "schedule_practice": "練習プランのスケジュール設定",
            "days": "日|日",
            "hours": "時間",
            "successfully_deleted_event": "イベントを削除しました： {event_name}",
            "successfully_restored_event": "イベントを復元しました： {event_name}",
            "event_unavailable": "このイベントはもう参加できません。",
            "loading_dots": "読み込み中...",
            "swing_types": {
                "all": "すべてのスイング",
                "swings_with_impact": "インパクトのあるスイング",
                "air_swings": "エアスイング"
            },
            "environments": {
                "all": "すべての計測条件",
                "tee": "ティー",
                "soft_toss": "ソフトトス",
                "front_toss_overhand": "フロントトス（オーバーハンド）",
                "front_toss_underhand": "フロントトス（アンダーハンド）",
                "live_pitch": "実際の投球",
                "pitching_machine": "ピッチングマシン",
                "in_game": "試合",
                "assessment": "評価",
                "general_practice": "一般練習",
                "chop_slap": "チョップスラップ",
                "general_slapping": "一般的な平手打ち",
                "power_slap": "パワースラップ",
                "soft_slap": "ソフトスラップ",
                "undefined": "未定義"
            },
            "constraints": {
                "all_constraints": "すべての制限",
                "no_constraint": "制限なし",
                "arm_constraint": "腕の制限",
                "wrist_constraint": "手首の制限",
                "torso_constraint": "上体の制限",
                "pelvis_constraint": "腰の制限",
                "other_constraint": "その他制限",
                "impact_bag": "インパクトバッグ",
                "undefined": "未定義"
            },
            "slapping": {
                "all": "すべてのスラップタイプ",
                "general_slapping": "一般的なスラップ",
                "power_slap": "パワースラップ",
                "chop_slap": "チョップスラップ",
                "soft_slap": "ソフトスラップ"
            },
            "slap_type": {
                "all": "すべてのスラップタイプ",
                "general_slapping": "一般的なスラップ",
                "power_slap": "パワースラップ",
                "chop_slap": "チョップスラップ",
                "soft_slap": "ソフトスラップ"
            },
            "pitch_type": {
                "all_pitch_types": "すべての投球タイプ",
                "fastball": "速球",
                "curveball": "カーブ",
                "slider": "スライダー",
                "changeup": "チェンジアップ",
                "other": "その他",
                "undefined": "未定義"
            },
            "pitch_location": {
                "all_pitch_locations": "すべての投球コース",
                "up_in": "内角高め",
                "up_mid": "真ん中高め",
                "up_away": "外角高め",
                "mid_in": "内角真ん中",
                "mid_mid": "真ん中",
                "mid_away": "外角真ん中",
                "low_in": "内角低め",
                "low_mid": "真ん中低め",
                "low_away": "外角低め",
                "undefined": "未定義"
            },
            "filter_action_types": {
                "all": "すべてのスイング",
                "swings_with_impact": "インパクトありのスイング",
                "air_swings": "素振り",
                "full_swing": "フルスイング",
                "slapping": "スラップ"
            },
            "filter_impact_types": {
                "all_swings": "すべてのスイング",
                "swings_with_impact": "インパクトありのスイング",
                "air_swings": "素振り"
            },
            "meeting": "ミーティング",
            "game": "試合",
            "practice_general": "練習（一般）",
            "event": "イベント",
            "gmap_format_msg": "Google マップ対応の形式にしてください。",
            "waiver": "権利の放棄",
            "waiver_text": "権利の放棄テキスト",
            "waiver_required": "権利の放棄が必要ですか？",
            "enable_site_access_waiver_msg": "これを有効にすると、すべての選手がサイトにアクセスする前に権利の放棄を承諾する必要があります。",
            "academy_customization": "チームのカスタマイズ",
            "collections_note": "チームの各ユーザー用ライブラリーの左側にコレクションが表示されます。コレクションはタグで絞り込みできるので、選手やコーチはよく使用するファイルに簡単にアクセスできます。",
            "used_on_menu_note": "空欄にするとデフォルトに戻ります。",
            "used_on_buttons_note": "ボタンと他のハイライトで使用します。空欄にするとデフォルトに戻ります。",
            "communicate_verb": "フィードバック",
            "default_menu_name_communicate_note": "デフォルトでは「カスタムフォーム」がメニューアイテムの名前です。この名前は変更できます。何も入力しなければ「カスタムフォーム」になります。",
            "academy_configuration": "チームの設定",
            "internal_academy": "Blastの運営チーム",
            "internal_academy_explain": "フラグがオンになっていると、{app_name}がチームを内部用またはデモ用と判断し、さまざまなシステムレポートからこのチームを除外します。",
            "view_adv_settings": "詳細設定を見る",
            "adv_config_warning": "詳細設定用のオプションです。これを使うと{academy_name}が不安定になるおそれがあります。サポートが必要な場合は、<a href=\"https://www.mizuno.co.jp/customer/\">弊社お客様相談センター</a>にお問い合わせください。",
            "got_it": "Got it",
            "enabling_this_provides_members_network": "コネクションを有効にしています。",
            "enabling_this_provides_messaging": "メッセージを有効にしています。",
            "enabling_search_in_menu_bar": "メニューバーの「検索」を有効にしています。",
            "team": "チーム",
            "academics_website": "チームのウェブサイト",
            "mens_coach": "男子のコーチ",
            "assistant_coach": "アシスタントコーチ",
            "womens_coach": "女子のコーチ",
            "send": "送信",
            "send_feedback": "フィードバックを送信",
            "no_thanks": "いいえ",
            "school": "チーム",
            "student_application": "選手の申請",
            "application_form": ":選手用の申請です。",
            "incomplete_school": "申し訳ありませんが、このチームは情報が不足しているため申請を送信できません。",
            "can_academy_use_communicate": "このチームにカスタムフォームの使用を許可しますか？",
            "owner_member_management": "監督によるメンバー管理",
            "can_owners_manage_members": "このチームの監督にメンバーの追加と管理を許可しますか？",
            "show_academy_skill_results": "選手のスキル結果",
            "universal_payments_enabled": "メインの支払い方法",
            "universal_payments_enabled_explain": "監督がクレジットカードを登録して、新メンバーの支払いができるようになります。",
            "new_members_recieve_email_w_login": "新メンバーにはログイン情報を記載したメールが届きます。新メンバーは初回ログイン時にパスワードを変更する必要があります。",
            "email_already_registered": "登録済みのメールアドレスです。",
            "temp_password_note": "8文字以上にしてください。パスワードには必ず文字と数字を使用してください。この欄を空欄のままにすると、新メンバーのパスワードがランダムに生成されます。",
            "student_requires_subscription": "選手が課金プランに登録すると、アカウントにアクセスできるようになります。",
            "you_will_need_a_subscription": "アカウントにアクセスするには、有効な課金プランが必要です。こちらで登録してください。",
            "coach_assignements": "コーチの割り当て",
            "assign_all_coaches": "すべてのコーチを割り当てる",
            "parent_assignments": "保護者の割り当て",
            "parents_available": "保護者",
            "students": "選手",
            "students_and_coaches": "選手とコーチ",
            "student": "選手",
            "first_name": "名",
            "last_name": "姓",
            "status": "ステータス",
            "parents": "保護者",
            "parent": "保護者",
            "coaches": "コーチ",
            "owner": "監督",
            "owners": "監督",
            "not_available": "表示できません",
            "no_students_in": "選手がいません：",
            "override_default_skills": "デフォルトのスキルを無効にする：",
            "enter_your_score": "スコアを入力",
            "default_skill_desc_notes": "デフォルトのタイトル「評価」をここで無効にします。説明を追加することもできます。追加した説明はタイトルの下に表示されます。",
            "default_skill_desc_org": "デフォルトのスキルの説明も組織レベルで変更できます。変更する場合は、管理者に連絡してください。",
            "custom_skills_description": "カスタムスキルのタイトルと説明",
            "save_skill_summary": "スキル概要を保存",
            "custom_skills_assessments": "カスタムスキルの評価",
            "verified_score": "確認済みスコア",
            "verified_scores_are": "自身のスコアや選手のスコアを入力すると「確認済み」スコアになります。",
            "org_skill_edit_delete": "組織のスキルは編集や削除ができません。サポートが必要な場合は、弊社お客様相談センターにお問い合わせください。",
            "add_custom_skill": "カスタムスキルを追加",
            "title": "タイトル",
            "change_title": "タイトルを変更",
            "description": "説明",
            "scoring_type": "スコアのタイプ",
            "scoring_range": "スコアの範囲",
            "between": "間",
            "score": "スコア",
            "no_associated_custom_skills_default": "は評価がありません。",
            "assign_coaches": "コーチを割り当てる",
            "remove_all_coaches": "すべてのコーチを削除",
            "assign_parents": "保護者を割り当てる",
            "academy_region": "地域",
            "academy_region_explain": "学校の地域",
            "academy_region_us": "米国",
            "academy_region_jp": "日本",
            "baseball_only": "野球のみ",
            "academy_logo": "学校ロゴ",
            "api_access": "APIアクセスが有効",
            "api_access_explain": "ユーザーは外部APIを使用してアカデミーにアクセスできますか。",
            "import_coach_schedule": "コーチのスケジュールをインポート",
            "import_coach_schedule_note": "Excelのカスタムスケジュールファイルをアップロードします。",
            "name": "名前",
            "domain": "区分",
            "national": "全国",
            "subscription": "課金プラン",
            "subscriptions": "課金プラン",
            "subscription_cancel": "課金プランを解約",
            "allow_invites": "招待を許可",
            "allow_invites_explain": "このチームに新メンバーの招待を許可しますか？",
            "allow_public_registration": "一般申し込みを許可",
            "allow_public_registration_explain": "画面に「<em>今すぐ申し込む</em>」と表示され、誰でも参加できるようになります。",
            "blast_require_subscription": "課金プランが必要です",
            "blast_require_subscription_explain": "有効にすると、選手は{academy_name}にアクセスするのにStripeの有効な課金プランが必要になります。",
            "enforce_licensed_seats": "ライセンスシートを適用する",
            "enforce_licensed_seats_explain": "この設定がオンに切り替えられた場合、アプリはライセンスされた座席制限を適用するものとします。",
            "your_subscription": "課金プラン",
            "subscription_valid": "有効",
            "subscription_invalid": "無効",
            "subscription_na": "利用不可",
            "subscription_unknown": "不明",
            "subscription_information_heading": "課金プランの情報",
            "subscription_status": "ステータス",
            "subscription_period": "期間",
            "subscription_change": "課金プランを変更",
            "subscription_update_payment_info": "支払い情報を更新",
            "new_credit_card": "クレジットカード情報を更新",
            "credit_card_information": "クレジットカード情報",
            "subscription_update_card": "クレジットカードを更新",
            "subscription_update_subscription_heading": "手順を更新",
            "subscription_update_subscription_message": "課金プランの情報を変更、更新したい場合は、弊社お客様相談センターにご連絡ください。",
            "subscription_not_available_heading": "現在利用不可",
            "subscription_not_available_message": "アカウントが課金プランに登録されていません。コーチや監督が有効な課金プランに登録していないため、{appName}にアクセスできません。",
            "subscription_not_needed_message": "{user_types} は課金プランがなくても{appName}にアクセスできます。選手はこのタブから課金プランの支払いができます。",
            "billing_customer_service": "支払い関連のカスタマーサービス",
            "account_cancelled": "アカウントが解約されました",
            "card_not_visible": "カード番号は表示されません。",
            "contact_location_name_blast_california": "カリフォルニア州カールスバッド",
            "contact_location_name_blast_canada": "カナダ、トロント",
            "settings_general_heading": "一般",
            "notifications_academy_heading": "チームの最新情報",
            "notifications_messages_content_heading": "メッセージとコンテンツの共有",
            "notifications_updates_from_blast": "Blast Motionの最新情報",
            "assessment_enabled": "評価を有効にする",
            "assessment_enabled_explain": "このチームで評価を使用できるようにする",
            "allow_coaches_to_manage_assessments": "コーチに評価の管理を許可する",
            "allow_coaches_to_manage_assessments_explain": "このチームのコーチに評価の管理を許可する",
            "camps_enabled": "イベントを有効にしました",
            "camps_enabled_explain": "このチームにイベントの作成を許可する",
            "blast_subscription_cancelled": "Blast Connect課金プランが解約されました",
            "seats": "シート",
            "capacity": "定員",
            "sales_rep": "販売担当者",
            "account_manager": "アカウントマネージャー",
            "renewal_price": "更新料金",
            "member_options": "メンバーのオプション",
            "manage_coaches": "コーチを管理",
            "suspend_account": "アカウントを一時停止",
            "block_access": "アクセスを禁止",
            "suspended": "一時停止中",
            "reinstate_account": "アカウントを復元",
            "resend_invitation": "招待を再送信",
            "manage_subscription": "課金プランを管理",
            "activate": {
                "yes_suspend": "一時停止する",
                "yes_block_access": "アクセスを禁止する",
                "yes_reinstate": "復元する",
                "no_go_back": "いいえ、戻る",
                "confirm_suspend": "このアカウントを一時停止にしてもよろしいですか？",
                "confirm_suspend_description": "ユーザーのアカウントが削除されるわけではありませんが、アカウントを復元するまでユーザーはアクセスできなくなります。",
                "confirm_reinstate": "このアカウントを復元してもよろしいですか？",
                "confirm_block": "<b><span class=\"blockUserFullName\"></span>のこのアカウントからのアクセスを禁止してもよろしいですか？</b>",
                "confirm_block_description": "アカウントが削除されるわけではありません。課金プランにも変更はありません。 ",
                "confirm_block_description_subscription": "<b>このアカウントの支払いをしているユーザーに今後も請求が発生します</b>。<br /><br /><span class=\"blockUserFullName\"></span>の課金プランを変更する場合は、同じメニューから「課金プランの変更」を選択します。",
                "confirm_block_description_ending": "<br /><br /> <span class=\"blockUserFirstName\"></span>は、復元するまでこのアカウントにアクセスできなくなります。 "
            },
            "account_blocked": "アカウントをブロックしました。{fullName}はアカウントにアクセスできなくなりました。アクセスを許可するには、「アカウントを復元」を選択します。",
            "invitation_unavailable": "招待が承諾されました",
            "invitation_unavailable_explain": "招待は既に承諾済みのようです。すぐに<a href=\"/login\">ログイン</a>できます。",
            "invitation_expired": "招待の有効期限が切れています",
            "invitation_expired_explain": "この招待は{exp_date}に有効期限が切れました。",
            "no": "いいえ",
            "in": "★★in",
            "courses": "コース",
            "course": "コース",
            "manage_academies": "チームを管理",
            "academy_delete_warning": "メンバーがいるチームは削除できません。",
            "force_statistic_updates_for": "データを強制更新：",
            "recalculate_statistics_note": "チームの各メンバーのデータを（10人単位で）再計算します。しばらく時間がかかりますが、そのままお待ちください。ボタンを1つずつ順番に押してください。",
            "refresh_statistics": "データを更新",
            "stats": "データ",
            "last_active": "前回の使用：",
            "files": "ファイル",
            "storage": "ストレージ",
            "sport": "競技",
            "locator": "場所検索",
            "no_files_uploaded_with": "ファイルはアップロードされていません：",
            "no_public_scores_entered": "公開スコアが入力されていません。さっそく入力しましょう！",
            "skills_tests": "スキルテスト",
            "enter_scores": "スコアを入力",
            "enter_score": "スコアを入力",
            "results": "結果",
            "result": "結果",
            "active_assessments": "アクティブな評価",
            "how_to_play": "プレー方法",
            "sorry": "ごめんなさい",
            "has_not_set_up_skills": "は今回{skills_term}を設定していません。",
            "preventing_video_load_warning": "エラーが発生したため動画を読み込めません。",
            "overall": "全体",
            "academy_average_grade": "チームの平均成績",
            "national_average_grade": "全国の平均成績",
            "my_recent_score": "最近のスコア",
            "scores": "スコア",
            "my_scores": "スコア",
            "currently_viewing_results_for": "フィルタ：",
            "academy_average": "チーム平均",
            "national_average": "全国平均",
            "leaderboard": "チームNO.1",
            "grade": "成績",
            "below_average": "平均より下",
            "average": "平均",
            "above_average": "平均より上",
            "avg": "平均",
            "high": "高",
            "low": "低",
            "skills": "スキル",
            "high_to_low": "高→低",
            "low_to_high": "低→高",
            "assessment": "評価",
            "assessments": "評価",
            "your_assessments": "{name}の評価",
            "assessment_view": {
                "measurements": {
                    "": "",
                    "types": {
                        "length": "長さ",
                        "speed": "スピード",
                        "weight": "重さ",
                        "time": "時刻",
                        "number": "ナンバー"
                    }
                },
                "labels": {
                    "assessments": "評価",
                    "scoring": "スコア",
                    "score": "スコア",
                    "add_result": "結果を追加",
                    "edit_result": "結果を編集",
                    "delete_result": "結果を削除",
                    "date": "日付",
                    "time": "時刻",
                    "your_scores": "スコア",
                    "leaders": "上位",
                    "view_results": "結果を見る",
                    "name": "名前",
                    "description": "説明",
                    "category": "カテゴリー",
                    "measurement_type": "測定のタイプ",
                    "status": "ステータス",
                    "create_assessment": "評価を作成",
                    "academy_leaderboard": "チームNo.1",
                    "organization_leaderboard": "組織のNo.1",
                    "result_limited_to": "{min}～{max}",
                    "result_limited_to_min": "最小{min}",
                    "result_limited_to_max": "最大{max}",
                    "best": "ベスト",
                    "last": "前回",
                    "rank": "ランク",
                    "out_of": "全体数",
                    "customize_assessment_page": "カスタマイズ",
                    "select_student_or_roster": "選手またはグループを選択すると結果を確認できます。",
                    "members": "メンバー",
                    "all_members": "すべてのメンバー",
                    "members_without_result": "結果なしのメンバー",
                    "has_not_participated_yet": "このメンバーはまだ参加していません。"
                },
                "messages": {
                    "no_assessments_available": "{academy_name} にはまだ評価がありません。",
                    "go_ahead_create": "「+」ボタンを押して評価を作成しましょう。",
                    "assessment_created": "{assessment_name} を作成しました",
                    "assessment_updated": "{assessment_name} を更新しました",
                    "assessment_deleted": "{assessment_name} を削除しました {undo_link}",
                    "assessment_restored": "{assessment_name} を復元しました",
                    "yourself": "自分",
                    "result_added": "結果を追加しました。",
                    "result_updated": "結果を更新しました。",
                    "result_deleted": "結果を削除しました。 {undo_anchor}",
                    "result_restored": "結果を復元しました。",
                    "assessments_edited": "評価を編集しました",
                    "result_delete_confirmation": "この結果を削除してもよろしいですか？",
                    "loading_results": "結果を読み込み中..."
                },
                "buttons": {
                    "manage_assessments": "評価を管理",
                    "team_report": "チームレポート",
                    "add_score": "スコアを追加",
                    "details": "情報",
                    "instructions": "手順",
                    "add_file": "ファイルを追加",
                    "add_detail": "情報を追加",
                    "edit_file": "ファイルを編集",
                    "edit_detail": "情報を編集",
                    "view_assessments": "評価を見る"
                }
            },
            "save_custom_settings": "カスタム設定を保存",
            "customize": "カスタマイズ",
            "category": "カテゴリー",
            "categories": "複数カテゴリー",
            "manage_categories": "複数カテゴリーを管理",
            "assess_category_description": "ここで割り当てられたカテゴリーによって、評価が保存されるタブが決まります。",
            "show_leaderboard": "選手のNo.1はこの順でよろしいですか？",
            "video_or_image": "動画または画像",
            "unit_of_measure": "測定単位",
            "value_decimal": "小数点以下の桁数",
            "set_max_low_limits": "スコアの最大と最小を設定",
            "what_scoring_objective": "この評価の採点基準は？",
            "outcome_high": "高",
            "outcome_low": "低",
            "outcome_target": "目標スコア",
            "outcome_target_range": "目標範囲",
            "outcome_none": "なし",
            "outcome_disable_leaderboard": "No.1が無効になり、スコアが日付順に表示されます。",
            "score_limits": "限度",
            "add_score": "スコアを追加",
            "add_a_score": "スコアを追加",
            "add_your_score": "スコアを追加",
            "categories_desc": "カテゴリーによって「評価」画面の一番上に表示されるタブが決まります。その後、評価をカテゴリーに割り当てられます。",
            "back_to_assessments": "評価に戻る",
            "view_assessments": "評価を見る",
            "view_active_assessments": "アクティブな評価を見る",
            "advanced_options": "詳細オプション",
            "no_categories": "カテゴリーまたは評価がまだ設定されていません。",
            "no_assessments_category": "このカテゴリーに評価がまだ追加されていません。",
            "no_assessments_categories": "評価カテゴリーがまだありません。「評価を管理」をクリックして、評価カテゴリーを追加してください。",
            "problem_saving_category": "カテゴリーの保存中にエラーが発生しました。やり直してください。",
            "if_problem_persists": "引き続きエラーが発生する場合は、弊社お客様相談センターにお問い合わせください。",
            "outcome_options_disabled": "ユーザーがこの評価にスコアを提出したため、採点オプションの編集が無効になりました。",
            "select_at_least_one_student": "結果を見るには選手またはグループを選択してください。",
            "date_filter": "日付絞り込み",
            "no_one_has_participated": "まだ参加者がいません。スコアを入力しましょう！",
            "select_student_to_view_results": "選手またはグループを選択すると結果を確認できます。",
            "participate_first": "さっそく参加しましょう！",
            "student_not_participated": "{name}はまだ参加していません。",
            "students_not_completed": "あなたと選手はこの評価をまだ完了していません。",
            "personal_best": "自己ベスト",
            "academy_best": "チームベスト",
            "verified": "確認済み",
            "add_category": "カテゴリーを追加",
            "wi_analysis_winning_identity": "動画分析",
            "panels": "パネル",
            "media_nav": "メディア",
            "cloud": "クラウド",
            "loading": "読み込み中",
            "all": "すべて",
            "tool_guide": "ツールガイド",
            "close": "閉じる",
            "chrome_required": "Google Chromeブラウザが必要です",
            "no_browser_support_screen_audio_recording": "現在お使いのブラウザは、画面録画と録音に対応していません。",
            "recording_use_dl_chrome": "画面録画と録音を使用するには、<a href=\"http://www.google.com/chrome/\" target=\"_blank\">Google Chromeをダウンロードして使用してください</a>。",
            "analysis_extension_required": "分析拡張機能が必要です",
            "screen_capture_extension_note": "Analysis Screen Capture（分析画面録画）拡張機能がブラウザにインストールされ、有効になっていることを確認してください。",
            "chrome_extension": "Chrome拡張機能",
            "install": "インストール",
            "analysis_view": {
                "ver2": {
                    "modal": {
                        "headers": {
                            "initializing": "初期化中...",
                            "loading": "読み込み中",
                            "stopped_recording": "録画が停止されました",
                            "save_to_library": "ライブラリーに保存",
                            "uploading": "アップロード中",
                            "saved": "保存済み",
                            "where_should_be_placed": "どこに配置しますか？",
                            "processing": "処理中…",
                            "chrome_extension": "申し訳ありませんが、ビデオ分析ツールはお使いの Web ブラウザーでサポートされていません。"
                        },
                        "messages": {
                            "annotation_saved": {
                                "before_file_name": "動画へのコメント",
                                "after_file_name": "ライブラリーに保存しました。"
                            },
                            "select_panel_to_replace": "両方のパネルを使用してメディアを比較しています。このファイルを保存するパネルを選択してください。",
                            "unable_install_chrome_ext": "残念ながら、Google はカスタム Chrome アプリのサポートを終了することを決定したため、Blast Video Analysis Tool をインストールできなくなりました。 ただし、Mobile Video Analysis は、iOS の Blast Baseball、Blast Softball、および Blast Golf アプリ内で利用できます。",
                            "grant_permission": "アドレスバーの左にあるアイコンを使って、画面の録画対象エリアを選択してください。"
                        },
                        "labels": {
                            "file_name": "ファイル名",
                            "description": "ファイルの説明",
                            "share_with": "共有相手",
                            "tags": "タグ",
                            "left": "左",
                            "right": "右"
                        },
                        "buttons": {
                            "save_to_library": "ライブラリーに保存",
                            "download": "ダウンロード",
                            "discard": "削除",
                            "save": "保存",
                            "back": "後",
                            "ok": "OK",
                            "select": "選択",
                            "cancel": "キャンセル",
                            "close": "閉じる",
                            "refresh": "更新",
                            "install": "インストール",
                            "view_in_library": "ライブラリーで見る"
                        }
                    },
                    "heading": {
                        "panel_list": "現在読み込み済みのメディア",
                        "select_another_file": "別のファイルを選択"
                    },
                    "messages": {
                        "empty_panel": "読み込み済みのメディアはありません。はじめましょう！"
                    },
                    "alerts": {
                        "types": {
                            "warning": "注意！"
                        },
                        "not-recording": "コメントを記録しないと、書き込みが保存されません。"
                    },
                    "buttons": {
                        "compare": "比較",
                        "add_image_video": "画像または動画を追加",
                        "options_tools": {
                            "overlay": "重ね合わせ",
                            "grid": "グリッド",
                            "mirror": "反転",
                            "rotate": "回転",
                            "zoom_in": "拡大",
                            "zoom_out": "縮小",
                            "reset": "リセット"
                        }
                    },
                    "tooltips": {
                        "tools": {
                            "move_tool": "移動",
                            "dot_tool": "点",
                            "line_tool": "線",
                            "circle_tool": "円",
                            "rectangle_tool": "長方形",
                            "brush_tool": "ブラシ",
                            "arrow_tool": "矢印",
                            "angle_tool": "角度",
                            "color_tool": "色",
                            "colors": {
                                "yellow": "黄",
                                "red": "赤",
                                "green": "緑",
                                "purple": "紫",
                                "white": "白"
                            },
                            "record_tool": "録画/録音",
                            "media": {
                                "backward": "戻る",
                                "backward10": "戻る（10倍速）",
                                "play": "再生",
                                "pause": "一時停止",
                                "forward": "進む",
                                "forward10": "進む（10倍速）",
                                "stop": "停止",
                                "loop": "ループ",
                                "all": "（すべて）"
                            },
                            "cue_tool": "タグを追加",
                            "option_tool": "その他オプション",
                            "panel": {
                                "hide": "メディアを非表示",
                                "undo": "元に戻す",
                                "clear": "すべて消去"
                            },
                            "layer": {
                                "layer_number": "レイヤー番号",
                                "hide_show": "選手/非表示",
                                "remove_layer": "重ね合わせを削除"
                            }
                        }
                    },
                    "panel_labels": {
                        "left": "左パネル",
                        "right": "右パネル",
                        "single": "アクティブなパネル"
                    }
                }
            },
            "zoomed": "ブラウザが拡大/縮小されているようです",
            "reset_zoom": "続行するには、ブラウザの拡大/縮小率をリセットしてください。",
            "chrome": "Chrome",
            "firefox": "Firefox",
            "zoom_menu_instructions_chrome": "「<em>表示</em>」>「<em>実際のサイズ</em>」を選択します",
            "zoom_key_instructions_chrome": "キーボードの<em>Ctrl+0（またはCommand+0）</em>を押します。",
            "zoom_menu_instructions_firefox": "<em>「表示」>「ズーム」</em>>「<em>リセット</em>」を選択します",
            "zoom_key_instructions_firefox": "キーボードの<em>Ctrl+0（またはCommand+0）</em>を押します。",
            "communicate_form_not_found": "フォームが見つかりませんでした",
            "communicate_response_not_found": "回答が見つかりません。",
            "communicate_response_not_found_message": "回答が見つかりません。サポートが必要な場合はご連絡ください。",
            "communicate_permission_denied": "権限が拒否されました",
            "communicate_permission_denied_message": "この回答を編集する権限がありません。エラーが発生していると思われる場合は、弊社お客様相談センターにお問い合わせください。",
            "communicate_problem_locating_account": "アカウント特定中のエラー",
            "communicate_problem_locating_account_message": "登録されているはずのアカウントが見つかりませんでした。サポートが必要な場合はご連絡ください。<br><small>エラー：42-5</small>",
            "communicate_organizational_form_title": "組織用フォーム",
            "communicate_organizational_form_message": "このフォームは、{academy_name}によって組織用フォームとして設定されています。チームの管理者に問い合わせてください。ありがとうございます。",
            "communicate_invalid_notify_emails": "通知リストに無効なメールアドレスがあります。",
            "communicate_answeree_message_title_edited": "{first_name} {last_name} （{email}）がフォームを編集しました {form_name}",
            "communicate_answeree_message_title_answered": "{first_name} {last_name} （{email}）がフォームに回答しました {form_name}",
            "communicate_by_coach_on_behalf_of_student": "*この選手に代わってコーチが送信済み",
            "communicate_email_problem": "メールを送信できません",
            "communicate_email_problem_message": "メールを送信中にエラーが発生しました。サポートが必要な場合はご連絡ください。",
            "communicate_thank_for_edited": "ありがとうございます！ {form_name} が編集されました。",
            "communicate_thank_for_answered": "ありがとうございます！ {form_name} が回答しました。",
            "communicate_form_response_not_found": "この回答が記載されているフォームが見つかりませんでした。",
            "communicate_response_deleted": "削除済みの回答 ",
            "communicate_form_deleted": "フォームを削除しました ",
            "communicate_form_delete_confirmation": "{form_name}を完全に削除しますか？",
            "response_deleted": "削除済みの回答",
            "response_restored": "回答を復元しました",
            "could_not_find_form": "フォームが見つかりませんでした",
            "permission_denied": "権限が拒否されました。エラーだと思われる場合はご連絡ください。",
            "form_name": "フォーム名",
            "short_name": "ニックネーム",
            "short_name_help": "フォーム名が長すぎてメニューに表示できない場合は、ニックネームを指定できます。",
            "menu_placement": "メニューの配置",
            "add_to_improve_menu_note": "このフォームを「トレーニング」メニューの一番下、既存のメニューオプションの下に追加する。",
            "add_to_analyze_menu_note": "このフォームを「分析」メニューの一番下、既存のメニューオプションの下に追加する。",
            "add_to_main_menu_note": "このフォームをメインメニューに追加する。メニューに複数のフォームがある場合、プルダウンメニューに追加され、次のタイトルが付きます： ",
            "not_on_menu_go_to_communicate_option": "このフォームはメニューに表示できません。右上にあるプロフィールのプルダウンで「コミュニケーション」オプションを選択すると表示されます。",
            "communicate_menu": "カスタムフォームメニュー",
            "form_avail_on_communicate_menu": "フォームは「カスタムフォーム」からアクセスできます。",
            "add_question": "質問を追加",
            "questions": "複数の質問",
            "question": "質問",
            "question_type": "質問のタイプ",
            "required": "必須",
            "hidden": "現在非表示",
            "undo_delete": "削除を取り消し",
            "add_questions_w_add_field": "「フィールドを追加」でフォームに質問を追加します。",
            "form_settings": "フォーム設定",
            "who_can_answer_this_form": "このフォームに回答できるのは？",
            "parent_accts_cant_respond_to_forms": "「<em>保護者</em>」アカウントは必須フォームも含め、フォームに回答できません。",
            "coaches_on_behalf_of_students": "選手の代理を務めるコーチ",
            "who_sees_responses_for_form": "このフォームの回答を閲覧できるのは？",
            "and_parents": "（該当する場合は保護者アカウントも）",
            "required_form": "必須フォーム",
            "required_form_to_access_site_note": "メンバーがログインするときに必須フォームの入力が完了していない場合は、サイトにアクセスする前に必須フォームの入力が必要になります。",
            "respond_limit": "回答の上限",
            "respond_limit_explanation": "このフォームにアクセスできるユーザーが回答できる回数の上限です。（無制限の場合は空欄または0と入力）",
            "show_form_on_timeline": "タイムラインの選手フォーム",
            "timeline_updated": "タイムラインを更新しました",
            "answered_forms_show_on_timeline": "フォームに回答が記入されると、ユーザーのタイムラインに表示されます。コーチが選手に代わって回答したフォームは、選手のタイムラインに表示されます。",
            "yes": "はい",
            "form_placed_in_every_academy_in_the": "このフォームはネットワーク内の各チームに保存されます",
            "network": "ネットワーク",
            "academy_owners_cannot_change_forms": "監督はこれらのフォームを編集、削除できます。",
            "save_form": "フォームを保存",
            "type": "タイプ",
            "255_character_max": "255文字までしか入力できません",
            "how_was_our_service": "Blastのサービスはいかがですか？",
            "instructions": "手順",
            "instructions_accompany_form_note": "ここに入力した指示や説明はフォームにアクセスしたときに一緒に表示されます。",
            "optional_summary_extras": "フォーム概要（長文）または情報を追加できます。",
            "possible_answers": "想定される回答",
            "one_answer_per_line": "1行に1つの回答を入力します。",
            "question_cannot_be_unanswered": "（この質問は回答必須）",
            "qm": "？",
            "hidden_fields_not_available_for_users": "現在非表示のフィールドはユーザーに<strong>表示されません</strong>。既に回答済みの既存のフォームから質問を削除したいときに使用してください。",
            "update_question": "質問を更新",
            "appears_invalid": "が無効のようです。これを使ってフォームを追加すると不安定になり、ユーザーがシステムを利用できなくなります。",
            "see_submitted_responses": "送信済みの回答を見る",
            "logout_return_later": "ログアウトしてあとで戻る",
            "answer_self_or_behalf_of_student": "自分で回答するか、選手の代理として回答してください。",
            "disabled_answer_self_or_behalf_of_student": "次の選手は回答の上限に達しました",
            "students_see_responses_on_their_behalf": "選手にフォームの閲覧が許可されていれば、選手に代わってあなたが入力した回答を選手が見ることができます。（フォームを「コーチのみ」に設定することができます）",
            "no_media_available_add_some": "表示できるメディアがありません。追加できます",
            "from_library": "ライブラリーから",
            "or": "または",
            "save": "保存",
            "publish": "公開",
            "required_lower": "必須",
            "question_lower": "質問",
            "questions_lower": "質問",
            "must_be_answered": "回答必須",
            "communicate_response_limit": "回答の上限",
            "communicate_response_limit_explanation": "ユーザーがこのフォームに回答できる回数の上限です。「0」と指定すると無制限に回答できます。",
            "communicate_your_limit": "回答の上限：",
            "create_form": "フォームを作成",
            "see_responses": "回答を見る",
            "answer": "回答",
            "no_custom_forms_for": "カスタムフォームなし：",
            "no_responses_logged": "このフォームへの回答はありません。",
            "back_to_communicate": "カスタムフォームに戻る",
            "export_to_excel": "Excelでエクスポート",
            "export_to_pdf": "PDFでエクスポート",
            "uc_date": "日付",
            "no_repsonse_edit_permission": "この回答を編集する権限がありません。",
            "no_repsonse_delete_permission": "この回答を削除する権限がありません。",
            "no_responses": "回答なし",
            "indicate_coach_submits_student_form_note": "コーチが選手に代わってフォームを送信したことを示しています。",
            "no_questions_added_to_form": "このフォームには質問なし",
            "submitted_by_coach": "コーチによる送信",
            "generate_report": "レポートを作成",
            "print": "印刷",
            "export": "エクスポート",
            "csv": ".CSV",
            "save_as_pdf": "PDFで保存",
            "save_as_csv": "CSVで保存",
            "save_as_excel": "Excelで保存",
            "save_full_team_report_excel": "チーム全員のレポートを保存（Excel）",
            "save_full_team_report_csv": "チーム全員のレポートを保存（CSV）",
            "you_must_select_a_session_first": "まず計測を選択してください。",
            "the_sessions_you_selected_were_not_created_by_you_and_cannot_be_deleted": "選択中の計測はあなた以外のユーザーが作成したものなので削除できません。| 選択中の計測はあなた以外のユーザーが作成したものなので削除できません。",
            "cannot_locate_deleted_file": "このファイルを見つけられません。削除されたようです。",
            "submitted": "送信済み",
            "your_average": "あなたの平均",
            "student_average": "{name}の平均",
            "continue_to_site": "サイトへ移動する",
            "timeline": "タイムライン",
            "golf_channel_news_archive": "Golf Channel - ニュースアーカイブ",
            "news": "ニュース",
            "just_now": "たった今",
            "wrote_on_timeline": "が自分のタイムラインに書きました",
            "write_to_your_timeline": "自分のタイムラインに書く",
            "welcome_to": "ようこそ",
            "youve_begun_a_journey": "{user_first_name}、{sport}上達の旅は始まったばかりです。世界トップのプロとつながりましょう。",
            "lets_get_started": "さっそくスタート！",
            "get_started": "はじめよう",
            "welcome_video": "紹介動画",
            "update_profile": "プロフィールを更新",
            "profile": "プロフィール",
            "provide_name_and_image": "名前と写真を設定しておくと、コーチとのコミュニケーションがスムーズになります。",
            "in_upper_right_corner_choose": "画面右上を選択",
            "my_profile": "プロフィール",
            "where_you_can_upload_media": "を選択します。ここで動画や画像などのファイルをアップロードできます。",
            "menu": "メニュー",
            "analyze": "分析",
            "analyzed": "分析済み",
            "improve": "スキルアップ",
            "check_out_your": "チェックしましょう：",
            "try_one_of": "試しましょう：",
            "default": "デフォルト",
            "test_your_skills_on_the": "スキルを試しましょう",
            "skills_tracker": "スキルトラッカー",
            "and_see_where_you_rank": "」でスキルをテストして、ランキングを確認しましょう！",
            "your_a_game": "試合",
            "follow_the_progress_of_your": "右上の",
            "friends_and_fellow_competitors": "「チーム」で",
            "in_the_upper_right_corner": "右上の",
            "with_your_academy_custom_forms_available": "★★使用できるカスタムフォームがあるようです。",
            "record_round_of": "{sport}のラウンドを記録",
            "or_two": "2ラウンドもOK！入力したデータから驚くほど詳しく試合での様子がわかります。",
            "play": "再生",
            "explore_minds": "使ってみましょう！{sport}の世界をリードする人たちの考え方を見てみましょう。",
            "skip_for_now": "今はスキップ",
            "dont_show_me_this_again": "今後",
            "with_your_academy_may_have_custom_forms_available": "★★使用できるカスタムフォームがあるようです。",
            "complete_your_profile": "プロフィールを完成させましょう",
            "manage_your_profile": "プロフィールを管理しましょう",
            "profile_strength": "プロフィールの長所",
            "of": "の",
            "your_best_metrics": "最高のデータ",
            "view_your_metrics": "データを見る",
            "announcement": "お知らせ",
            "profile_complete": "{name}のプロフィールは{complete}%入力済み。",
            "update_your_profile": "プロフィールを更新",
            "recently_added_files": "最近追加したファイル",
            "academy_overview": "チームの概要",
            "all_assessments": "すべての評価",
            "add_an_assessment": "評価を追加",
            "all_rounds": "すべてのラウンド",
            "start_a_round": "ラウンドを開始",
            "customize_your_dashboard": "ダッシュボードをカスタマイズ",
            "swing_metrics": "スイング測定データ",
            "show_workouts": "選手のワークアウト",
            "show_practices": "選手の練習",
            "main": "メイン",
            "sidebar": "サイドバー",
            "primary_academy": "メインのチーム",
            "events": "イベント",
            "reset_pass_complete_form": "パスワードをリセットするには、このフォームに必要事項を入力してください。",
            "link_expires_in": "リンクの有効期限はあと",
            "minutes": "分",
            "ffmpeg_exec_output": "FFMPEG EXEC出力",
            "user": "ユーザー",
            "has_invited_you_to_join": "があなたを次のチームに招待しました：",
            "invitation_available_until": "招待の有効期限：",
            "to_accept_please_visit": "承諾するには次にアクセスしてください：",
            "invites_subject_new": "{invitor_name}さんから招待されています： {academy_name}",
            "invites_subject_coach": "{invitor_name}さんから招待されています： {academy_name}",
            "invites_subject_academy": "{invitor_name}さんから招待されています： {academy_name}",
            "invites_subject_gca": "{invitor_name}さんから招待されています： {academy_name}",
            "error": "エラー",
            "server_error": "Blast側でエラーが発生しました",
            "internal_server_error": "内部サーバーエラー",
            "bad_request": "要求の形式が正しくありません",
            "400_explanation": "サーバーは、クライアント エラーであると認識される何かが原因で、リクエストを処理できないか、または処理しません (たとえば、不正なリクエスト構文、無効なリクエスト メッセージ フレーミング、不正なリクエスト ルーティング)。",
            "what_does_this_mean": "どういうことでしょうか？",
            "trying_to_access_without_credentials": "リソースにアクセスする際のログイン情報が間違っています。サポートが必要な場合は、弊社お客様相談センターにご連絡ください。",
            "forbidden": "アクセス禁止",
            "not_found": "お探しのページが見つかりません",
            "file_not_found": "ファイルが見つかりません。",
            "couldnt_find_requested_page": "お探しのページは移動または削除された可能性があります。リンクに問題があるか、URLが間違っている可能性もあります。アクセスできるページに移動します。",
            "something_went_wrong_on_server": "リクエストを処理中にBlastサーバーでエラーが発生しました。",
            "sorry_will_resolve_please_send_note": "ご不便をおかけしますが、解決までもうしばらくお待ちください。",
            "sorry_will_resolve_have_been_notified": "ご不便をおかけしますが、解決までもうしばらくお待ちください。",
            "something_went_wrong": "エラーが発生しました",
            "what_can_you_do": "どうすればよいでしょうか？",
            "send_us_message": "Blastにメッセージを送信する",
            "404_option_1": "前のページに戻る",
            "404_option_2": "ダッシュボードに移動する",
            "404_option_3": "Blastに問題を報告する",
            "try_again": "もう一度操作を繰り返してみる",
            "are_you_sure": "よろしいですか？",
            "return_to_previous_page": "前のページに戻る",
            "contact_customer_support": "弊社お客様相談センターに問い合わせる",
            "contact_our_customer_support": "カスタマーサポートチームに連絡してください。",
            "if_you_still_feel_thats_a_mistake_please_contact_our_support_team": "それでも間違いだと思われる場合は、サポート チームにお問い合わせください。",
            "stop_following": "フォローをやめる",
            "remove_follower": "\\(System.appSport.pieceOfEquipmentDescription)を削除",
            "joined": "参加済み",
            "no_coaches_yet": "コーチがいません。今すぐチームにスキルアップのことを聞いてみましょう！",
            "no_followers_yet": "フォロワーはまだいません。",
            "no_coaches_assigned": "コーチが割り当てられていません。",
            "no_students_assigned": "選手が割り当てられていません。",
            "coaches_assigned": "割り当て済みのコーチ",
            "students_assigned": "割り当て済みの選手",
            "cheatsheet": "早見表",
            "stat_name": "データ名",
            "last": "前回",
            "all_time": "全期間",
            "coming_soon": "近日公開...",
            "practices_completed": "完了した練習",
            "workouts_completed": "完了したワークアウト",
            "rounds_played_this_year": "今年プレーしたラウンド",
            "rounds_played": "プレーしたラウンド",
            "scoring_average": "平均スコア",
            "hasnt_written_bio_yet": "はまだ略歴を書いていません。",
            "your_profile": "プロフィール",
            "pga_average": "PGA平均",
            "following_graph_of_player_golf_game_msg": "下のグラフには選手のゴルフゲームの総合評価（PGAツアーの平均ストロークゲインドと比較）が表示されます。ストロークゲインドは、PGAツアーと比較した選手の総合評価です。算出方法は次のとおりです。たとえば、10ｍからワンパットでホールアウトしたとします。この距離からのホールアウトのツアー平均は2.0パットなので、そのフィールドでのストロークゲインドは1になります。</p><p>中央の赤い丸印が1～2ｍ、2～6ｍ、6m以上のパッティング、バンカープレー、0～20ヤード、20～60ヤード、60～100ヤードのショートゲームプレー、100～150ヤード、150～200ヤード、他ロングショットのボールストライキングデータのPGAツアー平均です。</p><p>ツアーと比較した長所や短所がわかります。PGAツアーのデータにできるだけ近付けることを目標にしましょう。",
            "explain_this_graph": "このグラフの説明",
            "yards": "ヤード",
            "yards_lower": "ヤード",
            "feet": "m",
            "feet_lower": "m",
            "other_long": "他のロング",
            "view_dashboard": "ダッシュボードを見る",
            "view_profile": "プロフィールを見る",
            "view_workout": "ワークアウトを見る",
            "view_practice": "練習を見る",
            "see_the_result": "結果を見る",
            "see_the_response": "回答を見る",
            "analysis": "分析",
            "hide": "非表示",
            "color": "色",
            "red": "赤",
            "blue": "青",
            "yellow": "黄",
            "green": "緑",
            "white": "白",
            "live_session": "ライブ計測",
            "browser_size_restriction": "ブラウザのサイズ制限",
            "live_session_requires": "ライブ計測ではブラウザサイズを幅1020ピクセル、高さ510ピクセルにしてください。",
            "beta_panel": "ベータ版パネル",
            "alpha_panel": "アルファ版パネル",
            "manage_golf_courses": "ゴルフコースを管理",
            "system_reports": "システムレポート",
            "sso_warning": "ユーザーはSSOではありません",
            "admin_search_desc": "{app_name}全体の簡単検索です。",
            "system_reports_desc": "チームの使用状況とデータのレポートです。",
            "non_gca_academy_report": "GCAチームレポート以外",
            "gca_academy_report": "GCAチームレポート",
            "sales_academy_report": "セールスレポート",
            "sales_academy_report_explain": "課金プランに登録していないチームのリストです。",
            "academy_report": "チームレポート",
            "audit": "監査",
            "welcome": "ようこそ",
            "please_login": "Blast Connectにログイン",
            "remember_me": "アカウント情報を保存",
            "please_visit": "パスワードのリセットにアクセスしてください。",
            "to_reset_it": "リセットしてください。",
            "send_instructions": "リセット手順を送信",
            "enter_email_to_reset": "メールアドレスを入力してリセットします。",
            "please_choose_new_password_auto_log_in": "新しいパスワードを選択すると、自動的にログインします。",
            "need_you_to_set_password": "ご利用いただきありがとうございます。新しいパスワードを作成して、今すぐスキルアップを目指しましょう！",
            "change_password": "パスワードを変更",
            "create_password": "パスワードを作成",
            "update_password": "パスワードを更新",
            "temporary_password": "仮パスワード",
            "importance_of_communication": "なぜコミュニケーションが大切なのか？コミュニケーションがなければ何もできないからです。誤解を避けるためにコミュニケーションが必要です。どんな組織も明確であることが不可欠です。コミュニケーションを重ねることで誤解を防ぐことができます。全員がシステムを理解し、その中での自分の責任を理解すれば、実行できるのです。",
            "login_to_your_academy": "チームにログイン",
            "no_academies_are_currently_accepting_members": "メンバーを受け入れているチームはありません",
            "change_password_login": "パスワードを変更してログイン",
            "terms_of_service_agree": "Blast Motionの",
            "terms_of_age_agree": "私は、私が 13 歳以上であること、または Blast Motion アカウントを作成することに親または保護者の同意を得ていることを証明します。",
            "terms_of_receive_sms_agree": "Blast Motion から定期的に SMS または MMS メッセージを受信することに同意します。これらのメッセージには、重要な情報、製品サポート情報、アップデート、セール、スペシャルが含まれますが、これらに限定されません。 標準のメッセージおよびデータ料金が適用される場合があります。",
            "terms_of_service": "利用規約に同意します",
            "register_no_account": "アカウントをお持ちでない場合",
            "register_call_to_action": "はじめましょう",
            "invite_account_registration_heading": "Blastアカウントを作成",
            "invite_information": "情報",
            "invite_information_caption": "短い自己紹介",
            "invite_account": "アカウント",
            "invite_account_caption": "アカウントを作成中",
            "email_note_available_error_message": "このメールアドレスは使用できません",
            "confirm_password": "パスワードを確認",
            "ready_heading": "準備はいいですか？",
            "ready_heading_caption": "素晴らしい！次は登録です",
            "service_disclaimer": "サービス免責事項",
            "service_disclaimer_text": "サービス免責事項の説明",
            "accept_and_continue": "続ける",
            "subscription_setup": "Blast Connectに加入する",
            "subscription_setup_subtext": "キャッチーな文章をここに入力しましょう...",
            "subscription_select_plan": "課金プランを選択",
            "free_trial": "{trial_days}日間無料トライアル込み",
            "one_year_subscription": "無料トライアル期間終了後、ただちに請求が発生します。",
            "billed_us_dollars": "すべてのプランは日本円で請求されます",
            "plans_automatic_renew": "プランは請求期間終了時に自動で更新されます。",
            "one_time": "一度",
            "subscription_monthly_plan": "1か月プラン",
            "subscription_monthly_plan_price": "お取り扱いしていません",
            "monthly": "月1回",
            "subscription_annual_plan": "1年プラン",
            "annual": "年1回",
            "addons": "アドオン",
            "boditrak": {
                "stance_width": "スタンス幅",
                "peak_lateral_cop_velocity": "水平方向の重心移動の最高速度<span class=\"text-lowercase\"></span>",
                "max_dvf": "最大DVF",
                "no_data": "表示できるBodiTrakデータはありません。",
                "student_no_data": "{student}には表示できるBodiTrakデータはありません。",
                "invalid_subscription": "BodiTrak課金プランへの登録がまだです。<a href=\"{subscription_link}\">さっそく登録</a>しましょう。"
            },
            "addon_boditrak": "アドオン - BodiTrak",
            "payment_source": "メインのクレジットカード",
            "payment_source_caption": "お支払い方法を設定中",
            "supported_credit_cards_jp": "お取り扱いクレジットカード：",
            "unsupported_credit_cards_jp": "その他のクレジットカードはご使用になれません。",
            "stripe_form_cc_nickname": "カードの種類",
            "stripe_form_cc_name": "カード名義人",
            "stripe_form_cc_number": "カード番号",
            "stripe_form_cc_expiry": "有効期限",
            "stripe_form_cvc": "CVCセキュリティコード",
            "stripe_form_mm": "月",
            "stripe_form_yy": "年",
            "stripe_form_confirm_cc": "クレジットカードを確認",
            "stripe_form_confirm_card": "カードを確認",
            "stripe_form_confirm_card_error": "カード確認エラー",
            "stripe_form_credit_card": "クレジットカード",
            "stripe_form_academy_card": "チームのカードですか？",
            "stripe_form_academy_card_description": "このチームの他の監督とこのカードを共有する",
            "stripe_form_cardholder_name_required": "カード所有者名フィールドは必須です",
            "master_card_about_to_expire": "メインのクレジットカードの有効期限がもうすぐ切れます。課金プランを今後もご利用いただくには、クレジットカード情報を更新してください。",
            "subscriptions_under_card": "このカードで支払い中の課金プラン",
            "valid_until": "有効期限",
            "remove_master_card_alert": "削除したカードで支払い中の有効なプランがあります。有効なプランのサービスを今後も利用するには、メインのクレジットカードを追加してください。",
            "pay_for_new_users_start": "メインのクレジットカードを追加して、新規ユーザーの支払いをする",
            "master_credit_card_desc_start": "追加すると、チームに追加する新規メンバーの支払いが",
            "master_credit_card_desc_end": "できるようになります。",
            "subscription_confirm": "確認しますか？",
            "subscription_confirm_caption": "ありがとうございます！下の青いボタンをクリックしてお知らせください",
            "subscription_subscribe": "Blast Connectに加入する",
            "academy_paid": "チームが支払い済み",
            "invalid": "無効",
            "renews": "更新",
            "plan": "プラン",
            "payment": "お支払い",
            "subscription_cancel_sorry_to_see_you_go": "これまでご利用いただきありがとうございます。",
            "subscription_cancel_we_would_love_to_know_why": "課金プランを解約する理由をお聞かせください。今後の改善に役立てさせていただきます。",
            "subscription_cancel_feedback_thanks": "フィードバックをありがとうございます。",
            "subscription_disclaimers": {
                "owners": "アカウントに追加された各アスリートは {price}（最初の月は無料）で、コーチまたはアスリートに請求できます。"
            },
            "pick_files_analyze": "分析するファイルを2個まで選択できます。",
            "pick_files_analyze_limit": "一度に2個までファイルを分析できます。",
            "streaming_video": "動画をストリーミング中",
            "dropbox": "Dropbox",
            "file_name": "ファイル名",
            "select_file": "ファイルを選択",
            "select_files": "複数ファイルを選択",
            "attach_file": "ファイルを添付",
            "500mb_max": "500MBまで",
            "max_file_size": "%sMBまで",
            "file_too_large": "ファイルサイズの上限は%sMBです",
            "unsupported_file_type": "次のファイル形式のみ対応しています： %s",
            "upload_a_file": "ファイルをアップロード",
            "uploading": "アップロード中",
            "initializing_upload": "アップロードを初期化中",
            "processing_upload": "アップロードを処理中",
            "upload_complete": "アップロード完了",
            "retry": "やり直す",
            "processing_dropped_files": "ドロップしたファイルを処理中...",
            "processing": "処理中…",
            "dropbox_coming_soon": "近日中にDropboxに対応予定です。",
            "streaming": "ストリーミング中",
            "score_entered": "スコア入力済み",
            "share_with_everyone_in": "全員と共有：",
            "you_can_optionally_rename_this_file": "省略可 - 空欄にするとファイル名が使用されます",
            "optional_desc_of_file": "省略可",
            "use_uploaded_file": "アップロードしたファイルを使用",
            "putting_driving": "例：パット、ショット",
            "please_add_your_file_first": "まずファイルを選択してください",
            "edit_file_details": "ファイル情報を編集",
            "add_or_change_file_details": "ファイル情報を追加/変更",
            "save_details": "情報を保存",
            "saving_details": "情報を保存中",
            "back_to_library": "ライブラリーに戻る",
            "action": "アクション",
            "download": "ダウンロード",
            "fullscreen": "全画面",
            "machine_vision": "M-Cast (BETA)",
            "machine_vision_result": "M-Cast Result (BETA)",
            "shared_by": "共有元：",
            "my": "",
            "shared_with": "共有相手：",
            "comments": "コメント",
            "write_a_comment": "コメントを入力...",
            "add_comment": "コメントを追加",
            "left_a_comment": "{user_name} コメントを追加しました",
            "no_comments_yet_be_the_first": "まだコメントはありません。真っ先にコメントしましょう！",
            "related": "関連",
            "drag_file_onto_page": "またはこのページにファイルをドラッグ",
            "add_to_your_library": "ライブラリーに追加",
            "you_are_viewing": "閲覧中：",
            "library_lower": "ライブラリー",
            "return_to_your_library": "ライブラリーに戻る",
            "newest_to_oldest": "新→古",
            "oldest_to_newest": "古→新",
            "library_collections": "ライブラリーコレクション",
            "collections": "コレクション",
            "tags": "タグ",
            "show": "表示",
            "uc_show": "表示",
            "hide_extra": "他を非表示",
            "more_tags": "他のタグ",
            "file_type": "ファイルタイプ",
            "videos": "動画",
            "standard_videos": "標準の動画",
            "analyzed_videos": "分析済み動画",
            "blast_metrics_videos": "計測値の動画",
            "images": "画像",
            "documents": "文章",
            "my_files": "自分のファイル",
            "academy_files": "チームのファイル",
            "shared_files": "共有ファイル",
            "premium_content": "プレミアムコンテンツ",
            "date_range": "期間",
            "sort_order": "表示順",
            "sharing": "共有中",
            "filter_library": "ライブラリーを絞り込む",
            "filters": "フィルタ",
            "more_filters": "その他フィルタ",
            "reset": "リセット",
            "apply": "更新",
            "apply_filter": "絞り込みを適用",
            "apply_filters": "絞り込みを適用",
            "hide_filters": "絞り込みを非表示",
            "show_filters": "選手を絞り込み",
            "previous": "前へ",
            "next": "次へ",
            "total_files": "合計ファイル",
            "no_results_try_expanding_filters_note": "<p>ライブラリーに表示できるアイテムがありません。</p><p>動画、画像、文章をライブラリーに追加したり、絞り込みの適用範囲を広げたりしてみましょう。</p>",
            "user_does_not_have_any_files": "{user_name} はライブラリーにファイルを追加していません。",
            "adding_library_items_is_simple_note": "ライブラリーに簡単にアイテムを追加できます。このページにドラッグするだけで完了です。追加したアイテムは共有、分析、分類されます。スキルアップのための大きな力になるはずです。",
            "view": "見る",
            "add_file_library": "ファイルを追加",
            "edit_file_library": "ファイルを編集",
            "edited_file": "編集済みファイル",
            "converting_video": "動画を編集中です。お待ちください。",
            "processing_video": {
                "headings": [
                    "もうすぐ完了！"
                ],
                "messages": [
                    "このページは、ビデオの準備ができるとすぐに更新されます。 他に何かする必要がある場合は、メール通知をオンにしてください。すべて設定され次第、通知します。"
                ],
                "labels": {
                    "notify_when_ready": "動画の準備ができたら通知する"
                }
            },
            "encoding_error": {
                "heading": "追加された動画を変換できませんでした。",
                "message": "アップロードした動画の変換処理を完了できませんでした。もう一度動画をアップロードしてください。引き続きエラーが発生する場合は、弊社お客様相談センターにお問い合わせください。"
            },
            "refresh_page": "ページを更新",
            "email_me_when_ready": "動画の準備ができたらメールで通知する",
            "view_all_metrics": "すべてのデータを見る",
            "deselect": "選択解除",
            "selected": "選択済み",
            "refresh_library": "ライブラリーを更新",
            "upload_another_file": "別のファイルをアップロード",
            "analysis_browser_no_support_title": "申し訳ありませんが、ビデオ分析ツールはお使いの Web ブラウザーでサポートされていません。 これは Chrome のみの機能です。",
            "analysis_browser_no_support_message": "ビデオ分析ツールは、以前に Google Chrome を使用して Blast ビデオを分析し、「Blast Motion - Web Analysis Extension」を削除していない場合にのみ、Google Chrome で使用できます。",
            "analysis_browser_no_support_chrome": "残念ながら、Google はカスタム Chrome アプリのサポートを終了することを決定したため、Blast Video Analysis Tool をインストールできなくなりました。 ただし、Mobile Video Analysis は、iOS の Blast Baseball、Blast Softball、および Blast Golf アプリ内で利用できます。",
            "analysis_browser_no_support_firefox": "Firefox - mozilla.org/firefox/",
            "analysis_browser_no_support_message_safari": "動画分析ツールを活用するには、Chromeを使用することをおすすめします。Chromeはhttp://www.google.com/chrome/から無料でダウンロードできます",
            "analysis_video_is_ready": "これで分析ビデオの準備が整いました。",
            "analysis_video_is_ready_title": "分析ビデオのアップロードが完了しました",
            "analysis_video_is_ready_body": "動画の処理が終了しました。 それはあなたの中で利用可能になりました <a href=\"https://{sub_domain}.{base_url}/library\"> {app_name} 図書館.</a>",
            "uploaded_file_is_ready": "アップロードしたファイルの準備ができました",
            "thanks_for_uploaded_file": "しばらくお待ちいただきますようお願いいたします。動画の準備が整い、ライブラリで利用できるようになりました。. <a href=\"https://{sub_domain}.{base_url}/library/{file_id}\">ここからファイルにアクセスできます</a>.",
            "drop_files_here": "ここにファイルをドロップ",
            "select_file_device": "デバイスからファイルを選択",
            "multiple_files_allowed": "複数ファイル可",
            "browse_files": "ファイルを選択",
            "browse_file": "ファイルを選択",
            "canceling_remove_uploads": "キャンセルすると処理中のアップロードがすべて削除されます。",
            "sure_cancel": "キャンセル",
            "go_back": "戻る",
            "view_library": "ライブラリーを見る",
            "add_another_file": "さらに追加",
            "something_prevents_video": "エラーが発生したため動画を読み込めません。",
            "uploaded_by": "アップロードしたユーザー：",
            "uploaded_by_you": "あなたがアップロードしました",
            "upload_and_analyze": "アップロードして分析",
            "team_averages": "チーム平均",
            "self_serve_registration": {
                "already_have_blast_account": "Blastアカウントをお持ちですか？",
                "already_have_blast_account_message": "Blastモバイルアプリをお持ちであれば、Blastアカウントもお持ちです。Blastアカウントのメールアドレスとパスワードでログインするだけで続行できます。",
                "do_not_have_blast_account": "Blast Connectアカウントをお持ちでない場合",
                "do_not_have_blast_account_message": "Blastモバイルアプリを使ったことがない場合は、新しくBlastアカウントを作成すると学校にアクセスできます。",
                "create_account": "アカウントを作成",
                "login_to_continue": "ログインして続行",
                "academy": {
                    "academy": "学校",
                    "owner": "統括コーチ",
                    "account_creation": "Blast Connectで使用する学校を作成",
                    "academy_information": "学校情報",
                    "academy_name": "名前",
                    "academy_logo": "ロゴ（省略可）",
                    "academy_website": "ウェブサイト",
                    "academy_phone": "電話番号",
                    "academy_address": "アドレス",
                    "academy_address_2": "住所（追加）",
                    "academy_city": "市",
                    "academy_state": "都道府県",
                    "academy_country": "国",
                    "academy_zip": "郵便番号",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "統括コーチの情報",
                    "owner_first_name": "名",
                    "owner_last_name": "姓",
                    "owner_email": "メールアドレス",
                    "owner_password": "パスワード",
                    "confirm_password": "パスワードの確認",
                    "create_account": "アカウントを作成",
                    "processing_registration": "登録を処理中",
                    "payment_source_reference": "支払い参照名",
                    "subscription_summary": "利用中のプランについて",
                    "payment_details": "支払い情報",
                    "plan_name": "Blast Connect - 1年課金プラン",
                    "plan_note": "",
                    "processing_subscription": "課金プランを処理中",
                    "payment_information": "支払い情報",
                    "shipping_address": "配送先住所",
                    "continue_message": "次のページで購入内容を確認できます。",
                    "credit_card_will_be_billed": "この購入手続きを完了後すぐに30日間のトライアルが開始します。クレジットカードへの請求は30日後です。",
                    "subtotal": "小計",
                    "tax": "税",
                    "total": "合計",
                    "credit_cart_required": "購入には支払い用のクレジットカードが必要です。",
                    "purchase_requirement_message": "続行するには、Blast Connectの課金プランの購入が必要になります。 ",
                    "subscribe_you_are_subscribed_message": "おめでとうございます！現在利用中のプラン：",
                    "subscribe_enhance_by_purchasing_message": "追加アドオンを購入してさらなる上達を：",
                    "subscribe_no_thanks_message": "購入せずログインを続行",
                    "main_subscription_title": "課金プランの支払い",
                    "cvc_code_description": "「CVC：カードの裏面にある３桁もしくは4桁の数字をご記入ください。」",
                    "shipping_country": "国",
                    "shipping_postal_code": "郵便番号",
                    "shipping_prefecture_name": "都道府県",
                    "shipping_city_village_ward": "市/郡",
                    "shipping_subarea": "区/町",
                    "shipping_subarea_number": "丁目",
                    "shipping_block_number": "番地",
                    "shipping_house_number": "建物名・部屋番号",
                    "first_run_title": "ありがとうございます！Blastプレミアムサービスの登録が完了しました！",
                    "first_run_description_coach": "Blast Connectを利用する前に、いくつか確認してください。",
                    "first_run_description_player1": "この購入手続きを完了後すぐに{days}日間のトライアルが開始します。トライアル期間終了時にクレジットカードに請求いたします。",
                    "first_run_description_player2": "Blast Connectを利用する前に、いくつか確認してください。",
                    "first_run_select_language_label": "言語設定",
                    "first_run_form_button": "Blast Connectの利用開始",
                    "first_run_mobile_apps_title": "Blast {academy_name}モバイルアプリをダウンロードして、Blastの各種機能を活用しましょう（新規ウィンドウが開きます）。",
                    "first_run_pro_team": " プロチーム",
                    "account_creation_successful": "アカウント作成が完了しました",
                    "thank_you_subscription_message": "{user_full_name}さん、課金プランにご登録いただきありがとうございます。",
                    "success_message": "学校（{academy_name}）が有効になりました。アカウントマネージャーが24時間以内にご連絡いたします。アカウントのカスタマイズなどをお手伝いいたします。",
                    "continue_to_dashboard": "続ける",
                    "complete_purchase": "購入手続きを完了"
                },
                "gca": {
                    "academy": "チーム",
                    "owner": "監督",
                    "account_creation": "Blast Connectで使用するチームを作成",
                    "academy_information": "チーム情報",
                    "academy_name": "名前",
                    "academy_logo": "ロゴ（省略可）",
                    "academy_website": "ウェブサイト",
                    "academy_phone": "電話番号",
                    "academy_address": "住所",
                    "academy_address_2": "住所（追加）",
                    "academy_city": "市",
                    "academy_state": "都道府県",
                    "academy_country": "国",
                    "academy_zip": "郵便番号",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "監督の情報",
                    "owner_first_name": "名",
                    "owner_last_name": "姓",
                    "owner_email": "メールアドレス",
                    "owner_password": "パスワード",
                    "confirm_password": "パスワードの確認",
                    "create_account": "アカウントを作成",
                    "processing_registration": "登録を処理中",
                    "payment_source_reference": "支払い参照名",
                    "payment_details": "支払い情報",
                    "plan_name": "Blast Connect - 1年課金プラン",
                    "plan_note": "",
                    "processing_subscription": "課金プランを処理中",
                    "account_creation_successful": "アカウント作成が完了しました",
                    "thank_you_subscription_message": "{user_full_name}さん、課金プランにご登録いただきありがとうございます。",
                    "success_message": "チーム（{academy_name}）が有効になりました。",
                    "continue_to_dashboard": "続ける"
                },
                "coach": {
                    "academy": "チーム",
                    "owner": "監督",
                    "account_creation": "Blast Connectで使用するチームを作成",
                    "academy_information": "チーム情報",
                    "academy_name": "名前",
                    "academy_logo": "ロゴ（省略可）",
                    "academy_website": "ウェブサイト",
                    "academy_phone": "電話番号",
                    "academy_address": "住所",
                    "academy_address_2": "住所（追加）",
                    "academy_city": "市",
                    "academy_state": "都道府県",
                    "academy_country": "国",
                    "academy_zip": "郵便番号",
                    "academy_facebook": "Facebook",
                    "academy_twitter": "Twitter",
                    "owner_information": "監督の情報",
                    "owner_first_name": "名",
                    "owner_last_name": "姓",
                    "owner_email": "メールアドレス",
                    "owner_password": "パスワード",
                    "confirm_password": "パスワードの確認",
                    "create_account": "アカウントを作成",
                    "processing_registration": "登録を処理中",
                    "payment_details": "支払い情報",
                    "plan_name": "Blast Connect - 1年課金プラン",
                    "plan_note": "",
                    "processing_subscription": "課金プランを処理中",
                    "account_creation_successful": "アカウント作成が完了しました",
                    "thank_you_subscription_message": "ありがとうございます！ {user_full_name} さん、課金プランにご登録いただきありがとうございます。",
                    "success_message": "チーム（{academy_name}）の登録が完了しました。",
                    "continue_to_dashboard": "続ける"
                },
                "email": {
                    "baseball": {
                        "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/baseball/get-started/blast-connect/get-started-overview/"
                        }
                    },
                    "softball": {
                        "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/softball/get-started/blast-connect/get-started-overview/d"
                        }
                    },
                    "golf": {
                        "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/",
                        "academy": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/"
                        },
                        "coach": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。",
                            "quick_start_video": "https://blastmotion.com/training-center/golf-putt/get-started/blast-connect/get-started-overview/"
                        }
                    },
                    "other": {
                        "academy": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。"
                        },
                        "coach": {
                            "mail_title": "Blast Connectを使ってみましょう！",
                            "mail_body": "{full_name}さん、ありがとうございます。アカウント（{academy_name}）の作成が完了しました。"
                        }
                    }
                }
            },
            "welcome_emails": {
                "title": {
                    "golf": {
                        "message": "Blast Connect Golfを使ってみましょう！",
                        "no_subscription": "Blast Connect Golfを使ってみましょう！"
                    },
                    "baseball": {
                        "message": "Blast Connect Baseballを使ってみましょう！",
                        "no_subscription": "Blast Connect Baseballを使ってみましょう！"
                    },
                    "softball": {
                        "message": "Blast Connect Softballを使ってみましょう！",
                        "no_subscription": "Blast Connect Softballを使ってみましょう！"
                    }
                },
                "intro": {
                    "heading": {
                        "golf": "<strong>Blast Golfチームソリューション</strong>のご利用に感謝します。",
                        "baseball": "<strong>Blast Baseballチームソリューション</strong>のご利用に感謝します。",
                        "softball": "<strong>Blast Softballチームソリューション</strong>のご利用に感謝します。"
                    },
                    "message": {
                        "student": "あと1ステップで、高度なデータ、クラウドベースの動画用ストレージ、詳細なレポート機能、チーム管理機能、コーチ用フィードバック機能、動画のコメント機能、スケジュール機能などをご利用いただけます。",
                        "coach": "あと1ステップで、高度なデータ、クラウドベースの動画用ストレージ、詳細なレポート機能、チーム管理機能、アプリに内蔵のコーチ用フィードバック機能、動画のコメント機能、スケジュール機能などをご利用いただけます。",
                        "owner": {
                            "generic": "あと1ステップで、さらに効率的な管理を実現させるための（分析、コーチング、コミュニケーション、管理ツール）ソフトウェアを、あなたのチームでご利用いただけます。",
                            "golf": "コーチ用アカウントを作成できました。さっそく使ってみましょう。",
                            "baseball": "コーチ用アカウントを作成できました。さっそく使ってみましょう。",
                            "softball": "コーチ用アカウントを作成できました。さっそく使ってみましょう。"
                        }
                    }
                },
                "account_info": {
                    "title": "<strong>アカウント情報：</strong>",
                    "confirm_message": "次のアカウント情報を確認してください：",
                    "academy_name": "チーム名：",
                    "name": {
                        "student": "選手の名前：",
                        "coach": "コーチの名前：",
                        "owner": "監督の名前："
                    },
                    "email": {
                        "student": "選手のメールアドレス：",
                        "coach": "コーチのメールアドレス：",
                        "owner": "監督のメールアドレス："
                    },
                    "subscription_plan_name": "プラン名：",
                    "subscription_price": "プランの料金：",
                    "subscription_start_date": "プラン開始日",
                    "verify_and_login_message": "以下のログインリンクからBlast Connectアカウントにログインしてください。ユーザー名（上記に記載）とパスワード（登録時に設定済み）の入力を求められます。\n            {login_anchor}"
                },
                "steps": {
                    "baseball": {
                        "step_1": {
                            "title": "<strong>ステップ1</strong>：チーム/チームに選手を招待します。",
                            "message": "次の動画と文章をご覧いただくと、すぐに使い始めることができます。"
                        }
                    },
                    "softball": {
                        "step_1": {
                            "title": "<strong>ステップ1</strong>：チーム/チームに選手を招待します。",
                            "message": "次の動画と文章をご覧いただくと、すぐに使い始めることができます。"
                        }
                    }
                },
                "onboarding": {
                    "softball": {
                        "title": "<strong>利用開始手順の文章：</strong>",
                        "list": {
                            "onboarding_video": {
                                "title": "利用開始手順の動画",
                                "url": "https://vimeo.com/299343554"
                            },
                            "functionality_video": {
                                "title": "Blast Softballアプリの機能",
                                "url": "https://vimeo.com/304655793"
                            },
                            "player_data_video": {
                                "title": "Blast Connectの選手データを表示中",
                                "url": "https://vimeo.com/304655839"
                            },
                            "user_guide_solution_functionality": {
                                "title": "Blastユーザーガイド（Blastの各機能）",
                                "url": "https://www.manula.com/manuals/blast-motion/get-started-blast-softball/1/en/topic/app-overviews"
                            }
                        }
                    },
                    "baseball": {
                        "title": "<strong>利用開始手順の文章：</strong>",
                        "list": {
                            "onboarding_video": {
                                "title": "利用開始手順の動画",
                                "url": "https://vimeo.com/299343491"
                            },
                            "functionality_video": {
                                "title": "Blast Baseballアプリの機能",
                                "url": "https://vimeo.com/304655793"
                            },
                            "player_data_video": {
                                "title": "Blast Connectの選手データを表示中",
                                "url": "https://vimeo.com/304655839"
                            },
                            "user_guide_solution_functionality": {
                                "title": "Blastユーザーガイド（Blastの各機能）",
                                "url": "https://www.manula.com/manuals/blast-motion/get-started-blast-baseball/1/en/topic/app-overviews"
                            }
                        }
                    }
                },
                "explore_messages": {
                    "click_to_schedule_meeting": "利用開始にあたってサポートが必要な場合は、",
                    "virtual_meeting_message": "{schedule_meeting_anchor}ここをクリックして30分間のオンラインミーティングを設定してください。（注：このミーティングにはパソコンが必要です）",
                    "video_invite_students_and_coaches_label": "動画：選手とコーチを招待する",
                    "begin_exploring_message": {
                        "student": "専用のBlast Connectダッシュボードを使って、トレーニングをレベルアップしましょう。",
                        "coach": "専用のBlast Connectダッシュボードを使って、Blast Connectポータルに選手を招待しましょう。",
                        "owner": {
                            "invite_user_highlight_text": "チームに選手やコーチを招待する",
                            "invite_user_video": "選手とコーチを招待する",
                            "generic": "チーム用Blast Connectダッシュボードを使ってチームのポータルにコーチや選手を招待し、トレーニングをレベルアップしましょう。",
                            "golf": "チームを設定する最初のステップ：{invite_user_highlight_text}次の動画でこのプロセスの手順を説明しています。?{invite_user_video_anchor}",
                            "baseball": "チームを設定する最初のステップ：{invite_user_highlight_text}次の動画でこのプロセスの手順を説明しています。?{invite_user_video_anchor}",
                            "softball": "チームを設定する最初のステップ：{invite_user_highlight_text}次の動画でこのプロセスの手順を説明しています。?{invite_user_video_anchor}"
                        }
                    },
                    "blast_sensor_synced_message": {
                        "student": "Blastセンサーをお持ちであれば、データは自動的にBlast Connectアカウントに同期されるので、確認や詳しい分析、コーチからのフィードバックなどもチェックできます。",
                        "coach": "Blastを持っている/購入した選手のデータがBlast Connectアカウントに同期され、詳しく分析できるようになります。",
                        "owner": {
                            "generic": "Blastを持っている/購入した選手のデータがBlast Connectアカウントに同期され、詳しく分析できるようになります。",
                            "golf": "選手をポータルに招待して選手が招待を承諾したら、Blastセンサーのデータと動画へのアクセスをリクエストしてください。分析後の詳しいフィードバックを提供するために必要です。",
                            "baseball": "選手をポータルに招待して選手が招待を承諾したら、Blastセンサーのデータと動画へのアクセスをリクエストしてください。分析後の詳しいフィードバックを提供するために必要です。",
                            "softball": "選手をポータルに招待して選手が招待を承諾したら、Blastセンサーのデータと動画へのアクセスをリクエストしてください。分析後の詳しいフィードバックを提供するために必要です。"
                        }
                    }
                },
                "support_info": {
                    "quick_start_video": "Blast Connect - クイックスタート動画",
                    "help_page": "Blast Connectヘルプページ",
                    "need_help_message": "お困りですか？ {quick_start_video_anchor}または{help_page_anchor}をご覧いただき、Blast Connectをご活用ください。",
                    "need_support_message": "技術的なサポートが必要なときは？ 弊社お客様相談センターにお問い合わせください。",
                    "for_additional_info": {
                        "generic": "BlastおよびBlast Connect、ドリルなどの<strong>詳しい情報</strong>は、トレーニングセンター（{blast_motion_anchor}）をご覧ください。{training_center_anchor}",
                        "golf": "Blast GolfおよびBlast Golf Premium、プロのアドバイス、ドリルなどの<strong>詳しい情報</strong>は、トレーニングセンター をご覧ください。{training_center_anchor}",
                        "baseball": "Blast BaseballおよびBlast Connect、ドリルなどの<strong>詳しい情報</strong>は、トレーニングセンター（{blast_motion_anchor}）をご覧ください。{training_center_anchor}",
                        "softball": "Blast Softball およびBlast Connect、ドリルなどの<strong>詳しい情報</strong>は、トレーニングセンター（{blast_motion_anchor}）をご覧ください。{training_center_anchor}"
                    },
                    "feel_free_to_contact": "ご不明な点がありましたら<strong><a target=\"_blank\" href=\"https://www.mizuno.co.jp/customer/\">弊社お客様相談センター</a></strong>からお問い合わせください。",
                    "generic": "ご不明な点がありましたら<strong><a target=\"_blank\" href=\"https://www.mizuno.co.jp/customer/\">弊社お客様相談センター</a></strong>からお問い合わせください。"
                },
                "signature": {
                    "message": "Blast Connectにご登録いただき誠にありがとうございます。",
                    "footer": "<br>Blastカスタマーサポートチーム",
                    "generic": "<br>Blastカスタマーサポートチーム"
                },
                "sign_in_link": {
                    "title": "<strong>ログインはこちら</strong>",
                    "url": "https://{sub_domain}.{root_domain}"
                }
            },
            "invitation_emails": {
                "title": {
                    "message": {
                        "complimentary": "{invited_by_user_name}から無料メンバーシップ - ようこそ {academy_name} ",
                        "payment_required": "つながりましょう - {invited_by_user_name}さんからの招待：?{academy_name}",
                        "subscription_off": "{invited_by_user_name}さんがあなたのBlast Connect{academy_name}アカウントを作成しました！"
                    }
                },
                "intro": {
                    "message": {
                        "complimentary": {
                            "student": "{blast_connect_feature_name}の{academy_name}に参加するための無料メンバーシップが届いています。上達のための分析、コーチング、コミュニケーション、管理ツールがそろったソフトウェアをご利用いただけます。また、コーチとつながると、いつどこにいても、コーチが練習セッションをチェック、ワークアウトを割り当て、データを分析し、リモートコーチングでアドバイスしてくれます。",
                            "coach": "{blast_connect_feature_name}の{academy_name}に参加するための無料メンバーシップが届いています。コーチング、コミュニケーション、管理ツールがそろったソフトウェアを利用できます。動画分析、音声吹き込み、編集機能で選手にフィードバックを提供できるようになります。また、いつどこにいても、選手の練習セッションをチェック、ワークアウトを割り当て、データを分析してアドバイスできます。",
                            "owner": "{blast_connect_feature_name}の{academy_name}に参加するための無料メンバーシップが届いています。コーチング、コミュニケーション、管理ツールがそろったソフトウェアを利用できます。動画分析、音声の吹き込み、編集機能で選手にフィードバックを提供できるようになります。また、いつどこにいても、選手の練習セッションをチェック、ワークアウトを割り当て、データを分析してアドバイスできます。"
                        },
                        "payment_required": {
                            "great_news_message": "Blastアカウントの作成が完了しました！",
                            "invited_by_message": "{invited_by_user_name} からチームに招待されています。"
                        },
                        "subscription_off": {
                            "message": "アカウントにアクセスするには、リンクをクリックして、指定されたメールアドレスとパスワードでログインしてください。"
                        }
                    }
                },
                "account_info": {
                    "accountEmail": "アカウントのメールアドレス：",
                    "accountPassword": "アカウントのパスワード：",
                    "ssoPasswordMessage": "既存のパスワードを使用してください",
                    "ssoPasswordResetMessage": "パスワードを忘れた場合は、{forgot_password_anchor}。",
                    "ssoPasswordResetText": "再設定できます",
                    "accountActivation": "アカウントを有効にする："
                },
                "payment_info": {
                    "heading": "Blast Connect課金プラン - {role_name} プラン＆お支払い",
                    "message": "次のリンクからお支払い情報（{payment_option_text}）を入力し、登録手続きを完了してください。"
                },
                "invite_info": {
                    "accountEmail": "アカウントのメールアドレス：",
                    "accountPassword": "アカウントのパスワード：",
                    "accountActivation": "アカウントを有効にする：",
                    "message": {
                        "student": "この招待を承諾して{academy_name}に参加すると、上達のための分析、コーチング、コミュニケーション、管理ツールがそろったソフトウェアを利用できるようになります。また、いつどこにいても、{coach_name}コーチが練習セッションをチェック、ワークアウトを割り当て、データを分析し、リモートコーチングでアドバイスできるようになります。",
                        "coach": "この招待を承諾して{academy_name}に参加すると、分析、コーチング、コミュニケーション、管理ツールがそろったソフトウェアを利用できるようになります。動画分析、音声の吹き込み、編集機能で選手にフィードバックを提供できるようになります。また、いつどこにいても、選手の練習セッションをチェック、ワークアウトを割り当て、データを分析してアドバイスできます。",
                        "owner": "この招待を承諾して{academy_name}に参加すると、分析、コーチング、コミュニケーション、管理ツールがそろったソフトウェアを利用できるようになります。動画分析、音声の吹き込み、編集機能で選手にフィードバックを提供できるようになります。また、いつどこにいても、選手の練習セッションをチェック、ワークアウトを割り当て、データを分析してアドバイスできます。"
                    }
                },
                "support_info": {
                    "message": "ご質問や技術的なサポートに関するお問い合わせは、弊社お客様相談センターまでご連絡下さい。"
                },
                "signature": {
                    "message": "-- Blast Motionチーム"
                }
            },
            "sign_up_title": "Blast Connectに登録",
            "choose_your_sport": "競技を選択",
            "sign_up_subtitle": "スキルアップする詳しい情報とツールの数々。",
            "choose_focus": "どこに重点を置くか選択",
            "account_type": "アカウントタイプ",
            "golf_athlete_description": "アドバイスとツールを活用してレベルアップを目指しましょう。",
            "golf_coach_description": "コーチング、分析、コミュニケーションツールで選手のスキルアップ。",
            "golf_academy_description": "選手のスキルアップだけでなく、ビジネス拡大も実現します。",
            "softball_athlete_description": "アドバイスとツールを活用して強打者を目指しましょう。",
            "softball_coach_description": "コーチング、分析、コミュニケーションツールで選手のスキルアップ。",
            "softball_academy_description": "選手のスキルアップだけでなく、チーム管理も実現します。",
            "baseball_athlete_description": "アドバイスとツールを活用して強打者を目指しましょう。",
            "baseball_player_description": "コーチと選手、両方のパフォーマンスを確認できます。<b>選手</b>と<b>保護者</b>はこちらを選択してください。",
            "softball_player_description": "コーチと選手、両方のパフォーマンスを確認できます。<b>選手</b>と<b>保護者</b>はこちらを選択してください。",
            "golf_player_description": "コーチと選手、両方のパフォーマンスを追跡できます。<b>選手</b>と<b>保護者</b>はこちらを選択してください。",
            "player_trial_period": "30日間無料トライアル",
            "footer_text": "Blast Motion. All rights reserved.",
            "footer_text_with_year": "©{year} Blast Motion",
            "all_right_reserved": "All rights reserved.",
            "great_news": "お待たせしました！",
            "your_team_report_is_ready_now": "チームレポートが完成しました",
            "here_is_a_link_to_download_the_report": "レポートのダウンロードリンク：",
            "this_report_will_be_available_for_download_for_the_next_24_hours_if_you_do_not_download_the_report_before_then": "24時間以内にレポートをダウンロードしてください。24時間以内にダウンロードできなかった場合は、再度レポートを作成してください。",
            "our_customer_support_team_is_here_for_you_with_any_questions_you_might_have": "ご不明な点がありましたら、カスタマーサポートにお問い合わせください。",
            "your_blast_connect_account_has_been_removed_from_academy": "{academy}からBlast Connectアカウントが削除されました",
            "player_description": "コーチと選手、両方のパフォーマンスを追跡できます。<b>選手</b>と<b>保護者</b>はこちらを選択してください。",
            "coach_description_self_serve": "チームや選手のパフォーマンスを追跡、管理しましょう。<b>コーチ</b>と<b>学校のオーナー</b>はこちらを選択して、アカウントに選手を追加してください。",
            "coach_trial_period": "各選手にBlast Connect課金プランへの登録が必要です。<br>",
            "baseball_player_trial_period": "30日間無料トライアル",
            "softball_player_trial_period": "30日間無料トライアル",
            "golf_player_trial_period": "30日間無料トライアル",
            "baseball_coach_description": "コーチング、分析、コミュニケーションツールで選手のスキルアップ。",
            "baseball_coach_description_self_serve": "チームや選手のパフォーマンスを確認、管理しましょう。\n    <b>コーチ</b>と<b>チームの監督</b>はこちらを選択して、アカウントに選手を追加してください。",
            "softball_coach_description_self_serve": "チームや選手のパフォーマンスを確認、管理しましょう。\n    <b>コーチ</b>と<b>チームの監督</b>はこちらを選択して、アカウントに選手を追加してください。",
            "golf_coach_description_self_serve": "チームや選手のパフォーマンスを追跡、管理しましょう。\n    <b>コーチ</b>と<b>チームの監督</b>はこちらを選択して、アカウントに選手を追加してください。",
            "baseball_academy_description": "選手のスキルアップだけでなく、チーム管理も実現します。",
            "baseball_coach_pricing": "<span><span>12,500円（税別）/年</span>",
            "baseball_coach_trial_period": "選手は各自有効なBlast Connect課金プランが必要です",
            "softball_coach_pricing": "<span><span>12,500円（税別）/年</span>",
            "softball_coach_trial_period": "選手は各自有効なBlast Connect課金プランが必要です",
            "golf_coach_pricing": "<span><span>$100.00/年</span>",
            "golf_coach_trial_period": "選手は各自有効なBlast Connect課金プランが必要です",
            "discounted_package": "お得なチームパッケージをご利用いただけます。",
            "request_a_quote": "見積を依頼",
            "registration_popup": {
                "us": {
                    "baseball": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "短期間で選手のスキルアップ！",
                            "items": {
                                "list_1": "チーム、ロースター、複数の選手を管理",
                                "list_2": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_3": "チームと選手に関するレポート",
                                "list_4": "ワークアウト＆練習",
                                "list_5": "共有できる動画分析",
                                "list_6": "共有できるメディアライブラリー"
                            }
                        }
                    },
                    "softball": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "短期間で選手のスキルアップ！",
                            "items": {
                                "list_1": "チーム、ロースター、複数の選手を管理",
                                "list_2": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_3": "チームと選手に関するレポート",
                                "list_4": "ワークアウト＆練習",
                                "list_5": "共有できる動画分析",
                                "list_6": "共有できるメディアライブラリー"
                            }
                        }
                    },
                    "golf": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "複数チームや選手グループを管理：",
                            "items": {
                                "list_1": "複数の選手とコーチを追加",
                                "list_2": "選手のレポート",
                                "list_3": "評価",
                                "list_4": "ラウンドの追跡データ",
                                "list_5": "練習＆ドリル",
                                "list_6": "共有できる動画分析",
                                "list_7": "共有できるメディアライブラリー"
                            }
                        }
                    }
                },
                "jp": {
                    "baseball": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "短期間で選手のスキルアップ！",
                            "items": {
                                "list_1": "チーム、ロースター、複数の選手を管理",
                                "list_2": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_3": "チームと選手に関するレポート",
                                "list_4": "共有できる動画分析",
                                "list_5": "共有できるメディアライブラリー"
                            }
                        }
                    },
                    "softball": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "短期間で選手のスキルアップ！",
                            "items": {
                                "list_1": "チーム、ロースター、複数の選手を管理",
                                "list_2": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_3": "チームと選手に関するレポート",
                                "list_4": "ワークアウト＆練習",
                                "list_5": "共有できる動画分析",
                                "list_6": "共有できるメディアライブラリー"
                            }
                        }
                    },
                    "golf": {
                        "player": {
                            "title": "個人のパフォーマンスを追跡できます。",
                            "items": {
                                "list_1": "自動スイング評価 - パフォーマンス履歴、スイングのアドバイス、おすすめのドリル",
                                "list_2": "選手公開プロフィール",
                                "list_3": "動画分析",
                                "list_4": "メディアライブラリー"
                            }
                        },
                        "non-player": {
                            "title": "複数チームや選手グループを管理：",
                            "items": {
                                "list_1": "複数の選手とコーチを追加",
                                "list_2": "選手のレポート",
                                "list_3": "評価",
                                "list_4": "ラウンドの追跡データ",
                                "list_5": "練習＆ドリル",
                                "list_6": "共有できる動画分析",
                                "list_7": "共有できるメディアライブラリー"
                            }
                        }
                    }
                }
            },
            "welcome_to_blast": "Blastにようこそ",
            "lets_setup_your_blast_account": "Blastアカウントを設定してBlast Connectを利用しましょう",
            "setup_blast_connect": "Blast Connectを設定",
            "already_using_blast_app": "Blastモバイルアプリをお使いですか？",
            "if_has_blast_app_login_to_continue": "既にBlastモバイルアプリをお使いの場合は、ログインしてください。Blast Connectにスムーズに登録できます。",
            "email_address": "メールアドレス",
            "dont_have_blast_app": "Blastモバイルアプリをお持ちでない場合",
            "have_mobile_app": "Blastモバイルアプリをお持ちですか？",
            "have_mobile_app_yes": "Blastモバイルアプリを使っている",
            "have_mobile_app_yes_desc": "Blastモバイルアプリを既にお使いの場合は、Blastもお持ちです。アプリと同じメールアドレスとパスワードでログインしてください。Blast Connectにスムーズに登録できます。",
            "have_mobile_app_no": "Blastモバイルアプリを持っていない",
            "have_mobile_app_no_desc": "まだBlastモバイルアプリをお持ちでない場合、Blastアカウントもお持ちでないと思われます。Blastアカウントを設定してBlast Connectに登録しましょう",
            "setup_blast_account": "新しいBlastアカウントを設定",
            "register_blast_connect": "Blast Connectに登録",
            "coach_signup": "コーチとして登録して、ご自分のチームを作成しますか？",
            "player_signup": "選手として登録しますか？",
            "already_have_mobile_app": "既にBlastアカウントをお持ちのようです",
            "log_in_app_pw": "Blastアカウントのパスワードでログインしてください。Blast Connectにスムーズに登録できます。",
            "please_login_with_blast_account": "Blastモバイルアカウントにログイン",
            "already_have_blast_mobile_account": "メールアドレスがBlastモバイルアカウントに登録済みのようです。{please_login_with_blast_account}するとBlast Connectアカウントを設定できます。",
            "invalid_blast_mobile_account_potential": "そのメールアドレスとパスワードで登録されたBlastアカウントが見つかりませんでした。入力した内容に間違いがないか確認してください。",
            "not_able_to_retrieve_blast_account": "Blastアカウント情報を取得できません。弊社お客様相談センターにご連絡ください。",
            "login_with_password_in_email": "ログインして続行",
            "password_from_invite_email": "Blastアカウントのパスワードは招待メールに記載されています。",
            "account_created_housekeeping": "準備ができるまで少々お待ちください。",
            "your_blast_account_ready": "Blastアカウントの準備ができました！",
            "download_the_app": "Blastアプリをダウンロード",
            "download_the_blast": "Blastモバイルアプリをダウンロードして、",
            "mobile_app_and": "Blastをご活用ください。",
            "no_thanks_dashboard": "Blast Connectにアクセスする",
            "pro": "プロ",
            "pro_team": "プロチーム",
            "please_check_all_subscription_information": "課金プラン情報をすべて確認してください。",
            "your_blast_connect_account_has_been_successfully_created_thank_you_for_subscribing": "Blast Connectアカウントの作成が完了しました！課金プランにお申し込みいただきありがとうございます。",
            "register_invalid_invitation": "無効な招待です。組織・チームの代表者にお問い合わせください。",
            "account_exists_on_register": "そのメールアドレスはBlast Connectアカウントに登録済みです。Blast Connectでログインしてください。",
            "account_register_provided_form_is_invalid": "フォーム情報が無効です。",
            "membership_receipt": {
                "subject": "{invitee_name} が{academy}に参加しました",
                "intro": "{owner_name}、{invitee_name}が招待を承諾し、アカウントを作成して{academy}に参加しました。次のクレジットカードにこのメンバーのプラン利用料金が請求されます。",
                "link_view_members": "<a href=\"{url}\">チームのメンバー</a>を見る",
                "subscription": "課金プラン",
                "interval": "期間",
                "amount": "金額",
                "card": "カード",
                "total": "合計",
                "paid": "支払い済み"
            },
            "add_follower": "フォロワーを追加",
            "invite": "招待",
            "invite_members": "メンバーを招待",
            "invite_another_member": "別のメンバーを招待",
            "new_members_invite_email": "新しいメンバーにはメールで招待が届きます。新メンバーはメールに記載されたリンクをクリックして、チームにアカウントを作成する必要があります。",
            "new_members_pro_create": "Blast Connectに新メンバーを追加。新しいメンバーにはメールで招待が届きます。新メンバーはメールに記載されたリンクをクリックして、アカウントを作成する必要があります。",
            "followers_are_already_part_of": "フォロワーとは、すでに",
            "want_to_follow_your_progress": "に参加している、あなたの上達をフォローする人です。フォロワーはあなたにメッセージを送信したり、あなたのデータ、ライブラリー、上達を確認できます。",
            "invite_students": "選手を招待",
            "invite_student_s": "選手を招待",
            "send_invitation": "招待を送信",
            "enter_students_name_email_send_invite": "選手のメールアドレスを入力して、{academy}への招待を送信します。",
            "invite_friends": "友だちを招待",
            "are_your_friends_golfers_invite_them_to": "ゴルフをしている友だちや、上達を見てほしい友だちがいますか？招待して参加してもらいましょう",
            "seven_days_to_join_free": "7日間無料で参加でき、今すぐアクセス可能です！<br><small><em>ヒント：複数のユーザーを招待するときは、メールアドレスをカンマで区切ってください（&ldquo;,&rdquo;）。</em></small>",
            "send_invite_s": "招待を送信",
            "manage_members": "メンバーを管理",
            "team_management": "チーム管理",
            "following": "フォロー中",
            "these_players_show_in_your_timeline": "これらの選手はタイムラインに表示されるので、プロフィールを確認したり、アカウントをフォローしたりできます。",
            "followers": "フォロワー",
            "followers_can_view_your_profile": "フォロワーはあなたのプロフィールを確認したり、アカウントをフォローしたりできます。",
            "you_give_players_permission_to_follow_above": "",
            "groups": "グループ",
            "create_group": "グループを作成",
            "add_group": "グループを追加",
            "no_groups_start_one": "グループが設定されていません。さっそく設定しましょう。",
            "members_message": "メッセージを送信：",
            "members_twitter": "のTwitter",
            "members_facebook": "のFacebook",
            "social_share": "SNS共有",
            "social_share_notice_coach": "上のリンクで招待された選手は、Blast Connectの課金プラン購入を求められます。選手のアカウントの料金を支払う場合は、「メール」オプションを選択してください。",
            "social_share_notice": "上のリンクで招待された選手は、Blast Connectの課金プラン購入を求められます。選手のアカウントの料金を支払う場合は、「メール」または「一括アップロード」オプションを選択してください。",
            "bulk_upload": "一括アップロード",
            "user_information": "ユーザー情報",
            "account_payment": "アカウントのお支払い",
            "coach_assignment": "コーチの割り当て",
            "whos_paying": "支払いを行うユーザー",
            "select_card": "カードを選択",
            "payer_will_not_be_charged": "選手が招待を承諾してアカウントを作成するまで請求は発生しません。",
            "member_will_pay": "メンバーが各自支払います",
            "member_paid_subscription": "メンバーがプラン料金を支払います",
            "owner_paid_subscription": "監督がプラン料金を支払います",
            "disable_password_reset": "パスワードのリセットを無効にする",
            "all_emails_must_be_unique": "メールアドレスは各自異なるものを使ってください。",
            "email_must_be_unique": "メールアドレスは共用しないでください。",
            "sensor_name": "センサー名",
            "sensor_serial_number": "センサーのシリアル番号",
            "sensor_location": "センサーの位置",
            "equipment_name": "バットの名前",
            "equipment_weight": "バットの重さ",
            "equipment_length": "バットの長さ",
            "mlb_bam_id": "MLB BAM ID",
            "embedded": "埋め込み済み",
            "attached": "取り付け済み",
            "not_specified": "指定なし",
            "invites_sent_message_new": "次の新しいメンバーが招待されました",
            "invites_sent_message_exist": "次のメンバーは既に選手として登録済みです。",
            "invites_sent_message_coach": "<i class=\"far fa-check\"></i>招待の送信先：",
            "invites_sent_message_academy": "<i class=\"far fa-exclamation\"></i>次のメールアドレスは既に別のチームに登録されています。あなたのチームに追加することはできません",
            "invites_sent_message_gca": "次のユーザーをチームに招待しました",
            "invites_error_self_invite": "既にメンバーになっているため、自分自身を招待することはできません。",
            "delete_user_multi_academy_message": "このユーザーは複数のチームに所属しています。 ",
            "email_in_use": "このメールアドレスは既に使用中です。",
            "subscription_plan": "課金プラン",
            "member_pay_desc": "このオプションを選択すると、メンバーはチームにアクセスするのにBlast Connect課金プランの購入が必要になります。",
            "global_payment_reminder": "全体の支払い用カードを設定するときは、各メンバーに課金プランを割り当ててください。",
            "disabled_add_new_user_btn_text": "このページでユーザーを招待すると、使用可能なライセンスシートがなくなったため、現時点でユーザーを追加することはできません。",
            "bulk_upload_spreadsheet_seats_error": "十分なライセンスシートが利用できないため、アップロードされたスプレッドシートの新しいアカウントは現時点では作成できません。 スプレッドシートから余分なユーザーを削除して、アップロードを再試行できます。 追加の座席を購入する必要がある場合は、見積もりについてBlastMotionの担当者にお問い合わせください。",
            "has_not_available_seats_error": "利用可能なライセンスシートがなくなったため、現時点では新しいアカウントを作成できません。 追加の座席を購入する必要がある場合は、見積もりについてBlastMotionの担当者にお問い合わせください。",
            "quick_create_seats_error": "利用可能なライセンスシートがなくなったため、現時点ではこのアカウントを作成できません。 追加の座席を購入する必要がある場合は、見積もりについてBlastMotionの担当者にお問い合わせください。",
            "account_settings_non_admin": "アカウントとプランの設定",
            "account_settings": "アカウント設定",
            "my_account": "アカウント設定",
            "msg_name_blast_connect": "Blast ConnectとBlast Connectで作成されるメッセージに表示したい自分の名前です。",
            "msg_email_blast_connect": "Blast Connectにログインするときに使用するメールアドレスです。",
            "msg_email_sso": "Blastアカウントにログインするときに使用するメールアドレスです。",
            "strokes_gained": "ストロークゲインド",
            "strokes_gained_total": "ストロークゲインド合計",
            "strokes_gained_putting": "ストロークゲインドパット",
            "monthly_reports": "月間レポート",
            "no_monthly_reports_yet_for": "月間レポートはまだありません",
            "uc_media": "メディア",
            "see": "見る",
            "full_library": "全ライブラリー",
            "hasnt_added_files_to_library": "はライブラリーにまだファイルを追加していません。",
            "statistics": "統計",
            "player_average": "選手平均",
            "stats_graph_description": "<p>下のグラフには選手のゴルフゲームの総合評価（PGAツアーの平均ストロークゲインドと比較）が表示されます。ストロークゲインドは、PGAツアーと比較した選手の総合評価です。算出方法は次のとおりです。たとえば、10ｍからワンパットでホールアウトしたとします。この距離からのホールアウトのツアー平均は2.0パットなので、そのフィールドでのストロークゲインドは1になります。</p><p>中央の赤い丸印が1～2ｍ、2～6ｍ、6m以上のパッティング、バンカープレー、0～20ヤード、20～60ヤード、60～100ヤードのショートゲームプレー、100～150ヤード、150～200ヤード、他ロングショットのボールストライキングデータのPGAツアー平均です。</p><p>ツアーと比較した長所や短所がわかります。PGAツアーのデータにできるだけ近付けることを目標にしましょう。</p>",
            "want_to_see_more_statistics": "他のデータも見ますか？",
            "uc_shows": "表示",
            "advanced_stats": "詳細なデータ",
            "repsonse_to_monthly_reports": "月間レポートへの回答",
            "canceled": "キャンセル済み",
            "balls": "ボール",
            "time": "時刻",
            "club": "クラブ",
            "distance": "飛距離",
            "comment": "コメント",
            "uc_score": "スコア",
            "no_practices_recorded_start_today": "まだ練習が記録されていません。上達に向けてスタート！",
            "equipment": "バット",
            "sets": "セット",
            "reps": "繰り返し回数",
            "weight": "重量",
            "tempo": "テンポ",
            "rest": "休憩",
            "no_workouts_recorded_start_today": "まだワークアウトが記録されていません。上達に向けてスタート！",
            "workout_log": "ワークアウトの記録",
            "practice_log": "練習の記録",
            "update_workout_log": "ワークアウトの記録に追加",
            "update_practice_log": "練習の記録に追加",
            "remove_from_log": "記録から削除",
            "your_avatar": "プロフィール写真",
            "swing_coach": "スイングコーチ",
            "golf_instructor": "ゴルフインストラクター",
            "golf_instructors": "ゴルフインストラクター",
            "overview": "概要",
            "goals": "目標",
            "jobtitle": "タイトル",
            "goal": "目標",
            "security": "セキュリティ",
            "tip_square_images_look_best": "アドバイス：正方形の画像を推奨",
            "personal_info": "個人情報",
            "phone": "電話番号",
            "mobile": "携帯電話",
            "office": "職場",
            "facebook": "Facebook",
            "twitter": "Twitter",
            "instagram": "Instagram",
            "timezone": "タイムゾーン",
            "address": "アドレス",
            "swings": "スイング",
            "throws": "投球",
            "edit_vitals": "身体データを編集",
            "custom_stats": "カスタムデータ",
            "athletic": "体力・運動能力",
            "add_another_stat": "別のデータを追加",
            "key_statistics": "主なデータ",
            "statisitic_name": "データ名",
            "statisitic_value": "データの値",
            "avg_driving_distance": "平均ドライバー飛距離",
            "eligibility_center": "資格審査会",
            "for_more_info": "で詳細を確認してください。",
            "tournament_name": "トーナメント＆イベントの名前",
            "tournament_location": "トーナメント＆イベントの場所",
            "start_date": "開始日",
            "end_date": "終了日",
            "field_size": "フィールドの大きさ",
            "yardage_and_par": "ヤード&amp;パー",
            "fourth": "第4",
            "did_you_play_in_more_tournaments": "他のトーナメントでもプレーしましたか？",
            "add_another_tournament": "トーナメントを追加",
            "profile_public": "プロフィールを公開する",
            "services_provided": "提供中のサービス",
            "accepting_new_students": "新しい選手を受け入れ中",
            "personal_stats": "個人データ",
            "athletic_stats": "競技データ",
            "edit_bio": "プロフィールを編集",
            "bio": "プロフィール",
            "describe_your_bio": "経歴と目標を詳しく記入しましょう",
            "edit_goals": "目標を編集",
            "describe_your_goals": "目標を説明してください",
            "if_left_blank": "空欄のままにしておくと、公開プロフィールには表示されません。",
            "education_experience": "学歴＆経験",
            "edit_education_experience": "学歴＆経験を編集",
            "dates": "日付",
            "dates_ie": "例：2016年～現在",
            "name_of_institution": "チーム名",
            "education_ie": "例：経験、実績、役割",
            "teams": "チーム",
            "add_team": "チームを追加",
            "team_members": "チームメンバー",
            "edit_your_team": "チームを編集",
            "add_team_member": "チームメンバーを追加",
            "edit_team_member": "チームメンバーを編集",
            "edit_your_teams_info": "チーム情報を編集",
            "title_ie": "例：コーチ、監督、保護者",
            "current_team": "現在のチームは？",
            "team_name": "チーム名",
            "team_details_ie": "例：ポジション、主な実績",
            "highlight_reel": "お気に入り動画",
            "highlights": "お気に入り",
            "add_highlight_reel": "お気に入り動画に追加",
            "add_highlight_videos": "お気に入り動画を追加",
            "customize_highlight_reel": "お気に入りト動画をカスタマイズ",
            "reorder_highlight_reel": "動画を追加、並べ替え、削除します。",
            "add_up_to_10": "10個まで追加できます。",
            "choose_up_to_images": "画像や動画を10個まで選択できます。",
            "are_you_sure_remove_highlight": "お気に入り動画からこのファイルを削除してもよろしいですか？",
            "yes_remove": "削除する",
            "verify_metrics": "これらのデータを確認",
            "verified_by": "確認者：",
            "customize_avg_swing_metrics": "平均スイングデータをカスタマイズ",
            "customize_best_swing_metrics": "ベストスイングデータをカスタマイズ",
            "select_metrics_to_show": "表示するデータを選択",
            "edit_stats": "データを編集",
            "add_education_experience": "学歴と経験を追加",
            "edit_school_info": "チーム情報を編集",
            "add_school": "チームを追加",
            "school_name": "チーム名",
            "advanced_placement": "上級クラス",
            "additional_information": "追加情報",
            "edu_additional": "オフィス、クラブ、上級クラスなどの詳細を追加",
            "gpa": "GPA",
            "sat": "SAT",
            "act": "ACT",
            "add_tournament": "トーナメントを追加",
            "edit_tournament_results": "トーナメント結果を編集",
            "tournament_dates": "トーナメント＆イベントの日付",
            "tournament_location_ie": "市の名前だけでOK",
            "yardage": "ヤード＆パー",
            "showcases": "アピールポイント",
            "add_showcase": "アピールポイントを追加",
            "customize_showcase": "アピールポイントをカスタマイズ",
            "showcase_name": "アピールポイント名",
            "showcase_city_state": "都道府県/市町村",
            "showcase_metrics": "アピールポイントのデータ",
            "share_profile": "プロフィールを共有",
            "public_profile": "公開プロフィール",
            "profile_located_at": "プロフィールの表示場所：",
            "ncaa_clearing_house": "NCAA クリアリングハウス",
            "caps_key_stats": "主なデータ",
            "key_stats": "主なデータ",
            "caps_tournament_results": "トーナメント結果",
            "tournament_results": "トーナメント結果",
            "the_open": "オープン",
            "caps_score": "スコア",
            "caps_finish": "終了",
            "finish": "終了",
            "caps_field": "フィールド",
            "caps_yardage_par": "ヤード/パー",
            "caps_upcoming_tournaments": "今後のトーナメント",
            "upcoming_tournaments": "今後のトーナメント",
            "caps_awards": "受賞歴",
            "caps_education": "学歴",
            "education": "学歴",
            "derek_allard_award": "受賞した賞の名前",
            "honors": "表彰歴",
            "honors_classes": "上級クラス",
            "advanced": "詳細",
            "placement": "クラス分け",
            "offices_held": "オフィス",
            "awards": "受賞歴",
            "caps_extra_curriculars": "その他カリキュラム",
            "extra_curriculars": "その他カリキュラム",
            "caps_other_information": "その他の情報",
            "my_team": "チーム",
            "golf_instructor_s": "ゴルフインストラクター",
            "references": "保証人",
            "reference": "保証人",
            "parent_info": "保護者情報",
            "graduated": "卒業",
            "learn_more_blast": "Blastについて：",
            "blastmotion_com": "blastmotion.com",
            "profile_fields_optional": "すべて任意項目です。空欄のままにすると、公開プロフィールにこのセクションが表示されません。",
            "profile_fields_required": "<sup class=\"text-danger\">*</sup>必須項目",
            "contact_information": "連絡先情報",
            "parent_information": "保護者情報",
            "parent_guardian": "保護者",
            "add_parent_guardian": "保護者を追加",
            "display_parent_profile": "プロフィールに保護者情報を表示しますか？",
            "display_contact_profile": "プロフィールに連絡先情報を表示しますか？",
            "settings_payment_source": "メインのクレジットカード",
            "payment_source_not_available": "アカウントがメインのクレジットカードと紐付けられていません。お支払い情報を更新してください。",
            "setting_add_payment_source": "メインのクレジットカードを追加",
            "settings_blast_account": "Blastアカウント",
            "settings_unlink_blast_account": "Blastアカウントのリンクを解除",
            "settings_unlink": "リンクを解除",
            "settings_unlink_warning": "Blast Motionアカウントのリンクを解除すると、保存済みデータがすべて消去されます。この操作は取り消せませんが、いつでも再接続できます。",
            "settings_unlink_reconnect_message": "Blast Motionアカウントの接続を解除しました。アカウントを<a href=\"{reconnect_url}\">再接続</a>してください。",
            "blast_mobile_app_sensor": "Blast Mobileアプリとセンサー",
            "settings_connect_msg_1": "BlastモバイルアプリとセンサーがBlast Connectに接続されていません。先に進んで",
            "settings_connect_msg_2": "今すぐ接続",
            "settings_save_updates": "プロフィールの更新内容を保存",
            "are_you_playing_in_upcoming_tournament": "他にも今後プレー予定のトーナメントがありますか？",
            "add_another_upcoming_tournament": "今後のトーナメントを追加",
            "fulltime_resi_student_years": "常時寄宿選手－年数",
            "school_info": "チーム情報",
            "graduation_year": "卒業予定年度",
            "high_school_name": "高校名",
            "offices_you_hold": "運営オフィス",
            "student_council_treasurer": "選手会会計担当",
            "eng_math_sci": "英語、数学、科学",
            "adv_placement_classes": "上級クラス",
            "special_awards": "特別賞",
            "community_spirit_award": "コミュニティスピリット賞",
            "did_you_attend_second_highschool": "別の高校にも通学しましたか？それも入力してください。",
            "show_highschool2_details": "選手の高校2の情報",
            "parent1_info": "保護者1の情報",
            "parent2_info": "保護者2の情報",
            "attachments": "添付ファイル",
            "choose_items_for_personal_library": "個人用ライブラリーからアイテムを選択して履歴書に表示できます。動画はウェブ版では再生できますが、ダウンロード可能なPDFファイルには表示されません。",
            "no_media_visible_add_some": "チームに表示されているメディアは選択できません。追加できます",
            "to": "終了日",
            "from": "開始日",
            "province_state": "都道府県",
            "zippostal": "郵便番号",
            "country": "国",
            "gender": "性別",
            "gender_male": "男性",
            "gender_female": "女性",
            "gender_other": "その他",
            "gender_unstated": "明記しない",
            "height": "身長",
            "birthday": "誕生日",
            "date_of_birth": "生年月日",
            "biography": "経歴",
            "just_a_few_words_about_yourself": "簡単な自己紹介",
            "outcome_goals_are_an_ultimate_destination": "最終的な目標です。",
            "change_password_follow_link": "パスワードはこのリンクから簡単に変更できます：",
            "change_password_follow_link_sso": "パスワードの変更はこちら：",
            "change_password_message": "パスワードを変更してタイムゾーンを設定しましょう。",
            "this_link_to_gca": "Golf Channel Academyへのリンク",
            "this_link_to_blast_motion": "Blast Motionパスワードリセット用リンク",
            "bm_password_change_page": "Blast Motionパスワード変更ページ",
            "you_need_to_login_again_after_change": "パスワードを変更後、もう一度ログインしてください。",
            "current_password": "現在のパスワード",
            "reenter_new_password": "新しいパスワードをもう一度入力",
            "show_welcome_on_dashboard": "選手のログイン時にウェルカムメッセージをダッシュボードに表示しますか？",
            "profile_updated": "プロフィールを更新しました。",
            "change_your_password": "パスワードを変更",
            "set_your_timezone": "タイムゾーンを設定",
            "cancel_subscription_message": {
                "cancel_subscription": "課金プランを解約",
                "we_are_sorry": "あなたが私たちを離れることを考えているのは残念です！ ご出発前に何かお手伝いできることがございましたら、サポートチームが喜んでお手伝いいたします。 <b><a href=\"{help_link}\" target=\"_blank\">ヘルプについては、ここをクリックしてください。</a></b>",
                "we_would_love_to_know_why": "課金プランを解約する理由をお聞かせください。今後の改善に役立てさせていただきます。",
                "warning_message": "注意！この操作は取り消せません。",
                "are_you_sure": "課金プランを解約してもよろしいですか？",
                "if_cancelled": "解約した場合のアクセス終了日： {period_end_date}",
                "yes_cancel": "解約する",
                "no_go_back": "いいえ、戻る",
                "dont_cancel": "解約しない",
                "feedback": "フィードバック",
                "send_feedback": "フィードバックを送信",
                "dont_send_feedback": "フィードバックを送信しない",
                "cancellation_completed": "課金プランの解約を完了しました",
                "processing_cancellation": "解約処理中",
                "sending_feedback": "フィードバックを送信中"
            },
            "cancel_subscription_form": {
                "primary_reason_for_canceling_label": "キャンセルの主な理由を選択してください (必須):",
                "primary_reason_for_canceling_options": {
                    "no_playing_or_coaching": "もうプレーも指導もしていない {sport}",
                    "no_working_with": "コーチ/チーム/アカデミーとはもう仕事をしていません",
                    "was_not_satisfied": "機能に満足できなかった、または機能に問題があった",
                    "needed_features_temporarily": "一時的に Blast Connect / Premium Services だけが必要だった",
                    "too_expensive_time": "Blast Connect/Premium Services は、使用頻度に対して高すぎる",
                    "too_expensive_value": "Blast Connect / Premium Services 機能から得られる価値に対して高すぎる",
                    "dont_have_budget": "払える予算がなくなった Blast Connect / Premium Services",
                    "take_break": "ちょこっとお休みですが、また来ます",
                    "other": "他の"
                }
            },
            "handicap": "ハンデ",
            "jersey_number": "背番号",
            "position": "ポジション",
            "bam_id": "BAM ID",
            "organization_member_id": "組織のメンバーID",
            "is_organization_admin": "組織の管理者です",
            "handedness": "利き腕",
            "dexterity": "利き手",
            "left": "左",
            "right": "右",
            "both": "両利き",
            "left_or_right": "左右",
            "email_confirmed": "メールアドレスの確認が完了しました。",
            "email_confirmation_expired": "メールアドレスの確認の期限が切れました。プロフィールをもう一度更新してください。",
            "email_confirmation_sent": "確認メールを{email}宛てに送信しました。",
            "confirm_your_email_address": "メールアドレスを確認",
            "confirm_email_body": "<p>Blast Connectアカウントに新しいメールアドレスが入力されました。次のリンクから変更を確定してください。</p>\n<p><a href=\"{url}\">{url}</a></p>\n<p>変更した覚えがない場合は、このメールを無視してください。</p>",
            "golf_stats": "ゴルフデータ",
            "rounds": "ラウンド",
            "notes_for_hole": "ホールのメモを入力 {hole_number}",
            "back_to_rounds": "ラウンドに戻る",
            "played_rounds": "プレーしたラウンド",
            "play_round": "ラウンドをプレー",
            "round": "ラウンド",
            "practice_stats": "練習データ",
            "workout_stats": "ワークアウトデータ",
            "par": "パー",
            "hole": "ホール",
            "view_details": "詳細を見る",
            "shot": "ショット",
            "shots": "ショット",
            "recovery": "リカバリー",
            "hasnt_played_any_rounds_yet": "はまだラウンドしていません。",
            "accept_eula": "エンドユーザ使用許諾契約",
            "accept_eula_to_continue_to_site": "<a href=\"{link}\" rel=\"external\">Blast Connectエンドユーザ使用許諾契約</a>に同意します。",
            "eula_i_accept": "同意する",
            "eula_i_decline": "拒否する",
            "eula_error": "Blast Connectを利用するには、エンドユーザ使用許諾契約に同意してください。",
            "accept_waiver": "権利の放棄に同意する。",
            "accept_waiver_to_continue_to_site": "サイトにアクセスするには、以下の権利の放棄に同意してください：",
            "waiver_rejected": "権利の放棄を拒否しました",
            "waiver_rejected_msg": "この度はご同意いただけず残念です。ご不明な点がありましたらご連絡ください。安心してご利用いただけるようサポートいたします。あとでいつでも権利の放棄を承諾できます。",
            "create_a_new_message": "新しいメッセージ",
            "message_everyone": "全員にメッセージ送信",
            "message_all_students": "全選手にメッセージ送信",
            "message_all_coaches": "全コーチにメッセージ送信",
            "subject": "件名",
            "participants": "参加者",
            "unread": "未読",
            "uc_unread": "未読",
            "sorry_no_msg": "メッセージはありません。",
            "write_one": "さっそくメッセージを書きましょう",
            "now": "。",
            "back_to_messages": "メッセージに戻る",
            "mark": "マーク",
            "mark_read": "選択したものを既読にする",
            "mark_unread": "選択したものを未読にする",
            "delete_thread": "スレッドを削除",
            "people_in_this_conversation": "この会話に参加中のユーザー",
            "leave_reply": "返信",
            "no_academies_yet": "まだチームがありません。次の既存チームを編集して追加する：",
            "sub_domain_not_used_but_here_note": "現在、サブドメインは使用されていませんが、今後Blastで「組織ごとの」ページを導入した後もデータを使用できるようになります。",
            "logo": "ロゴ",
            "this_isnt_working": "エラーが発生して作成できませんでしたが、対象がBlast管理者のみなので優先度は高くありません。",
            "permanently_delete": "完全に削除",
            "organization_name": "組織名",
            "share_with_other_coaches_in": "他のコーチと共有： {academy_name}",
            "share_with_all_students_in": "他の選手と共有： {academy_name}",
            "share_with_your_students": "選手と共有",
            "author": "作者",
            "button_above": "上のボタンを押します。",
            "description_of_the_practice": "練習の説明",
            "make_this_practice_available_to_other_coaches_in": "この練習を他のコーチも使えるようにする",
            "practice_builder": "練習作成ツール",
            "practices_comprised_of_drills_note": "システムに保存されている<em>ドリル</em>を組み合わせた物が<em>練習</em>です。ドリルを追加するか、練習の指示を作成して割り当てられます。",
            "add_drills_first": "最初にドリルを追加",
            "existing": "既存",
            "created_by": "作成者：",
            "shared": "共有済み",
            "currently_available": "がありません。",
            "assigned": "\\(self.playersIdentifier)に割り当て済み",
            "mark_progress_coming_soon": "進捗マーク機能を近日公開予定。",
            "mark_progress": "進捗をマーク",
            "no_practices_assigned_yet": "まだ練習が割り当てられていません。ライブラリーで自主練のアイデアを探しましょう！",
            "recently_completed": "最近完了したもの",
            "to_see_full_practice_history_view": "すべての練習履歴を確認：",
            "no_completed_practices_yet": "まだ完了した練習はありません。",
            "back_to": "戻る",
            "date_completed": "完了日",
            "uc_drill": "ドリル",
            "scores_are_optional_title": "スコアは上達を示す目安ですが省略可能です。練習の採点方法はコーチに相談してください。",
            "optional_comments": "コメント（省略可）",
            "practice_history": "練習履歴",
            "drills_in_this_practice": "この練習のドリル",
            "to_this_practice": "この練習に",
            "no_drills_assigned_yet": "この練習にはドリルがまだ追加されていません。",
            "add_one_with_the": "追加するには",
            "button": "ボタンを押してください",
            "students_assigned_this_practice": "この練習を割り当てられた選手",
            "all_students_assignd_this_practice": "すべての選手がこの練習を割り当てられています。",
            "assign_practice_to_students": "この練習を選手に割り当てる",
            "no_students_assinged_this_practice": "この練習には選手がまだ割り当てられていません。",
            "to_this": "この",
            "optional_bg_colors_note": "選手が「ワークアウト」を見るときに、オプションの背景色が表示されます。",
            "select_all": "すべて選択",
            "unselect_all": "すべて選択解除",
            "assign_this_practice": "この練習を割り当てる",
            "assign_this_practices": "この練習を割り当てる",
            "completed": "完了",
            "nothing_yet": "まだありません",
            "main_menu": "メインメニュー",
            "distance_to_pin_before_shot": "ショット前のピンまでの距離",
            "choose_club": "クラブを選択",
            "take_your_first_swing": "最初のスイング開始！",
            "add_shot": "ショットを追加",
            "save_shot": "ショットを保存",
            "cancel_shot": "ショットをキャンセル",
            "done": "完了",
            "cancel": "キャンセル",
            "other": "他の",
            "round_summary": "ラウンド概要",
            "to_par": "パーまで",
            "total": "合計",
            "golf_stats_see_them_from": "メンバー全員が試合とラウンドをここに記録できます。この情報を集約したものが、プロフィールに表示される「<em>ゴルフのデータ</em>」になります。お子様とお子様のプロフィールはネットワークページで確認できます",
            "network_page": "ネットワークページ",
            "where_playing": "プレーしている場所は？",
            "post_score": "スコアを投稿",
            "tournament": "トーナメント",
            "treatment": "処置",
            "start_game": "試合開始",
            "start_round": "ラウンド開始",
            "select_hole": "ホールを選択",
            "no_tee_found_new_add": "ティーが見つかりません。新しいティーが追加されます",
            "could_not_locate_game": "試合が見つかりませんでした",
            "round_recorded": "ラウンドを記録しました",
            "not_your_game": "そのショットが含まれる試合はあなたの試合ではありません",
            "round_deleted": "ラウンドを削除しました",
            "round_restored": "ラウンドを復元しました",
            "shot_not_found": "ショットが見つかりません",
            "shot_deleted": "ショットを削除しました",
            "shot_restored": "ショットを復元しました",
            "hide_diagram": "図解を非表示",
            "show_diagram": "選手の図解",
            "diagram_explaining": "ショット前にピンまでの距離をどう使用するか説明した図解です",
            "how_distance_to_pin_works": "ピンまでの距離について",
            "view_calendar": "カレンダーを見る",
            "distance_to_pin_error": "各ショットにピンまでの距離が数字で表示されます。",
            "page": "ページ",
            "wi.see_progress_from_the": "ここでメンバー全員が各自の上達を確認できます。お子様とお子様のプロフィールはネットワークページで確認できます",
            "tee_to_green": "ティーからグリーンまで",
            "exercise_type": "エクササイズのタイプ",
            "exercise_types": "エクササイズのタイプ",
            "filter_stats": "データを絞り込む",
            "balls_hit": "打球",
            "longest_shot": "最長ショット",
            "practices_assigned": "練習を割り当てました",
            "practices_over_time": "時系列での練習",
            "see_games_rounds_from_the": "ここでメンバー全員が過去の試合とラウンドを確認できます。この情報を集約したものが、プロフィールに表示される「<em>ゴルフのデータ</em>」になります。お子様とお子様のプロフィールはネットワークページで確認できます",
            "tee": "ティー",
            "no_games_recorded_start_today": "まだ試合が記録されていません。上達に向けてスタート！",
            "workouts_assigned": "ワークアウトを割り当てました",
            "workouts_over_time": "時系列でのワークアウト",
            "workout_history": "ワークアウト履歴",
            "gca_player_links": "Golf Channel Academy選手のリンク",
            "legend": "レジェンド",
            "active_available_for_air": "アクティブ - 放送可能",
            "uncategorized": "未分類",
            "archived_hidden_but_recoverable": "アーカイブ済み - 表示されていませんが復元可能です",
            "accepted_video_files_5mb_plz": "（MP4、MPEG、AVI、MOV、WebMファイル。5MBまで）",
            "upload_a_video": "動画をアップロード",
            "upload": "アップロード",
            "restrict_to_shows": "表示を制限",
            "use": "使用",
            "archive": "アーカイブ",
            "no_results": "結果なし。",
            "start": "開始",
            "end": "終了",
            "seconds": "秒",
            "set_time": "時刻を設定",
            "shows_assigned_to_this_video": "この動画を放送するテレビ番組",
            "selected_for_show_use": "番組で放送する",
            "removed_from_show_use": "番組で放送しない",
            "on_air_video_welcome_msg": "On airの動画アップロードへようこそ。動画をここで共有すると、放送中にチェックしてもらえます。",
            "on_air_video_step1": "ステップ1 - 動画を選択してOn Airに送信！",
            "oav_step1_details": "推奨ファイル形式はMP4、MPEG、AVI、MOV、WebMです。サイズは5MBまでです。",
            "on_air_video_step2": "ステップ2 - 説明",
            "oav_step2_details": "動画とあなたのことを簡単に紹介してください。こちらからの連絡を希望する場合は、メールアドレスを記入してください。",
            "on_air_video_step3": "ステップ3 - 送信",
            "oav_step3_details": "Golf Channelの規約に従って動画を共有することに同意します。",
            "thank_you_for_your_video_submission": "動画をお送りいただきありがとうございます。",
            "another_video": "別の動画",
            "to_get_started": "はじめに",
            "edit_your_profile": "プロフィールを編集",
            "update_my_profile": "プロフィールを更新",
            "tweets": "ツイート",
            "word_count": "文字数",
            "no_summary_available": "表示できる概要がありません。",
            "out_of": "/",
            "with": "で",
            "routines": "ワークアウト&amp;練習",
            "all_routines": "すべてのワークアウト&amp;練習",
            "exercises": "エクササイズ",
            "drills": "ドリル",
            "an_exercise": "エクササイズ",
            "a drill": "ドリル",
            "assigned_to_me": "自分に割り当て済み",
            "history": "履歴",
            "available": "実施可能",
            "assigned_description": "あなたに割り当てられた、まだ完了していないワークアウトや練習です。",
            "available_description": "今までにあなたに割り当てられたすべてのワークアウトや練習です。もう一度やりましょう！",
            "assigned_by": "割り当てた人：",
            "date_assigned": "割り当てた日付：",
            "start_workout": "ワークアウト開始",
            "start_practice": "練習を開始",
            "create_workout": "ワークアウトを作成",
            "create_practice": "練習を作成",
            "create_workout_practice": "ワークアウトや練習を作成",
            "complete_workout": "ワークアウト完了",
            "workout_type": "ワークアウトのタイプ",
            "practice_type": "練習のタイプ",
            "workout_description": "ワークアウトの説明",
            "practice_description": "練習の説明",
            "assign_workout": "ワークアウトを割り当てる",
            "assign_practice": "練習を割り当てる",
            "schedule_assign": "スケジュールを設定して割り当て",
            "assign_without_schedule": "スケジュールを設定せずに割り当て",
            "share_workout": "ワークアウトを共有",
            "share_practice": "練習を共有",
            "other_coachs_academy": "このチームの他のコーチ",
            "add_to_workout": "ワークアウトに追加",
            "add_to_practice": "練習に追加",
            "create_exercise": "エクササイズを作成",
            "create_new_exercise": "新規エクササイズを作成",
            "create_drill": "ドリルを作成",
            "exercise_description": "エクササイズの説明",
            "drill_description": "ドリルの説明",
            "video_image": "動画または画像",
            "equipment_type": "トレーニング用具の種類",
            "all_equipment_types": "すべての機器タイプ",
            "exercise_details": "エクササイズ詳細",
            "drill_details": "ドリル詳細",
            "share_exercise_with": "エクササイズの共有先",
            "share_drill_with": "ドリルの共有先",
            "your_students": "選手",
            "notes": "メモ",
            "complete": "完了",
            "skip": "スキップ",
            "equipment_needed": "必要なトレーニング用具",
            "finish_workout": "ワークアウトを終了",
            "finish_practice": "練習を終了",
            "complete_exercise": "エクササイズを完了",
            "complete_drill": "ドリルを完了",
            "you_finished": "終了！がんばりましたね。",
            "review_workout": "ワークアウトをチェック",
            "view_mark_all": "一度にすべてのエクササイズを表示してマークしますか？",
            "view_mark_one": "エクササイズを完了したときに表示してマークしますか？",
            "switch_list_view": "リスト表示に切り替え",
            "switch_horizontal_view": "グリッド表示に切り替え",
            "add-group": "グループを追加",
            "add_group_same_exercises": "割り当てられた以上に完了した場合は、同じエクササイズのグループを追加してください。",
            "add_group_same_drills": "割り当てられた以上に完了した場合は、同じドリルのグループを追加してください。",
            "outstanding": "未完了",
            "since": "次以来",
            "last_7_days": "過去7日間",
            "by_month": "月",
            "by_type": "タイプ",
            "your_workout_list": "ワークアウトリスト",
            "your_practice_list": "練習リスト",
            "view_only": "表示のみ",
            "duplicate_to_edit": "複製して編集",
            "scheduled": "スケジュール設定済み",
            "your_week_at_a_glance": "{name}　1週間の概要",
            "schedule_coach_subtext": "あなたが選手に割り当てたワークアウトと練習です。",
            "full_calendar": "カレンダー全表示",
            "complete_question": "完了しましたか？",
            "mark_complete": "完了にする",
            "owner_mode": "監督モード",
            "coach_mode": "コーチモード",
            "personal_mode": "個人モード",
            "coach_mode_tip": "選手のワークアウトと練習を管理",
            "personal_mode_tip": "自分のワークアウトと練習を管理",
            "no_type": "完了したワークアウトは、作成されたときにカテゴリータイプがありませんでした。",
            "routines_before_after": "割り当て日より前または後に完了したルーティンには完了とは表示されません。",
            "not_editable_note": "他のメンバーが作成してあなたと共有したものなので編集できませんが、選手に割り当てることは可能です。",
            "not_editable_note_student": "他のメンバーが作成してあなたと共有したものなので編集できませんが、スケジュール設定は可能です。",
            "assign": "割り当てる",
            "complete_routine_for_student": "<strong>{user}</strong>向けのこの{routine_type}を完了しようとしています。",
            "routine_which_type_are_you_completing": "スケジュール設定済みのどの{type}を完了しますか？",
            "routine_not_found": "お探しのワークアウトや練習が見つかりません。削除された可能性があります。<a href=\"{url}\">別のワークアウトや練習を検索してください。</a>",
            "routine_deleted": "お探しの{type}が見つかりません。削除された可能性があります。<a href=\"{url}\">別の{type}を検索してください。</a>",
            "complete_again": "もう一度やる",
            "other_coaches_in": "他のコーチ： {academy_name}",
            "other_coaches": "他のコーチ",
            "all_coaches_in": "すべてのコーチ： {academy_name}",
            "select_coaches": "特定のコーチ",
            "all_students_in": "すべての選手： {academy_name}",
            "your_next_workout": "{name}　次のワークアウト",
            "your_last_workout": "{name}　前のワークアウト",
            "your_next_practice": "{name}　次の練習",
            "your_last_practice": "{name}　前の練習",
            "routines_calendar_disabled": "選手の上達度を常に把握しましょう。割り当て済みのワークアウトや練習、完了済み履歴など、各選手のトレーニングを監視できます。",
            "form_validation_error_message": "すべての必須項目を入力してください。",
            "event_must_be_workout_or_practice": "完了できるのはワークアウトと練習のみです。",
            "drill": "ドリル",
            "routines_category": {
                "workouts": {
                    "title": "ワークアウト",
                    "recent": "最近のワークアウト",
                    "scheduled_this_week": "今週に設定されたワークアウト",
                    "routine_view": "ワークアウトを見る",
                    "routine_review": "ワークアウトをチェック",
                    "routine_create": "ワークアウトを作成",
                    "routine_list": "ワークアウトリスト",
                    "manage_task": "エクササイズを管理",
                    "tasks_link": "エクササイズ",
                    "your_have_completed_your_routine": "ワークアウトを完了しました。ナイス！",
                    "start_routine": "ワークアウト開始",
                    "log_routine": "ワークアウトを記録",
                    "routine_name": "ワークアウト名",
                    "routine_type": "ワークアウトのタイプ",
                    "routine_assign": "ワークアウトを割り当てる",
                    "routine_share": "ワークアウトを共有",
                    "routine_description": "ワークアウトの説明",
                    "duplicate_task": "エクササイズを複製",
                    "create_task": "エクササイズを作成",
                    "task": "エクササイズ",
                    "tasks": "エクササイズ",
                    "task_add": "エクササイズを追加",
                    "task_name": "エクササイズ名",
                    "task_description": "エクササイズの説明",
                    "task_type": "エクササイズのタイプ",
                    "task_create_new": "新規エクササイズを作成",
                    "task_details": "エクササイズ詳細",
                    "task_group_desc": "グループにエクササイズを追加しました。これでさまざまなワークアウトを指定できます（ウォームアップ、クールダウンなど）。ワークアウトには必ずエクササイズを含めてください。",
                    "share_task_with": "エクササイズの共有先",
                    "task_details_text": "このエクササイズで記録したいものを指定します。「ワークアウトを作成」画面でこのエクササイズの繰り返し回数、重さなどを指定できます。",
                    "add_to_routine": "ワークアウトに追加",
                    "manage_tasks": "エクササイズを管理",
                    "routine_updated": "ワークアウトを更新しました",
                    "routine_deleted": "ワークアウトを削除しました {restore_anchor}",
                    "routine_restored": "ワークアウトを復元しました",
                    "routine_complete": "ワークアウト完了",
                    "assign_routine_to_students": "選手にこのワークアウトを割り当てる",
                    "schedule_routine": "ワークアウトのスケジュール設定",
                    "make_routine_available": "ワークアウトの公開先：",
                    "make_routine_available_text": "これでワークアウトが割り当てられるわけではありませんが、公開されるので各自で完了（コーチの場合は他のユーザーに割り当て）できるようになります。"
                },
                "practices": {
                    "title": "練習",
                    "recent": "最近の練習",
                    "scheduled_this_week": "今週に設定された練習",
                    "routine_review": "練習をチェック",
                    "routine_create": "練習を作成",
                    "routine_view": "練習を見る",
                    "routine_list": "練習リスト",
                    "manage_task": "ドリルを管理",
                    "tasks_link": "ドリル",
                    "your_have_completed_your_routine": "練習を完了しました。ナイス！",
                    "start_routine": "練習を開始",
                    "log_routine": "練習を記録",
                    "routine_name": "練習名",
                    "routine_type": "練習のタイプ",
                    "routine_assign": "練習を割り当てる",
                    "routine_share": "練習を共有",
                    "routine_description": "練習の説明",
                    "duplicate_task": "ドリルを複製",
                    "create_task": "ドリルを作成",
                    "task": "ドリル",
                    "tasks": "ドリル",
                    "task_add": "ドリルを追加",
                    "task_name": "ドリル名",
                    "task_description": "ドリルの説明",
                    "task_type": "ドリルのタイプ",
                    "task_create_new": "新規ドリルを作成",
                    "task_details": "ドリル詳細",
                    "task_group_desc": "グループにドリルを追加しました。これでさまざまな練習プランを指定できます（ウォームアップ、クールダウンなど）。練習には必ずドリルを含めてください。",
                    "share_task_with": "ドリルの共有先",
                    "task_details_text": "このドリルで記録したいものを指定します。「練習を作成」画面でこのドリルの繰り返し回数などを指定できます。",
                    "add_to_routine": "練習に追加",
                    "manage_tasks": "ドリルを管理",
                    "routine_updated": "練習を更新しました",
                    "routine_deleted": "練習を削除しました {restore_anchor}",
                    "routine_restored": "練習を復元しました",
                    "routine_complete": "練習を完了",
                    "assign_routine_to_students": "この練習を選手に割り当てる",
                    "schedule_routine": "練習のスケジュール設定",
                    "make_routine_available": "練習の公開先：",
                    "make_routine_available_text": "これで練習が割り当てられるわけではありませんが、公開されるので各自で完了（コーチの場合は他のユーザーに割り当て）できるようになります。"
                }
            },
            "desc_of_exercise": "エクササイズの説明",
            "share_with": "共有相手",
            "auto_shared_with": "自動的に共有する相手",
            "back_to_workouts": "ワークアウトに戻る",
            "back_to_manage_exercises": "「エクササイズを管理」に戻る",
            "exercises_may_not_be_deleted_in_workouts": "ワークアウトに含まれているエクササイズは削除できません",
            "exercise_lower": "エクササイズ",
            "workouts_using": "使用中のワークアウト",
            "not_currently_used_in_any_workouts": "ワークアウトでは使用されていません。",
            "return_to_workouts": "ワークアウトに戻る",
            "no_exercises_yet_add_first_w": "まだエクササイズはありません。上のボタンを押して追加します。",
            "workout_builder": "ワークアウト作成ツール",
            "workout_not_found": "ワークアウトが見つかりません",
            "workouts_practices_comprised_of_saved_exercises_you_can_add": "システムに保存されている<strong>エクササイズ</strong>を組み合わせた物が<strong>ワークアウト</strong>です。エクササイズを追加するか、ワークアウトの指示を作成して割り当てられます。",
            "add_exercises_first": "最初にエクササイズを追加",
            "no_workouts_currently_available": "実施できるワークアウトはありません。",
            "your_workouts": "ワークアウト",
            "no_workouts_assigned_yet": "まだワークアウトが割り当てられていません。ライブラリーで自主練のアイデアを探しましょう！",
            "to_see_full_workout_history_view_your": "すべてのワークアウト履歴を確認：",
            "no_completed_workouts_yet": "まだ完了したワークアウトはありません。",
            "sorry_that_workout_isnt_in_the_system": "そのワークアウトはシステムにありません。",
            "sorry_that_practice_isnt_in_the_system": "その練習はシステムにありません。",
            "exercises_in_this_workout": "このワークアウトのエクササイズ",
            "to_this_workout": "このワークアウトに",
            "no_exercises_assigned_yet": "このワークアウトにはエクササイズがまだ追加されていません。",
            "exercise": "エクササイズ",
            "order": "順序",
            "students_assigned_this_workout": "このワークアウトを割り当てられた選手",
            "all_students_assigned_workout": "すべての選手がこのワークアウトを割り当てられています。",
            "assign_workout_to_students": "選手にこのワークアウトを割り当てる",
            "no_students_assigned_this_workout": "このワークアウトには選手がまだ割り当てられていません。",
            "add_exercise_to_this_workout": "エクササイズをこのワークアウトに追加",
            "assign_this_workout": "このワークアウトを割り当てる",
            "assign_this_workouts": "このワークアウトを割り当てる",
            "desc_of_the_workout": "ワークアウトの説明",
            "make_this_workout_available_to_other_coaches_in": "このワークアウトを他のコーチも使えるようにする：",
            "enter_your_email_to_reset": "メールアドレスを入力してパスワードをリセットします。",
            "enter_email_to_reset_password": "メールアドレスを入力してパスワードをリセット",
            "login_to_academy": "チームにログイン",
            "find_academy": "チームを検索",
            "enter_academy_domain": "チームの<strong>{network_name}</strong>ドメインを入力：",
            "cant_remember_domain": "チームのドメインを忘れた場合：",
            "find_your_academy": "チームを検索",
            "send_me_email": "メールを受け取る",
            "enter_your_email": "<strong>メールアドレス</strong>を入力：",
            "check_email_domain_match": "Blastのシステムにあなたのメールアドレスを確認して、チームのログインページのリンクをお送りします。",
            "academy_domain": "チームドメイン",
            "your_email": "メールアドレス",
            "sport_incomplete": "この競技のBlast Analyticsはまだ完成していません。あとで確認してください。",
            "check_app_for_instructions": "Blastアプリで手順を確認してください。",
            "blast_logo": "Blast Motionロゴ",
            "connect_title": "Blastアプリに接続",
            "connect_subtitle": "Blastアプリで直接スイングデータや動画を見ることができます。",
            "connect_intro_text": "データを見るには、センサーとアプリとの接続を認証してください。センサーとアプリをお手元に準備してください。セットアップ中に必要になります。",
            "start_connecting": "接続を開始",
            "dont_have_sensor": "センサーをお持ちでない場合",
            "dont_have_sensor_text": "スイングを録画、分析、改善しましょう。アプリがスイングのハイライト動画を録画、Blastセンサーの詳しいデータと組み合わせることで、あなたのスイングを分析、上達のためのドリルも紹介します。",
            "buy_sensor": "オンラインでセンサーを購入",
            "enter_blast_app_info": "モバイルアプリと接続",
            "enter_blast_info_pw_match": "Blast MotionポータルとBlast Motionアプリのメールアドレスが一致しません。Blast Motionアプリのパスワードを入力するだけで、Blast Motionアプリのデータを見ることができます。",
            "enter_blast_info_pw_no_match": "アプリにメールアドレスとパスワードを入力すると、アプリのデータを見ることができます。",
            "connect_desc_golf": "Blast Connectにデータを同期するには、Blast Golfモバイルアプリにログインする際に使用するメールアドレスとパスワードを入力してください。",
            "connect_desc_baseball": "Blast Connectにデータを同期するには、Blast Baseballモバイルアプリにログインする際に使用するメールアドレスとパスワードを入力してください。",
            "connect_desc_softball": "Blast Connectにデータを同期するには、Blast Softballモバイルアプリにログインする際に使用するメールアドレスとパスワードを入力してください。",
            "blast_motion_app_email": "アプリのメールアドレス",
            "blast_motion_app_pw": "アプリのパスワード",
            "connect_blast_app": "接続する",
            "forgot_blast_password": "モバイルアプリのパスワードを忘れた場合",
            "how_to_find_blast_email": "メールアドレスとパスワードが見つからない場合",
            "email_listed_profile_golf": "Blast Golfモバイルアプリのユーザープロフィールにメールアドレスとパスワードが記載されています。",
            "email_listed_profile_baseball": "Blast Baseballモバイルアプリのユーザープロフィールにメールアドレスとパスワードが記載されています。",
            "email_listed_profile_softball": "Blast Softballモバイルアプリのユーザープロフィールにメールアドレスとパスワードが記載されています。",
            "ios": "iOS",
            "android": "Android",
            "step1": "1",
            "step2": "2",
            "step3": "3",
            "step4": "4",
            "ios_bb_step1_title": "設定",
            "ios_bb_step1_instructions": "画面左上の3本線アイコンをタップします。",
            "ios_bb_step2_title": "プロフィール",
            "ios_bb_step2_instructions": "ユーザーの写真をタップすると「ユーザープロフィール」が開きます。",
            "ios_bb_step3_title": "アカウント",
            "ios_bb_step3_instructions": "画面の上の方にある「アカウント」をタップします。",
            "ios_bb_step4_title": "メールアドレス",
            "ios_bb_step4_instructions": "最初の入力欄にはメールアドレスが表示されます。",
            "android_bb_step1_title": "設定",
            "android_bb_step1_instructions": "画面左上の3本線アイコンをタップします。",
            "android_bb_step2_title": "プロフィール",
            "android_bb_step2_instructions": "ユーザーの写真をタップすると「ユーザープロフィール」が開きます。",
            "android_bb_step3_title": "アカウント",
            "android_bb_step3_instructions": "画面の上の方にある「アカウント」をタップします。",
            "android_bb_step4_title": "メールアドレス",
            "android_bb_step4_instructions": "最初の入力欄にはメールアドレスが表示されます。",
            "golf_step1_title": "設定",
            "golf_step1_instructions": "画面左上の3本線アイコンをタップします。",
            "golf_step2_title": "プロフィール",
            "golf_step2_instructions": "アバターをタップすると「ユーザープロフィール」が開きます。",
            "golf_step3_title": "アカウント",
            "golf_step3_instructions": "画面の上の方にある「アカウント」をタップします。",
            "golf_step4_title": "メールアドレス",
            "golf_step4_instructions": "最初の入力欄にはメールアドレスが表示されます。",
            "android_golf_step1_title": "設定",
            "android_golf_step1_instructions": "画面左上の3本線アイコンをタップします。",
            "android_golf_step2_title": "プロフィール",
            "android_golf_step2_instructions": "アバターをタップすると「ユーザープロフィール」が開きます。",
            "android_golf_step3_title": "アカウント",
            "android_golf_step3_instructions": "画面の上の方にある「アカウント」をタップします。",
            "android_golf_step4_title": "メールアドレス",
            "android_golf_step4_instructions": "最初の入力欄にはメールアドレスが表示されます。",
            "error_title": "もう一度お試しください！",
            "email_not_in_system": "次のフィールドに入力した情報がシステムに存在しません：",
            "metric_name": "計測値の名前",
            "metric_value": "計測値",
            "metric_unit": "計測値の単位",
            "you": "",
            "you2": "",
            "your": "",
            "your2": "",
            "dont": "しない",
            "doesnt": "しない",
            "has": "ある",
            "have": "ある",
            "blast_metrics": "計測値",
            "blast_metrics_and_reports": "計測値＆レポート",
            "metric_definitions": "計測値の意味",
            "many_metrics_search": "次の一致する計測値があります：",
            "invalid_access_token": "アクセストークンが無効です。アカウントを再接続してください。",
            "with_actions": "アクションあり",
            "total_actions": "合計アクション",
            "without_actions": "アクションなし",
            "showing_actions_pt1": "表示中",
            "refresh": "更新",
            "sync": "同期",
            "async": "非同期",
            "strokes": "ストローク",
            "swings_num": "スイング|スイング",
            "swing_type": "スイングタイプ",
            "timeframe": "タイムフレーム",
            "individual_swings": "個々のスイング",
            "no_actions": "{sport}のアクションが見つかりません。絞り込みや期間を変更するか、センサーでスイングを録画してください。",
            "no_actions_student": "{name}にはまだ{sport}のアクションがありません。絞り込みや期間を変更してみてください。",
            "averages": "平均",
            "all_metrics_averages": "すべての計測値/平均",
            "swing_averages": "スイング平均",
            "all_swings": "すべてのスイング",
            "full_swings": "フルスイング",
            "short_games": "ショートゲーム",
            "bunkers": "バンカー",
            "total_swings": "合計スイング数",
            "total_strokes": "合計ストローク",
            "putts": "パット",
            "jumps": "ジャンプ",
            "sprints": "短距離走",
            "last_swing": "前回のスイング",
            "last_5_swings": "最近の5スイング",
            "last_10_swings": "最近の10スイング",
            "last_25_swings": "最近の25スイング",
            "last_50_swings": "最近の50スイング",
            "go": "検索",
            "filter": "絞り込み",
            "clear_filters": "絞り込みをクリア",
            "averages_charts_last_100_golf": "*グラフは最近の100スイングをもとにしています。",
            "scheduler_must_be_enabled_organization": "まず組織レベルでスケジューラーをオンにしてください。",
            "metrics_must_be_enabled_organization": "まず組織レベルで計測値をオンにしてください。",
            "subscription_must_be_enabled_organization": "まず組織レベルで課金プランをオンにしてください。",
            "public_registration_must_be_enabled_organization": "まず組織レベルで一般登録をオンにしてください。",
            "connecting": "接続中...",
            "importing": "データをインポート中...",
            "finding_new_metrics": "新しい計測値を検索中...",
            "finished": "完了",
            "finished_redirecting": "完了しました。再検索中...",
            "calculating_averages": "平均を計算中...",
            "importing_equipment": "器具をインポート中...",
            "importing_sessions": "計測をインポート中...",
            "initiating_import": "データの同期を初期化中...",
            "requesting_import": "データの同期を開始中...",
            "actions": "アクション",
            "sync_latest_metrics": "最新の計測値を同期",
            "refresh_all_metrics": "すべての計測値を更新",
            "unable_to_connect_blast_account": "<i class=\"far fa-exclamation-triangle\"></i>アカウントに接続中にエラーが発生しました。<a href=\"/blast/connect\">接続し直してください。</a>",
            "see_section_below": "下の&quot;<em>{section}</em>&quot;をご覧ください。",
            "metrics_sport_not_supported": "この競技の計測値はまだ完成していません。あとで確認してください。",
            "blast_account_not_connected": "アカウントがまだ{appname}に接続されていません。<a href=\"{url}\">今すぐ接続</a>すると計測値がここに表示されます。",
            "blast_account_connected": "アプリに接続できました。",
            "blast_metrics_unavailable": "<i class=\"far fa-exclamation-triangle\"></i>計測値は現在利用できません。ご迷惑をおかけしますが、しばらくしてからもう一度アクセスしてください。",
            "blast_metrics_updated_zero": "お使いの計測値は最新の状態です。",
            "page_out_of_date": "このページは古くなっています。",
            "blast_metrics_updated": "計測値に新しいアクションが<span class=\"import-total\">{imported}</span>個追加されました。",
            "blast_session_timeout": "計測はタイムアウトしました。もう一度接続してください。",
            "metrics_sync_error": "<i class=\"far fa-exclamation-triangle\"></i>データの同期中にエラーが発生しました。もう一度同期してください。",
            "metrics_sync_error_retrying": "<i class=\"far fa-exclamation-triangle\"></i>データの同期中にエラーが発生しました。やり直しています。お待ちください。",
            "error_contact_support": "<i class=\"far fa-exclamation-triangle\"></i>データの同期中にエラーが発生しました。",
            "team_report": "チームレポート",
            "swing_profile": "スイングプロフィール",
            "swing_data": "スイングデータ",
            "back_to_team_report": "チームレポートに戻る",
            "rankings": "ランキング",
            "back_to_metrics": "計測値に戻る",
            "customize_your_metrics": "計測値をカスタマイズ",
            "show_videos_only": "選手の動画のみ",
            "videos_only": "動画のみ",
            "share_your_metrics": "データを共有",
            "reset_filters": "絞り込みをリセット",
            "close_filters": "絞り込みを閉じる",
            "customize_metrics": "計測値をカスタマイズ",
            "sync_metrics": "計測値を同期",
            "sync_metrics_sport": "{sport}データを同期",
            "sync_all_students": "全選手を同期",
            "sync_all_students_sport": "{sport}全選手を同期",
            "download_full_team_report": "チーム全員のレポートをダウンロード",
            "full_team_report": "チーム全員のレポート",
            "full_team_report_options": {
                "email": {
                    "title": "レポートが完成するとメールが届きます。",
                    "description": "選手数が多いレポートを作成するときに便利なオプションです。レポートの作成中は、Blast Connectからチェックできます。",
                    "button_caption": "メールを受け取る"
                },
                "browser": {
                    "title": "ブラウザから直接レポートをダウンロードします。",
                    "description": "選手数が多いレポートは、作成に数分かかることがあります。レポートのダウンロードが完了するまで、この画面から移動することができません。",
                    "button_caption": "ダウンロード"
                },
                "common": {
                    "title": "チームレポートの作成とダウンロードには少々時間がかかります。完成したら、レポートのリンクをメールでお送りします。",
                    "description": "レポートが届くのを待っている間、Blast Connectの他の機能を利用できます。",
                    "button_caption": "レポートを作成"
                }
            },
            "user_unsynced": "このユーザーはアプリにまだ接続していません。",
            "current_user_unsynced": "アプリがまだ接続されていません。",
            "user_reconnect": "このユーザーはアプリを再接続する必要があります。",
            "current_user_reconnect": "アカウントに接続中にエラーが発生しました。",
            "connect_account": "アカウントを接続",
            "reconnect_account": "アカウントを再接続",
            "learn_about_metrics": "各種計測値について",
            "all_equipment": "すべての器具",
            "sessions": "計測",
            "all_session_types": "計測条件",
            "all_sessions": "計測",
            "multi_player_sessions": "複数選手の計測",
            "no_sessions": "計測はありません",
            "clear_daterange": "期間をクリア",
            "delete_metrics": "計測値を個別に削除",
            "delete_session": "計測を削除",
            "delete_sessions": "計測を削除",
            "delete_session_info": "計測を削除しても、それに紐付けられているアクションは削除されません。",
            "can_not_delete_session_text": "次の計測は他のユーザーが作成したものなので削除できません：",
            "can_not_deleted_session_description": "表示中の計測はあなた以外のユーザーが作成したものなので削除できません。",
            "view_session": "計測を表示",
            "download_csv": "CSV形式でダウンロード",
            "download_excel": "Excel形式でダウンロード",
            "download_metrics": "計測値をダウンロード",
            "downloading_metrics_please_wait": "計測値をエクスポート中です。数分かかることがあります。お待ちください。",
            "no_actions_selected": "削除するアクションが選択されていません。",
            "confirm_delete_actions": "この操作は取り消せません。これらのアクションを削除してもよろしいですか？",
            "confirm_delete_session": "この計測を削除してもよろしいですか？",
            "confirm_delete_sessions": "これらの計測を削除してもよろしいですか？",
            "delete_session_and_actions": "この計測とすべてのアクションを削除",
            "delete_sessions_and_actions": "これらの計測とすべてのアクションを削除",
            "delete_session_only": "計測のみ削除（アクションは削除しない）",
            "delete_sessions_only": "計測のみ削除（アクションは削除しない）",
            "delete_sessions_and_all_actions": "計測とすべてのアクションを削除",
            "yes_delete": "削除する",
            "no_go_back": "いいえ、戻る",
            "blast_metrics_deleted": "{total}個のアクションを削除しました。",
            "blast_session_deleted": "計測を削除しました。",
            "blast_sessions_deleted": "{count}個の計測を削除しました。",
            "blast_session_missing": "計測が見つかりませんでした。",
            "reset_daterange": "期間をリセット",
            "session_notes": "計測のメモ",
            "date_s": "日付",
            "environment_s": "計測条件",
            "pitch_type_s": "投球タイプ",
            "pitch_location_s": "投球コース",
            "constraint_s": "制限",
            "slap_type_s": "スラップタイプ",
            "search_for_a_player": "選手を検索",
            "search_for_a_roster": "ロースターを検索",
            "all_students": "全選手",
            "all_rosters": "全ロースター",
            "action_type": "アクションタイプ",
            "impact_type": "ンパクトタイプ",
            "range_today": "今日",
            "range_yesterday": "昨日",
            "range_last_x_days": "過去{days}日間",
            "range_next_x_days": "次の{days}日間",
            "range_days": "日",
            "range_all_time": "全期間",
            "custom_range": "範囲をカスタマイズ",
            "terms_and_conditions": "利用規約",
            "note_access_to_and_use_of_this_data_is_subject_to_the_blast_motion_terms_of_use_and_end_user_license_agreement": "注： このデータへのアクセスと使用には、Blast Motion利用規約およびエンドユーザー使用許諾契約が適用されます。利用規約およびエンドユーザー使用許諾契約：{url}",
            "blast_motion_services": "nBlast Motionサービス",
            "invalid_login_credentials": "ログイン情報が間違っています。やり直してください。",
            "uploaded_videos_actions": "{name}が{videos}個の新しい{videos_noun}と{actions}個の新しい{actions_noun}をアップロードしました。",
            "all_metrics": "すべての計測値",
            "your_latest_actions": "{name}の最新のアクション",
            "recent_student_sessions": "最近の選手計測",
            "recent_player_sessions": "最近の選手計測",
            "your_last_session": "{name}の前回の計測",
            "videos_noun": "動画|動画",
            "actions_noun": "アクション|アクション",
            "session_s": "計測",
            "sessions_are_not_found": "計測が見つかりません",
            "no_equipment_found": "機器が見つかりません",
            "period": "期間",
            "view_in_library": "ライブラリーで見る",
            "camp_invite_to_join": "いますぐこの招待を承諾して、{camp_academy_name} + Blast への登録を完了してください。",
            "camp_invite_to_join_student": "次の {camp_academy_name} イベントでは、ブラスト モーション スイング アナライザーを使用して、スイングのメトリック、インパクト メトリック、およびスイングの品質スコアを取得します。 このスイング パフォーマンス データは、イベント後に Blast Connect の個人の Blast プレーヤー レポートで利用できます。",
            "invite_to_join": "があなたをBlast Connectチームに招待しました。",
            "login_to_join": "この招待を受け入れるには Blast Connect にログインしてください",
            "invitation_username": "ユーザー名：",
            "invitation_password": "パスワード（新規ユーザーのみ）：",
            "invitation_accept": "招待を承諾",
            "invitation_sub_heading_camp": "この招待を承諾し、Blast利用規約に同意するには、{camp_academy_name} + Blast に参加してください。イベントでスイングデータを取り込めるよう、上記リンクをクリックしてください。",
            "invitation_sub_heading_camp_student": "この Blast Connect への招待を受け入れることは、イベントに参加したり、Blast のスイング パフォーマンス データを取得したりする必要はありません。 イベント終了後、データを表示する準備ができたら、上のボタンを使用してこの Blast Connect の招待を承認してください。 データは、イベント開始後 45 日間、追加料金なしで閲覧できます。 45 日後、データにアクセスするにはアクティブな Blast プレミアム サービス サブスクリプションが必要になります。<br><br>Blast プレミアム サービスを Blast Swing Analyzer と組み合わせると、トレーニングをまったく新しいレベルに引き上げて、 皿。 {camp_academy_name} イベントの参加者は、サインアップ時に Blast プレミアム サービスの 30 日間無料トライアルを利用できます。 <a href=\"{url}\" target=\"_blank\" class=\"link-font\">Blast ソリューションの詳細</a>をご覧ください。",
            "invitation_sub_heading_player": "参加すると、あなたとコーチがBlastアプリを使ってすべてのBlastデータ、動画、トレーニング履歴にアクセスできます。Blast Connectではさらに詳細なデータを確認できます。",
            "invitation_sub_heading_coach_admin": "動画分析、音声録音、動画編集機能で選手にフィードバックを提供しましょう。また、いつどこにいても、選手の練習セッションをチェック、ワークアウトを割り当て、データを分析してアドバイスできます。",
            "ready_to_continue_your_player_development": "プレーヤーの開発を続ける準備はできましたか?",
            "need_a_sensor": "センサーが必要な場合",
            "sensor_description": "Blastセンサーを使うと、スイングインパクトのデータを収集、確認し、上達につなげられます。",
            "sensor_description_student": "{blast_sport} は、プロチーム、大学、高校、エリート旅行チーム向けの <strong class=\"link-font\">ナンバー 1 スイング アナライザー</strong> です。<br><br>ブラスト スイング アナライザーは、よりスマートにトレーニングし、より良いトレーニングを構築するのに役立ちます。 スイングのインパクト指標を収集、表示、改善できるようにすることで、スイングを向上させます。",
            "subscription_description": "プレミアム有料課金サービスでは、Blastの機能がさらに充実、Blast Connectへのアクセス、ウェブサイトや情報管理プラットフォームのカスタマイズも可能です。",
            "get_a_sensor": "センサーを入手",
            "get_a_blast_swing_analyzer": "ブラスト スイング アナライザーを入手する",
            "camp_invitation_title": "{parent_academy} - {camp_academy} の Blast Connect への招待",
            "camp_invitation_upsell": "期間限定オファー！{camp_academy} + Blast に参加すると、特別価格でBlastスイング分析センサーを購入できます。オファーの有効期限は{upsell_expiration}までです。",
            "camp_invitation_upsell_student": "期間限定オファー！{camp_academy} + Blast に参加すると、特別割引で自分だけの Blast Swing Analyzer を手に入れることができます。 オファーは {upsell_expiration} に期限切れになります。",
            "invitation_title": "{invited_by} があなたをBlast Premiumに招待しました。",
            "invitation_accepted_title": {
                "baseball": "Blast Connectチームにようこそ！",
                "softball": "Blast Connectチームにようこそ！",
                "golf": "Blast Premiumにようこそ！"
            },
            "invitation_accepted_message_coach_admin": {
                "baseball": "BlastアプリやBlast Connectから選手のBlastデータ、動画、トレーニング履歴にアクセスできます。",
                "softball": "BlastアプリやBlast Connectから選手のBlastデータ、動画、トレーニング履歴にアクセスできます。",
                "golf": "BlastアプリやBlast Connectから選手とあなた自身のBlastデータ、動画、トレーニング履歴にアクセスできます。"
            },
            "invitation_accepted_message_player": "あなたとコーチがBlastアプリやBlast Connectを使ってすべてのBlastデータ、動画、トレーニング履歴にアクセスできます。",
            "invitation_accepted_instructions_title": "はじめてBlastをお使いになる場合の手順",
            "invitation_accepted_device_ios_title": "Apple/iOSの手順",
            "invitation_accepted_device_android_title": "Androidの手順",
            "invitation_accepted_instructions": {
                "1": {
                    "title": "Blast {sport}アプリをダウンロードしてログインする",
                    "description": "スマートフォンでAppleのApp Storeを開き、「Blast {sport}」を検索し、アプリをダウンロードします。アプリを起動したら、Blast登録時に使用したメールアドレスでログインします。"
                },
                "2": {
                    "title": "センサーをペアリングする",
                    "description": {
                        "ios": "「<b style=\"font-weight{700};\">タップしてセンサーを追加</b>」をタップします。画面に表示される指示に従ってください。",
                        "android": "<b style=\"font-weight{700};\">3本線のアイコン</b>、「<b style=\"font-weight{700};\">センサー</b>」の順にタップします。画面に表示される指示に従ってください。"
                    }
                },
                "3": {
                    "title": "{equipment}を追加する",
                    "description": "<b style=\"font-weight{700};\">「メニュー」アイコン</b>、「<b style=\"font-weight{700};\">自分のバット</b>」の順にタップします。{multiple_equipment}。"
                },
                "4": {
                    "title": "スイングを開始しましょう！",
                    "description": "Blast {sport}アプリでスイングするたびにパフォーマンスを計測します。また、Blast Connectを使ってデータの推移を確認することもできます。"
                }
            },
            "boditrak_metrics": "BodiTrakのデータ",
            "boditrak_take_swings": "BodiTrak Dashアプリでスイングを録画します。",
            "dont_have_boditrak": "BodiTrak Dashをお持ちでない場合",
            "boditrak_description": "BodiTrakはグラウンドフォース、圧力、動画分析ソリューションです。",
            "boditrak_mat_separately": "BodiTrakマットは別売りです。",
            "download_ios": "App Storeでダウンロード",
            "download_android": "Google Playで入手",
            "no_sensor_title_golf": "Blast Golfセンサーをお持ちでない場合",
            "no_sensor_title_baseball": "Blast Baseballセンサーをお持ちでない場合",
            "no_sensor_title_softball": "Blast Softballセンサーをお持ちでない場合",
            "no_sensor_desc_golf": "Blast Golfセンサーがスイングとストロークを録画し、データを分析し、上達のためのドリルを提案します。データを理解することで、パットやショットの安定性が増します。",
            "no_sensor_desc_baseball": "Blast Baseballアプリで スイングの動画を撮影し、Blastセンサーの詳しいデータと組み合わせることであなたのテクニックを分析、上達のためのドリルも紹介します。",
            "no_sensor_desc_softball": "Blast Softballスイング分析アプリがスイングのハイライト動画を録画、Blastセンサーの詳しいデータと組み合わせることであなたのテクニックを分析、上達のためのドリルも紹介します。",
            "sunday_shortname": "日",
            "monday_shortname": "月",
            "tuesday_shortname": "火",
            "wednesday_shortname": "水",
            "thursday_shortname": "木",
            "friday_shortname": "金",
            "saturday_shortname": "土",
            "not_going": "参加しない",
            "select_date_range": "期間を選択",
            "training-center": "トレーニングセンター",
            "golf": "ゴルフ",
            "baseball": "野球",
            "softball": "ソフトボール",
            "get_better": "スキルアップ",
            "training-drills": "トレーニングドリル",
            "no_training_center_drills_for": "現在トレーニングセンターには{sport}向けのドリルがありません。あとでまた確認してください。",
            "training-drills-description-app": "ガイド付きトレーニングでスイングを改善しましょう。",
            "pro-tips": "プロのアドバイス",
            "pro-tips-description-app": "全体的なパフォーマンス改善のためのプロのアドバイスです。",
            "back_to_training_center": "「トレーニングセンター」に戻る",
            "back_to_pro_tips": "「プロのアドバイス」に戻る",
            "metrics_title-description-app": "データの意味と説明です。",
            "back_to_drills": "「ドリル」に戻る",
            "golf-putting": "パッティング",
            "golf-full-swing": "フルスイング",
            "golf-short-game": "ショートゲーム",
            "golf-bunker": "バンカー",
            "baseball-swing": "野球のスイング",
            "softball-swing": "ソフトボールのスイング",
            "tm-putting": "パッティング",
            "tm-full-swing": "フルスイング",
            "control": "コントロール",
            "power": "パワー",
            "length": "長さ",
            "timing": "タイミング",
            "angles": "角度",
            "pro-tip": "プロのアドバイス",
            "standard_drill": "標準ドリル",
            "interactive_drill": "インタラクティブドリル",
            "all_putts": "すべてのパット",
            "putt": "パット",
            "putting": "パッティング",
            "swing": "スイング",
            "swing_details": "スイング条件",
            "show_videos_only_phrase": "動画のみ表示",
            "swing_s": "{number}スイング|{number}スイング",
            "full_swing": "フルスイング",
            "full-swing": "フルスイング",
            "short_game": "ショートゲーム",
            "short-game": "ショートゲーム",
            "youth-drills": "ユース向けドリル",
            "bunker": "バンカー",
            "learn_more_about": "{item}について",
            "visit_the_training_center": "「トレーニングセンター」をご覧ください",
            "unassigned": "未割り当て",
            "youth_drills": "ユース向けドリル",
            "member_search": "メンバー検索",
            "academy_search": "チーム検索",
            "subscriber": "プレミアム有料課金プラン加入者",
            "subscriber_report": "プレミアム有料課金プラン加入者レポート",
            "subscriber_reports": "プレミアム有料課金プラン加入者レポート",
            "subscriber_reports_desc": "組織で新しくプレミアム有料課金プランに加入したユーザーのレポートです。",
            "members_reports": "メンバーレポート",
            "members_reports_desc": "チーム内の全メンバーのレポートです。",
            "export_unpaid": "未払いアカウントレポート",
            "export_unpaid_current_academy": "現在のチームの未払いアカウントデータをエクスポート",
            "export_unpaid_all_academy": "すべてのチームの未払いアカウントデータをエクスポート",
            "export_unpaid_explain": "Blast Connectに登録したものの、課金プランの支払いが終わっていないユーザーのレポートです。",
            "admin_user_report": "Blast管理者ユーザーレポート",
            "view_report": "レポートを見る",
            "most_active_reports": "最もアクティブなレポート",
            "most_active_sensors": "最もアクティブなセンサー",
            "most_active_subscriptions": "最もアクティブなプラン",
            "equipments": {
                "golf": {
                    "drivers": {
                        "name": "運転手",
                        "types": {
                            "driver": "運転者"
                        }
                    },
                    "irons": {
                        "name": "アイロン",
                        "types": {
                            "one_iron": "ワンアイアン",
                            "two_iron": "2つの鉄",
                            "three_iron": "スリーアイアン",
                            "four_iron": "フォーアイアン",
                            "five_iron": "ファイブアイアン",
                            "six_iron": "シックスアイアン",
                            "seven_iron": "セブンアイアン",
                            "eight_iron": "エイトアイアン",
                            "nine_iron": "ナインアイアン"
                        }
                    },
                    "wedges": {
                        "name": "厚切りポテト",
                        "types": {
                            "pitching_wedge": "ピッチングウェッジ",
                            "gap_wedge": "ギャップウェッジ",
                            "sand_wedge": "サンドウェッジ",
                            "lob_wedge": "ロブウェッジ"
                        }
                    },
                    "putters": {
                        "name": "パター",
                        "types": {
                            "putter": "パター"
                        }
                    },
                    "training_aids": {
                        "name": "トレーニングエイド",
                        "types": {
                            "super_light": "スーパーライト"
                        }
                    },
                    "fairways_hybrids": {
                        "name": "フェアウェイ/ハイブリッド",
                        "types": {
                            "two_hybrid": "2ハイブリッド",
                            "four_hybrid": "4ハイブリッド"
                        }
                    }
                },
                "baseball": {
                    "bats": {
                        "name": "コウモリ",
                        "types": {
                            "bat": "バット"
                        }
                    }
                },
                "softball": {
                    "bats": {
                        "name": "コウモリ",
                        "types": {
                            "bat": "バット"
                        }
                    }
                }
            },
            "metrics": {
                "load_consistency": "タメの安定性",
                "impact_position": "インパクトの位置",
                "definitions": {
                    "goal": "目標",
                    "pro_average": "プロ平均",
                    "amateur_average": "アマチュア平均",
                    "little_league_average": "リトルリーグ平均",
                    "senior_league_average": "シニアリーグ平均",
                    "high_school_average": "高校平均",
                    "collegiate_pro_average": "大学/プロ平均",
                    "recreational": "レクリエーション",
                    "high_school": "高校生",
                    "travel_ball_12u_14u": "クラブチームU12 - U14",
                    "travel_ball_16u_18u": "クラブチームU16 - U18",
                    "college_non_d1": "大学（D1以外）",
                    "college_d1": "大学（D1）",
                    "professional": "プロ",
                    "tip": "データについて"
                },
                "golf": {
                    "putt": {
                        "back_stroke_time": {
                            "name": "バックストロークの時間",
                            "description": "バックストロークの時間とは、バックストロークを完了するまで（アドレスからバックストロークの頂点まで）にかかった時間のことで、秒で表示されます。",
                            "goal": "ツアープロのバックストロークの時間は約0.60秒です。",
                            "pro_average": "0.57～0.63秒",
                            "amateur_average": "0.54～0.66秒",
                            "tip": "最も安定したバックストロークの時間がわかったら、あらゆる距離のパッティングで繰り返し練習しましょう。",
                            "unit": "秒"
                        },
                        "forward_stroke_time": {
                            "name": "フォワードストロークの時間",
                            "description": "フォワードストロークの時間とは、フォワードストロークを完了するまで（バックストロークの頂点からインパクトまで）にかかった時間のことです。",
                            "goal": "ツアープロのフォワードストロークの時間は約0.30秒で、パットの距離に関係なくバックストロークの時間の半分ほどです。",
                            "pro_average": "0.29～0.31秒",
                            "amateur_average": "0.26～0.34秒",
                            "tip": "フォワードストロークの時間を一定に保ち、テンポの割合が2.0{1}になるよう練習しましょう。フォワードストロークの時間が長すぎるとボールが遅くなります。",
                            "unit": "秒"
                        },
                        "total_stroke_time": {
                            "name": "合計ストローク時間",
                            "description": "合計ストローク時間とは、ストロークの開始からボールへのインパクトまで、パッティングを完了するまでにかかった時間のことで、秒で表示されます。",
                            "goal": "",
                            "pro_average": "0.86～0.94秒",
                            "amateur_average": "0.80～1.00秒",
                            "tip": "パッティングの理想的な合計ストローク時間がわかったら、目標を設定/更新してあらゆる距離で繰り返し練習しましょう。",
                            "unit": "秒"
                        },
                        "tempo": {
                            "name": "テンポ",
                            "description": "テンポとは、バックストロークの時間とフォワードストロークの時間の割合のことです。",
                            "goal": "パターでの理想的なテンポはおおよそ2.0{1}で、バックストロークの時間がフォワードストロークの時間の2倍の長さです。",
                            "pro_average": "1.8{1}～2.2{1}",
                            "amateur_average": "1.6{1}～2.5{1}",
                            "tip": "理想的なテンポがわかったら、目標を設定/更新してあらゆる距離で繰り返し練習しましょう。",
                            "unit": "割合"
                        },
                        "back_stroke_length": {
                            "name": "バックストロークの長さ",
                            "description": "バックストロークの長さとは、バックストロークでのパターフェースの移動距離のことで、アドレスからバックストロークの頂点までの長さがセンチで表示されます。  バックストロークの長さは、グリーンの速さや傾斜、パットの距離など、コンディションによって変わります。  そのためバックストロークの長さは自動的に設定されません。",
                            "goal": "目安として、2.5cmのバックストロークで約30cm転がります（中くらいの速さのフラットなパッティング）。",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "同じ場所からのパッティングを練習する場合は、理想的なバックストロークの長さを決めて目標を設定し、繰り返し練習しましょう。",
                            "unit": "cm"
                        },
                        "impact_stroke_speed": {
                            "name": "インパクトストロークスピード",
                            "description": "インパクトストロークスピードとは、インパクト時のパターフェースのスイートスポットのスピードのことで、時速（km/h）で表示されます。  理想的なストロークスピードは、グリーンの速さや傾斜、パットの距離など、コンディションによって変わります。  そのためストロークスピードは自動的に設定されません。",
                            "goal": "目安として、平らな約0.9ｍのパッティング（中くらいの速さのグリーン）のインパクトストロークスピードは約2.4km/h、約1.8mのパットで約4.8km/hです。",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "同じ場所からのパッティングを練習する場合は、理想的なパッティングのスピードを決めて目標を設定し、繰り返し練習しましょう。",
                            "unit": "km/h"
                        },
                        "loft": {
                            "name": "ロフト変化",
                            "unit": "°",
                            "increased": "増",
                            "decreased": "減",
                            "no_change": "変化なし",
                            "description": "ロフト変化とは、ストローク開始からボールに当たる瞬間までのロフト（縦方向の軌道に対するパターフェースの角度）の増減のことで、「°」で表示されます。  ロフト変化がマイナスの場合はロフトが減っていて、ボールが下向きに飛び、スピードのコントロールに影響します。  ロフト変化がプラスの場合はロフトが増えていて、ボールが上向きに飛び、スピードのコントロールに影響します。",
                            "goal": "理想的なストロークでは、ロフトが増えても減ってもいけません。  ロフト変化は0*になります。",
                            "pro_average": "0.3°",
                            "amateur_average": "1.3°",
                            "tip": ""
                        },
                        "back_stroke_rotation": {
                            "name": "バックストロークのローテーション",
                            "unit": "°",
                            "open": "オープン",
                            "closed": "クローズド",
                            "no_change": "変化なし",
                            "description": "バックストロークのローテーションとは、バックストローク中のパターフェースの回転のことで、「°」で表示されます。  バックストロークのローテーションはパッティングの距離で変わるため、目標は自動的に設定されません。",
                            "goal": "バックストロークのローテーションとフォワードストロークのローテーションが同じになるのが理想的です。",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": ""
                        },
                        "forward_stroke_rotation": {
                            "name": "フォワードストロークのローテーション",
                            "unit": "°",
                            "open": "オープン",
                            "closed": "クローズド",
                            "no_change": "変化なし",
                            "description": "フォワードストロークのローテーションとは、フォワードストローク中のパターフェースの回転のことで、「°」で表示されます。  フォワードストロークのローテーションはパッティングの距離で変わるため、目標は自動的に設定されません。",
                            "goal": "フォワードストロークのローテーションとバックストロークのローテーションが同じになるのが理想的です。",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": ""
                        },
                        "face_angle_at_impact": {
                            "name": "インパクト時のフェース角",
                            "unit": "°",
                            "open": "オープン",
                            "closed": "クローズド",
                            "no_change": "変化なし",
                            "description": "インパクト時のフェース角はバックストロークのローテーションとフォワードストロークのローテーション（シャフト付近のパターフェースの回転）の差で、「°」で表示されます。  インパクト時のフェース角（オープン/+）とは、フォワードストロークでのパターフェースの回転が不十分で、ストローク前の元の向きに戻っていないことを指します。インパクト時のフェース角（クローズド/-）とは、パターフェースが元の向きを越えてしまっていることを指します。",
                            "goal": "パターフェースの最初の向きが目標の中心に真っ直ぐ向いていると仮定すると、インパクト時のフェース角は0.0*になるのが理想です。",
                            "pro_average": "0.3°",
                            "amateur_average": "1.3°",
                            "tip": ""
                        },
                        "lie": {
                            "name": "ライ変化",
                            "unit": "°",
                            "increased": "増",
                            "decreased": "減",
                            "no_change": "変化なし",
                            "description": "ライ変化とは、ストローク開始からボールに当たる瞬間までのライ（クラブシャフトと地面の角度）の増減のことで、「°」で表示されます。  パターの底面がアドレス時に地面に平行になっている場合、手が上がるとライが増え、ヒールがトゥより高くなり、パターフェースが目標の右側に向いてしまいます。  手が下がるとライが減り、トゥがヒールより高くなり、パターフェースが目標の左側に向いてしまいます。",
                            "goal": "理想的なストロークでは、ライが増えても減ってもいけません。  ライ変化は0*になります。",
                            "pro_average": "0.3°",
                            "amateur_average": "1.3°",
                            "tip": ""
                        },
                        "backstroke_speed": {
                            "name": "バックストロークスピード",
                            "unit": "km/h",
                            "description": "Blastデータ（社内のみ）",
                            "goal": "今後のリリースで決定",
                            "pro_average": "今後のリリースで決定",
                            "amateur_average": "今後のリリースで決定",
                            "tip": "今後のリリースで決定"
                        },
                        "forward_to_back_stroke_speed_ratio": {
                            "name": "スピード比",
                            "unit": "",
                            "description": "Blastデータ（社内のみ）",
                            "goal": "今後のリリースで決定",
                            "pro_average": "今後のリリースで決定",
                            "amateur_average": "今後のリリースで決定",
                            "tip": "今後のリリースで決定"
                        }
                    },
                    "swing": {
                        "backswing_time": {
                            "name": "バックスイングの時間",
                            "unit": "秒",
                            "description": "バックスイングの時間とは、バックスイングを完了するまで（アドレスからバックスイングの頂点まで）にかかった時間のことで、秒で表示されます。",
                            "goal": "理想的なバックスイングの時間は、ダウンスイングの時間の2.5～3倍です。理想的なバックスイングの時間はショートゲームやバンカーショットのタイプによって異なりますが、ダウンスイングの時間の2～3倍です。",
                            "pro_average": "ウッド/ドライバー：0.7～0.9秒、ロングアイアン：0.65～0.85秒、アイアン：0.65～0.85秒、ウェッジ：0.65～0.85秒",
                            "amateur_average": "ウッド/ドライバー：0.7～0.9秒、ロングアイアン：0.65～0.85秒、アイアン：0.65～0.85秒、ウェッジ：0.65～0.85秒",
                            "tip": "スイング、ショートゲームでのショット、バンカーショットの理想的なバックスイングの時間がわかったら、目標を設定/更新して繰り返し練習しましょう。"
                        },
                        "downswing_time": {
                            "name": "ダウンスイングの時間",
                            "unit": "秒",
                            "description": "ダウンスイングの時間とは、ダウンスイングを完了するまで（バックスイングの頂点からインパクトまで）にかかった時間のことで、秒で表示されます。",
                            "goal": "理想的なダウンスイングの時間は、フルスイングでのバックスイングの時間の1/2.5～1/3です。理想的なダウンスイングの時間はショートゲームやバンカーショットのタイプによって異なりますが、バックスイングの時間の1/2～1/3倍ほどです。",
                            "pro_average": "ウッド/ドライバー：0.23～0.32秒、ロングアイアン：0.23～0.32秒、アイアン：0.23～0.32秒、ウェッジ：0.23～0.32秒",
                            "amateur_average": "ウッド/ドライバー：0.23～0.32秒、ロングアイアン：0.23～0.32秒、アイアン：0.23～0.32秒、ウェッジ：0.23～0.32秒",
                            "tip": "スイング、ショートゲームでのショット、バンカーショットの理想的なダウンスイングの時間がわかったら、目標を設定/更新して繰り返し練習しましょう。"
                        },
                        "total_swing_time": {
                            "name": "合計スイング時間",
                            "unit": "秒",
                            "description": "合計スイング時間とは、スイングを完了するまで（スイングの開始からインパクトまで）にかかった時間のことで、秒で表示されます。  合計スイング時間はショットの種類によって異なります。",
                            "goal": "",
                            "pro_average": "ウッド/ドライバー：0.93～1.22秒、ロングアイアン：0.88～1.17秒、アイアン：0.88～1.17秒、ウェッジ：0.88～1.17秒",
                            "amateur_average": "ウッド/ドライバー：0.93～1.22秒、ロングアイアン：0.88～1.17秒、アイアン：0.88～1.17秒、ウェッジ：0.88～1.17秒",
                            "tip": "スイング、ショートゲームでのショット、バンカーショットの理想的な合計スイング時間がわかったら、目標を設定/更新して繰り返し練習しましょう。"
                        },
                        "swing_tempo": {
                            "name": "スイングテンポ",
                            "unit": "割合",
                            "description": "スイングテンポとは、バックスイングの時間とダウンスイングの時間の割合です。",
                            "goal": "フルスイングの理想的なテンポは2.5{1}～3.0{1}くらいで、バックスイングの方がダウンスイングよりも2.5～3倍時間がかかります。ショートゲームでの理想的なテンポはショットの種類によって異なりますが、だいたい2.0{1}～3.0{1}くらいです。バックストロークの方がフォワードストロークよりも2～3倍時間がかかります。",
                            "pro_average": "ウッド/ドライバー：2.7{1}～3.3{1}、ロングアイアン：2.7{1}～3.3{1}、アイアン：2.5{1}～3.1{1}、ウェッジ：2.5{1}～3.1{1}",
                            "amateur_average": "ウッド/ドライバー：2.7{1}～3.3{1}、ロングアイアン：2.7{1}～3.3{1}、アイアン：2.5{1}～3.1{1}、ウェッジ：2.5{1}～3.1{1}",
                            "tip": "スイング、ショートゲームでのショット、バンカーショットに最適なテンポがわかったら、目標を設定/更新して繰り返し練習しましょう。"
                        },
                        "attack_angle": {
                            "name": "アッパースイング度",
                            "unit": "",
                            "description": "アタックアングルとはインパクト時のボールに対するクラブヘッドの上下方向の動きのことで、地面に対して測定します。アイアンでは、わずかにダウンブローのアタックアングルが理想的です。ショートゲームやバンカーに強い選手のアタックアングルはウェッジでもわずかにダウンブローです。アプリの目標レンジはプロのツアーデータをもとに決定しています。",
                            "goal": "",
                            "pro_average": "ウッド/ドライバー：イーブン～アップ、ロングアイアン：ダウン、アイアン：ダウン、ウェッジ：ダウン",
                            "amateur_average": "ウッド/ドライバー：イーブン～アップ、ロングアイアン：ダウン、アイアン：ダウン、ウェッジ：ダウン",
                            "tip": "ドライバーでの飛距離を最大限に伸ばすには、インパクト時の角度がボールに対して水平またはアッパーブローになるようにスイングします。",
                            "up": "アップ",
                            "down": "ダウン",
                            "level": "水平"
                        },
                        "swing_speed": {
                            "name": "スイングスピード",
                            "unit": "km/h",
                            "description": "スイングスピードとは、インパクト時のクラブヘッドのスイートスポットのスピードのことで、時速（km/h）で表示されます。  スイングスピードは年齢、能力、可動域の広さ、筋力、体力に加え、ショットの距離やクラブの種類により異なります。  そのためスイングスピードは自動的に設定されません。",
                            "goal": "",
                            "pro_average": "",
                            "amateur_average": "",
                            "tip": "特定のショットを練習する場合は、理想的なスイングスピードを決めて目標を設定し、繰り返し練習しましょう。（違うショットを練習するときや違うクラブを使用するときは新しく目標を設定し直してください。）  ドライバーのスイングスピードを上げるには、目標となるスピードを設定して、それをクリアするまでスイングの動きを練習しましょう。"
                        },
                        "peak_hand_speed": {
                            "name": "手の最大スピード",
                            "unit": "km/h",
                            "description": "手の最大スピードはクラブのグリップ部分で測定し、時速（km/h）で表示されます。  フルスイングのショットでは、インパクトの直前、スイングのコミット時間近くに手のスピードが最大になります。このとき手がスイングのエネルギーをシャフトに伝えて、クラブヘッドが加速して手のスピードを超えます。  アプリで自動的に設定されるレンジに反映されます。  ショートゲームやバンカーショットでは、インパクト直前に手の最大スピードが出るのが理想ですが、ショットの種類により異なります。",
                            "goal": "",
                            "pro_average": "ウッド/ドライバー：27～48km/h、ロングアイアン：25～45km/h、アイアン：25～45km/h、ウェッジ：25～45km/h",
                            "amateur_average": "ウッド/ドライバー：27～48km/h、ロングアイアン：25～45km/h、アイアン：25～45km/h、ウェッジ：25～45km/h",
                            "tip": "ダウンスイングの時間の60%～80%が経過したあたりで手の最大スピードが出るのが理想です。  ショットの効率を上げるには、スイング中の適切なタイミングで手の最大スピードが出るよう練習しましょう。"
                        },
                        "backswing_speed": {
                            "name": "バックスイングスピード",
                            "unit": "km/h",
                            "description": "Blastデータ（社内のみ）",
                            "goal": "今後のリリースで決定",
                            "pro_average": "今後のリリースで決定",
                            "amateur_average": "今後のリリースで決定",
                            "tip": "今後のリリースで決定"
                        },
                        "speed_ratio": {
                            "name": "スピード比",
                            "unit": "割合",
                            "description": "Blastデータ（社内のみ）",
                            "goal": "今後のリリースで決定",
                            "pro_average": "今後のリリースで決定",
                            "amateur_average": "今後のリリースで決定",
                            "tip": "今後のリリースで決定"
                        }
                    }
                },
                "baseball": {
                    "swing": {
                        "swing_speed": {
                            "name": "バットスピード",
                            "unit": "km/h",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "relates_to": "制御なしの力",
                            "description": "インパクト時のバットスピードです。"
                        },
                        "time_to_contact": {
                            "name": "スイング時間",
                            "unit": "秒",
                            "description": "ダウンスイング開始からインパクトまでの時間です。"
                        },
                        "bat_rpm": {
                            "name": "バットRPM",
                            "unit": "rpm",
                            "description": "バットRPMとは、インパクト時のバットの回転スピードです。",
                            "little_league_average": "320～380rpm",
                            "senior_league_average": "355～415rpm",
                            "high_school_average": "390～450rpm",
                            "collegiate_pro_average": "425～485rpm"
                        },
                        "bat_path_angle": {
                            "name": "アッパースイング度",
                            "unit": "°",
                            "description": "インパクト時にバットがボールに当たる角度です。プラスはアッパースイング、マイナスはダウンスイングです。",
                            "relates_to": "スイングの方向"
                        },
                        "blast_factor": {
                            "name": "Blast係数",
                            "description": "各要素を以下の比重で算出した全体的なスイングスコア：\nオンプレーンスコア：15%\nピークのバットスピードスコア：10%\nアッパースイング度スコア：10%\n体の回転スコア：15%\nパワースコア：50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast係数",
                            "description": "「Blast係数」とは、計測中の全体的なパフォーマンスに対するスコア（0～100）のことです。"
                        },
                        "efficiency_index": {
                            "name": "効率指数",
                            "description": "効率指数とは、いかに効率よくエネルギーを発生させてボールに伝えているかを示すスコアで、0～100で表示されます。エネルギー伝達、バット軌道、バットウィップのスコアを合わせたものです。",
                            "tip": "理想的な効率指数は100です。パワーを犠牲にすることなく、効率指数をできるだけ増やすことが目標です。"
                        },
                        "power_index": {
                            "name": "パワー指数",
                            "description": "パワー指数とは、力そのものを示すスコアで、0～100で表示されます。打球のスピードはバットの重さ、スイングスピード、インパクトの質で決まります。パワー指数では重さとスピードに加え、そのスピードが出るまでの時間にも重点を置いています。ニュートンの運動の第2法則では、「力＝質量×加速度」、または「力＝質量×スイングスピード÷インパクトまでの時間」です。短い時間で大きなスイングができれば、パワー指数も大きくなります。",
                            "tip": "理想的なパワー指数は100です。この数値にどのくらい近付けるかは、年齢、筋力、技術レベル、バットのサイズや重さにより異なります。効率を犠牲にすることなく、できる限り高いパワー指数を出すことが目標です。"
                        },
                        "energy_transfer": {
                            "name": "エネルギー伝達",
                            "description": "エネルギー伝達とは、体からバットにどのようにエネルギーが伝わっているかを示すスコアで、0～100で表示されます。運動連鎖（腰→肩→腕→手首）により回転し、バットにエネルギーが伝わります。体を使ってスピードを出すことで、さらに効率的にバットスピードが出て、腕の力が少なくて済みます。腕の力に頼っているとバットスピードが安定せず、速いスピードも出ません。スイング前半のスピードとスイング後半のスピードを比較し、体をどれくらい効率的に使えているかを判定します。エネルギー伝達は効率指数の要素の1つです。",
                            "tip": "回転効率のよいスイングでは、スイングの前半でスピードの約半分が発生します。スピードの発生源は腕と手首ではなく、腰と肩です。目標はスイングの前半で45～55％程のスピードを出すことです。これより低い数値だと、エネルギー伝達スコアが100より低くなります。腕に頼りすぎている（体から腕が離れている）とスコアが低くなります。目標のパーセンテージに達する（または超える）と、エネルギー伝達スコアは100になります。超えても減点にはなりませんが、実際の試合でバットをコントロールしにくくなったり、ボールに合わせにくくなる可能性があります。靴が脱げそうなスイングだね！"
                        },
                        "bat_whip": {
                            "name": "バットウィップ",
                            "description": "バットウィップは効率指数の1つです。スイング中の回転スピード（RPM）がピークに達した瞬間とインパクトの瞬間の間の時間を測定します。インパクト時に回転スピードがピークに達するのが効率的なスイングです。",
                            "tip": "インパクト時に回転スピードがピークに達するのが効率的な野球のスイングです。これを達成できれば、インパクト前にバットウィップが出たことを示す線が3Dスイングに表示されません。"
                        },
                        "bat_path": {
                            "name": "バット軌道",
                            "description": "バット軌道は効率指数の1つです。飛距離を最大限に伸ばすスイングスピードとバット軌道の角度をもとにしたスコアです。例：スイングスピードが56km/hのときは、スイングが22°であれば飛距離が最も伸びます。88km/hなら15°、120km/hなら7°、137km/hなら3°です。一般的に、スイングスピードが速いほど、最大飛距離を出すのに必要な角度が小さくなります。",
                            "tip": "理想的なバット軌道は、投球の角度、スイングスピード、打撃の状況など、さまざまな要素により異なります。この場合のバット軌道のスコアは、打球の飛距離を伸ばすことを目的に設定しています。3～22°であれば、効率指数のバット軌道で高いスコアが出ますが、この角度はスイングスピードによって異なります。一般的にはスイングスピードが速いほど、飛距離を伸ばすための角度が小さくなります。"
                        },
                        "barrel_acceleration": {
                            "name": "バットの加速",
                            "description": "バットの加速は効率指数の1つです。バットスピードの2/3（66%）がスイングの最後1/3の部分で出るのが理想的な加速で、スコアは0～10で表示されます。効率的なスイングはインパクト時に加速のピークが来ます。つまり、ダウンスイングの開始からインパクトの瞬間まで加速するということです。スイングの前半で加速のピークを迎えてしまうと、ボールに伝わる力が小さくなります。",
                            "tip": "常に理想のスコア10を目指してください。ダイナミックな加速でインパクト時に加速のピークが来るようにしましょう。ボールを強く打てるようになり、上達につながります。"
                        },
                        "peak_speed": {
                            "name": "最高バットスピード",
                            "unit": "km/h",
                            "description": "最高バットスピードはバットのスイートスポットの前方への最高スピードで、バットの先端から約15cmのところで測定します。インパクト時またはインパクト前に最高バットスピードが出ることがあります。\n\nインパクト時にバットスピードがピークに達すると、打球スピードと飛距離が伸びます。スイングの効率が悪く、インパクト時のバットスピードが遅くなっているとインパクト時に最高スピードが出ないので、ボールを強く打てません。\n\n投球を読み、自分のスイング時間を把握できれば、最高スピードに近いスピードでインパクトできるようになります。  計測では、最高バットスピードがインパクト時のバットスピードは同じかほぼ同じ数値になるのが理想です。"
                        },
                        "bat_whip_sec_prior": {
                            "name": "最大スピード（インパクト前）",
                            "unit": "秒",
                            "description": "最大スピード（インパクト前）は最大スピードが出た瞬間からインパクトの瞬間までの時間で、秒で表示されます。効率的な野球のスイングではインパクトの瞬間に最大スピードが出ます。そのため、最大スピード（インパクト前）の理想的な数値は0です。"
                        },
                        "power": {
                            "name": "パワー",
                            "unit": "kW",
                            "description": "スイング中に発生するパワーの量（キロワット）です。"
                        },
                        "vertical_bat_angle": {
                            "name": " バット角度",
                            "unit": "°",
                            "description": "インパクト時のヘッド角度です。手よりもヘッドが下がっていると数値がマイナスになります。"
                        },
                        "body_tilt_angle": {
                            "name": "体の角度",
                            "unit": "°",
                            "description": "体の回転の中心点から算出したおおよその傾きを3Dアニメーションで表示します。体の軸の角度は、前後左右への傾きを合わせて測定し、3Dスイングに表示します。"
                        },
                        "peak_hand_speed": {
                            "name": "手の最大スピード",
                            "unit": "km/h",
                            "description": "スイング中の手の最大スピードです。"
                        },
                        "on_plane": {
                            "name": "オンプレーン",
                            "unit": "%",
                            "description": "オンプレーンのデータは、スイング中バットのスイートスポットがオンプレーンに乗っている割合を測定します。  基準となるオンプレーンはインパクト時に決まります。  スイングのオンプレーンのパーセンテージは、基準となるオンプレーン中に発生したスピードで決まります。\n\nこのパーセンテージを上げることを目指しましょう。  オンプレーンのパーセンテージは高いほど良いです。ダウンスイング中にバットを意識したりコントロールしたりする必要が減るからです。打者の構えとオンプレーンのデータには高い相関関係があります。  スイング開始時にまっすぐ立ち、スイングが始まってからスイングプレーンにバットを落とす打者に比べると、プレートの方に体が傾いている打者の方がオンプレーンに乗っている時間が長くなります。\n\nオンプレーンの平均パーセンテージが60%以上であれば、うまくスイングできています。  通常は55～65%の間です。  オンプレーンのデータでは、数値が上がるほど良いスイングで、バットと体の角度が正しく維持できていることになります。"
                        },
                        "body_rotation": {
                            "name": "体の回転",
                            "unit": "%",
                            "description": "野球のスイングでは、バットスピードは体とバットの回転で決まります。  Blastは高度なアルゴリズムモデルを活用して、バットに取り付けたセンサーから体の回転とバットの回転の両方を測定します。  打者が手首を緩めてスイングを開始した後、体の回転とバットの回転を比較することで、スイング中の体とバットの角度を分析できます。体の回転は、スイング開始後の回転の合計に対する体の回転の割合で表示されます。\n\nほとんどの選手で体の回転率の平均は45%で、40～50%の間に収まるはずです。  常にこのレンジを外れている場合は、打者の運動連鎖のパターンに欠点があると思われます。平均値の45％から外れる、または40～50％のレンジから外れるのは、投球コースが原因であるとも考えられます。  内角低めや外角高めのコースでは、スイングにさらなる適応力が必要になります。  スイング中の体とバットの回転パターンがずれるほど、体の回転率のずれも大きくなります。"
                        },
                        "planar_efficiency": {
                            "name": "オンプレーンの効率",
                            "score_name": "オンプレーン",
                            "unit": "%",
                            "description": "スイング中にバットがオンプレーンに乗っている割合を測定します。インパクト時のバット角度でオンプレーンが決まります。バットが安定してインパクトできているかはオンプレーンでわかります。",
                            "relates_to": "スイング軌道",
                            "relates_to_tab": "インパクト",
                            "blast_iq_description": "オンプレーンのスコアはオンプレーンの効率データから直接算出し、{scouting_scale}で評価されます。<strong>インパクト</strong>では、オンプレーンの効率は重要なデータです。<br><br>インパクトが強ければ、ボールを強く打てるようになります。",
                            "blast_iq_carousel_title": "インパクトのスイングデータには2つのデータが含まれます。オンプレーンの効率はスイング軌道で、アッパースイング度はスイングの方向です。",
                            "charts_description": "スイング軌道とスイングの方向が良ければ、インパクトのデータも良くなります。つまり、オンプレーンの効率とアッパースイング度の両方がレベルアップに欠かせません。"
                        },
                        "rotational_acceleration": {
                            "name": "体の回転によるバットの加速の大きさ（初動）",
                            "score_name": "回転",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "unit": "G",
                            "description": "バットがオンプレーンに乗るまでの加速度を測定します。体の回転によるバットの加速の大きさ（初動）を見ると、手打ちではなく、一連の正しい動作でスイングスピードが上がっているのか、傾向がわかります。体の回転によるバットの加速の大きさ（初動）が大きいほどパワーも増し、様々な投球コースにも適応できる可能性があります。",
                            "relates_to": "パワー効率",
                            "relates_to_tab": "パワー",
                            "blast_iq_description": "回転のスコアは回転の強さデータから直接算出し、{scouting_scale}で評価されます。<strong>パワー</strong>では、回転の強さは重要なデータです。<br><br>パワーがが優れた打者は、インパクトを犠牲にすることなく力強く打てるようになります。Blastでは、これを「ダイナミックパワー」と呼んでいます。",
                            "blast_iq_carousel_title": "パワーのスイングデータには2つのデータが含まれます。バットスピードは制御なしの力で、回転の強さはパワー効率です。",
                            "charts_description": "パワーのデータが良ければ、力強く効率的ということになります。つまり、回転の強さとバットスピードの両方がレベルアップに欠かせません。"
                        },
                        "connection": {
                            "name": " 体とバットの角度（インパクト）",
                            "score_name": "体とバットの角度",
                            "unit": "°",
                            "description": "インパクト時の体とバットの角度を測定します。どのコースに対しても体とバットの角度（90°）を維持できることが、適応能力があることを示しています。",
                            "relates_to": "スイングの安定度",
                            "relates_to_tab": "スイングの安定度",
                            "blast_iq_description": "体とバットの角度のスコアは、スイング前の体とバットの角度とインパクト時の体とバットの角度から直接算出し、{scouting_scale}で評価されます。<br><br>スイング前からインパクト時まで体とバットの角度を維持できる打者は、オンプレーンの効率が優れており、ゾーン内の投球への適応能力も優れています。",
                            "blast_iq_carousel_title": "<strong>安定度</strong>には2つのデータが含まれます。スイング前の体とバットの角度は<strong>タメの安定性</strong>の重要データです。インパクト時の体とバットの角度は<strong>インパクトの位置</strong>の重要データです。",
                            "charts_description": "体とバットの角度をヘッド角度と比べることで、ヒッティングゾーン内での安定性と適応力を可視化できます。ヘッド角度は低めのコースでは大きく、高めのコースでは水平に近くなります。"
                        },
                        "early_connection": {
                            "name": " 体とバットの角度（構え）",
                            "unit": "°",
                            "relates_to": "タメの安定性",
                            "description": "ダウンスイング開始時の体とバットの角度を測定します。スイング前の体とバットの角度が90°の場合、バットをすばやくオンプレーンに乗せることができ、さまざまな投球コースに適応できる可能性があります。"
                        },
                        "commit_time": {
                            "name": "コミット時間",
                            "unit": "秒",
                            "description": "コミット時間とは、ダウンスイング中に打者が手首を緩めて投球を見極める時間のことです。"
                        },
                        "plane_score": {
                            "name": "オンプレーンスコア",
                            "description": "各スイング平面の効率をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "connection_score": {
                            "name": "体とバットの角度スコア",
                            "description": "各スイングにおけるスイング前とインパクト時の体とバットの角度をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "rotation_score": {
                            "name": "回転スコア",
                            "description": "各スイングの回転の強さをスカウティングスケール（20～80）に基づいて採点します。  同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "exit_velocity": {
                            "name": "打球スピード",
                            "unit": "km/h"
                        },
                        "launch_angle": {
                            "name": "打球角度",
                            "unit": "°"
                        },
                        "estimated_distance": {
                            "name": "推定飛距離",
                            "unit": "m"
                        },
                        "ball_direction": {
                            "name": "ボールの方向"
                        },
                        "field_angle": {
                            "name": "フィールドの角度",
                            "unit": "°"
                        }
                    }
                },
                "softball": {
                    "swing": {
                        "swing_speed": {
                            "name": "バットスピード",
                            "unit": "km/h",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "relates_to": "制御なしの力",
                            "description": "インパクト時のバットスピードです。 "
                        },
                        "time_to_contact": {
                            "name": "スイング時間",
                            "unit": "秒",
                            "description": "ダウンスイング開始からインパクトまでの時間です。",
                            "tip": "インパクトまでの時間は、スピードと安定性で決まります。投球に反応するためには、インパクトまでの時間をできるだけ短くしなければなりません。また、スイング間の動作も安定させる必要があります。変化する唯一の要素は、スイングを開始するタイミングです。あとは体が勝手に動き、運動連鎖が起こります。理想的なインパクトまでの時間は年齢、体力、バットの長さや重さ、経験、スイングスタイルによって異なります。Blastでは年齢やレベルごとにインパクトまでの時間を表示します。"
                        },
                        "bat_rpm": {
                            "name": "バットRPM",
                            "unit": "rpm",
                            "description": "バットRPMとは、インパクト時のバットのグリップ部分の回転スピードです。（X、Y、Z軸の回転を合わせたもので）高いほど良いスコアです。練習では、理想的なバットRPMは年齢、技術レベル、バットの長さや重さによって異なります。年齢や筋力が上がるほど、バットRPMも効率的に出せるようになります。"
                        },
                        "bat_path_angle": {
                            "name": "アッパースイング度",
                            "unit": "°",
                            "description": "インパクト時にバットがボールに当たる角度です。プラスはアッパースイング、マイナスはダウンスイングです。",
                            "relates_to": "スイングの方向"
                        },
                        "blast_factor": {
                            "name": "Blast係数",
                            "description": "各要素を以下の比重で算出した全体的なスイングスコア：\nオンプレーンスコア：15%\nピークのバットスピードスコア：10%\nアッパースイング度スコア：10%\n体の回転スコア：15%\nパワースコア：50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast係数",
                            "description": "「Blast係数」とは、計測中の全体的なパフォーマンスに対するスコア（0～100）のことです。"
                        },
                        "efficiency_index": {
                            "name": "効率指数",
                            "description": "効率指数とは、いかに効率よくエネルギーを発生させてボールに伝えているかを示すスコアで、0～100で表示されます。エネルギー伝達、バット軌道、バットウィップのスコアを合わせたものです。効率指数は重要なデータです。運動連鎖を通じて効率的にエネルギーを伝達し、スイングを投球に合わせ、タイミング良くスイングできれば、体からバット、ボールへと最大限にエネルギーを伝達できるからです。理想的な効率指数は100です。パワーを犠牲にすることなく、効率指数をできるだけ増やすことが目標です。",
                            "tip": "理想的な効率指数は100です。パワーを犠牲にすることなく、効率指数をできるだけ増やすことが目標です。"
                        },
                        "power_index": {
                            "name": "パワー指数",
                            "description": "パワー指数とは、力そのものを示すスコアで、0～100で表示されます。打球のスピードはバットの重さ、スイングスピード、インパクトの質で決まります。パワー指数では重さとスピードに加え、そのスピードが出るまでの時間にも重点を置いています。ニュートンの運動の第2法則では、「力＝質量x加速度」、または「力＝質量xスイングスピード÷インパクトまでの時間」です。短い時間で大きなスイングができれば、パワー指数も大きくなります。この数値にどのくらい近付けるかは、年齢、筋力、技術レベル、バットのサイズや重さにより異なります。効率を犠牲にすることなく、できる限り高いパワー指数を出すことが目標です。",
                            "tip": "理想的なパワー指数は100です。この数値にどのくらい近付けるかは、年齢、筋力、技術レベル、バットのサイズや重さにより異なります。効率を犠牲にすることなく、できる限り高いパワー指数を出すことが目標です。"
                        },
                        "energy_transfer": {
                            "name": "エネルギー伝達",
                            "description": "エネルギー伝達とは、体からバットにどのようにエネルギーが伝わっているかを示すスコアで、0～100で表示されます。運動連鎖（腰→肩→腕→手首）により回転し、バットにエネルギーが伝わります。体を使ってスピードを出すことで、さらに効率的にバットスピードが出て、腕の力が少なくて済みます。腕の力に頼っているとバットスピードが安定せず、速いスピードも出ません。スイング前半のスピードとスイング後半のスピードを比較し、体をどれくらい効率的に使えているかを判定します。エネルギー伝達は効率指数の要素の1つです。回転効率のよいスイングでは、スイングの前半でスピードの約半分が発生します。スピードの発生源は腕と手首ではなく、腰と肩です。目標はスイングの前半で45～55％程のスピードを出すことです。これより低い数値だと、エネルギー伝達スコアが100より低くなります。腕に頼りすぎている（体から腕が離れている）とスコアが低くなります。目標のパーセンテージに達する（または超える）と、エネルギー伝達スコアは100になります。目標を超えても減点にはなりませんが、実際の試合でバットをコントロールしにくくなったり、ボールに合わせにくくなることがあります。靴が脱げそうなスイングだね！",
                            "tip": "回転効率のよいスイングでは、スイングの前半でスピードの約半分が発生します。スピードの発生源は腕と手首ではなく、腰と肩です。目標はスイングの前半で45～55％程のスピードを出すことです。これより低い数値だと、エネルギー伝達スコアが100より低くなります。腕に頼りすぎている（体から腕が離れている）とスコアが低くなります。目標のパーセンテージに達する（または超える）と、エネルギー伝達スコアは100になります。超えても減点にはなりませんが、実際の試合でバットをコントロールしにくくなったり、ボールに合わせにくくなる可能性があります。靴が脱げそうなスイングだね！"
                        },
                        "bat_whip": {
                            "name": "バットウィップ",
                            "description": "バットウィップは効率指数の1つです。スイング中の回転スピード（RPM）がピークに達した瞬間とインパクトの瞬間の間の時間を測定します。インパクト時に回転スピードがピークに達するのが効率的なスイングです。",
                            "tip": "インパクト時に回転スピードがピークに達するのが効率的な野球のスイングです。これを達成できれば、インパクト前にバットウィップが出たことを示す線が3Dスイングに表示されません。"
                        },
                        "bat_path": {
                            "name": "バット軌道",
                            "description": "理想的なバット軌道の角度は、投球の角度、スイングスピード、打撃の状況などにより異なります。バット軌道のスコアは打球の飛距離を伸ばすことを目的に設定しています。一般的にはスイングスピードが速いほど、最大飛距離を得るための角度が小さくなります。バット軌道のスコアは、（ボールにしっかりインパクトしたと仮定して）実際のバット軌道の角度と、スイングスピードに対する最大飛距離を出せる理想的な角度との違いをもとに0～100で表示されます。バット軌道は効率指数の1つです。理想的なバット軌道のスコア100は、実際のバット軌道の角度がスイングスピードに対する最大飛距離を出せる理想的な角度と一致したときに出ます。飛距離が最大になる角度は、スイングスピードが56km/hなら+22°、88km/hなら+15°、120km/hなら+7°。136km/hなら+3°です。",
                            "tip": "理想的なバット軌道は、投球の角度、スイングスピード、打撃の状況など、さまざまな要素により異なります。この場合のバット軌道のスコアは、打球の飛距離を伸ばすことを目的に設定しています。3～22°であれば、効率指数のバット軌道で高いスコアが出ますが、この角度はスイングスピードによって異なります。一般的にはスイングスピードが速いほど、飛距離を伸ばすための角度が小さくなります。"
                        },
                        "barrel_acceleration": {
                            "name": "バットの加速",
                            "description": "バットの加速は効率指数の1つです。バットスピードの2/3（66%）がスイングの最後1/3の部分で出るのが理想的な加速で、スコアは0～10で表示されます。効率的なスイングはインパクト時に加速のピークが来ます。つまり、ダウンスイングの開始からインパクトの瞬間まで加速するということです。スイングの前半で加速のピークを迎えてしまうと、ボールに伝わる力が小さくなります。",
                            "tip": "常に理想のスコア10を目指してください。ダイナミックな加速でインパクト時に加速のピークが来るようにしましょう。ボールを強く打てるようになり、上達につながります。"
                        },
                        "peak_speed": {
                            "name": "最高バットスピード",
                            "unit": "km/h",
                            "description": "最高バットスピードはバットのスイートスポットの前方への最高スピードで、バットの先端から約15cmのところで測定します。インパクト時またはインパクト前に最高バットスピードが出ることがあります。\n\nインパクト時にバットスピードがピークに達すると、打球スピードと飛距離が伸びます。スイングの効率が悪く、インパクト時のバットスピードが遅くなっているとインパクト時に最高スピードが出ないので、ボールを強く打てません。\n\n投球を読み、自分のスイング時間を把握できれば、最高スピードに近いスピードでインパクトできるようになります。  計測では、最高バットスピードがインパクト時のバットスピードは同じかほぼ同じ数値になるのが理想です。"
                        },
                        "bat_whip_sec_prior": {
                            "name": "バットウィップ（秒前）",
                            "unit": "秒前",
                            "description": ""
                        },
                        "power": {
                            "name": "パワー",
                            "unit": "kW",
                            "description": "スイング中に発生するパワーの量（キロワット）です。"
                        },
                        "vertical_bat_angle": {
                            "name": " バット角度",
                            "unit": "°",
                            "description": "インパクト時のヘッド角度です。手よりもヘッドが下がっていると数値がマイナスになります。"
                        },
                        "body_tilt_angle": {
                            "name": "体の角度",
                            "unit": "°",
                            "description": "体の回転の中心点から算出したおおよその傾きを3Dアニメーションで表示します。体の軸の角度は、前後左右への傾きを合わせて測定し、3Dスイングに表示します。"
                        },
                        "peak_hand_speed": {
                            "name": "手の最大スピード",
                            "unit": "km/h",
                            "description": "スイング中の手の最大スピードです。"
                        },
                        "on_plane": {
                            "name": "オンプレーン",
                            "unit": "%",
                            "description": "オンプレーンのデータは、スイング中バットのスイートスポットがオンプレーンに乗っている割合を測定します。  基準となるオンプレーンはインパクト時に決まります。  スイングのオンプレーンのパーセンテージは、基準となるオンプレーン中に発生したスピードで決まります。\n\nこのパーセンテージを上げることを目指しましょう。  オンプレーンのパーセンテージは高いほど良いです。ダウンスイング中にバットを意識したりコントロールしたりする必要が減るからです。打者の構えとオンプレーンのデータには高い相関関係があります。  スイング開始時にまっすぐ立ち、スイングが始まってからスイングプレーンにバットを落とす打者に比べると、プレートの方に体が傾いている打者の方がオンプレーンに乗っている時間が長くなります。\n\nオンプレーンの平均パーセンテージが60%以上であれば、うまくスイングできています。  通常は55～65%の間です。  オンプレーンのデータでは、数値が上がるほど良いスイングで、バットと体の角度が正しく維持できていることになります。"
                        },
                        "body_rotation": {
                            "name": "体の回転",
                            "unit": "%",
                            "description": "ソフトボールのスイングでは、バットスピードは体とバットの回転で決まります。  Blastは高度なアルゴリズムモデルを活用して、バットに取り付けたセンサーから体の回転とバットの回転の両方を測定します。  打者が手首を緩めてスイングを開始した後、体の回転とバットの回転を比較することで、スイング中の体とバットの角度を分析できます。体の回転は、スイング開始後の回転の合計に対する体の回転の割合で表示されます。\n\nほとんどの選手で体の回転率の平均は45%で、40～50%の間に収まるはずです。  常にこのレンジを外れている場合は、打者の運動連鎖のパターンに欠点があると思われます。平均値の45％から外れる、または40～50％のレンジから外れるのは、投球コースが原因であるとも考えられます。  内角低めや外角高めのコースでは、スイングにさらなる適応力が必要になります。  スイング中の体とバットの回転パターンがずれるほど、体の回転率のずれも大きくなります。"
                        },
                        "planar_efficiency": {
                            "name": "オンプレーンの効率",
                            "score_name": "オンプレーン",
                            "unit": "%",
                            "description": "スイング中にバットがオンプレーンに乗っている割合を測定します。インパクト時のバット角度でオンプレーンが決まります。バットが安定してインパクトできているかはオンプレーンでわかります。",
                            "relates_to": "スイング軌道",
                            "relates_to_tab": "連絡先",
                            "blast_iq_description": "オンプレーンのスコアはオンプレーンの効率データから直接算出し、{scouting_scale}で評価されます。<strong>インパクト</strong>では、オンプレーンの効率は重要なデータです。<br><br>インパクトが強ければ、ボールを強く打てるようになります。",
                            "blast_iq_carousel_title": "インパクトのスイングデータには2つのデータが含まれます。オンプレーンの効率はスイング軌道で、アッパースイング度はスイングの方向です。",
                            "charts_description": "スイング軌道とスイングの方向が良ければ、インパクトのデータも良くなります。つまり、オンプレーンの効率とアッパースイング度の両方がレベルアップに欠かせません。"
                        },
                        "rotational_acceleration": {
                            "name": "体の回転によるバットの加速の大きさ（初動）",
                            "score_name": "回転",
                            "unit": "G",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "description": "バットがオンプレーンに乗るまでの加速度を測定します。体の回転によるバットの加速の大きさ（初動）を見ると、手打ちではなく、一連の正しい動作でスイングスピードが上がっているのか、傾向がわかります。体の回転によるバットの加速の大きさ（初動）が大きいほどパワーも増し、様々な投球コースにも適応できる可能性があります。",
                            "relates_to": "パワー効率",
                            "relates_to_tab": "パワー",
                            "blast_iq_description": "回転のスコアは回転の強さデータから直接算出し、{scouting_scale}で評価されます。<strong>パワー</strong>では、回転の強さは重要なデータです。<br><br>パワーがが優れた打者は、インパクトを犠牲にすることなく力強く打てるようになります。Blastでは、これを「ダイナミックパワー」と呼んでいます。",
                            "blast_iq_carousel_title": "パワーのスイングデータには2つのデータが含まれます。バットスピードは制御なしの力で、回転の強さはパワー効率です。",
                            "charts_description": "パワーのデータが良ければ、力強く効率的ということになります。つまり、回転の強さとバットスピードの両方がレベルアップに欠かせません。"
                        },
                        "connection": {
                            "name": " 体とバットの角度（インパクト）",
                            "score_name": "バットと体の角度",
                            "unit": "°",
                            "description": "インパクト時の体とバットの角度を測定します。どのコースに対しても体とバットの角度（90°）を維持できることが、適応能力があることを示しています。",
                            "relates_to": "スイングの安定度",
                            "relates_to_tab": "スイングの安定度",
                            "blast_iq_description": "体とバットの角度のスコアは、スイング前の体とバットの角度とインパクト時の体とバットの角度から直接算出し、{scouting_scale}で評価されます。<br><br>スイング前からインパクト時まで体とバットの角度を維持できる打者は、オンプレーンの効率が優れており、ゾーン内の投球への適応能力も優れています。",
                            "blast_iq_carousel_title": "<strong>安定度</strong>には2つのデータが含まれます。スイング前の体とバットの角度は<strong>タメの安定性</strong>の重要データです。インパクト時の体とバットの角度は<strong>インパクトの位置</strong>の重要データです。",
                            "charts_description": "体とバットの角度をヘッド角度と比べることで、ヒッティングゾーン内での安定性と適応力を可視化できます。ヘッド角度は低めのコースでは大きく、高めのコースでは水平に近くなります。"
                        },
                        "early_connection": {
                            "name": " 体とバットの角度（構え）",
                            "unit": "°",
                            "relates_to": "タメの安定性",
                            "description": "ダウンスイング開始時の体とバットの角度を測定します。スイング前の体とバットの角度が90°の場合、バットをすばやくオンプレーンに乗せることができ、さまざまな投球コースに適応できる可能性があります。"
                        },
                        "commit_time": {
                            "name": "コミット時間",
                            "unit": "秒",
                            "description": "コミット時間とは、ダウンスイング中に打者が手首を緩めて投球を見極める時間のことです。"
                        },
                        "plane_score": {
                            "name": "オンプレーンスコア",
                            "description": "各スイング平面の効率をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "connection_score": {
                            "name": "体とバットの角度スコア",
                            "description": "各スイングにおけるスイング前とインパクト時の体とバットの角度をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "rotation_score": {
                            "name": "体の回転による加速スコア",
                            "description": "各スイングの回転の強さをスカウティングスケール（20～80）に基づいて採点します。  同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "exit_velocity": {
                            "name": "打球スピード",
                            "unit": "km/h"
                        },
                        "launch_angle": {
                            "name": "打球角度",
                            "unit": "°"
                        },
                        "estimated_distance": {
                            "name": "推定飛距離",
                            "unit": "m"
                        },
                        "ball_direction": {
                            "name": "ボールの方向"
                        },
                        "field_angle": {
                            "name": "フィールドの角度",
                            "unit": "°"
                        }
                    },
                    "slap": {
                        "swing_speed": {
                            "name": "バットスピード",
                            "unit": "km/h",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "relates_to": "制御なしの力",
                            "description": "インパクト時のバットスピードです。 "
                        },
                        "time_to_contact": {
                            "name": "スイング時間",
                            "unit": "秒",
                            "description": "ダウンスイング開始からインパクトまでの時間です。",
                            "tip": "インパクトまでの時間は、スピードと安定性で決まります。投球に反応するためには、インパクトまでの時間をできるだけ短くしなければなりません。また、スイング間の動作も安定させる必要があります。変化する唯一の要素は、スイングを開始するタイミングです。あとは体が勝手に動き、運動連鎖が起こります。理想的なインパクトまでの時間は年齢、体力、バットの長さや重さ、経験、スイングスタイルによって異なります。Blastでは年齢やレベルごとにインパクトまでの時間を表示します。"
                        },
                        "bat_rpm": {
                            "name": "バットRPM",
                            "unit": "rpm",
                            "description": "バットRPMとは、インパクト時のバットのグリップ部分の回転スピードです。（X、Y、Z軸の回転を合わせたもので）高いほど良いスコアです。練習では、理想的なバットRPMは年齢、技術レベル、バットの長さや重さによって異なります。年齢や筋力が上がるほど、バットRPMも効率的に出せるようになります。"
                        },
                        "bat_path_angle": {
                            "name": "アッパースイング度",
                            "unit": "°",
                            "description": "インパクト時にバットがボールに当たる角度です。プラスはアッパースイング、マイナスはダウンスイングです。",
                            "relates_to": "スイングの方向"
                        },
                        "blast_factor": {
                            "name": "Blast係数",
                            "description": "各要素を以下の比重で算出した全体的なスイングスコア：\nオンプレーンスコア：15%\nピークのバットスピードスコア：10%\nアッパースイング度スコア：10%\n体の回転スコア：15%\nパワースコア：50%"
                        },
                        "blast_factor_2": {
                            "name": "Blast係数",
                            "description": "「Blast係数」とは、計測中の全体的なパフォーマンスに対するスコア（0～100）のことです。"
                        },
                        "efficiency_index": {
                            "name": "効率指数",
                            "description": "効率指数とは、いかに効率よくエネルギーを発生させてボールに伝えているかを示すスコアで、0～100で表示されます。エネルギー伝達、バット軌道、バットウィップのスコアを合わせたものです。効率指数は重要なデータです。運動連鎖を通じて効率的にエネルギーを伝達し、スイングを投球に合わせ、タイミング良くスイングできれば、体からバット、ボールへと最大限にエネルギーを伝達できるからです。理想的な効率指数は100です。パワーを犠牲にすることなく、効率指数をできるだけ増やすことが目標です。",
                            "tip": "理想的な効率指数は100です。パワーを犠牲にすることなく、効率指数をできるだけ増やすことが目標です。"
                        },
                        "power_index": {
                            "name": "パワー指数",
                            "description": "パワー指数とは、力そのものを示すスコアで、0～100で表示されます。打球のスピードはバットの重さ、スイングスピード、インパクトの質で決まります。パワー指数では重さとスピードに加え、そのスピードが出るまでの時間にも重点を置いています。ニュートンの運動の第2法則では、「力＝質量x加速度」、または「力＝質量xスイングスピード÷インパクトまでの時間」です。短い時間で大きなスイングができれば、パワー指数も大きくなります。この数値にどのくらい近付けるかは、年齢、筋力、技術レベル、バットのサイズや重さにより異なります。効率を犠牲にすることなく、できる限り高いパワー指数を出すことが目標です。",
                            "tip": "理想的なパワー指数は100です。この数値にどのくらい近付けるかは、年齢、筋力、技術レベル、バットのサイズや重さにより異なります。効率を犠牲にすることなく、できる限り高いパワー指数を出すことが目標です。"
                        },
                        "energy_transfer": {
                            "name": "エネルギー伝達",
                            "description": "エネルギー伝達とは、体からバットにどのようにエネルギーが伝わっているかを示すスコアで、0～100で表示されます。運動連鎖（腰→肩→腕→手首）により回転し、バットにエネルギーが伝わります。体を使ってスピードを出すことで、さらに効率的にバットスピードが出て、腕の力が少なくて済みます。腕の力に頼っているとバットスピードが安定せず、速いスピードも出ません。スイング前半のスピードとスイング後半のスピードを比較し、体をどれくらい効率的に使えているかを判定します。エネルギー伝達は効率指数の要素の1つです。回転効率のよいスイングでは、スイングの前半でスピードの約半分が発生します。スピードの発生源は腕と手首ではなく、腰と肩です。目標はスイングの前半で45～55％程のスピードを出すことです。これより低い数値だと、エネルギー伝達スコアが100より低くなります。腕に頼りすぎている（体から腕が離れている）とスコアが低くなります。目標のパーセンテージに達する（または超える）と、エネルギー伝達スコアは100になります。目標を超えても減点にはなりませんが、実際の試合でバットをコントロールしにくくなったり、ボールに合わせにくくなることがあります。靴が脱げそうなスイングだね！",
                            "tip": "回転効率のよいスイングでは、スイングの前半でスピードの約半分が発生します。スピードの発生源は腕と手首ではなく、腰と肩です。目標はスイングの前半で45～55％程のスピードを出すことです。これより低い数値だと、エネルギー伝達スコアが100より低くなります。腕に頼りすぎている（体から腕が離れている）とスコアが低くなります。目標のパーセンテージに達する（または超える）と、エネルギー伝達スコアは100になります。超えても減点にはなりませんが、実際の試合でバットをコントロールしにくくなったり、ボールに合わせにくくなる可能性があります。靴が脱げそうなスイングだね！"
                        },
                        "bat_whip": {
                            "name": "バットウィップ",
                            "description": "バットウィップは効率指数の1つです。スイング中の回転スピード（RPM）がピークに達した瞬間とインパクトの瞬間の間の時間を測定します。インパクト時に回転スピードがピークに達するのが効率的なスイングです。",
                            "tip": "インパクト時に回転スピードがピークに達するのが効率的な野球のスイングです。これを達成できれば、インパクト前にバットウィップが出たことを示す線が3Dスイングに表示されません。"
                        },
                        "bat_path": {
                            "name": "バット軌道",
                            "description": "理想的なバット軌道の角度は、投球の角度、スイングスピード、打撃の状況などにより異なります。バット軌道のスコアは打球の飛距離を伸ばすことを目的に設定しています。一般的にはスイングスピードが速いほど、最大飛距離を得るための角度が小さくなります。バット軌道のスコアは、（ボールにしっかりインパクトしたと仮定して）実際のバット軌道の角度と、スイングスピードに対する最大飛距離を出せる理想的な角度との違いをもとに0～100で表示されます。バット軌道は効率指数の1つです。理想的なバット軌道のスコア100は、実際のバット軌道の角度がスイングスピードに対する最大飛距離を出せる理想的な角度と一致したときに出ます。飛距離が最大になる角度は、スイングスピードが56km/hなら+22°、88km/hなら+15°、120km/hなら+7°。136km/hなら+3°です。",
                            "tip": "理想的なバット軌道は、投球の角度、スイングスピード、打撃の状況など、さまざまな要素により異なります。この場合のバット軌道のスコアは、打球の飛距離を伸ばすことを目的に設定しています。3～22°であれば、効率指数のバット軌道で高いスコアが出ますが、この角度はスイングスピードによって異なります。一般的にはスイングスピードが速いほど、飛距離を伸ばすための角度が小さくなります。"
                        },
                        "barrel_acceleration": {
                            "name": "バットの加速",
                            "description": "バットの加速は効率指数の1つです。バットスピードの2/3（66%）がスイングの最後1/3の部分で出るのが理想的な加速で、スコアは0～10で表示されます。効率的なスイングはインパクト時に加速のピークが来ます。つまり、ダウンスイングの開始からインパクトの瞬間まで加速するということです。スイングの前半で加速のピークを迎えてしまうと、ボールに伝わる力が小さくなります。",
                            "tip": "常に理想のスコア10を目指してください。ダイナミックな加速でインパクト時に加速のピークが来るようにしましょう。ボールを強く打てるようになり、上達につながります。"
                        },
                        "peak_speed": {
                            "name": "最高バットスピード",
                            "unit": "km/h",
                            "description": "最高バットスピードはバットのスイートスポットの前方への最高スピードで、バットの先端から約15cmのところで測定します。インパクト時またはインパクト前に最高バットスピードが出ることがあります。\n\nインパクト時にバットスピードがピークに達すると、打球スピードと飛距離が伸びます。スイングの効率が悪く、インパクト時のバットスピードが遅くなっているとインパクト時に最高スピードが出ないので、ボールを強く打てません。\n\n投球を読み、自分のスイング時間を把握できれば、最高スピードに近いスピードでインパクトできるようになります。  計測では、最高バットスピードがインパクト時のバットスピードは同じかほぼ同じ数値になるのが理想です。"
                        },
                        "bat_whip_sec_prior": {
                            "name": "バットウィップ（秒前）",
                            "unit": "秒前",
                            "description": ""
                        },
                        "power": {
                            "name": "パワー",
                            "unit": "kW",
                            "description": "スイング中に発生するパワーの量（キロワット）です。"
                        },
                        "vertical_bat_angle": {
                            "name": " バット角度",
                            "unit": "°",
                            "description": "インパクト時のヘッド角度です。手よりもヘッドが下がっていると数値がマイナスになります。"
                        },
                        "body_tilt_angle": {
                            "name": "体の角度",
                            "unit": "°",
                            "description": "体の回転の中心点から算出したおおよその傾きを3Dアニメーションで表示します。体の軸の角度は、前後左右への傾きを合わせて測定し、3Dスイングに表示します。"
                        },
                        "peak_hand_speed": {
                            "name": "手の最大スピード",
                            "unit": "km/h",
                            "description": "スイング中の手の最大スピードです。"
                        },
                        "on_plane": {
                            "name": "オンプレーン",
                            "unit": "%",
                            "description": "オンプレーンのデータは、スイング中バットのスイートスポットがオンプレーンに乗っている割合を測定します。  基準となるオンプレーンはインパクト時に決まります。  スイングのオンプレーンのパーセンテージは、基準となるオンプレーン中に発生したスピードで決まります。\n\nこのパーセンテージを上げることを目指しましょう。  オンプレーンのパーセンテージは高いほど良いです。ダウンスイング中にバットを意識したりコントロールしたりする必要が減るからです。打者の構えとオンプレーンのデータには高い相関関係があります。  スイング開始時にまっすぐ立ち、スイングが始まってからスイングプレーンにバットを落とす打者に比べると、プレートの方に体が傾いている打者の方がオンプレーンに乗っている時間が長くなります。\n\nオンプレーンの平均パーセンテージが60%以上であれば、うまくスイングできています。  通常は55～65%の間です。  オンプレーンのデータでは、数値が上がるほど良いスイングで、バットと体の角度が正しく維持できていることになります。"
                        },
                        "body_rotation": {
                            "name": "体の回転",
                            "unit": "%",
                            "description": "ソフトボールのスイングでは、バットスピードは体とバットの回転で決まります。  Blastは高度なアルゴリズムモデルを活用して、バットに取り付けたセンサーから体の回転とバットの回転の両方を測定します。  打者が手首を緩めてスイングを開始した後、体の回転とバットの回転を比較することで、スイング中の体とバットの角度を分析できます。体の回転は、スイング開始後の回転の合計に対する体の回転の割合で表示されます。\n\nほとんどの選手で体の回転率の平均は45%で、40～50%の間に収まるはずです。  常にこのレンジを外れている場合は、打者の運動連鎖のパターンに欠点があると思われます。平均値の45％から外れる、または40～50％のレンジから外れるのは、投球コースが原因であるとも考えられます。  内角低めや外角高めのコースでは、スイングにさらなる適応力が必要になります。  スイング中の体とバットの回転パターンがずれるほど、体の回転率のずれも大きくなります。"
                        },
                        "planar_efficiency": {
                            "name": "オンプレーンの効率",
                            "score_name": "オンプレーン",
                            "unit": "%",
                            "description": "スイング中にバットがオンプレーンに乗っている割合を測定します。インパクト時のバット角度でオンプレーンが決まります。バットが安定してインパクトできているかはオンプレーンでわかります。",
                            "relates_to": "スイング軌道",
                            "relates_to_tab": "連絡先",
                            "blast_iq_description": "オンプレーンのスコアはオンプレーンの効率データから直接算出し、{scouting_scale}で評価されます。<strong>インパクト</strong>では、オンプレーンの効率は重要なデータです。<br><br>インパクトが強ければ、ボールを強く打てるようになります。",
                            "blast_iq_carousel_title": "インパクトのスイングデータには2つのデータが含まれます。オンプレーンの効率はスイング軌道で、アッパースイング度はスイングの方向です。",
                            "charts_description": "スイング軌道とスイングの方向が良ければ、インパクトのデータも良くなります。つまり、オンプレーンの効率とアッパースイング度の両方がレベルアップに欠かせません。"
                        },
                        "rotational_acceleration": {
                            "name": "体の回転によるバットの加速の大きさ（初動）",
                            "score_name": "回転",
                            "unit": "G",
                            "target": {
                                "basic": "大学",
                                "pro": "プロ"
                            },
                            "description": "バットがオンプレーンに乗るまでの加速度を測定します。体の回転によるバットの加速の大きさ（初動）を見ると、手打ちではなく、一連の正しい動作でスイングスピードが上がっているのか、傾向がわかります。体の回転によるバットの加速の大きさ（初動）が大きいほどパワーも増し、様々な投球コースにも適応できる可能性があります。",
                            "relates_to": "パワー効率",
                            "relates_to_tab": "パワー",
                            "blast_iq_description": "回転のスコアは回転の強さデータから直接算出し、{scouting_scale}で評価されます。<strong>パワー</strong>では、回転の強さは重要なデータです。<br><br>パワーがが優れた打者は、インパクトを犠牲にすることなく力強く打てるようになります。Blastでは、これを「ダイナミックパワー」と呼んでいます。",
                            "blast_iq_carousel_title": "パワーのスイングデータには2つのデータが含まれます。バットスピードは制御なしの力で、回転の強さはパワー効率です。",
                            "charts_description": "パワーのデータが良ければ、力強く効率的ということになります。つまり、回転の強さとバットスピードの両方がレベルアップに欠かせません。"
                        },
                        "connection": {
                            "name": " 体とバットの角度（インパクト）",
                            "score_name": "バットと体の角度",
                            "unit": "°",
                            "description": "インパクト時の体とバットの角度を測定します。どのコースに対しても体とバットの角度（90°）を維持できることが、適応能力があることを示しています。",
                            "relates_to": "スイングの安定度",
                            "relates_to_tab": "スイングの安定度",
                            "blast_iq_description": "体とバットの角度のスコアは、スイング前の体とバットの角度とインパクト時の体とバットの角度から直接算出し、{scouting_scale}で評価されます。<br><br>スイング前からインパクト時まで体とバットの角度を維持できる打者は、オンプレーンの効率が優れており、ゾーン内の投球への適応能力も優れています。",
                            "blast_iq_carousel_title": "<strong>安定度</strong>には2つのデータが含まれます。スイング前の体とバットの角度は<strong>タメの安定性</strong>の重要データです。インパクト時の体とバットの角度は<strong>インパクトの位置</strong>の重要データです。",
                            "charts_description": "体とバットの角度をヘッド角度と比べることで、ヒッティングゾーン内での安定性と適応力を可視化できます。ヘッド角度は低めのコースでは大きく、高めのコースでは水平に近くなります。"
                        },
                        "early_connection": {
                            "name": " 体とバットの角度（構え）",
                            "unit": "°",
                            "relates_to": "タメの安定性",
                            "description": "ダウンスイング開始時の体とバットの角度を測定します。スイング前の体とバットの角度が90°の場合、バットをすばやくオンプレーンに乗せることができ、さまざまな投球コースに適応できる可能性があります。"
                        },
                        "commit_time": {
                            "name": "コミット時間",
                            "unit": "秒",
                            "description": "コミット時間とは、ダウンスイング中に打者が手首を緩めて投球を見極める時間のことです。"
                        },
                        "plane_score": {
                            "name": "オンプレーンスコア",
                            "description": "各スイング平面の効率をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "connection_score": {
                            "name": "体とバットの角度スコア",
                            "description": "各スイングにおけるスイング前とインパクト時の体とバットの角度をスカウティングスケール（20～80）に基づいて採点します。同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "rotation_score": {
                            "name": "体の回転による加速スコア",
                            "description": "各スイングの回転の強さをスカウティングスケール（20～80）に基づいて採点します。  同レベルの他の選手と比較して採点されます。点数は高いほど良いです。"
                        },
                        "exit_velocity": {
                            "name": "打球スピード",
                            "unit": "km/h"
                        },
                        "launch_angle": {
                            "name": "打球角度",
                            "unit": "°"
                        },
                        "estimated_distance": {
                            "name": "推定飛距離",
                            "unit": "m"
                        },
                        "ball_direction": {
                            "name": "ボールの方向"
                        },
                        "field_angle": {
                            "name": "フィールドの角度",
                            "unit": "°"
                        }
                    }
                },
                "athletic_performance": {
                    "jump": {
                        "vertical_height": {
                            "name": "垂直方向の高さ",
                            "unit": "in",
                            "description": "ジャンプ中、センサーの移動距離（地面からジャンプの最高到達点まで）をcmで計測します。"
                        },
                        "jump_force": {
                            "name": "ジャンプ力",
                            "unit": "N",
                            "description": "ジャンプ力は、踏切前にジャンプにかかる力の最大値です。踏切直前に計測した選手の体重と最大加速度を組み合わせたものです。"
                        },
                        "jump_acceleration": {
                            "name": "ジャンプ加速度",
                            "unit": "G",
                            "description": "加速度は標準加速重力単位つまり「G」で測定され、全力疾走または走ったり飛んだりしたときに最大になります。"
                        },
                        "rotation": {
                            "name": "回転",
                            "unit": "°",
                            "description": "回転はジャンプ中に空中で体が回転した量で、「°」で表示されます。"
                        },
                        "hang_time": {
                            "name": "滞空時間",
                            "unit": "秒",
                            "description": "滞空時間は足が地面を離れてから着地するまでの時間で、コンマ何秒で表示されます。計測できるのは18cm以上のジャンプです。"
                        }
                    },
                    "sprint": {
                        "time_to_peak_acceleration": {
                            "name": "最大加速までの時間",
                            "unit": "秒",
                            "description": "最大加速までの時間は、ダッシュのスタートから加速が最大値に達する瞬間までにかかる時間です。"
                        },
                        "sprint_force": {
                            "name": "スプリント力",
                            "unit": "N",
                            "description": "スプリント力は、ダッシュ中にかかる力の最大値です。ダッシュ中に計測した選手の体重と最大加速度を組み合わせたものです。"
                        },
                        "sprint_acceleration": {
                            "name": "ダッシュ加速度",
                            "unit": "G",
                            "description": "加速度は標準加速重力単位つまり「G」で測定され、全力疾走または走ったり飛んだりしたときに最大になります。"
                        }
                    }
                }
            },
            "api": {
                "messages": {
                    "auth": {
                        "golf_channel_academy_error": "Golf Channel Academyサーバーとの通信中にエラーが発生したため、アカウントを確認できませんでした。やり直してください。",
                        "something_went_wrong": "ログイン中にエラーが発生しました。",
                        "user_not_exist": "ユーザーが存在しない製品： {app_name}",
                        "account_not_active": "アカウントが現在停止中です。チームにお問い合わせください。",
                        "pass_academy_id_in_request": "リクエストで'api_academy_id\\’を渡してください。",
                        "no_valid_academy": "どのチームにも所属していません。問題を解決するには、弊社お客様相談センターにお問い合わせください。",
                        "academy_access_denied": "チームへのアクセスが拒否されました。",
                        "you_belong_to_multiple_academies": "複数のチームに所属しています",
                        "invalid_subscription": "{role}課金プランが無効/有効期限切れです。",
                        "mobile_not_support_multiple_academies": "Blast Connectモバイルアプリは、複数のチームに紐付けられたユーザーには対応していません。Blast Connectウェブインターフェースをお使いください。",
                        "camp_login_window_passed": "このイベントのログインウィンドウは有効期限切れです。",
                        "camp_login_window_not_begun": "このイベントのログインウィンドウはまだ開始されていません。",
                        "you_are_not_in_the_current_academy": "現在のチームには所属していませんが、一般申し込みはできません。問題を解決するには、弊社お客様相談センターにお問い合わせください。",
                        "you_are_all_set_for_event_name": "{event_name}の準備完了です！",
                        "check_back_again_on_event_start_date_to_see_your_swing_data_from_the_event": "{start_date}からイベントのスイングデータを確認できるようになります。"
                    },
                    "regenerate_token": {
                        "user_not_found": "ユーザーが見つかりません",
                        "token": {
                            "not_verified": "トークンを認証できませんでした。",
                            "expired": "有効期限切れのトークン",
                            "invalid": "無効なトークン",
                            "absent": "トークンなし"
                        }
                    }
                }
            },
            "faq": "よくある質問",
            "welcome_help": "<a href=\"{help_link}\">ヘルプ</a>ではさらに詳しい手順やヒントをご覧いただけます。",
            "customer_support_link": "https://www.mizuno.co.jp/customer/",
            "blastmotion_com_link": "<a href=\"https://blastmotion.com\">https://blastmotion.com</a>",
            "customer_service": "ミズノお客様相談センター",
            "help": "ヘルプ",
            "contact_us": "お問い合わせ",
            "optional": "省略可",
            "privacy_policy_link": "プライバシーポリシー： <a href=\"{url}\">{url}</a>",
            "customer_support_phone": "ミズノお客様相談センター<br>0120-320-799<br><br>受付時間<br>午前10時～午後5時（土日祝日を除く）<br><br>",
            "customer_support_phone_number": "0120-320-799",
            "question_or_problem": "お問い合わせ内容は？",
            "getting_started": "はじめよう",
            "using_blast_connect": "Blast Connectを使う",
            "using_mobile_apps": "Blast {sport}モバイルアプリを使う",
            "account_error": "アカウントエラー",
            "csrf_error": "リクエストを確認できませんでした。やり直してください。",
            "january": "1月",
            "february": "2月",
            "march": "3月",
            "april": "4月",
            "june": "6月",
            "july": "7月",
            "august": "8月",
            "september": "9月",
            "october": "10月",
            "november": "11月",
            "december": "12月",
            "alerts": {
                "account_created": "アカウントの作成が完了しました。",
                "instructions_sent": "アカウントの確認方法を記載したメールをお送りしましたので確認してください。",
                "too_many_attempts": "試行回数が多すぎます。数分経ってからもう一度お試しください。",
                "wrong_credentials": "ユーザー名、メールアドレス、パスワードのいずれかが間違っています。",
                "not_confirmed": "アカウントを確認できません。メールに記載されている確認用リンクをご覧ください。",
                "confirmation": "アカウントの確認が完了しました！ログインできます。",
                "password_confirmation": "パスワードが一致しません。",
                "wrong_confirmation": "確認コードが違います。",
                "password_forgot": "パスワードのリセットに関する情報をメールでお送りしました。",
                "wrong_password_forgot": "ユーザーが見つかりません。",
                "password_reset": "パスワードの変更が完了しました。",
                "wrong_password_reset": "無効なパスワードです。もう一度お試しください",
                "wrong_token": "パスワードのリセットトークンが無効です。",
                "duplicated_credentials": "このログイン情報は既に使用中です。別のログイン情報を使用してください。",
                "coaches_can_only_be_added_via_direct_invitation": "コーチを追加するときは直接招待してください。",
                "email_and_or_password_are_incorrect_please_try_again_or_register": "メールアドレスかパスワード（または両方）が間違っています。もう一度お試しいただくか、このページの「登録」オプションでアカウントを新規作成してください。"
            },
            "validation": {
                "errors": {
                    "unauthorized": {
                        "access": "Unauthorized Access",
                        "actions": "不正なアクション",
                        "resources": "不正なリソース",
                        "cannot_authorize": "内部サーバーエラーです。ユーザーを認証できません"
                    },
                    "phone": {
                        "regex": "電話番号には、数字、スペース、および+、-、（、）文字のみを含めることができます。",
                        "digits": "電話番号には、数字、スペース、および+、-、（、）文字のみを含めることができます。"
                    }
                },
                "title": {
                    "required_if": "タイトルは必須です。"
                },
                "until": {
                    "required_if": "最終日は必須です。"
                },
                "viewable": {
                    "invalid": "{relation}アイテムを使用する権限がありません。"
                },
                "is_watcher": {
                    "invalid": "特定のユーザーの情報にアクセスする権限がありません。"
                },
                "assessment_result_limit": {
                    "invalid": "認められていない範囲の値が評価に入力されています。"
                },
                "messages": {
                    "standard": {
                        "email": {
                            "unique": "メールアドレスが既に取得されています。その他のご質問は、既存のアカウントに<a href=\"{login_link}\">ログイン</a>するか、<a href=\"{customer_support_link}\">弊社お客様相談センター</a>にお問い合わせください。"
                        }
                    },
                    "event": {
                        "email": {
                            "unique": "メールアドレスが既に取得されています。その他のご質問は、既存のアカウントにログインするか、<a href=\"{customer_support_link}\">弊社お客様相談センター</a>にお問い合わせください。"
                        }
                    }
                }
            },
            "errors": {
                "academy": {
                    "invalid": "無効なチーム"
                }
            },
            "email_view": {
                "subscription": {
                    "unpaid": {
                        "login_credentials": "ログイン情報",
                        "academy_name": "チーム名",
                        "account_name": "アカウント名",
                        "account_email": "アカウントのメールアドレス",
                        "need_support": "ご質問やサポートの依頼は？ お電話ください： {support_number}"
                    }
                },
                "account": {
                    "email_change": {
                        "subject": "メールアドレス変更リクエスト",
                        "messages": [
                            "Blast Connectアカウントに関連付けられているメールアドレスを変更するリクエストを受け取りました。",
                            "この変更を確定するには、次のリンクをクリックしてください。 {email_change_confirmation_url_anchor}",
                            "",
                            "この変更に心当たりが無い場合は、ここをクリックしてください。{password_reset_url_anchor} to reset your password."
                        ]
                    },
                    "charge_failed": {
                        "subject": "Blast Connect - 支払いエラー",
                        "messages": [
                            "{user_full_name} 様",
                            "",
                            "残念ながら、保存したお支払い方法が無効になったため、更新サブスクリプションの支払いを完了できませんでした。 {update_your_cards_anchor} をクリックして、支払い方法を再設定してください。",
                            "",
                            "お困りですか？ {contact_customer_support_anchor} までご連絡ください。"
                        ],
                        "please_update_your_payment_source": "お支払い方法を更新してください",
                        "contact_customer_support": "弊社お客様相談センターに問い合わせる",
                        "signature": "Blast Connectをご利用いただきありがとうございます！"
                    }
                },
                "password": {
                    "reset_request": {
                        "subject": "{academy_name} Blast Connectパスワードのリセット",
                        "messages": [
                            "{to_user}, {academy_name} Blast Connect アカウントのパスワードをリセットするリクエストを受け取りました。 .",
                            "",
                            "下のリンクをリクックしてパスワードをリセットしてください。:",
                            "{reset_password_link_anchor}",
                            "",
                            "ご不明な点がございましたら、ミズノお客様相談センターまでご連絡ください。 {support_phone_number} もしくは  {support_email}"
                        ],
                        "signature": "今後ともよろしくお願いいたします。Blast Motion"
                    }
                },
                "media": {
                    "shared": {
                        "subject": "{from_user} があなたとファイルを共有しました。",
                        "messages": [
                            "{from_user} があなたとファイルを共有しました。",
                            "",
                            "ファイルを確認するには、Blast Connectライブラリーにアクセスしてください。: {media_url_anchor}"
                        ]
                    },
                    "encoded": {
                        "subject": "{to_user}、Blast Connectへの動画のアップロードが完了しました",
                        "messages": [
                            "お待たせしました。BlastConnectアカウントにアップロードされた動画の準備が整いました。ファイルを表示するには、ここをクリックしてください:",
                            "{media_url_anchor}"
                        ]
                    }
                },
                "analysis": {
                    "encoded": {
                        "subject": "{to_user}、Blast Connectで動画を閲覧、分析、共有しましょう",
                        "messages": [
                            "{to_user}, 動画はBlast Connectライブラリ内で表示、分析、および共有する準備ができています。 {media_url_anchor}.",
                            "",
                            "Blast Connectの動画分析の詳細についてはこちらをご確認ください。, {learn_about_analysis_url_anchor}"
                        ]
                    }
                },
                "message": {
                    "received": {
                        "subject": "{to_user}、次のユーザーからプライベートメッセージが届いています： {from_user}",
                        "messages": [],
                        "labels": {
                            "from": "差出人： {from_user}",
                            "message": "メッセージ： "
                        }
                    }
                },
                "communicate": {
                    "submitted_on_behave": {
                        "subject": "{to_user}、次のユーザーがあなたのフォームを編集しました。 {from_user}",
                        "messages": [
                            "{to_user}, あなたのフォームは {from_user}　によって編集されました。",
                            "",
                            "リンクをクリックして編集内容を確認してください。 {communicate_url_anchor}"
                        ]
                    }
                },
                "event": {
                    "added": {
                        "title": "あなたはに追加されました {event_name}",
                        "subject": "{to_user}、次のユーザーがあなたを{event_type}に追加しました： {from_user}",
                        "message": "{to_user}、{from_user}があなたを{event_type}に追加しました： {event_name} {on_days}",
                        "body": "<p>親愛なる {first_name},</p><p>あなたはに追加されました {event_name}: <strong>{event_title}</strong> オン <strong>{start_date}</strong></p>",
                        "wish_cancel_message": "<p>キャンセルをご希望の場合は、 {date}.</p>"
                    },
                    "updated": {
                        "subject": "{to_user}、次のユーザーが{event_name}を変更しました： {from_user}",
                        "message": "{event_type}{event_name}が変更されました {on_days} "
                    },
                    "with_more": "と他{count}件",
                    "on_days": "曜日：|次の日： ",
                    "view_your_calendar": "カレンダーを見る",
                    "cancel_by_date": "キャンセルする場合は、{cancel_by_date} までにしてください。"
                },
                "routine": {
                    "assigned": {
                        "subject": "{to_user_name}、次のユーザーがあなたに{routine_name}を割り当てました： {from_user_name}",
                        "messages": [
                            "{to_user_name}, あなたは {from_user_name}　によって　{routine_name} に割り当てられました。",
                            "{view_and_complete_anchor}",
                            "({routine_url})"
                        ],
                        "view_and_complete_message": "確認して実施する"
                    }
                },
                "unpaid_reminder": {
                    "subject": "Blast Connectアカウントを作成しました - あと1ステップ！",
                    "student_subject": "Blast Motion Blast Connect {sport} アカウントが作成されました – もう 1 つのステップへ"
                }
            },
            "edit_your_account": "アカウント設定を編集",
            "manage_your_members_subscription": "他のメンバーの課金プランを管理",
            "currently_viewing_members_subscription": "<strong>注：</strong>他のメンバーの課金プラン情報を閲覧中です。このメンバーが購入したプランは、あなたの登録済みクレジットカードに請求されます。",
            "subscription_viewable_admin": "Blast管理者は課金プランの支払いをする必要がないため、Blast管理者としてログインすると課金プランは表示されません。",
            "base_plan": "基本プラン",
            "add_ons": "アドオン",
            "product": "製品",
            "buy_now": "今すぐ購入",
            "renewal_date": "更新日",
            "billing_frequency": "請求サイクル",
            "credit_card": "クレジットカード",
            "request_take_over": "引き継ぎをリクエスト",
            "cancel_take_over": "引き継ぎをキャンセル",
            "cancel_payment_source_change": "お支払い方法の変更をキャンセル",
            "take_over": "引き継ぎ",
            "request_hand_off": "受け渡しをリクエスト",
            "cancel_hand_off": "受け渡しをキャンセル",
            "hand_off_requested": "ハンドオフが要求されました",
            "hand_off_declined": "ハンドオフが拒否されました",
            "hand_off": "受け渡し",
            "hand_off_desc": "場合によっては、次回更新の後もBlast Connectやアドオンの課金プランの料金支払いをチームの監督に依頼することができます。注：ただし、依頼に過ぎないため、依頼した相手が承諾しない限りお支払いに関する変更は有効になりません。",
            "hand_off_select_person": "今後{entitlement_user_name}課金プランの支払いをするユーザーを選択してください。",
            "hand_off_accept_title": "が課金プランの受け渡しを依頼しています",
            "hand_off_accept_desc": "が次回請求サイクル終了時にあなたが課金プランの支払いを引き継ぐことを依頼しています。",
            "hand_off_accept_optional": "これは任意です。このリクエストを承諾する場合は、承諾する前に支払い方法を選択してください。",
            "unauthorized_payment_source": "不正な支払い元",
            "cancel_subscription": "課金プランを解約",
            "change_card": "カードを変更",
            "change_billing_frequency": "請求サイクルを変更",
            "one_time_charge": "1回限りの請求",
            "restore_subscription": "課金プランを再度利用",
            "select_product": "製品を選択",
            "please_select_a_product": "商品をお選びください。",
            "pay_card_on_file": "登録済みクレジットカードで支払う",
            "use_another_card": "別のクレジットカードで支払う",
            "buy": "購入",
            "select_card_on_file": "登録済みクレジットカードを選択",
            "add_new_card": "新しいカードを追加",
            "cancel_are_you_sure": "この課金プランを解約してもよろしいですか？",
            "cancel_access_ends": "解約した場合のアクセス終了日：",
            "cannot_be_undone": "この操作は取り消せません。",
            "cancel_yes": "解約する",
            "cancel_no": "いいえ、戻る",
            "you_have_already_paid": "次の日付まで支払い済み：{expiry_date}。変更が適用される日付：{new_date}。",
            "paid_for_by_card": "このカードで支払い中の課金プラン",
            "cards_on_file": "登録済みカード",
            "account_configuration": "アカウント構成",
            "account_configuration_has_been_updated": "アカウント構成が更新されました.",
            "currently_paying_for_subscription": "この課金プランを支払い中",
            "will_be_paying_for_subscription_on_renewal": "更新時にこの課金プランの支払いを開始",
            "notifications": "通知",
            "expiry": "有効期限",
            "expires": "有効期限",
            "expired": "有効期限切れ",
            "active_subscriptions": "有効な課金プラン",
            "pending_subscriptions": "保留中の課金プラン",
            "remove_card": "カードを削除",
            "remove_card_sure": "このクレジットカードを削除してもよろしいですか？",
            "update_your_card": "クレジットカードを更新",
            "update_card": "カードを更新",
            "card_name": "カード名",
            "card_number": "カード番号",
            "card_expiry": "有効期限",
            "card_holder_name": "カードの名義人",
            "add_credit_card": "クレジットカードを追加",
            "clear": "消去",
            "remove_card_description": "有効な課金プランの支払いに使用中のクレジットカードを削除しようとしています。アカウントへのアクセスが中断しないよう、今後プランの支払いに使用するカードを追加してください。",
            "choose_card_on_file": "登録済みクレジットカードを選択",
            "use_new_card": "新しいクレジットカードを使用する",
            "remove_card_transfer": "カードを削除して新しいカードに変更",
            "subscription_active": "課金プランは有効です",
            "no_cards_on_file": "カードがまだ登録されていません。",
            "no_addons_available": "購入できるアドオンはありません。",
            "currently_paying_for": "現在支払い中：",
            "currently_paying_for_desc": "このユーザーが現在支払い中のプランの支払いを引き継ぐときはこちらを使用します。",
            "viewing_own_info": "自分の情報を閲覧中です。",
            "select_card_pay": "支払いに使用するカードを選択",
            "people_plans": "ユーザーとプラン",
            "person_not_paying": "このユーザーは製品の支払いをしていません。",
            "paid_by": "支払い担当者：",
            "next_renewal": "次回更新",
            "take_over_views": {
                "payment_source_required": "引き継ぎを依頼する際は、登録済みクレジットカードが必要になります。  まずクレジットカードを追加してから、引き継ぎの依頼をしてください。 {cards_on_file_anchor}"
            },
            "current": "現在",
            "pending": "保留中",
            "pending_change": "保留中の変更",
            "pending_cc_change": "保留中のカードの変更",
            "active": "アクティブ",
            "trial": "無料トライアル",
            "trial-ending-notification": "無料トライアル期間はあと{days}{day_label}です。",
            "features": {
                "blast-connect": {
                    "description": "360°トレーニング・コミュニケーション・管理・上達のための、選手・コーチ・チーム向けツール。"
                },
                "boditrak": {
                    "description": "グラウンドフォース、圧力、動画分析ソリューションです。"
                }
            },
            "primary_position": "メインポジション",
            "secondary_position": "サブポジション",
            "update_profile_slug_requirement": "英数字、ダッシュ（-）、アンダースコア（_）のみ使用できます。",
            "copy_url": "URLをコピー",
            "copied_to_clipboard_success_message": "URLをクリップボードにコピーしました。",
            "update_profile_settings_success_message": "公開設定を更新しました。",
            "update_profile_settings_error_message": "エラーが発生しました。しばらく経ってからやり直してください。",
            "user_profile_notification": "プロフィール情報を入力してください。",
            "delete_school": "チームを削除",
            "metrics_headings": {
                "plane_score": "オンプレーンスコア",
                "connection_score": "体とバットの角度スコア",
                "rotation_score": "体の回転による加速スコア"
            },
            "select_timezone": "タイムゾーンを選択",
            "empty_states_messages": {
                "initial_coach": {
                    "title": "選手のスイングデータを詳しくチェックできます。",
                    "text": "選手を選択して、「GO」を押すと分析が始まります。"
                },
                "no_actions": {
                    "title": "{name}はまだスイングを撮影していません。",
                    "text": "{first}-nameにBlastアプリでスイングを計測してもらいましょう。"
                },
                "student_no_actions": {
                    "title": "まだスイングを撮影していません。",
                    "text": "Blastアプリでスイングを計測しましょう。"
                },
                "no_swings": {
                    "title": "表示できるスイングデータはありません。",
                    "text": "フィルタを変更して「Go」を押してください。"
                }
            },
            "max_chart_actions": "直近の{actions}アクションのみ表示中です。フィルタを変更すると、これより古いアクションもグラフに表示されます。",
            "session_types": {
                "baseball": {
                    "tee": "ティー",
                    "soft_toss": "ソフトトス",
                    "live_pitch": "実際の投球",
                    "pitching_machine": "ピッチングマシン",
                    "in_game": "試合",
                    "assessment": "評価",
                    "general_practice": "一般練習"
                },
                "softball": {
                    "tee": "ティー",
                    "soft_toss": "ソフトトス",
                    "live_pitch": "実際の投球",
                    "pitching_machine": "ピッチングマシン",
                    "in_game": "試合",
                    "assessment": "評価",
                    "general_practice": "一般練習"
                },
                "golf": {
                    "inside_5_feet": "1.5ｍ以内",
                    "5_to_10_feet": "1.5～3m",
                    "10_to_20_feet": "3～6m",
                    "lag_putts": "ロングパット",
                    "on_course": "コース上",
                    "assess": "評価",
                    "custom": "カスタム",
                    "less_than_25_yards": "25ヤード未満",
                    "25_to_50_yards": "25～50ヤード",
                    "50_to_100_yards": "50～100ヤード",
                    "75_to_100_yards": "75～100ヤード",
                    "100_to_150_yards": "100～150ヤード",
                    "chipping": "チップ",
                    "pitching": "ピッチング",
                    "bump_and_run": "ランニングアプローチ",
                    "lob_shot": "ロブショット",
                    "short_bunker_shot": "ショートバンカーショット",
                    "long_bunker_shot": "ロングバンカーショット"
                }
            },
            "ncsa": {
                "errors": {
                    "200": "あなたの情報をNCSAに送信しました。NCSAへの設定が完了すると、Blast Connect選手プロフィールをBlastスコア、データ、動画と一緒に読み込み、NCSAプロフィールで公開できるようになります。大勢の選手の中でひときわ目立って、スカウトやコーチの注目を集めましょう。",
                    "409": "入力された名前、メールアドレス、電話番号によれば、すでにNCSAのシステムに選手として登録済みです。  アカウントについては直接NCSAの方で確認してください。",
                    "409_initial": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。",
                    "409_updated": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。",
                    "400": "あなたの情報をNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "500": "あなたの情報をNCSAに送信できませんでした。  やり直してください。",
                    "general": "エラーが発生しました。やり直してください。",
                    "video_metric_error": "一部のBlast動画とデータをNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "metrics_error": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。  一部のBlastデータをNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "metrics_error_no_videos": "一部のBlastデータをNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "videos_error": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。  一部のBlast動画をNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "videos_error_no_metrics": "一部のBlast動画をNCSAに送信できませんでした。カスタマーサービスがフォローいたします。",
                    "video_limit_reached": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。次のBlast動画をNCSAに送信できませんでした：{videoList}.NCSAのプロフィールに送信できる動画の制限（6つまで）を超えています。",
                    "video_limit_reached_no_metrics": "次のBlast動画をNCSAに送信できませんでした：{videoList}.NCSAのプロフィールに送信できる動画の制限（6つまで）を超えています。",
                    "video_error_invalid_url": "NCSAのプロフィールを公開しました。NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。次のBlast動画をNCSAに送信できませんでした：{videoList}.カスタマーサービスがフォローいたします。",
                    "video_error_invalid_url_no_metric": "次のBlast動画をNCSAに送信できませんでした：{videoList}.カスタマーサービスがフォローいたします。"
                }
            },
            "help_page": {
                "title": "お困りですか？",
                "list": {
                    "block_1": {
                        "title": "Welcomeツアー",
                        "description": "Blastにようこそ！Welcomeツアーをはじめましょう。"
                    },
                    "block_2": {
                        "title": "スコアと計測値について",
                        "description": "Blast Metricsを説明したドキュメントとPowerPointです。ダウンロードして、印刷したり、共有したりしましょう。"
                    },
                    "block_3": {
                        "title": "トレーニングセンター",
                        "description": "計測値を理解し、コーチからアドバイスをもらい、上達する方法を学びましょう。"
                    },
                    "block_4": {
                        "title": "Blastユーザーガイド",
                        "description": "Blastの使い方を詳しく説明しています。"
                    },
                    "block_5": {
                        "title": "よくある質問",
                        "description": "よくある質問の回答集です。"
                    },
                    "block_6": {
                        "title": "さらにサポートが必要な場合",
                        "description": "サポートスタッフが喜んでお手伝いします。"
                    }
                },
                "featured": {
                    "title": "注目のトピック",
                    "topics": {
                        "golf-putt": {
                            "list_1": "Blast Golf - 総合ソリューション",
                            "list_2": "モバイル動画分析の使い方",
                            "list_3": "モバイル動画分析のサンプル",
                            "list_4": "Sean Lanyi - 動画分析",
                            "list_5": "JJ Woodコーチのケーススタディ",
                            "list_6": "Blast Golfでコーチング",
                            "list_7": "レッスンの合間の練習",
                            "list_8": "Blast GolfとMartin Hall",
                            "list_9": "Blast Golf - 総合ソリューションの概要",
                            "list_10": "選手プロフィール"
                        },
                        "softball": {
                            "list_1": "利用を開始しています",
                            "list_2": "Blast Softballアプリの使い方",
                            "list_3": "Blast Connectでスイングを見るには",
                            "list_4": "新しいバットを追加するには",
                            "list_5": "アプリでスイングを削除するには",
                            "list_6": "アプリでコーチモードを使用するには",
                            "list_7": "オンプレーン、体とバットの角度、回転でトレーニングをレベルアップ",
                            "list_8": "TNTソフトボールアカデミーのケーススタディ"
                        },
                        "baseball": {
                            "list_1": "利用を開始しています",
                            "list_2": "Blast Baseballアプリの使い方",
                            "list_3": "Blast Connectでスイングを見るには",
                            "list_4": "新しいバットを追加するには",
                            "list_5": "アプリでスイングを削除するには",
                            "list_6": "アプリでコーチモードを使用するには",
                            "list_7": "モバイル動画分析の使い方",
                            "list_8": "サンディエゴ大学のケーススタディ"
                        }
                    }
                },
                "documents": {
                    "title": "スコアとデータについて",
                    "description": "Blast Metricsを説明したドキュメントです。ダウンロードして、印刷したり、共有したりしましょう。",
                    "baseball": {
                        "list_1": {
                            "title": "Blast スイング指標",
                            "description": "スイングの評価スコア、スイングデータ、インパクトデータ、飛距離データの概要を1ページにまとめたものです。"
                        },
                        "list_2": {
                            "title": "Blast Insights ガイド",
                            "description": "スイングスコア、データ、試合への影響をもう少し詳しく説明したものです。"
                        },
                        "list_3": {
                            "title": "Blast メトリック範囲",
                            "description": "理想的なメトリクス値の範囲のクイック リファレンス。"
                        }
                    },
                    "softball": {
                        "list_1": {
                            "title": "Blast スイング指標",
                            "description": "スイングの評価スコア、スイングデータ、インパクトデータ、飛距離データの概要を1ページにまとめたものです。"
                        },
                        "list_2": {
                            "title": "Blast Insights ガイド",
                            "description": "スイングスコア、データ、ゲームへの影響をもう少し詳しく説明したものです。"
                        },
                        "list_3": {
                            "title": "Blast メトリック範囲",
                            "description": "理想的なメトリクス値の範囲のクイック リファレンス。"
                        }
                    },
                    "golf": {
                        "list_1": {
                            "title": "Blast Golf - スタートガイドブックレット",
                            "description": "データについて簡単にまとめたブックレットと、スイング改善を目指す3つのレベルのトレーニング方法です。"
                        },
                        "list_2": {
                            "title": "ゴルフデータの意味",
                            "description": "ゴルフのデータ（パッティングとフルスイング）を簡潔に解説したドキュメントです。"
                        },
                        "list_3": {
                            "title": "コーチ用データシート",
                            "description": "推奨レンジを記載したパッティングデータがひと目でわかる早見表（1ページ）です。"
                        }
                    }
                },
                "event_solutions": {
                    "title": "イベントソリューション",
                    "description": "Blastでイベントを実行するために知っておく必要があるすべて。",
                    "baseball": {
                        "block_1": {
                            "title": "入門",
                            "list_1": {
                                "title": "ブラストモーションイベントチェックリスト",
                                "description": "イベントを実行するために必要なものを見つけ、イベントをスムーズに実行するために従う必要のある手順のチェックリストを入手してください。"
                            }
                        },
                        "block_2": {
                            "title": "プレイベント",
                            "list_1": {
                                "title": "ブラストコネクト-イベントの作成",
                                "description": "BlastConnectでイベントを作成して入力する方法のステップバイステップのプロセスを学びます。"
                            },
                            "list_2": {
                                "title": "ブラストコネクト-プレイヤーをイベントに招待する",
                                "description": "作成したイベントにプレーヤーを招待するのがいかに迅速で簡単かをご覧ください。"
                            },
                            "list_3": {
                                "title": "ブラストコネクト-ソーシャルシェアでプレイヤーを招待",
                                "description": "ソーシャルシェアオプションを利用してプレーヤーを招待する方法を学びます。"
                            },
                            "list_4": {
                                "title": "ブラストアプリ-センサーの追加",
                                "description": "イベントが始まる前に、センサーをコーチアカウントに追加することをお勧めします。 これは、そのプロセスを説明する短いビデオです。"
                            },
                            "list_5": {
                                "title": "ブラストアプリ-コウモリの追加",
                                "description": "前夜のイベントで見られると予想されるバットの長さと重さを追加することをお勧めします。 これは、そのプロセスを説明する短いビデオです。"
                            }
                        },
                        "block_3": {
                            "title": "イベント当日/イベント中",
                            "list_1": {
                                "title": "ブラストアプリ-相互参照/プレーヤーのクイック追加",
                                "description": "アプリでイベントに招待されたプレーヤーを相互参照することをお勧めします。 これを行う方法のウォークスルーは次のとおりです。"
                            },
                            "list_2": {
                                "title": "Blastアプリ-環境とレイアウトオプションの変更",
                                "description": "イベントのアプリ内で環境と指標のレイアウトを変更する方法については、こちらをご覧ください。"
                            },
                            "list_3": {
                                "title": "ブラストアプリ-キャプチャ",
                                "description": "イベント中にすべてのプレーヤーのアクションをキャプチャするためのベストプラクティスに関するこのビデオをご覧ください。"
                            }
                        },
                        "block_4": {
                            "title": "イベント後",
                            "list_1": {
                                "title": "BlastConnect-チームレポートの表示",
                                "description": "BlastConnectポストイベントでチームレポートを表示する方法については、このビデオをご覧ください。 チームレポートには、すべてのプレーヤーの各メトリックの平均が表示されます。"
                            },
                            "list_2": {
                                "title": "BlastConnect-プレーヤーのスイングプロファイルの表示",
                                "description": "BlastConnectで個々のプレーヤーのスイングプロファイルを表示する方法を学びます。 個々のプレーヤーのスイングプロファイルは、プレーン、接続、回転のスコア、およびスイングごとのデータを分類します。"
                            },
                            "list_3": {
                                "title": "Blast Connect –チームレポートのダウンロード",
                                "description": "BlastConnectの完全なチームレポートをExcelファイルにダウンロードする方法をご覧ください。"
                            }
                        }
                    }
                }
            },
            "subscription_reminder": {
                "subject": "Blast {sport}プレミアム有料課金サービス1年プラン更新のお知らせ",
                "intro": {
                    "trial": {
                        "all": "Blastプレミアム有料課金サービスの30日間無料トライアルをご利用いただきありがとうございます！"
                    },
                    "player": {
                        "golf": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、去年よりワンランク上のゴルファーを目指しましょう。",
                        "softball": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、去年よりワンランク上の打者を目指しましょう。",
                        "baseball": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、去年よりワンランク上の打者を目指しましょう。"
                    },
                    "non-player": {
                        "golf": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、選手のみなさんのさらなる上達をサポートしましょう。",
                        "softball": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、選手のみなさんのさらなる上達をサポートしましょう。",
                        "baseball": "Blast {sport}プレミアム有料課金サービスの各種機能を活用して、選手のみなさんのさらなる上達をサポートしましょう。"
                    }
                },
                "trial": {
                    "subject": "Blast {sport}プレミアム有料課金サービストライアル期間終了のお知らせ",
                    "renewal_date_and_charges": "{expiration_date}に課金が開始され、登録済みクレジットカードに{charge}が請求されます。",
                    "paying_for_description": "以下のユーザーの課金プランの開始は次のとおりです。料金は登録済みクレジットカードに請求されます。",
                    "paying_for_item_description": "{expiration_date}に{name}さんへの課金が開始されます（料金は{charge}）",
                    "blast_premium_benefits_caption": "Blastプレミアム有料課金サービスの特長をまだご覧になっていない場合は、各種機能を簡単に説明していますのでご覧ください：",
                    "premium_features": {
                        "golf": {
                            "non-player": {
                                "golf_premium_features_1": "<b>コーチモード：</b>チームの登録選手を管理し、各選手のパッティングとフルスイングの結果をアプリ内に取り込んだり分析したりできます。",
                                "golf_premium_features_2": "<b>モバイル動画分析：</b>自動で切り出された動画を分析し、音声や描画によるリモートコーチング機能で選手とフィードバックを共有できます。",
                                "golf_premium_features_3": "<b>選手＆チームレポート：</b>スイングの特性ごとに選手を分類・ランク付けしてトレーニング計画をカスタマイズ、上達度を確認して、結果を選手や保護者と共有できます。"
                            },
                            "player": {
                                "golf_premium_features_1": "<b>Coach Connection</b> - Blastを利用しているチームに参加して、コーチとつながりましょう。いつでも、どこでもフィードバックを受け取ることができます。",
                                "golf_premium_features_2": "<b>データ＆動画分析</b> - 自動で切り出した動画を測定データをもとに分析します。音声や書き込みなどでコーチの指導を受けられます。",
                                "golf_premium_features_3": "<b>パフォーマンスレポート</b> - 数値やデータ画像でこれまでのパフォーマンスを評価、目標を設定して結果を共有できます。",
                                "golf_premium_features_4": "<b>クラウドストレージ</b> - Blastクラウドに動画やスイング情報をすべて保存できます。"
                            }
                        },
                        "baseball": {
                            "non-player": {
                                "baseball_premium_features_1": "<b>自動スイング評価：</b>すべてのオンプレーン、体とバットの角度、体の回転によるバットの加速スコアを確認して改善しましょう。Blast iQ?による分析結果をリアルタイムでチェックできます。",
                                "baseball_premium_features_2": "<b>コーチモード：</b>チームの登録選手を管理し、各選手のスイング結果をアプリ内に取り込んだり分析したりできます。",
                                "baseball_premium_features_3": "<b>詳細なスイング分析：</b>インパクト前後のスイングを詳しく分析できます。",
                                "baseball_premium_features_4": "<b>モバイル動画分析：</b>自動で切り出された動画を分析し、音声や描画によるリモートコーチング機能で選手とフィードバックを共有できます。",
                                "baseball_premium_features_5": "<b>選手＆チームレポート：</b>スイングの特性ごとに選手を分類・ランク付けしてトレーニング計画をカスタマイズ、上達度を確認して、結果を選手や保護者と共有できます。"
                            },
                            "player": {
                                "baseball_premium_features_1": "<b>自動スイング評価</b> - すべてのオンプレーン、体とバットの角度、体の回転によるバットの加速スコアを確認して改善しましょう。Blast iQ?による分析結果をリアルタイムでチェックできます。",
                                "baseball_premium_features_2": "<b>Coach Connection</b> - Blastを利用しているチームに参加して、コーチとつながりましょう。いつでも、どこでもフィードバックを受け取ることができます。",
                                "baseball_premium_features_3": "<b>データ＆動画分析</b> - 自動で切り出した動画を測定データをもとに分析します。その動画に追加された音声や描画によるコーチの指導を受けられます。",
                                "baseball_premium_features_4": "<b>パフォーマンスレポート</b> - 数値やデータ画像でこれまでのパフォーマンスを評価、目標を設定して結果を共有できます。",
                                "baseball_premium_features_5": "<b>クラウドストレージ</b> - Blastクラウドに動画やスイング情報をすべて保存できます。"
                            }
                        },
                        "softball": {
                            "non-player": {
                                "softball_premium_features_1": "<b>自動スイング評価：</b>すべてのオンプレーン、体とバットの角度、体の回転によるバットの加速スコアを確認して改善しましょう。Blast iQ?による分析結果をリアルタイムでチェックできます。",
                                "softball_premium_features_2": "<b>コーチモード：</b>チームの登録選手を管理し、各選手のスイング結果をアプリ内に取り込んだり分析したりできます。",
                                "softball_premium_features_3": "<b>詳細なスイング分析：</b>インパクト前後のスイングを詳しくチェックしましょう。",
                                "softball_premium_features_4": "<b>モバイル動画分析：</b>自動で切り出された動画を分析し、音声や描画によるリモートコーチング機能で選手とフィードバックを共有できます。",
                                "softball_premium_features_5": "<b>選手＆チームレポート：</b>スイングの特性ごとに選手を分類・ランク付けしてトレーニング計画をカスタマイズ、上達度を確認して、結果を選手や保護者と共有できます。"
                            },
                            "player": {
                                "softball_premium_features_1": "<b>自動スイング評価</b> - すべてのオンプレーン、体とバットの角度、体の回転によるバットの加速スコアを確認して改善しましょう。Blast iQ?による分析結果をリアルタイムでチェックできます。",
                                "softball_premium_features_2": "<b>Coach Connection</b> - Blastを利用しているチームに参加して、コーチとつながりましょう。いつでも、どこでもフィードバックを受け取ることができます。",
                                "softball_premium_features_3": "<b>データ＆動画分析</b> - 自動で切り出した動画を測定データをもとに分析します。その動画に追加された音声や描画などでコーチの指導を受けられます。",
                                "softball_premium_features_4": "<b>パフォーマンスレポート</b> - 数値やデータ画像でこれまでのパフォーマンスを評価、目標を設定して結果を共有できます。",
                                "softball_premium_features_5": "<b>クラウドストレージ</b> - Blastクラウドに動画やスイング情報をすべて保存できます。"
                            }
                        }
                    }
                },
                "renewal_date_and_charges": "課金プランの更新日は{expiration_date}です。登録済みクレジットカードに料金（{charge}）が請求されます。",
                "paying_for_description": "以下のユーザーの課金プランの更新は次のとおりです。料金は登録済みクレジットカードに請求されます。",
                "paying_for_item_description": "{expiration_date}に{name}の課金情報が更新されます（料金は{charge}）",
                "change_title": "<b>プランの変更が必要ですか？</b>",
                "change_steps_1": "<a href=\"{app_url}\"><b>{app_domain}</b>にログイン</a>",
                "change_steps_2": "「<b>プロフィール</b>」（画面右上）を選択",
                "change_steps_3": "「<b>アカウント設定</b>」を選択",
                "change_steps_4": "「<b>課金プラン</b>」を選択",
                "cancel_title": "プレミアム課金サービスを解約する場合は、下記を参照ください。",
                "cancel_instruction_title": "<b>プレミアム課金サービスの解約方法：</b>",
                "cancel_steps_1": "<a href=\"{app_url}\"><b>{app_domain}</b></a> にログイン",
                "cancel_steps_2": "右上の <b>【プロフィールアイコン】</b> 選択",
                "cancel_steps_3": "<b>【アカウントとプランの設定】</b> を選択",
                "cancel_steps_4": "<b>【課金プラン】</b> を選択",
                "cancel_steps_5": "<b>キャンセル</b> をクリック",
                "for_more_info": "Blast {sport} ソリューションの使い方は、<a href=\"{training_center_url}\"><b>トレーニングセンター</b></a>または<a href=\"{help_url}\"><b>ヘルプ</b></a> をご覧ください。",
                "any_questions": "ご不明な点がありましたら、<a href=\"https://www.mizuno.co.jp/customer/\">弊社お客様相談センター</a> にお問い合わせください。",
                "signature": "今後ともよろしくお願いいたします<br>チームBlast"
            },
            "training_center_v3": {
                "title": "トレーニングセンター",
                "subtitle": "「トレーニングセンター」の動画でアプリの使い方、データの見方、トレーニングドリルについて紹介しています。スマートなトレーニングとスキルアップに役立ててください。"
            },
            "roles": {
                "student": "選手",
                "owner": "監督",
                "coach": "コーチ"
            },
            "score_analyzes": {
                "planar_efficiency": {
                    "below_average": "同様のレベルのプレイを持つ他のプレイヤーと比較して、平均よりも低いプレーンスイングパフォーマンスを示しました。 スイングの質を向上させるための最優先事項は、プレーンドリルに集中することです。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "average": "同様のレベルのプレイを持つ他のプレイヤーと比較して、平均的なプレーンスイングパフォーマンスを示しました。 スイングの質を向上させるには、プレーンドリルに焦点を合わせます。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "above_average": "同様のレベルのプレーを持つ他のプレーヤーと比較して、平均以上のプレーンスイングパフォーマンスを示しました。 高品質のスイングを継続的に改善および維持するには、以下の推奨ドリルを確認してください。"
                },
                "connection": {
                    "below_average": "同様のレベルのプレイを持つ他のプレイヤーと比較して、平均よりも低いコネクションスイングパフォーマンスを示しました。 スイングの質を向上させるための最優先事項は、接続ドリルに集中することです。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "average": "同様のレベルのプレイを持つ他のプレイヤーと比較して、平均的なコネクションスイングパフォーマンスを示しました。 スイングの質を向上させるには、接続ドリルに焦点を合わせます。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "above_average": "同様のレベルのプレイを持つ他のプレイヤーと比較して、平均以上のコネクションスイングパフォーマンスを示しました。 高品質のスイングを継続的に改善および維持するには、以下の推奨ドリルを確認してください。"
                },
                "rotational_acceleration": {
                    "below_average": "同様のレベルのプレーを持つ他のプレーヤーと比較して、平均よりも低い回転スイングパフォーマンスを示しました。 スイングの質を向上させるための最優先事項は、ローテーションドリルに集中することです。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "average": "同様のレベルのプレーを持つ他のプレーヤーと比較して、平均的な回転スイングパフォーマンスを示しました。 スイングの質を向上させるには、回転ドリルに焦点を合わせます。 以下は、開始するためのいくつかの推奨されるドリルです。",
                    "above_average": "同様のレベルのプレーを持つ他のプレーヤーと比較して、平均以上の回転スイングパフォーマンスを示しました。 高品質のスイングを継続的に改善および維持するには、以下の推奨ドリルを確認してください。"
                }
            },
            "selected_session_not_found": "選択した計測が見つかりません",
            "cannot_create_payment_source": "お支払い方法を設定できません。もう一度お試しいただくか、弊社お客様相談センターにお問い合わせください。",
            "academy_not_found_are_you_logged_in": "チームが見つかりませんでした。ログインしていますか？",
            "user_is_not_found": "ユーザーが見つかりません",
            "account_exists_login_or_reset": "Blastアカウントをお持ちですか？現在のパスワードを今後も使用するか、受け取ったリンクからパスワードをリセットしてください。",
            "account_already_exists_login_or_reset": "Blastアカウント登録済みです。現在のパスワードを今後も使用するか、受け取ったリンクからパスワードをリセットしてください。",
            "current_academy_is_not_a_camp": "現在のチームはイベントではありません。",
            "removed": "削除済み",
            "user_removed_messages_popover": "このユーザーは削除されているため、メッセージを受け取ることができなくなります。",
            "academy_is_not_available_for_public_registration_if_you_feel_this_is_an_error_please_contact_us": "{academy_name} は一般申し込みを受け付けていません。エラーが発生していると思われる場合は、弊社お客様相談センターにお問い合わせください。",
            "profile_items_have_been_added_successfully": "プロフィール項目を追加しました。",
            "profile_item_has_been_deleted_successfully": "プロフィール項目を削除しました。",
            "we_are_not_able_to_retrieve_your_blast_mobile_account_information_please_try_again": "Blast Mobileアカウント情報を取得できません。しばらくしてからもう一度お試しください。",
            "there_was_a_problem_with_update_your_blast_mobile_account_please_try_again": "Blast Mobileアカウントの更新中にエラーが発生しました。しばらくしてからもう一度お試しください。",
            "publish_to_your_ncsa_profile": "NCSAプロフィールに公開",
            "need_help_question": "お困りですか？",
            "swing_quality_scores_and_metrics": "スイングスコア＆計測値",
            "you_are_currently_showing_length_sets_of_metrics_on_your_profile": "現在プロフィールに表示されているデータは1セットです。NCSAプロフィールに公開できるデータは1セットのみで、20本以上のスイングが必要です。この下にスイングスコアと計測値を表示してNCSAに送信するには、スイング20本以上のスコアや計測値が必要です。打球スピードを以下のデータリストに表示してNCSAに送信するには、セットの平均値が{minimumExitVelocity}km/h以上でなければなりません。現在プロフィールに表示されているデータは{numberSets}セットです。NCSAプロフィールに公開できるデータは1セットのみで、20本以上のスイングが必要です。この下にスイングスコアとデータを表示してNCSAに送信するには、スイング20本以上のスコアやデータが必要です。打球スピードを以下のデータリストに表示してNCSAに送信するには、セットの平均値が{minimumExitVelocitykm}/h以上でなければなりません。次から1つ選択してください",
            "you_are_currently_showing_length_videos_on_your_profile": "現在プロフィールに表示されている動画は1個です。NCSAに公開できる動画は6つまでです。動画を公開するときは、過去に公開したものも含め、公開したい動画を以下からすべて選択してください。操作を続行すると、Blast選手プロフィールに過去に公開した動画が削除され、代わりにここで選択した動画が公開されます。現在プロフィールに表示されている動画は{numberOfVideos}個です。NCSAに公開できる動画は6つまでです。動画を公開するときは、過去に公開したものも含め、公開したい動画を以下からすべて選択してください。操作を続行すると、Blast選手プロフィールに過去に公開した動画が削除され、代わりにここで選択した動画が公開されます。",
            "you_can_have_a_maximum_of_6_videos_on_your_ncsa_profile": "NCSAプロフィールに表示できる動画は6個までです。",
            "do_not_publish_any_metrics": "計測値を公開しない",
            "highlight_videos": "ハイライト動画",
            "who_is_making_this_submission": "送信者は？",
            "by_proceeding_you_grant_your_permission_for_the_information_from": "By proceeding, you grant your permission for the information from the previous form to be submitted to NCSA for purposes of NCSA contacting you about their services.",
            "ncsa_consent_disclaimer": "「はい」をクリックして送信することにより、NCSA から個別のフォローアップおよびマーケティング メッセージを電子メール、電話、自動テキストで受信することに同意したことになります。 同意は購入の条件ではありません。 標準料金が適用されます。",
            "start_by_inviting_your_players": "まず、選手を招待する",
            "then_get_them_swinging_with_a_blast_sensor": "次に、Blastセンサーを使ってスイングしてもらいます。",
            "then_get_them_swinging_with_a_blast_analyzer_sensor": "次に、Blast Swing Analyzer センサーでスイングさせます。",
            "their_swing_quality_scores_with_insights_will_appear_here": "インサイト付きのスイング品質スコアがここに表示されます。",
            "invite_your_players": "選手を招待する",
            "getting_started_tour": "スタートガイドツアー",
            "need_sensors_question": "センサーが必要ですか？",
            "you_need_to_update_your_browser": "ブラウザをアップデートしてください",
            "viewing_metrics_on_blast_connect_works_best_on_the_following_browsers": "Blast Connectでデータを確認するのに推奨のブラウザ：",
            "there_are_no_swings_to_display": "表示できるスイングがありません",
            "there_are_no_swings_to_display_with_sensor_message": "表示するブラスト スイング アナライザー スイングはありません",
            "if_first_name_is_new_to_blast": "{first_name}さんがBlastに登録したばかりの場合",
            "if_first_name_has_already_been_using_blast": "{first_name}さんがすでにBlastを利用している場合",
            "if_first_name_has_already_been_using_blast_with_sensor_message": "{first_name} がすでに Blast Swing Analyzer を使用している場合",
            "tell_them_to_start_a_session_in_their_blast_app": "Blastアプリで計測を開始して、スイングを撮影するよう伝えます。Wi-Fiに接続すると、こちらに選手のスイングが自動的に表示されます。",
            "tell_them_to_start_a_session_in_their_blast_app_with_sensor_message": "Blast アプリでセッションを開始し、Blast Swing Analyzer センサーでスイングするように伝えます。 Wi-Fi に接続すると、スイングが自動的にここに表示されます。",
            "if_you_are_new_to_blast": "Blastに登録したばかりの場合",
            "start_a_session_in_your_blast_app_and_take_some_swings": "Blastアプリで計測を開始して、スイングを撮影します。Wi-Fiに接続すると、こちらにスイングが自動的に表示されます。",
            "start_a_session_in_your_blast_app_and_take_some_swings_with_sensor_message": "Blast アプリでセッションを開始し、Blast Swing Analyzer センサーでスイングを行います。 Wi-Fi に接続すると、スイングが自動的にここに表示されます。<br> <b>Note:</b> Blast パーソナル スイング トレーナー センサーでキャプチャされたスイングは、Blast Connect では使用できません。",
            "if_you_have_already_been_using_blast": "すでにBlastを利用している場合",
            "try_expanding_your_filters_above": "上記のフィルタを広げてください。",
            "note_swings_capture": "<b>ノート：</b> Blast Personal Swing Trainer センサーでキャプチャされたスイングは、コーチ モードまたは Blast Connect 内では使用できません。",
            "relates_to": "関連する",
            "target": "目標",
            "there_is_no_items_with_provided_words": "指定した言葉を含む項目はありません",
            "rankings_allow_you_to_compare_each_player_use_rankings_along_with_the_filters": "「ランキング」では選手同士を比較できます。上記のフィルタと一緒にランキングを使用すると、期間を指定して選手のパフォーマンスを比較できます。",
            "filter_by_below_average_to_isolate_players_that_need_extra_work_to_correct": "「平均より下」を適用すると、集中的に練習が必要な選手が表示され、特定のスコアやデータを目指した弱点強化ができます。",
            "select_a_player_to_see_specifically_how_to_help_them_improve_for_a_particular_metric": "選手を選択すると、特定のデータを強化するための指導方法を確認できます。",
            "customize_this_screen_to_show_rankings_for_scores_and_metrics_that_interest_you": "この画面をカスタマイズすると、重要なスコアやデータごとのランキングを確認できます。",
            "use_the_team_report_to_take_a_wholistic_view_of_your_players_and_identify": "「チームレポート」で選手の全体像を把握でき、どの選手が指導を必要としているかがわかります。重点練習が必要なポイントは赤い棒グラフを見るとわかります。",
            "sort_this_chart_by_clicking_on_a_column_heading": "各列の見出しをクリックすると、このグラフを並べ替えできます。",
            "click_on_a_player_to_get_more_insights_on_how_that_player_can_improve": "選手名をクリックすると、選手が上達するためのアドバイスが表示されます。",
            "click_icon_to_learn_more_about_what_a_metric_or_score_means": "<i class=\"tw-text-blue fal fa-info-circle\"></i>をクリックすると、データやスコアの説明が表示されます。",
            "measures_the_percentage_of_your_swing_where_the_bat_is_on_the_swing_plane": "スイング中にバットがオンプレーンに乗っている割合を測定します。インパクト時のバット角度でオンプレーンが決まります。バットが安定してインパクトできているかはオンプレーンでわかります。",
            "load_consistency_great_hitters_have_consistent_early_connection_values_on_all_swings": "優れた打者は、すべてのスイングでスイング前の体とバットの角度が安定しています。スイング前の体とバットの角度は、打者が力をためてからダウンスイングに移行するときの体とバットの角度を測定します。打者のスイングがレンジ内に収まっていれば、安定したタメと回転ができてオンプレーンに乗っています。スイング前の体とバットの角度の目標値に幅を設けることで、選手はスイングで自身のスタイルを活かしながら無理のない調節ができます。",
            "impact_consistency_the_goal_of_impact_consistency_is_for_the_hitter_to_always": "インパクトの安定性で目指すのは、すべてのスイングで常に強くインパクトすることです。さまざまな投球コースでのインパクト時の体とバットの角度を（ヘッド角度を用いて）比較することで、ゾーン内の投球コースによって打者の体とバットの角度がどのように変化しているか（安定しているか）がわかります。",
            "learn_more_in_the_training_center": "詳細は「トレーニングセンター」をご覧ください",
            "plane": "オンプレーン",
            "connection": "バットと体の角度",
            "rotation": "回転",
            "measures_the_relationship_between_your_body_tilt_and_vertical_bat_angle_at_impact": "インパクト時の体とバットの角度を測定します。どのコースに対しても体とバットの角度（90°）を維持できることが、適応能力があることを示しています。",
            "measures_how_quickly_your_bat_accelerates_into_the_swing_plane": "バットがオンプレーンに乗るまでの加速度を測定します。回転は、動作をうまく連動させることでどのくらいバットスピードが出せているかを確認するのに便利な指標です。回転スピードが速いほどパワーも大きくなって時間の余裕ができるので、どんな投球コースにも適応できるようになります。",
            "watch_video": "動画を見る",
            "your_best": "自己ベスト",
            "your_range": "レンジ",
            "recommended_training": "おすすめのトレーニング",
            "achieve_score": "{percent}がこのスコアを達成",
            "achieve_avg_above": "平均より上",
            "achieve_avg_below": "平均より下",
            "achieve_avg_based_on_level_of_play": "レベルに基づく平均",
            "scores_based_on_the": "スコアの基準：",
            "20_80_scouting_scale": "0～80のスカウティングスケール",
            "the_scouting_scale": "スカウティングスケール",
            "measures_a_players_swing_performance_and_distributes_it_on_a_bell_curve_based_on_level_of_play": "選手のスイングパフォーマンスを測定し、レベルに基づいてベルカーブに分布させます。",
            "there_are_no_players_who_have_swings_with_selected_date_range": "選択した期間にスイングした選手はいません。",
            "there_are_no_players_who_are_average": "{average}の選手はいません。",
            "customize_ranking_layout": "ランキングレイアウトをカスタマイズ",
            "academies_are_not_found": "学校が見つかりません",
            "please_wait_while_we_are_processing_your_request": "リクエストを処理中です。お待ちください…",
            "there_are_not_valid_subscription_available_to_cancel": "キャンセルできる有効な課金プランはありません。",
            "fullnames_subscription_has_been_cancelled_successfully": "{fullname}\\さんの課金プランをキャンセルしました。",
            "fullnames_subscription_can_not_be_cancelled_properly_please_contact_customer_support": "{fullname}\\さんの課金プランをキャンセルできません。カスタマーサポートにお問い合わせください。",
            "where_do_you_live": "どちらにお住まいですか？",
            "select_a_sport": "競技を選択",
            "exclusive_of_taxes": "税別",
            "this_has_the_potential_of_disrupting_this_customers_service_please_use_caution": "このユーザーのサービスが中断している可能性があります。ご注意ください。ご質問は<a href=\"mailto:{email}\">開発チームにお問い合わせください</a>。",
            "you_can_only_transfer_players_into_an_academy_of_the_same_sport_type": "選手の移動は選手が自信の課金プランの支払いを完了している場合に限り、競技、組織、地域、課金プラン設定が同じ場合のみ可能です。",
            "initiated": "初期化中...",
            "upload-started": "アップロードを開始しました",
            "upload-paused": "アップロードを停止しました",
            "upload-cancelled": "アップロードを中止しました",
            "upload-completed": "アップロードを完了しました",
            "encode-started": "エンコードを開始しました",
            "encode-paused": "エンコードを停止しました",
            "encode-cancelled": "エンコードを中止しました",
            "encode-completed": "エンコードを完了しました",
            "sequence-started": "シーケンスを開始しました",
            "sequence-paused": "シーケンスを停止しました",
            "sequence-cancelled": "シーケンスを中止しました",
            "sequence-completed": "シーケンスを完了しました",
            "trialing": "トライアル中",
            "unpaid": "未払い",
            "pending-cancel": "キャンセル保留中",
            "pending-payment-source-change": "お支払い方法の変更保留中",
            "pending-product-change": "製品の変更保留中",
            "pending-payment-hand-off-transfer": "支払い引き渡し保留中",
            "pending-payment-take-over-transfer": "支払い引き継ぎ保留中",
            "language_preference": "言語設定",
            "address_additional": "住所（追加）",
            "japanese": "日本語",
            "english": "English (US)",
            "blast_account_email": "Blastアカウントのメールアドレス",
            "blast_account_password": "Blastアカウントのパスワード",
            "yearly": "年",
            "domains_academy_is_not_found": "サブドメインに入力されたアカデミーは見つかっていません。",
            "thanks_for_contacting_us": "ご連絡ありがとうございます。",
            "you_now_may_want_to": "に戻る",
            "return_to_your": "ことができます。",
            "visit": "アクセスする",
            "edit_and_share": "編集＆シェア",
            "left_handed": "左利き",
            "right_handed": "右利き",
            "your_browser_does_not_support_the_video_tag": "ご使用のブラウザは動画のタグに対応していません。",
            "ball_flight": "打球＆飛距離",
            "please_login_to_the_subscribing_account_to_continue_the_subscription_process": "課金プランの処理を続行するにはアカウントにログインしてください。",
            "the_social_share_link_is_not_available_for_blast_admins_if_you_need_an_invite_url_you_must_login_on": "Blast管理者はソーシャルシェアリンクを利用できません。招待用のURLが必要な場合は、コーチの代理でログインしてコーチ用のソーシャルシェアリンクを使用してください。",
            "unknown_error": "不明のエラーが発生しました。",
            "your_profile_is_percent_complete": "プロフィール{percent}作成済みです。",
            "insights": "リポート",
            "training": "トレーニング",
            "metrics_amp_reports": "データ&amp;レポート",
            "media_library": "メディアライブラリー",
            "video_analysis": "動画分析",
            "workouts_amp_practices": "ワークアウト&amp;練習",
            "training_center": "トレーニングセンター",
            "your_invitations_have_been_successfully_sent": "招待の送信を完了しました。|招待の送信を完了しました。",
            "add_an_avatar": "画像",
            "date_of_birth_required": "生年月日は必須です",
            "date_of_birth_will_get_saved": "プロフィールに生年月日が保存されます。",
            "profile_functionality_years_requires": "一部のプレイヤー プロフィール機能では、ユーザーが 13 歳以上である必要があります。 13 歳未満の場合でも、プロフィールのほとんどの機能を使用でき、コーチはプロフィールを見ることができます。",
            "profile_functionality_years_personalize_your_goals": "あなたの生年月日は、あなたがより良い打者になるのを助けるために、あなたの目標と洞察をパーソナライズするのにも役立ちます.",
            "profile_functionality_years_please_enter_birthday": "続行するには、生年月日を入力してください。",
            "hitter_type": "打者タイプ",
            "tell_about_yourself": "自己紹介",
            "put_your_best_foot_forward": "長所をアピールしましょう。基本情報や身体情報がここに表示されるので、プロフィールの他の部分を見ていてもすぐにわかります。",
            "add_your_vitals": "身体情報を追加",
            "publish_and_share": "公開と共有",
            "public": "公開",
            "published_to_NCSA": "NCSAに公開済み",
            "publish_to_NCSA": "NCSAに公開",
            "need_to_add_videos_and_set_of_metrics": "NCSAに公開するには、動画を「概要」に追加するか、スイングデータを「データ」に複数セット（1セット20スイング以上）追加してください。",
            "visible_to_ncsa": "NCSAにBlastプロフィールに表示しますか？",
            "enter_information_before_share": "プロフィールを共有する前に情報を入力してください。",
            "wish_to_remove_your_metrics": "NCSAのプロフィールからデータや動画を削除する場合は、NCSAのプロフィールから直接削除してください。",
            "summary": "概要",
            "athletics": "競技",
            "academics": "学歴",
            "contacts": "連絡先",
            "actions_speak_louder_than_words": "言葉より行動。最高のスイングとこれまでの実績を動画で見てもらいましょう！",
            "add_profile_information": "プロフィール情報を追加",
            "tell_your_story_in_your_own_words": "自分の言葉で自己紹介を記載します。経歴、目標、その他重要な情報を共有しましょう。",
            "showcases_games_events": "ショーケース、試合、イベント",
            "sure_to_delete": "ショーケースをプロフィー",
            "showcase_from_profile": "ルから削除してもよろしいですか？",
            "show_your_best_showcase": "イベント参加時のデータや見てほしい動画を追加しましょう。",
            "add_your_team_information": "チーム情報を追加",
            "you_didnot_get_here_alone": "これまでに所属したチームを記載してください。各チームに所属していたときの実績も忘れずに記載しましょう。",
            "team_from_your_profile": "チームをプロフィールから削除してもよろしいですか？",
            "member_pays": "メンバーが支払う",
            "levels_of_play": {
                "other": "アマチュア - 全レベル",
                "youth": "ユース",
                "middle_school": "中学",
                "high_school_junior_varsity": "高校 - 準レギュラー",
                "high_school_varsity": "高校 - レギュラー",
                "college_all_divisions": "大学 - すべてのリーグ"
            },
            "this_roster_has_no_players_in_it": "このロースターには選手がいません。",
            "add_some_players": "選手を追加",
            "ball_flight_swings": "打球＆飛距離スイング",
            "this_means_ball_flight_data_was_not_captured_for_this_player_to_capture_ball_flight_data_make_sure_ball_flight_mode": "この選手の打球＆飛距離データは取り込まれていません。打球＆飛距離データを取り込むには、選手がスイングを撮影する際にアプリで打球＆飛距離モードを有効にするか、コーチモードで有効にしてください。",
            "action_id": "アクションID",
            "air_swing": "素振り",
            "this_means_ball_flight_data_was_not_captured_for_this_swing_to_capture_ball_flight_data_make_sure_ball_flight_mode": "このスイングの打球＆飛距離データは取り込まれていません。打球＆飛距離データを取り込むには、スイングを撮影する際にアプリで打球＆飛距離モードを有効にしてください。",
            "number_actions_are_marked_for_deletion": "<strong>1</strong> アクションは削除対象としてマークされています。|<strong>{number}</strong> アクションは削除対象としてマークされています。",
            "additional_sports": "他の競技",
            "sport_from_your_profile": "競技をプロフィールから削除してもよろしいですか？",
            "edit_your_sport": "競技を編集",
            "add_your_sport_information": "競技情報を追加",
            "add_additional_sports": "他の競技を追加",
            "more_to_life": "この競技以外に関心があること：",
            "other_sports_you_play": "現在やっている他の競技やこれまでに所属した他のチーム（他競技含む）を記入してください。",
            "from_your_profile": "プロフィールから削除してもよろしいですか？",
            "add_education_info": "学歴情報を追加",
            "your_education_history": "学歴には表彰歴も含めます。",
            "educational_institution": "学校名",
            "coaching_certification_levels": "コーチ認定レベルI、II、II",
            "add_more": "さらに追加",
            "putting_averages": "パッティング平均",
            "short_game_averages": "ショートゲーム平均",
            "bunker_averages": "バンカー平均",
            "full_swing_averages": "フルスイング平均",
            "your_blast_swing_metrics": "Blast Motionセンサーで取り込んだBlastスイングデータを見てもらいましょう。",
            "select_your_swing_metrics": "スイングデータを選択",
            "performance": "パフォーマンス",
            "add_more_stats": "データを追加",
            "add_any_other_relevant_statistics": "パフォーマンスに関するデータ（Blast Motionセンサーで取り込んだデータ以外）を追加しましょう。",
            "graduating": "卒業見込み",
            "edit_your_profile_statement": "プロフィール文を編集",
            "tell_recruiters_about_who_you_are": "自己紹介や目標をスカウトにアピールしましょう。",
            "tips_for_writing_profile": "プロフィール文を書くときのヒント",
            "your_opportunity_to_give_recruiters_a_glimpse": "プロフィール文は、データや動画だけではわからないことをスカウトに伝えるチャンスです。あなたの目標や性格が伝わりやすい自己紹介を書きましょう。",
            "profile_statement_concise": "プロフィール文は次のような内容を簡潔にまとめます。",
            "why_you_play": "競技をする理由。競技に対する情熱。",
            "your_most_important_accomplishments": "最も重要な実績について（子供のころのことでも可）。",
            "personal_qualities_you_possess": "競技で有利に働いている自身の性質。",
            "why_you_seek_an_opportunity": "大学に進学したい理由。",
            "summary_of_your_academic": "学業での実績について。",
            "other_interests": "スポーツ以外に興味のあること。",
            "a_sample_profile_statement": "プロフィール文の見本",
            "sample_profile_statement_1": "ベン・スミスです。カリフォルニア州カールスバーグのセージクリーク高校4年生です。6歳から野球をやっています。\n              小さいころはバスケットボールもやっていましたが、すぐに自分の進む道は野球だと思いました。10歳からクラブチームでプレーしています。",
            "sample_profile_statement_2": "高校では3年までずっと、代表チームのスタメンでショートを守っていました。マウンドではリリーフかクローザーですが、4年では先発も務める予定です。球種が豊富なので打たせて取るピッチングスタイルで、コントロールにも自信があります。コーチによると、私の一番の武器は心理戦に強いところだそうです。打撃も得意で、3番を打っています。3年生のときはベストナインに選ばれました。高校では3年までずっとオールリーグ選手に選ばれ、2年からはアカデミックオールリーグ選手に選ばれました。",
            "sample_profile_statement_3": "オフシーズンには認定トレーナーのもと週に3回、ウエイト、スピード、瞬発系のトレーニングをしています。4年生は高校を締めくくる最高の1年にすることが目標です。チームキャプテンとして、ダイナミックなプレーヤーになり、チームを引っ張っていきたいです。フィールド内外での行いが、チームや家族、学校に影響することもわかっています。",
            "sample_profile_statement_4": "競技の面でも学業の面でも、自分に合ったプログラムを探しています。経験豊富なコーチのもとでこれからも成長を続けると同時に、高いレベルで野球をしたいと考えています。大学レベルでプレーする能力があり、そのための資質、高い自律心、どんなプログラムでもすぐに発揮できるリーダーシップを備えていると思います。",
            "sample_profile_statement_5": "スポーツマネージメントを中心にビジネスを専攻することを目指しています。3年修了時のGPAは3.7で、APコース2つに挑戦しました。次はAPコース3つに挑戦するつもりです。プロフィール文を最後までお読みいただきありがとうございます。これからも野球で切磋琢磨していきます。",
            "ball_flight_data_was_not_captured_description": "この選手の打球＆飛距離データは取り込まれていません。打球＆飛距離データを取り込むには、選手がスイングを撮影する際にアプリで打球＆飛距離モードを有効にするか、コーチモードで有効にしてください。",
            "roster_has_no_players": "このロースターには選手がいません。",
            "report_date": "報告日",
            "swing_count": "スイングカウント",
            "roster_average": "名簿平均",
            "variance": "分散",
            "l_handedness": "左",
            "r_handedness": "右",
            "b_handedness": "B",
            "ok": "OK",
            "share_file": "ファイルを共有する",
            "image": "画像",
            "document": "資料",
            "already_have_blast_connect_account_good_news": "このメールアドレスで登録したBlast Connectアカウントをすでにお持ちのようです。Blast Connectアカウントに<a href=\"/login/\">ログイン</a>していただくだけでお使いいただけます。",
            "please_enter_2_or_more": "2文字以上入力してください。",
            "added_to_their_library": "ライブラリーに{file_type}を追加しました",
            "media_from_your_library": "ライブラリーのメディア",
            "starting_recorder_dots": "レコーダーを起動中...",
            "your_recording_will_start_in": "録画開始まであと：",
            "please_move_your_mouse_around": "ブラウザウィンドウ内でマウスカーソルを動かして続行してください。",
            "upload_file": "ファイルをアップロード",
            "upload_images_formats": "受け入れられる画像形式は ",
            "selected_files": "選択済みファイル",
            "encoding_files": "ファイルをエンコード中",
            "video": "動画",
            "audio": "オーディオ",
            "profile_has_been_updated": "{name} プロファイルが更新されました",
            "profile_changed": "{name} プロファイルが変更されました",
            "subscription_purchased_from_us_company": "米国のBlast Motionへの支払いになります。ご使用のクレジットカードにより、手数料が加算される場合があります。",
            "filter_by_date_range": "期間で並べ替え",
            "filter_by_month": "月で並べ替え",
            "almost_ready": "もうすぐ完了！",
            "your_video_is_processing": "動画を処理中です。少々お待ちください。または、以下をクリックすると完了したときにメールでお知らせします。",
            "continue_and_email": "続行して完了したらメールで通知",
            "pause": "一時停止",
            "select_user_to_view_their_media_library": "メディアライブラリーを表示するユーザーを選択",
            "sorry_file_is_not_valid": "ファイルを送信できません",
            "added_on": "追加日",
            "file_size": "ファイルサイズ",
            "first": "最初",
            "no_data_available_in_table": "表示できるデータがありません",
            "showing_of_total_entities": "_TOTAL_エントリーの_START_～_END_を表示中",
            "filtered_from_total_entities": "_TOTAL_エントリ全体からフィルタリング",
            "showing_0_of_entities": "0～0/0エントリーを表示中",
            "all_dates": "すべての日付",
            "show_num_entries": "_MENU_を表示",
            "want_to_play_baseball_in_college": "大学で野球をしたいですか？",
            "blast_motion_has_teamed_up_with_next_college_player_athlete_ncsa_to_help_athletes_with_the_dream_of_playing_sports": "Blast Motionはアスリートの競技力をさらに高めるサポートをするため、NCSA College Recruiting と提携しています。",
            "go_to_your_player_profile_to_start_your_own_free_recruiting_profile_with_ncsa_then_publish_your_blast_scores": "「選手プロフィール」でNCSAのリクルート用プロフィールを無料で作成できます。作成後、Blastスコア、データ、動画をNCSAプロフィールに直接公開して、35,000人以上を超える大学のコーチにアピールしましょう。",
            "publish_your_scores": "Blast のスコア、メトリクス、ビデオを NCSA プロファイルに直接公開して、35,000 人を超える大学のコーチと交流できます。 800 人以上の採用専門家からなるチームは、あなたとあなたの家族が採用プロセスをよりよく理解するのにも役立ちます。",
            "we_would_have_never_been_able_to_find_player_athletes_name_removed_had_it_not_been_for_your_services": "このサービスがなかったら、[player-athlete's-name removed]選手を見つけることはできませんでした。",
            "ncaa_division_i_head_baseball_coach": "NCAAディビジョン | 野球ヘッドコーチ",
            "get_recruited": "募集する",
            "im_not_interested_right_now": "今は興味ない",
            "im_interested": "興味ある",
            "go_to_player_profile": "選手プロフィールに移動",
            "dismiss": "閉じる",
            "ncsa_profile_settings_updated": "設定が更新されました",
            "metrics_are_not_found": "指標が見つかりません",
            "hi_user_name": "{name}こんにちは",
            "dont_show_again": "もう一度見せないでください",
            "what_does_mean": "どういう意味？‘ - - ‘",
            "chop_slap": "チョップスラップ",
            "select_your_session": "セッションを選択してください",
            "add_another_time_frame": "別の時間枠を追加する",
            "optional_describe_your_metrics_with_a_title": "オプション-メトリックをタイトルで説明します",
            "highlight": "「ハイライト」",
            "show_hide": "表示/非表示",
            "you_need_to_select_a_session_or_date_range": "セッションまたは日付範囲を選択する必要があります！",
            "start_year": "開始年",
            "head_coach": "ヘッドコーチ",
            "john_smith": "ジョンスミス",
            "sport_name": "スポーツ名",
            "add_video": "ビデオを追加",
            "if_you_do_not_add_videos": "動画を追加しない場合、このセクションは公開プロフィールに表示されません。",
            "under_13_years_old_cannot_share_profiles": "13歳未満のプレイヤーはプロフィールを公開できませんのでご注意ください。",
            "update_profile_field_instruction": "この値を更新するには、[アカウントとサブスクリプションの設定] > [マイ アカウント設定] > [概要] に移動します。",
            "switch_hitter": "スイッチヒッター",
            "slap_full_swing": "平手打ち/ Full Swing",
            "parent_or_guardian_contact_information.": "親/保護者の連絡先情報。",
            "add_your_parent_info": "親情報を追加する",
            "there_is_no_action_in_the_selected_date_range": "選択した日付範囲にアクションはありません。",
            "list_some_relevant_stats_about_your_athletic_physical_abilities": "あなたの運動/身体能力に関するいくつかの関連する統計をリストしてください。",
            "value": "値",
            "unit": "単位",
            "highlighted_question": "ハイライト？",
            "list_some_relevant_stats_about_your_in_game_performance": "ゲーム内のパフォーマンスに関連する統計をいくつか挙げてください。",
            "your_profile_has_been_updated": "あなたのプロフィールが更新されました",
            "birth_date": "誕生日",
            "age": "年齢",
            "blast_connect_account_created": "Blast Connectアカウントが作成されました–アクセスのためのもう1つのステップ{academy_name}！",
            "great_news_account_has_been_created": "すばらしいニュースです。BlastConnectアカウントが作成されました。",
            "great_news_account_has_been_created_student": "すばらしいニュースです。BlastConnectアカウントが作成されました。",
            "we_need_you_to_complete_one_more_step": "チーム/アスリートをより効果的かつ効率的に管理するために設計されたソフトウェア分析、コーチング、コミュニケーション、および管理ツールの完全に統合されたスイートにアクセスする前に、<strong>もう1つのステップを完了する必要があります</strong>.",
            "coach_subscription_plan_selection": "Blast Connect –コーチサブスクリプションプランの選択と支払い",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect": "Blast Connectアカウントにアクセスするには、Blast Connect – Coach / Admin Coachサブスクリプションプランを選択し、支払いプロセス（{price_interval}）を完了することにより、サインアッププロセスを完了する必要があります。 次のリンクをクリックしてログインし、この手順を完了してください。",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect_student": "Blast Connectアカウントにアクセスするには、Blast Connect-Athleteサブスクリプションプランを選択し、支払いプロセス（{price_interval}）を完了することにより、サインアッププロセスを完了する必要があります。 次のリンクをクリックしてログインし、この手順を完了してください。",
            "need_to_complete_the_sign_up_process_by_choosing_a_blast_connect_us_student": "アスリートは <b>30 日間の無料トライアル</b>を利用できますが、Blast Motion Blast Connect アカウントと無料トライアルにアクセスするには、Blast Connect を選択してサインアップ プロセスを完了する必要があります。 - アスリート サブスクリプション プランと支払いの詳細の入力 ({price_interval})。 クレジット カードへの請求を避けるため、30 日間の試用期間が終了する前であればいつでもキャンセルできます。 次のリンクをクリックしてログインし、この手順を完了してください。",
            "the_blast_motion_team": "BlastMotion チーム",
            "athlete_subscription_plan_selection_payment": "Blast Connect –アスリートサブスクリプションプランの選択と支払い",
            "we_need_you_to_complete_one_more_step_student_precondition": "自分でサインアップした場合でも、コーチから招待された場合でも、",
            "we_need_you_to_complete_one_more_step_student": "<strong>もう 1 つのステップを完了する必要があります</strong> スマートなトレーニングを行い、より速く上達するために設計された、独自のソフトウェア分析、コーチング、コミュニケーション、および管理ツールのパーソナライズされたスイートにアクセスする前に。",
            "bat_speed": "バットスピード",
            "exit_velocity": "出口速度",
            "now_playing": "再生中",
            "delete_showcase": "ショーケースを削除",
            "add_to_your_showcase_video": "ショーケース ビデオに追加",
            "showing_of_total_entities_replace": "{total}エントリーの{start}～{end}を表示中",
            "no_video_in_your_library": "ライブラリに利用可能なビデオがありません!",
            "weekly_event_report": "ウィークリーイベントレポート",
            "number_events_have_ended_this_week": "今週、1つのイベントが終了しました。 | 今週は{number}つのイベントが終了しました。",
            "the_following_session_was_created_by_other_people_and_can_not_be_deleted": "次のセッションは他の人が作成したものであり、削除できません|次のセッションは他の人が作成したものであり、削除できません",
            "number_sessions_have_been_deleted": "1つのセッションが削除されました|{number}セッションが削除されました",
            "searching": "検索中...",
            "results_could_not_be_loaded": "結果を読み込めませんでした",
            "no_results_found": "結果が見つかりません",
            "remove_all": "すべて削除する",
            "general_email_mail_to": "https://www.mizuno.co.jp/customer/",
            "temporarily_down": "メンテナンスのため一時的にダウン",
            "we_are_doing_maintenance": "{appName}で定期的なメンテナンスを行っています。 ただの標準的なもの。 すぐ戻ってきます！",
            "down_since": "以来ダウン",
            "full_team_report_is_ready": "完全なチームレポートの準備ができました",
            "graduating_": "卒業",
            "graduating_high_school": "高校卒業",
            "uploaded": "アップロード済み",
            "delete_sport_from_profile": "プロフィールから {sport} スポーツを削除してもよろしいですか？",
            "warning": "警告",
            "email_entered_not_change_login": "ここに入力された電子メールは、Blastアカウントのログインを変更しません",
            "delete_sport": "スポーツを削除する",
            "bench_press": "ベンチプレス",
            "want_to_delete_this_parent": "この親を削除してもよろしいですか？",
            "want_to_delete_this_stat": "この統計を削除してもよろしいですか？",
            "want_to_delete_these_metrics": "これらのメトリックをプロファイルから削除してもよろしいですか？",
            "help_uppercase": "ヘルプ",
            "high_school": "高校",
            "jr_college": "短期大学",
            "university": "大学",
            "present": "現在",
            "sure_to_delete_item": "プロファイルから{item}を削除してもよろしいですか？",
            "minor_league": "マイナーリーグ（全レベル）",
            "dsl": "DSL",
            "rookie_ball": "ルーキーボール",
            "class_a_short_season": "クラスA（ショートシーズン）",
            "class_a_low": "クラスA（低）",
            "class_a_advanced": "クラスA（上級）",
            "aa": "AA",
            "aaa": "NS",
            "mlb": "MLB",
            "handicap_21_plus": "ハンディキャップ21+",
            "handicap_16_20": "ハンディキャップ16-20",
            "handicap_11_15": "ハンディキャップ11-15",
            "handicap_6_10": "ハンディキャップ6-10",
            "handicap_0_5": "ハンディキャップ0-5",
            "handicap_plus_1_plus_5": "ハンディキャップ+ 1- + 5",
            "tour_player": "ツアープレーヤー",
            "travel_ball_12u_14u": "トラベルボール12U-14U",
            "travel_ball_16u_18u": "トラベルボール16U-18U",
            "college_junior_d3_d2": "カレッジジュニアD3D2",
            "college_d1": "カレッジD1",
            "professional": "プロ",
            "player_profile": "プレイヤープロフィール",
            "number": "番号",
            "user_renews_status_description": "その人のBlastPremiumアカウントがアクティブであり、その人のアカウントが更新される日付が表示されます。",
            "user_pending_status_description": "その人のBlastPremiumアカウントはアクティブではありません。おそらく、アカウントへの招待を受け入れていないためです。",
            "user_invalid_status_description": "無効な人のBlastPremiumアカウントはアクティブではありません。",
            "search_players": "プレイヤーを検索",
            "search_coaches": "コーチを検索",
            "graduating_jr_college": "卒業ジュニア。 カレッジ",
            "graduating_university": "大学卒業",
            "count_seats_in_academy": "{account_type} このアカデミーでは： {count}",
            "assigned_seats_of_available": "{assigned_count} の {available_count} 空席が割り当てられます",
            "assigned_seats": "{assigned_count} 座席が割り当てられています。 利用可能な座席数については、BlastMotionの担当者にお問い合わせください。",
            "seats_validation_message": "座席は必須フィールドであり、アカデミー構成を保存する前に入力する必要があります。",
            "accept_hand_off": "ハンドオフを受け入れる",
            "decline_hand_off": "ハンドオフを拒否する",
            "requested_take_over_subscription": "{name}がサブスクリプションの1つを引き継ぐように要求しました。",
            "requested_take_over_subscription_below": "{names}は、サブスクリプションの1つを引き継ぐように要求しました（以下に記載）。",
            "coaches_corner": "コーチズコーナー",
            "coaches_corner_page": {
                "title": "ようこそ、コーチ！",
                "list": {
                    "block_1": {
                        "title": "オンボーディングビデオ",
                        "description": "プレーヤーを招待してデータを収集することから始めましょう。"
                    },
                    "block_2": {
                        "title": "ブラストによるトレーニング",
                        "description": "Blastを使用したトレーニングは、評価フェーズ、分析フェーズ、トレーニングフェーズ、および再評価フェーズの4つのフェーズで簡単に行うことができます。"
                    },
                    "block_3": {
                        "title": "ブラストビデオ殿堂",
                        "description": "Blastで作成した最高で最も役立つビデオのコレクション。 これらのビデオはあなたに直接影響を与え、スイングフェーズ、スイングプロファイル、およびキーブラストメトリックに焦点を当てています。"
                    },
                    "block_4": {
                        "title": "スコアと指標を理解する",
                        "description": "ブラストメトリクスを理解するためのダウンロード用ドキュメント。 ダウンロード、印刷、共有。"
                    },
                    "block_5": {
                        "title": "ブラスト認証",
                        "description": "Blastのすべての概要を説明する、このセルフペースのビデオ認定コースでBlast認定を取得してください。"
                    },
                    "block_6": {
                        "title": "イベントソリューション",
                        "description": "Blastでイベントを実行するために知っておく必要があるすべて。"
                    },
                    "block_7": {
                        "title": "サポートチケット",
                        "description": "私たちのフレンドリーなスタッフがあなたの道を見つけるお手伝いをします。"
                    }
                },
                "onboarding_videos": {
                    "title": "オンボーディングビデオ",
                    "description": "プレーヤーを招待してデータを収集することから始めましょう。",
                    "list": {
                        "block_1": {
                            "title": "はじめに",
                            "list": {
                                "title_1": "はじめに",
                                "title_2": "フォローアップをサポートする",
                                "title_3": "より深い理解"
                            }
                        }
                    }
                },
                "training_with_blast": {
                    "title": "ブラストによるトレーニング",
                    "list": {
                        "block_1": {
                            "title": "はじめに",
                            "list": {
                                "title_1": "4 つの簡単なフェーズに従って Blast でトレーニングする",
                                "title_2": "施設に Blast Motion スマート ケージを設置する"
                            }
                        }
                    }
                },
                "blast_video_hall_of_fame": {
                    "title": "ブラストビデオ殿堂",
                    "description": "Blastで作成した最高で最も役立つビデオのコレクション。 これらのビデオはあなたに直接影響を与え、スイングフェーズ、スイングプロファイル、およびキーブラストメトリックに焦点を当てています。",
                    "block_1": {
                        "title": "主要な指標",
                        "list_1": {
                            "title": "ブラストモーションの主要な指標",
                            "description": "スイングの主要なメトリックを理解するのに役立つ実際の打者の例を使用して、平面、接続、および回転のブラストスイングメトリックをウォークスルーします。"
                        }
                    },
                    "block_2": {
                        "title": "スイングプロファイル",
                        "list_1": {
                            "title": "スイングの一貫性プロファイル：早期接続+インパクト時の接続",
                            "description": "コンシステンシースイングプロファイルには、初期接続（度）と衝撃時接続（度）の2つの部分があります。 もっと詳しく知る。"
                        },
                        "list_2": {
                            "title": "連絡先プロファイル：平面効率+迎え角について"
                        },
                        "list_3": {
                            "title": "ブラスト付きパワープロファイル（バットスピード+回転加速度）"
                        }
                    },
                    "block_3": {
                        "title": "指標の定義と比較",
                        "list_1": {
                            "title": "迎え角と発射角度",
                            "description": "迎え角は発射角度にどのように影響しますか？ 打者のタイプに基づいて、迎え角を希望の打ち上げ角度に一致させるように努めます。 迎え角と打ち出し角度を同じにしてボールを直角にすると、最も硬いボールが打たれます。 詳細については、このビデオをご覧ください。"
                        },
                        "list_2": {
                            "title": "垂直バット角度",
                            "description": "垂直バット角度は、衝撃の瞬間の水平に対するバットの角度です。 垂直バット角度は度で測定され、インパクト時のバットのノブに対するバットのバレルの位置を提供します。 バットのバレルとノブが地面に平行である場合、垂直バット角度はゼロになります。 バットのバレルがインパクト時にバットのノブの下にある場合、垂直バット角度は負になります。"
                        },
                        "list_3": {
                            "title": "インパクト時の接続",
                            "description": "接続（インパクト時）は、インパクト時の体の傾きとバットの垂直角度の関係を測定します。 すべてのピッチ位置で良好な接続（90度）を維持することは、動的調整可能性の指標です。"
                        },
                        "list_4": {
                            "title": "早期接続",
                            "description": "アーリーコネクションは、ダウンスイング開始時の体の傾きとバットの垂直角度の関係を測定します。 スイングの早い段階で良好な接続（90度）を確立すると、飛行機に乗ることができ、すべてのピッチ位置に適応する能力が向上します。"
                        },
                        "list_5": {
                            "title": "回転加速度",
                            "description": "回転は、バットがスイングプレーンに向かって加速する速度を測定します。 回転は、適切に順序付けするか、手でバットを引くことによってバット速度を構築する方法の良い指標です。 回転加速度が速いほど、より多くのパワーが得られ、プレートで決定を下すために必要な時間が長くなります。"
                        },
                        "list_6": {
                            "title": "平面効率について",
                            "description": "バットがスイングプレーン上にあるスイングのパーセンテージを測定します。 接触時の垂直バット角度は、そのスイングの平面を確立します。 平面は、バットのバレルをより安定して接触させるための優れた指標です。"
                        },
                        "list_7": {
                            "title": "インパクト時の接続と早期接続",
                            "description": "インパクト時の接続と早期接続とは何か、そしてそれらがどのように測定されるかをご覧ください。 インパクト時の接続は、インパクト時の体の傾きと垂直バット角度の関係を測定します。 アーリーコネクションは、スイング開始直後の体の傾きとバットの垂直角度の関係を測定します。"
                        }
                    },
                    "block_4": {
                        "title": "トレーニング",
                        "list_1": {
                            "title": "最初にトレーニングする指標",
                            "description": "トレーニングする必要のある指標を学び、最初に焦点を当てます。 トレーニングを推奨する最初の2つのメトリックは、早期接続（スイングメトリック）と迎え角（インパクトメトリック）です。"
                        },
                        "list_2": {
                            "title": "PVCパイプドリル：ディープダイブ",
                            "description": "私たちのPVCパイプドリルを詳しく見て、ドリルの最適な使用方法に関するヒントやコツを学び、より良い打者を作ることができます。"
                        },
                        "list_3": {
                            "title": "意思決定を伴う小さなボールドリル",
                            "description": "のようなドリルゲームを作成し、意思決定プロセスを追加できます。 このビデオを見て、さまざまな色のボールを追加し、意思決定をミックスに追加することで、小さなボールドリルを実行する高度な方法を学びます。"
                        },
                        "list_4": {
                            "title": "ヘビーボールプレーイングキャッチ（ユース）",
                            "description": "重いボールを使用すると、フィードバックに使用できる優れたツールになります。 打者と一緒にヘビーボールドリルを使用して、良好なスイングとハードコンタクトを促進するいくつかの方法を学びます。 重いボールは誇張されたフィードバックを与えます。 あなたがキャッチをしているので、ドリルもゲームです。 詳細をご覧ください。"
                        },
                        "list_5": {
                            "title": "あなた自身のバットが付いている加重バットスリーブ",
                            "description": "重いバットを振るのは、平面、接続、回転などのスイングに最適です。 重いバットをいつどのように使用するか、そして既存のバットに体重を追加する簡単な方法を学びましょう。"
                        },
                        "list_6": {
                            "title": "6ボールアプローチドリル",
                            "description": "シンプルな6ボールアプローチドリルを使用して、プレートの規律とアプローチをトレーニングします。 プレートのお気に入りの部分を選択し、打者がプレートとそのアプローチを理解するためのビジュアルを作成します。"
                        },
                        "list_7": {
                            "title": "初期接続と迎え角を改善する方法",
                            "description": "アーリーコネクションと迎え角とは何ですか？ 改善に役立つ特定のドリルを使用して、これらのメトリックを使用してトレーニングする方法を学びます。"
                        }
                    }
                },
                "understanding_scores_and_metrics": {
                    "title": "スコアと指標を理解する",
                    "description": "ブラストメトリクスを理解するためのダウンロード用ドキュメント。 ダウンロード、印刷、共有。",
                    "list_1": {
                        "title": "Blast スイング指標",
                        "description": "スイング品質スコア、スイングメトリック、インパクトメトリック、およびボールフライトメトリックの概要を説明する1ページのポケットベル。"
                    },
                    "list_2": {
                        "title": "Blast メートル法の範囲",
                        "description": "理想的なメトリック値の範囲へのクイックリファレンス。"
                    },
                    "list_3": {
                        "title": "平面接続の回転 - PowerPoint",
                        "description": "このプレゼンテーションを使用して、平面、接続、回転について他の人を教育します。"
                    },
                    "list_4": {
                        "title": "Blast Insights ガイド",
                        "description": "スイング スコア、メトリクス、およびゲームへの影響の詳細な概要。"
                    }
                },
                "certification": {
                    "title": "認証",
                    "description": "Blastのすべての概要を説明する、このセルフペースのビデオ認定コースでBlast認定を取得してください。",
                    "block_1": {
                        "title": "ビデオを見る",
                        "list_1": {
                            "title": "ブラスト認定ビデオ",
                            "description": "Blastコーチ認定ビデオコースでは、組織またはプログラム内でBlastソリューションを使用する方法に関する重要な洞察を提供します。 ブラストスイングアナライザーとブラストコネクト（プレミアムサービス）を使用してプレーヤーのスイングを評価し、時間の経過とともにパフォーマンスを追跡し、ブラスト情報を使用してコーチングを改善してより良いドライブを行う方法の基礎を学びます。 トレーニングとフィールドでの結果。"
                        }
                    },
                    "block_2": {
                        "title": "クイズに答える",
                        "list_1": {
                            "title": "ブラストモーション認定クイズ",
                            "description": "ビデオを見た後、認定クイズに答えて、Blast認定コーチとしての証明書を受け取ります。 クイズには約30分かかり、1回のセッションで完了する必要があります。 （部分的に完了している場合は、保存するオプションはありません。）\n\n                         クイズを無事に完了すると、PDFダウンロード用の証明書のコピーを取得して印刷できるようになります。 また、結果と、ダウンロード、保存、印刷できる証明書へのリンクが記載された電子メールが届きます。"
                        }
                    }
                }
            },
            "sns_message_invalid": "SNSメッセージが無効です",
            "sales_report_title": "Blast Connect 売上報告書",
            "academy_suspended": "アカデミー一時停止",
            "suspended_academy_title": "このアカデミーへのアクセスは期限切れになりました",
            "suspended_academy_help": "アカウント担当者に連絡するか、 <a href=\"{help_url}\">顧客サポート</a> ご不明な点がございましたら。",
            "disabled_registration_in_academy_title": "このアカデミーへの登録は現在利用できません",
            "disabled_registration_in_academy_help": "登録については、コーチにお問い合わせください。",
            "you_have_no_more_seats_available": "利用可能なライセンスシートはもうありません。 追加の座席を購入する必要がある場合は、見積もりについてBlastMotionの担当者にお問い合わせください。",
            "did_you_find_it_useful": "役に立ちましたか？",
            "change_to_sport_training_center": "{sport} トレーニングセンターに変更",
            "name_has_been_moved_into_target_academy": "{name} は<a href=\"{url}\">{target_academy}</a>に移動されました。",
            "upgrade_to_blast_premium_services": "ブラストプレミアムサービスにアップグレードする",
            "get_the_most_from_your_blast_experience_advanced_insights_analysis_and_reporting_at_your_fingertips": "ブラストエクスペリエンスを最大限に活用してください！<br>高度な洞察、分析、レポートをすぐに利用できます。",
            "you_have_number_days_left_in_your_free_trial": "無料トライアルの残り日数{number}日",
            "learn_more_about_premium_services": "プレミアムサービスの詳細",
            "click_to_change_language_label": "クリックして言語をに変更 {lang}",
            "swing_trainer_sensors_are_not_available": "Blast Swing Analyzer センサーでキャプチャされたスイングのみが含まれます。<br>ブラスト スイング トレーナー センサーでキャプチャされたスイングは利用できません。",
            "swing_trainer_sensors_are_not_available_warning": "<b>警告:</b> Blast Swing Analyzer センサーでキャプチャされたスイングのみが Blast プレミアム サービスの対象となり、Blast Connect 内で表示できます。 <br>ブラスト スイング トレーナー センサーでキャプチャされたスイングはサポートされていません。 <b><a href=\"{url}\" target=\"_blank\">もっと詳しく知る</a></b>.",
            "allow_coaches_send_invites": "コーチが招待状を送信できるようにする",
            "academy_was_deleted": "あなたが招待されたアカデミーは削除されました。",
            "video_invite_title": "ビデオ: 生徒とコーチを招待する",
            "roles_and_permissions_management": "役割と権限の管理",
            "create_role": "ロールの作成",
            "update_role": "ロールの更新",
            "roles_title": "役割",
            "permissions": "権限",
            "the_role_has_been_created_successfully": "ロールが正常に作成されました",
            "the_role_has_been_update_successfully": "役割が正常に更新されました",
            "the_role_has_been_deleted_successfully": "役割が正常に削除されました",
            "ncsa_modal": {
                "contact": {
                    "title": "NCSAカレッジリクルーティングによる大学リクルート",
                    "note": "注: NCSA に情報を提出するには、選手は 13 歳以上である必要があります。 NCSA に公開するには、次のフィールドが必要です。 続行するには不足している情報を入力してください。",
                    "required_fields_description": "特に明記されていない限り、すべてのフィールドは必須です。",
                    "fill_requred_fields": "続行するには不足している情報を入力してください。 アスリートが継続するには、13 歳以上である必要があります。",
                    "we_want_to_help": "NCSA の 800 人以上の採用専門家の 1 人にあなたをつなげたいと考えています。 彼らのチームは、募集プロセスと、あなたの家族が競合他社に先んじるために取ることができるステップをよりよく理解するのに役立ちます.",
                    "benefits": "彼らは無料のリクルーティング プロファイルを電子メールで送信してボールを転がし、35,000 人を超える大学のコーチに触れることができるようにします。 Blast スコア、メトリクス、ビデオを NCSA プロファイルに直接公開することで、進行状況をいつでも更新できます。",
                    "athlete_information": "選手情報",
                    "submiting_note": "NCSA に情報を提出するには、選手は 13 歳以上である必要があります。 続行するには生年月日を入力してください"
                }
            },
            "type_the_name_of_academy_to_search": "検索するアカデミーの名前を入力してください",
            "air_swings_attack_angle_note": "注: エア スイングではアタック アングルの値は使用できません。",
            "required_fields_modal": {
                "title": "プロフィール情報がありません",
                "birthday": "プロファイルの生年月日と年齢認証チェックボックスの値は必須であり、より良い打者になるための目標と洞察をパーソナライズするのに役立ちます.",
                "phone": "電話番号を提供することを選択した場合、重要な情報、製品サポート情報、更新、取引、および特別情報を受け取る可能性が高くなります."
            }
        },
        "vue_component": {
            "select2_messages": {
                "count_item_selected": "{item} 未選択 | {item} を1個選択済み | {count} を {item} 個選択済み",
                "all_item_selected": "{item} をすべて選択済み"
            }
        },
        "pagination": {
            "previous": "&laquo; 前",
            "next": "次 &raquo;"
        },
        "common": {
            "file": "ファイル",
            "close": "閉じる",
            "complete": "完了",
            "deleted": "削除済み",
            "validation": {
                "missing_required_data": "必要なデータがありません"
            }
        },
        "members": {
            "registration": {
                "sso_existing_bc": "メールアドレスが既にBlast Connectアカウントに登録済みです。"
            },
            "invitations": {
                "confirm": "この招待を送信してもよろしいですか？",
                "number_invites_sent": "{1} {number} 件の招待を送信しました。|[2,*] {number} 件の招待を送信しました。",
                "not_accepted_members": "ユーザー招待の処理中にエラーが発生しました。 一部のユーザーは招待されませんでした。"
            },
            "errors": {
                "organization_member_id_not_available": "チームメンバーIDを持っていないユーザーです",
                "sensor_conflict_with_another_user": "センサーを割り当てられませんでした。別のユーザーに割り当て済みです。",
                "sensor_conflict_with_another_sport": "センサーを割り当てられませんでした。別の競技で認証されています。",
                "sensor_could_not_be_added": "センサーを割り当てられませんでした。",
                "contact_support": "この問題を解決するには、サポートにお問い合わせください。",
                "invalid_account": "無効なアカウント情報",
                "invalid_cloud_access_token": "クラウドアクセストークンが無効です。もう一度認証してください。",
                "session_expired_login_again": "セッションの有効期限が切れました。もう一度ログインしてください。",
                "session_expired_connect_again": "セッションの有効期限が切れました。もう一度Blastアカウントを接続してください。",
                "not_able_to_complete_user_creation": "ユーザー登録を完了できません。",
                "blast_server_is_temporary_unavailable_please_try_again": "Blastサーバーが一時的に停止しています。あとでやり直してください。",
                "user_not_found": "ユーザーが見つかりません"
            },
            "bulk_upload": {
                "the_number_new_member": "{number}人の新しいメンバー",
                "add_user_message": "インポート済みのユーザー情報を確認してください。",
                "members_successfully_processed": "ユーザー[0,1] {number}人の処理を完了しました。|ユーザー[2,*] {number}人の処理を完了しました。",
                "new_data_will_be_available_in_few_minutes": "もうすぐ新しいデータが表示されます。",
                "confirm_add": "このユーザーを登録してもよろしいですか？",
                "invite_message": "インポート済みのユーザー情報を確認してください。必要に応じて以下で変更してください。変更がなければ送信してください。各ユーザーに招待が届きます。",
                "empty_list": "1人以上追加してください。",
                "some_addresses_belongs_to_exist_accounts": "このメールアドレスは既存のBlastユーザーアカウントに登録されていますが、入力した名前と一致しません。",
                "if_this_is_not_the_player_you_intended_to_invite_click_edit_to_modify_the_information_you_provided": "表示されている名前で選手を追加するには、「この選手を追加」をクリックします。別の選手を追加する場合は、上の編集アイコンをクリックして入力した情報を修正するか、ゴミ箱アイコンをクリックして招待を完全に削除してください。",
                "yes_add_this_person": "はい、この選手を追加します。",
                "this_person_has_been_added": "追加しました！",
                "there_errors_with_this_member": "エラーが発生したメンバー：|エラーが発生したメンバー：",
                "this_user_is_already_part_of_another_academy": "このユーザーは別のチームに参加しています。"
            },
            "validation_messages": {
                "member_type_required": "{member_name} のアカウントタイプが入力されていません。",
                "member_type_invalid": "{member_name} のメンバータイプが無効です。",
                "first_name_required": "{member_name} の名前（名）が入力されていません。",
                "first_name_regex": "名に無効な文字が含まれています。",
                "last_name_regex": "姓に無効な文字が含まれています。",
                "name_regex": "名前に無効な文字が含まれています。",
                "last_name_required": "{member_name} の名前（姓）が入力されていません。",
                "full_name_field_required": "[フルネーム]フィールドは必須です。",
                "email_required": "{member_name} のメールアドレスが入力されていません。",
                "email_field_required": "[メール]フィールドは必須です。",
                "email_email": "{member_name} のメールアドレスが無効です。",
                "email_valid_email": "{member_name} のメールアドレスは既に使用中です。",
                "email_unique": "{member_name} のメールアドレスは既に取得されています。",
                "password_min": "{member_name} のパスワードは8文字以上にしてください。",
                "password_max": "{member_name} のパスワードは100文字以下にしてください。",
                "password_regex": "{member_name} のパスワード形式が無効です。",
                "password_required": "{member_name} のパスワードを入力してください。",
                "valid_sensor_serial": "{member_name} のセンサーのシリアル番号が無効です。",
                "sensor_serial_numeric": "{member_name} のセンサーのシリアル番号は数字で入力してください。",
                "coach": "{member_name} のコーチが無効です。",
                "mlb_bam_id_invalid": "MLB BAM ID 英数字、ダッシュ、コロンのみを含める必要があります。",
                "equipment_name_alpha_num": "{member_name} のバット名は英数字で入力してください。",
                "equipment_name_required_with": "{member_name} のバット名を入力してください（別のバット情報が表示されている場合）。",
                "equipment_weight_required_with": "{member_name} のバットの重さを入力してください（別のバット情報が表示されている場合）。",
                "equipment_length_required_with": "{member_name} のバットの長さを入力してください（別のバット情報が表示されている場合）。",
                "equipment_weight_numeric": "{member_name} のバットの重さは数字で入力してください。",
                "equipment_length_numeric": "{member_name} のバットの長さは数字で入力してください。",
                "member_email_unique": "既に使用中のメールアドレスがあります。ハイライト表示されたアカウントのメールアドレスを変更してください。まだアカウントが作成されていません。修正して選手をアップロードし直してください。",
                "bulk_upload_generic_error": "選手のインポートフォームに問題があります。{number}人分が未処理です。エラーを修正してフォームを再送信してください。",
                "email_already_belongs_to_another_user": "別の選手に登録されているメールアドレスです。入力した名前と一致しません。",
                "we_are_not_able_to_process_your_information_please_contact_customer_support_for_more_information": "情報を処理できません。詳しくはカスタマーサポートにお問い合わせください。",
                "country_required": "{member_name}\\の国を入力してください。",
                "country_in": "{member_name}\\の国に対応していません。",
                "bulk_wrong_external_id": "このユーザーには、この組織に割り当てられた外部 ID が既にありますが、入力したものと一致しません。 外部 ID が表示されたプレーヤーを追加するには、[アクション] の下のチェックマークをクリックします。 プレーヤーを削除するには、[アクション] の下のゴミ箱をクリックします。 電子メール アドレスを編集するには、[アクション] の下にある鉛筆アイコンをクリックします。",
                "external_id_already_assigned_for_this_organization": "この外部 ID はこの組織に既に割り当てられていますが、電子メール アドレスが入力したものと一致しません。 電子メールが表示されたプレーヤーを追加するには、[アクション] の下のチェックマークをクリックします。 プレーヤーを削除するには、[アクション] の下のゴミ箱をクリックします。 外部 ID とメンバー情報を編集するには、[アクション] の下にある鉛筆アイコンをクリックします。",
                "external_id_has_duplicate": "外部 ID フィールドの値が重複しています。",
                "names_not_equal_external_api": "この電子メール アドレスは既存の Blast ユーザーに属していますが、名前が提供された値と一致しません。 ユーザーは、ユーザーの既存の名前でイベントに追加されました。 {first_name} {last_name}."
            },
            "configuration": {
                "blast_certified": "ブラスト認定",
                "blast_certification_date": "ブラスト認証日",
                "address": "研修先住所: 番地",
                "additional_address": "トレーニングの住所: 住所 (追加)",
                "city": "トレーニングの住所: 市区町村",
                "state": "トレーニングの住所: 州/県",
                "country": "研修先住所: 国",
                "zip_code": "研修先住所: 郵便番号"
            }
        }
    },
    "packages": {
        "en": {
            "confide": {
                "confide": {
                    "username": "Username",
                    "password": "Password",
                    "password_confirmation": "Confirm Password",
                    "e_mail": "Email",
                    "username_e_mail": "Username or Email",
                    "signup": {
                        "title": "Signup",
                        "desc": "Signup for new account",
                        "confirmation_required": "Confirmation required",
                        "submit": "Create new account"
                    },
                    "login": {
                        "title": "Login",
                        "desc": "Enter your credentials",
                        "forgot_password": "(forgot password)",
                        "remember": "Remember me",
                        "submit": "Login"
                    },
                    "forgot": {
                        "title": "Forgot password",
                        "submit": "Continue"
                    },
                    "alerts": {
                        "account_created": "Your account has been successfully created.",
                        "instructions_sent": "Please check your email for the instructions on how to confirm your account.",
                        "too_many_attempts": "Too many attempts. Try again in few minutes.",
                        "wrong_credentials": "Incorrect email or password.",
                        "not_confirmed": "Your account may not be confirmed. Check your email for the confirmation link",
                        "confirmation": "Your account has been confirmed! You may now login.",
                        "password_confirmation": "The passwords did not match.",
                        "wrong_confirmation": "Wrong confirmation code.",
                        "password_forgot": "The information regarding password reset was sent to your email.",
                        "wrong_password_forgot": "User not found.",
                        "password_reset": "Your password has been changed successfully.",
                        "wrong_password_reset": "Invalid password. Try again",
                        "wrong_token": "The password reset token is not valid.",
                        "duplicated_credentials": "The credentials provided have already been used. Try with different credentials."
                    },
                    "email": {
                        "account_confirmation": {
                            "subject": "Account Confirmation",
                            "greetings": "Hello {name}",
                            "body": "Please access the link below to confirm your account.",
                            "farewell": "Regards"
                        },
                        "password_reset": {
                            "subject": "Password Reset",
                            "greetings": "Hello {name}",
                            "body": "Access the following link to change your password",
                            "farewell": "Regards"
                        }
                    }
                }
            }
        },
        "jp": {
            "confide": {
                "confide": {
                    "username": "ユーザー名",
                    "password": "パスワード",
                    "password_confirmation": "パスワードの確認",
                    "e_mail": "メールアドレス",
                    "username_e_mail": "ユーザー名 もしくは メールアドレス",
                    "signup": {
                        "title": "アカウント作成",
                        "desc": "新しいアカウントの作成",
                        "confirmation_required": "確認が必要です",
                        "submit": "新規アカウント作成"
                    },
                    "login": {
                        "title": "ログイン",
                        "desc": "ログイン情報を入力してください",
                        "forgot_password": "(パスワードを忘れた)",
                        "remember": "ログイン状態を保持する",
                        "submit": "ログイン"
                    },
                    "forgot": {
                        "title": "パスワードを忘れた",
                        "submit": "次へ"
                    },
                    "alerts": {
                        "account_created": "あなたのアカウントは正常に作成されました。 アカウントの確認方法についてはご登録のメールを参照してください。",
                        "too_many_attempts": "ログイン試行回数が多すぎます。 しばらくしてから再実行してください。",
                        "wrong_credentials": "ユーザー名、メールアドレスあるいはパスワードが間違っています。",
                        "not_confirmed": "あなたのアカウントは確認されていません。メールに記載されている確認用のリンクへアクセスしてください",
                        "confirmation": "あなたのアカウントが確認されました！ いますぐログインできます。",
                        "wrong_confirmation": "確認コードが間違っています。",
                        "password_forgot": "ご登録のメールアドレス宛にパスワード初期化についての情報をお送りいたしました。",
                        "wrong_password_forgot": "ユーザーが存在しません。",
                        "password_reset": "パスワードを正常に変更しました。",
                        "wrong_password_reset": "パスワードが間違っています。 もう一度入力してください",
                        "wrong_token": "パスワード初期化用のトークンが間違っています。",
                        "duplicated_credentials": "ご入力いただいた認証情報はすでに使用されています。別のものをご入力ください。"
                    },
                    "email": {
                        "account_confirmation": {
                            "subject": "アカウント確認",
                            "greetings": "こんにちは {name} さん",
                            "body": "あなたのアカウントを確認するために以下のリンクへアクセスしてください。",
                            "farewell": "よろしくお願いいたします。"
                        },
                        "password_reset": {
                            "subject": "パスワード初期化",
                            "greetings": "こんにちは {name} さん",
                            "body": "あなたのパスワードを初期化するために以下のリンクへアクセスしてください。",
                            "farewell": "よろしくお願いいたします。"
                        }
                    }
                }
            }
        }
    },
    "translations": []
}
